
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eiA8Z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $1663cf3718a173a6$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $1663cf3718a173a6$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $1663cf3718a173a6$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $1663cf3718a173a6$var$useStaticPlugins(plugins);
    const selectorRef = (0, $42omo.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $1663cf3718a173a6$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $1663cf3718a173a6$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $42omo.useRef)($1663cf3718a173a6$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $42omo.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($1663cf3718a173a6$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $1663cf3718a173a6$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $1663cf3718a173a6$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}
module.exports["useSharedPluginStateWithSelector"] = $1663cf3718a173a6$export$e5d623015ec283cc;

});

parcelRegister("2cmfr", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $3jQ9y = parcelRequire("3jQ9y");

const $cdbf3a2c8517d76b$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $cdbf3a2c8517d76b$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $3jQ9y.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        ...((0, $dh538.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') || (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) && {
            priority: extensionModule.priority
        },
        ...extensionModule.lozenge != null && {
            lozenge: extensionModule.lozenge
        },
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $cdbf3a2c8517d76b$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$cdbf3a2c8517d76b$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $cdbf3a2c8517d76b$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $cdbf3a2c8517d76b$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $cdbf3a2c8517d76b$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $cdbf3a2c8517d76b$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cdbf3a2c8517d76b$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $cdbf3a2c8517d76b$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $cdbf3a2c8517d76b$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $cdbf3a2c8517d76b$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $cdbf3a2c8517d76b$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $cdbf3a2c8517d76b$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $cdbf3a2c8517d76b$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $cdbf3a2c8517d76b$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$cdbf3a2c8517d76b$var$compareContext(currentContext, context)));
    }
};
const $cdbf3a2c8517d76b$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $cdbf3a2c8517d76b$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $cdbf3a2c8517d76b$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($cdbf3a2c8517d76b$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($cdbf3a2c8517d76b$var$isToolbarButton(toolbarItem)) return $cdbf3a2c8517d76b$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $cdbf3a2c8517d76b$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $cdbf3a2c8517d76b$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}
module.exports["getQuickInsertItemsFromModule"] = $cdbf3a2c8517d76b$export$a1d0004a197b97a3;
module.exports["getAutoConvertPatternsFromModule"] = $cdbf3a2c8517d76b$export$60407594ea5edd1c;
module.exports["getExtensionAutoConvertersFromProvider"] = $cdbf3a2c8517d76b$export$38a3a11e6509754a;
module.exports["getContextualToolbarItemsFromModule"] = $cdbf3a2c8517d76b$export$9d13b95c50a2a6c9;

});

parcelRegister("b5IZN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ffCOo = parcelRequire("ffCOo");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");


var $2T4ch = parcelRequire("2T4ch");


var $lWghV = parcelRequire("lWghV");


var $iu6m9 = parcelRequire("iu6m9");


var $fswVK = parcelRequire("fswVK");


var $auTg8 = parcelRequire("auTg8");


var $6DQRK = parcelRequire("6DQRK");


var $7lreV = parcelRequire("7lreV");


var $75KVc = parcelRequire("75KVc");





var $jSnXV = parcelRequire("jSnXV");









// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $df33a49f9570fdc5$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $2791f7d61bdfd64e$export$51e52147760fc784 {
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
   * Returns the `interactionCount` value using the native API (if available)
   * or the polyfill estimate in this module.
   */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        this.po = void 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
}


class $11086031fa1bcc5c$export$aaa80641d584351c {
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
    constructor(){
        this.longestInteractionList = void 0;
        this.longestInteractionMap = void 0;
        this.interactionCountPolyfill = void 0;
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $2791f7d61bdfd64e$export$51e52147760fc784)();
    }
}
$11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER = 10;


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $a86e91972531a920$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};


// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

const $4716358fa782d9bd$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $4716358fa782d9bd$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $a86e91972531a920$export$91ec2be6fdd8f1b4)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $4716358fa782d9bd$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $e53cd74394c138c9$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $df33a49f9570fdc5$export$17679dccdd551979)(callback);
    const interactionManager = new (0, $11086031fa1bcc5c$export$aaa80641d584351c)();
    const handleEntries = (entries)=>{
        (0, $4716358fa782d9bd$export$4d9952dcbf5b2792)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $e53cd74394c138c9$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $a86e91972531a920$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $e53cd74394c138c9$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};



var $kyRHQ = parcelRequire("kyRHQ");

const $1035ef17fe90bcc8$export$56930d9a67e0aae6 = (callback)=>{
    if (!$1035ef17fe90bcc8$var$isINPSupported()) return;
    return (0, $e53cd74394c138c9$export$7df4b36ecaed99e1)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $1035ef17fe90bcc8$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $kyRHQ !== 'undefined' && Boolean($kyRHQ?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};



var $4u5NT = parcelRequire("4u5NT");

const $32714f82364735d9$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $inPa6.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $42omo.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $32714f82364735d9$var$createIdleCallback(()=>{
            cleanupFn = (0, $1035ef17fe90bcc8$export$56930d9a67e0aae6)(({ value: value })=>{
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $32714f82364735d9$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $32714f82364735d9$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $32714f82364735d9$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















var $jTxSS = parcelRequire("jTxSS");


var $1oCLl = parcelRequire("1oCLl");


var $eTj7Y = parcelRequire("eTj7Y");




function $03c9dba1f478f2d1$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $42omo.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $42omo.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $42omo.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portalElements);
}


function $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $42omo.useState)(portalManager.getBuckets());
        (0, $42omo.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $42omo.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03c9dba1f478f2d1$export$828f0f29e8293a07), {
                    key: i,
                    id: i,
                    portalManager: portalManager
                })), [
            buckets
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, portalsElements);
    };
}
const $07ca771f5bf2bd0c$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $42omo.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getChildren());
};
const $07ca771f5bf2bd0c$var$PortalRenderWrapper = /*#__PURE__*/ (0, $42omo.memo)($07ca771f5bf2bd0c$export$eab0ea19ad3bed77);
$07ca771f5bf2bd0c$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
// Tree-shakable renderToStaticMarkup that should work only in SSR
function $07ca771f5bf2bd0c$var$getRenderToStaticMarkup() {
    return ()=>'';
}
const $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender, immediate = false)=>{
            if ((0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) {
                let html = '';
                try {
                    const renderToStaticMarkup = $07ca771f5bf2bd0c$var$getRenderToStaticMarkup();
                    const Children = children;
                    html = renderToStaticMarkup(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Children, null));
                } catch (error) {}
                container.innerHTML = html;
            } else if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07ca771f5bf2bd0c$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            } else {
                const portal = /*#__PURE__*/ (0, $jTxSS.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            }
        },
        remove: (key)=>{
            if ((0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) return;
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};



var $8Yfbq = parcelRequire("8Yfbq");




const $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS = 50;
const $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $3a8111d444031088$var$DEFAULT_SCALE_RATIO = 0.5;
const $3a8111d444031088$var$DEFAULT_THROTTLE_DELAY = 16; // ~60fps for smooth updates
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $3a8111d444031088$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $3a8111d444031088$export$52c7ef79917c2f38 {
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($3a8111d444031088$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getOrCreateThrottledUpdater(id) {
        if (!this.throttledBucketUpdaters.has(id)) {
            const throttledUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
                this.buckets[id]?.updater?.(()=>({
                        ...this.buckets[id].portals
                    }));
            }, this.throttleDelay);
            this.throttledBucketUpdaters.set(id, throttledUpdater);
        }
        return this.throttledBucketUpdaters.get(id);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
        // Clean up throttled updater when bucket is unregistered
        if (this.throttledBucketUpdaters.has(id)) {
            this.throttledBucketUpdaters.get(id)?.cancel();
            this.throttledBucketUpdaters.delete(id);
        }
    }
    updateBuckets(id, immediate = false) {
        if (!this.throttleActivationRAFId && (0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) this.throttleActivationRAFId = requestAnimationFrame(()=>{
            this.shouldUseThrottledUpdates = true;
        });
        if (immediate || !this.shouldUseThrottledUpdates || !(0, $1oCLl.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) {
            // Cancel any pending throttled update and update immediately
            if (this.throttledBucketUpdaters.has(id)) this.throttledBucketUpdaters.get(id)?.cancel();
            this.buckets[id].updater?.(()=>({
                    ...this.buckets[id].portals
                }));
        } else // Use throttled update for smooth, regular updates
        this.getOrCreateThrottledUpdater(id)?.();
    }
    registerPortal(key, portal, immediate = false) {
        this.createBucket();
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.portalToBucketMap.set(key, id);
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[id].portals[key] !== portal) {
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].portals[key] = portal;
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        }
        //returns a function to unregister the portal
        return ()=>{
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].capacity += 1;
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.availableBuckets.add(id);
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
   * Cleans up resources used by the PortalManager. This includes clearing all portals,
   * unregistering all buckets, and resetting internal state.
   */ destroy() {
        // Cancel all pending throttled updates
        this.throttledBucketUpdaters.forEach((updater)=>{
            updater.cancel();
        });
        this.throttledBucketUpdaters.clear();
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
    constructor(initialBuckets = $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $3a8111d444031088$var$DEFAULT_SCALE_RATIO, throttleDelay = $3a8111d444031088$var$DEFAULT_THROTTLE_DELAY){
        this.maxBucketCapacity = void 0;
        this.scaleRatio = void 0;
        this.buckets = void 0;
        this.availableBuckets = void 0;
        this.portalToBucketMap = void 0;
        this.portalRendererUpdater = void 0;
        this.scaleCapacityThreshold = void 0;
        this.throttledBucketUpdaters = void 0;
        this.throttleDelay = void 0;
        /**
     * Controls whether to use throttled updates or immediate synchronous updates.
     * During initial load, we use synchronous updates to avoid delays and ensure immediate responsiveness.
     * After the initial load period (one RAF cycle), we switch to throttled updates for better performance.
     */ this.shouldUseThrottledUpdates = false;
        /**
     * RequestAnimationFrame callback ID used to transition from synchronous to throttled update mode.
     * This ensures we switch to throttled mode after the initial render cycle completes.
     */ this.throttleActivationRAFId = void 0;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        this.throttleDelay = throttleDelay;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$3a8111d444031088$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
        this.throttledBucketUpdaters = new Map();
    }
}


function $b81f72f3142ef144$export$9b00782c24eb3d6b() {
    const portalManager = (0, $42omo.useMemo)(()=>new (0, $3a8111d444031088$export$52c7ef79917c2f38)(), []);
    const PortalRenderer = (0, $42omo.useMemo)(()=>(0, $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $42omo.useMemo)(()=>(0, $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}



var $dh538 = parcelRequire("dh538");








var $dQl1W = parcelRequire("dQl1W");


var $2xIMp = parcelRequire("2xIMp");







var $56Wjx = parcelRequire("56Wjx");


var $kckFS = parcelRequire("kckFS");


var $hWRJP = parcelRequire("hWRJP");





var $9JpPs = parcelRequire("9JpPs");

/* eslint-disable require-unicode-regexp */ 


const $1ad229e75f2927fb$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? chromeVersion >= 123 : chromeVersion >= 84) return false;
    const gecko = /gecko\/\d/i.test(userAgent);
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? geckoVersion >= 124 : geckoVersion >= 84) return false;
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? edgeVersion >= 123 : edgeVersion >= 84) return false;
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if ((0, $1oCLl.expValEquals)('platform_editor_outdated_browser_update', 'isEnabled', true) ? safariVersion >= 17 : safariVersion >= 12) return false;
    return true;
};








const $090d7aafd4648237$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $auTg8.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};


class $24b7332c0d770745$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kckFS.IntlErrorBoundary), null, this.props.children);
    }
    constructor(props){
        super(props);
        this.featureFlags = void 0;
        this.browserExtensions = undefined;
        this.state = {
            error: undefined
        };
        this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $56Wjx.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $1ad229e75f2927fb$export$12d09524e028927)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            this.logException(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        };
        this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        };
        this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $ajtqX.editorAnalyticsChannel));
        };
        this.logException = (error, tags)=>{
            (0, $hWRJP.logException)(error, tags);
        };
        this.featureFlags = props.featureFlags;
    }
}
$24b7332c0d770745$export$d6d3bedcc5fc09c8.defaultProps = {
    rethrow: true,
    errorTracking: true
};
class $24b7332c0d770745$export$e34b68cf8622e9fd extends $24b7332c0d770745$export$d6d3bedcc5fc09c8 {
    constructor(props){
        super(props);
        this.context = void 0;
        this.logException = (error, tags)=>{
            const extraTags = {};
            extraTags.editorSessionId = this.context?.getAtlaskitAnalyticsContext()?.[0]?.fabricEditorCtx?.editorSessionId;
            (0, $hWRJP.logException)(error, {
                ...tags,
                ...extraTags
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$24b7332c0d770745$export$e34b68cf8622e9fd.contextType = (0, $2xIMp.default);
const $24b7332c0d770745$var$_default_1 = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('platform_editor_sentry_breadcrumbs'), (0, $090d7aafd4648237$export$cf381084b490bd31)($24b7332c0d770745$export$e34b68cf8622e9fd), (0, $090d7aafd4648237$export$cf381084b490bd31)($24b7332c0d770745$export$d6d3bedcc5fc09c8));
var $24b7332c0d770745$export$2e2bcd8739ae039 = $24b7332c0d770745$var$_default_1;



var $bn5lP = parcelRequire("bn5lP");





var $f8zg2 = parcelRequire("f8zg2");





var $2oRGU = parcelRequire("2oRGU");





var $6dGgK = parcelRequire("6dGgK");


var $aFUXX = parcelRequire("aFUXX");

// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $67f6e75f4f4df09d$var$defaultFontSize = 14;
function $67f6e75f4f4df09d$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $42omo.useMemo)(()=>({
            baseFontSize: baseFontSize || $67f6e75f4f4df09d$var$defaultFontSize,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
        theme: memoizedTheme
    }, children);
}



var $jTtEd = parcelRequire("jTtEd");

function $93c55730732033da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93c55730732033da$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $93c55730732033da$var$DEFAULT_VALUE_PROP_TO_IGNORE = [
    'defaultValue'
];
const $93c55730732033da$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $42omo.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $b81f72f3142ef144$export$9b00782c24eb3d6b)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $b81f72f3142ef144$export$9b00782c24eb3d6b)();
    const propsToIgnore = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $93c55730732033da$var$DEFAULT_VALUE_PROP_TO_IGNORE : [
        'defaultValue'
    ];
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: propsToIgnore,
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $24b7332c0d770745$export$2e2bcd8739ae039), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $93c55730732033da$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $auTg8.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f8zg2.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bn5lP.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017: this callback closes over the full props object and derived featureFlags; memoization is ineffective because ReactEditorViewNext is not memo()'d and deps (props, featureFlags) change every render
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $67f6e75f4f4df09d$export$3de34996b814f0f0), {
                baseFontSize: (0, $jTtEd.getBaseFontSize)(props.appearance, props.contentMode)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                onSSRMeasure: props.onSSRMeasure,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                contentMode: props.contentMode,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $9K4OG.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $9K4OG.jsx)(NodeViewPortalRenderer, null)))))));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
















function $ea8d7238f61ed9d1$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9HtP4 = parcelRequire("9HtP4");







function $04f7f6d8a5e7af43$export$2e2bcd8739ae039() {
    (0, $9HtP4.default)(()=>{
        (0, $2T4ch.startMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
    });
}


function $4672b7597b696155$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $04f7f6d8a5e7af43$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        (0, $2T4ch.stopMeasure)((0, $7lreV.default).EDITOR_MOUNTED, (0, $ea8d7238f61ed9d1$export$2e2bcd8739ae039)((0, $d925B.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}





const $1b1b779d278e7645$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $42omo.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            onSSRMeasure: passedProps.onSSRMeasure,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider,
            pasteWarningOptions: passedProps.pasteWarningOptions
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentMode,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.onSSRMeasure,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation,
        passedProps.syncBlock,
        passedProps.syncedBlockProvider,
        passedProps.pasteWarningOptions
    ]);
    return memodProps;
};
var $1b1b779d278e7645$export$2e2bcd8739ae039 = $1b1b779d278e7645$export$d9d7e48a5f16fb4d;






var $4FxUL = parcelRequire("4FxUL");


var $2XqLN = parcelRequire("2XqLN");


var $eEmxu = parcelRequire("eEmxu");

function $9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $eEmxu.default)(extensionProviders(editorActions));
    return (0, $eEmxu.default)(extensionProviders);
}
const $9b8bf99e5ea95e38$var$prepareExtensionProvider = (getEditorActions)=>(0, $2XqLN.default)((extensionProviders)=>$9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $9b8bf99e5ea95e38$export$2e2bcd8739ae039 = $9b8bf99e5ea95e38$var$prepareExtensionProvider;






var $4wH3g = parcelRequire("4wH3g");







var $2cmfr = parcelRequire("2cmfr");

var $3jQ9y = parcelRequire("3jQ9y");


var $iScNA = parcelRequire("iScNA");







/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $lWghV.findInsertLocation)(selection);
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    // @note inputMethod defaults to QUICK_INSERT if not provided
                    inputMethod: source || (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }
        });
    }
}
const $4a8f1fc352d7e11f$var$showDummyAPIWarning = (location)=>{};
const $4a8f1fc352d7e11f$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:update')
    }
};
async function $4a8f1fc352d7e11f$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            // `extensionProvider` is supplied independently of the preset, so
            // suppress its items in markdown mode where rich-only content cannot
            // be inserted. See `MarkdownModeReader` above for why this is read
            // via a structural cast rather than the typed plugin API.
            const isMarkdownMode = apiRef.current?.markdownMode?.sharedState.currentState()?.isMarkdownMode;
            if (isMarkdownMode) return Promise.resolve([]);
            const quickInsertItems = (0, $2cmfr.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
                    __loadable_id__: "N8xjw",
                    name: "Icon",
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    // Add module key so typeahead/quick-insert can identify items
                    // **locale-agnostically**! nb: we _already_ send key in analytics
                    // events, this standardises and makes our items more predictable.
                    key: item.key,
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    ...((0, $dh538.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') || (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) && {
                        priority: item.priority
                    },
                    categories: item.categories,
                    ...item.lozenge != null && {
                        lozenge: item.lozenge
                    },
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $3jQ9y.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $3jQ9y.resolveImport)(item.node($4a8f1fc352d7e11f$var$dummyExtensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
function $4a8f1fc352d7e11f$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $iScNA.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}


function $857dcb67a4f61ef1$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $4a8f1fc352d7e11f$export$6b0bb34c2583056f)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? Promise.resolve((0, $4a8f1fc352d7e11f$export$e3759a254d73dcb7)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ])) : quickInsertProvider || extensionQuickInsertProvider;
}


function $e5d3ec72975fd3ba$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}


function $6c9d292cfdbfb05b$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}


function $cf88016029b1c3dc$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $cf88016029b1c3dc$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $9b8bf99e5ea95e38$export$2e2bcd8739ae039)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $857dcb67a4f61ef1$export$2e2bcd8739ae039)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $cf88016029b1c3dc$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $42omo.useMemo)(()=>(0, $e5d3ec72975fd3ba$export$2e2bcd8739ae039)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $42omo.useRef)(new (0, $4FxUL.default)());
    const editorRef = $cf88016029b1c3dc$var$useEditorRef(props.preset);
    const preparedProviders = (0, $42omo.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $cf88016029b1c3dc$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $6c9d292cfdbfb05b$export$2e2bcd8739ae039)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}



/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $f12bc0dec21ca30e$var$Editor(passedProps) {
    const propsRef = (0, $42omo.useRef)(passedProps);
    const props = (0, $1b1b779d278e7645$export$2e2bcd8739ae039)(passedProps);
    (0, $42omo.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $auTg8.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $42omo.useMemo)(()=>new (0, $fswVK.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $42omo.useCallback)((data)=>{
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $42omo.useCallback)(()=>{
        return {
            ...(0, $6DQRK.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $42omo.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $2T4ch.startMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $2T4ch.stopMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK, (0, $ea8d7238f61ed9d1$export$2e2bcd8739ae039)((0, $d925B.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $42omo.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $4672b7597b696155$export$2e2bcd8739ae039)(props, createAnalyticsEvent);
    const providerFactory = (0, $cf88016029b1c3dc$export$2e2bcd8739ae039)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $42omo.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageAppearance = Boolean(props.appearance && [
        'full-page',
        'full-width',
        ...(0, $iu6m9.editorExperiment)('platform_synced_block', true) ? [
            'max'
        ] : []
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, isFullPageAppearance ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $32714f82364735d9$export$5942461441325be9), null) : null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $93c55730732033da$export$2617c0dabe49c335), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $42omo.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $f12bc0dec21ca30e$export$be7eaacc86ce4514(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorSessionId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const data = (0, $42omo.useMemo)(()=>{
        return {
            packageName: (0, $75KVc.name),
            packageVersion: (0, $75KVc.version),
            componentName: 'editorCore',
            appearance: (0, $lWghV.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($f12bc0dec21ca30e$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$f12bc0dec21ca30e$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $f12bc0dec21ca30e$export$2e2bcd8739ae039 = $f12bc0dec21ca30e$export$be7eaacc86ce4514;
module.exports["CoreEditor"] = $f12bc0dec21ca30e$export$be7eaacc86ce4514;

});

parcelRegister("ajtqX", function(module, exports) {

var $k7eoe = parcelRequire("k7eoe");


var $2XqLN = parcelRequire("2XqLN");

var $59df087331ac03f0$var$_AnalyticsQueue;
class $59df087331ac03f0$export$b44c4ba8fe19bbc7 {
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
}
$59df087331ac03f0$var$_AnalyticsQueue = $59df087331ac03f0$export$b44c4ba8fe19bbc7;
$59df087331ac03f0$export$b44c4ba8fe19bbc7.get = (0, $2XqLN.default)(()=>new $59df087331ac03f0$var$_AnalyticsQueue());


const $2ca897dc13b18654$export$1467dbbb3bb418c6 = (0, $k7eoe.FabricChannel).editor;
const $2ca897dc13b18654$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $2ca897dc13b18654$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $59df087331ac03f0$export$b44c4ba8fe19bbc7).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };
module.exports["editorAnalyticsChannel"] = $2ca897dc13b18654$export$1467dbbb3bb418c6;
module.exports["fireAnalyticsEvent"] = $2ca897dc13b18654$export$c7d191551feb734;

});

parcelRegister("fswVK", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $6tl2G = parcelRequire("6tl2G");


var $lWghV = parcelRequire("lWghV");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

// Please, do not copy or use this kind of code below
// @ts-ignore
const $674469a067b8ad06$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $674469a067b8ad06$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $674469a067b8ad06$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}


function $24808638338110d5$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $24808638338110d5$export$2e2bcd8739ae039 = $24808638338110d5$var$deprecationWarnings;


const $4f0bf41d03b55c89$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $1ec3bd762a62c85b$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $1ec3bd762a62c85b$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $1ec3bd762a62c85b$export$b648602b09795358(nodeChild);
}


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $9bc21d8203f55b17$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $h9yJL = parcelRequire("h9yJL");

const $e456faba3d0c2065$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $e456faba3d0c2065$export$54fd2c36b5cc6731(node) {
    return $e456faba3d0c2065$var$transformer.encode(node);
}


// Please, do not copy or use this kind of code below
// @ts-ignore
const $982b9f7bd08d5545$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $982b9f7bd08d5545$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $982b9f7bd08d5545$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated This is deprecated and is no longer maintained.
   *
   * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
   * it has inbuilt throttling and is designed for use with `ComposableEditor`.
   *
   * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
   *
   * WARNING: this may be called repeatedly, async with care
   */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $674469a067b8ad06$export$99c45752ffdaa598)(editorView);
        const json = (0, $e456faba3d0c2065$export$54fd2c36b5cc6731)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $5SAOw.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
   * @example
    	const { editorApi, preset } = usePreset(...);
  	const extensionAPI = editorAPI?.extension?.actions?.api();
  	// Use nodeWithPos as desired
  	const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
  	const node = nodeWithPos.node;
  	const nodePos = nodeWithPos.pos;
   */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $9bc21d8203f55b17$export$947fc26275418e36)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $4f0bf41d03b55c89$export$1dc8bea8646ac811)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
   * This method will return the currently selected `Node` if the selection is a `Node`.
   * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
   */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node;
            return (0, $8m4tT.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $1ec3bd762a62c85b$export$2da47a16c0b6bcb)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `replaceDocument` found in the core plugin actions instead
   * using this will reset your Editor State which could cause some things to break (like emojis)
   * @example - use the `replaceDocument` from the core plugin actions instead
   * ```ts
   * const { editorApi, preset } = usePreset(...);
  	// where you need it
  	editorApi?.core.actions.replaceDocument(value);
  	return <ComposableEditor preset={preset} ... />
   */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $24808638338110d5$export$2e2bcd8739ae039)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $6tl2G.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $6tl2G.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $8m4tT.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.editorView = void 0;
        this.contentTransformer = void 0;
        this.contentEncode = void 0;
        this.eventDispatcher = void 0;
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
     * If editor is using new collab service,
     * we want editor to call the collab provider to
     * retrieve the final acknowledged state of the
     * editor. The final acknowledged editor state
     * refers to the latest state of editor with confirmed
     * steps.
     */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $674469a067b8ad06$export$99c45752ffdaa598)(editorView);
            const collabEditState = $982b9f7bd08d5545$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}
module.exports["default"] = $982b9f7bd08d5545$export$2e2bcd8739ae039;

});

parcelRegister("5vVM5", function(module, exports) {
class $36d44ab91368ab14$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $36d44ab91368ab14$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $36d44ab91368ab14$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($36d44ab91368ab14$var$getEventFromEventName(eventName), data);
    };
}
module.exports["EventDispatcher"] = $36d44ab91368ab14$export$ec8b666c5fe2c75a;
module.exports["createDispatch"] = $36d44ab91368ab14$export$f57f9cc7ce57b7d0;

});

parcelRegister("6tl2G", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $584b2e64b69fa432$export$dbdec03917c683f4 = (schema, adf)=>{
    let isTransformed = false;
    const { syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, unsupportedBlock: unsupportedBlock } = schema.nodes;
    if (!unsupportedBlock) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        syncBlock: (node)=>{
            if (syncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        bodiedSyncBlock: (node)=>{
            if (bodiedSyncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        unsupportedBlock: (node)=>{
            if (!node.attrs?.originalValue) return node;
            if (node.attrs.originalValue.type === 'syncBlock' && syncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            } else if (node.attrs.originalValue.type === 'bodiedSyncBlock' && bodiedSyncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $1c2816ef0c8b7188$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $1c2816ef0c8b7188$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $1c2816ef0c8b7188$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $1c2816ef0c8b7188$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};




const $c7e8fda47c191e04$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $c7e8fda47c191e04$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $c7e8fda47c191e04$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
            return;
        },
        tableHeader: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};





var $hbEec = parcelRequire("hbEec");

const $5b85afc4a4930f06$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $5b85afc4a4930f06$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $5b85afc4a4930f06$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $hbEec.isEmpty)(node));
        //remove other remaining dupicates
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $5b85afc4a4930f06$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $5b85afc4a4930f06$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $5b85afc4a4930f06$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $1LHXq = parcelRequire("1LHXq");



const $012dd1aff3a76210$export$abd79dcca4cbaf32 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            const { width: width, widthType: widthType } = node.attrs || {};
            // if width is not a number or greater than 100, and widthType is not set, we set width to 100
            if (typeof width === 'number' && width > 100 && !widthType) {
                isTransformed = true;
                const newAttrs = {
                    ...node.attrs,
                    width: 100
                };
                return {
                    ...node,
                    attrs: newAttrs
                };
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $dDZcC = parcelRequire("dDZcC");




var $eyfm5 = parcelRequire("eyfm5");

var $2FFuS = parcelRequire("2FFuS");

var $inmjk = parcelRequire("inmjk");

var $8WrQo = parcelRequire("8WrQo");




const $c977c2fbc5484638$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $c977c2fbc5484638$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $2FFuS.paragraph)()
            ];
        default:
            return [];
    }
};
const $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$createValidEmptyContent(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $c977c2fbc5484638$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $hbEec.isEmpty)(childNode)) {
                    const result = (0, $eyfm5.listItem)([
                        (0, $2FFuS.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $eyfm5.listItem)([
                    (0, $2FFuS.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $eyfm5.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasNonListItemChildren(node) || $c977c2fbc5484638$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $c977c2fbc5484638$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $8WrQo.tableRow)([
                    (0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $8WrQo.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $hbEec.isEmpty)(childNode)) return (0, $8WrQo.tableRow)([
                    ...new Array(maxColsCount).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0) || undefined;
const $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasEmptyTableRowChildren(node) || $c977c2fbc5484638$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
        return;
    };
const $c977c2fbc5484638$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return false;
        }
        return;
    };
const $c977c2fbc5484638$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        mediaSingle: $c977c2fbc5484638$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        bulletList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




const $8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $8fc0fe8ad0751ae2$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $8fc0fe8ad0751ae2$var$removeCodeMarks(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};



var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $sxTNo = parcelRequire("sxTNo");


var $hpdQE = parcelRequire("hpdQE");


var $juTiU = parcelRequire("juTiU");


var $6aq5c = parcelRequire("6aq5c");

const $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(node);
        if ((0, $dh538.fg)('platform_editor_show_diff_scroll_navigation')) {
            if (isTransformed) {
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
                return {
                    transformedAdf: transformedAdf,
                    isTransformed: isTransformed
                };
            }
        } else if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $c8ab5aa71274e362$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    let { transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    const result = (0, $584b2e64b69fa432$export$dbdec03917c683f4)(schema, transformedAdf);
    if (result.isTransformed && result.transformedAdf) transformedAdf = result.transformedAdf;
    return (0, $5SAOw.Node).fromJSON(schema, transformedAdf);
}
function $c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $5SAOw.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        if ((0, $dh538.fg)('platform_editor_transform_invalid_media_width')) {
            // Fix mediaSingle width issues
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $012dd1aff3a76210$export$abd79dcca4cbaf32)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).MEDIA_SINGLE_WIDTH_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $1c2816ef0c8b7188$export$af4e387303482581)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $c977c2fbc5484638$export$652814b83c30d251)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $c7e8fda47c191e04$export$c06e4b521519af22)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $5b85afc4a4930f06$export$1c8c16d74c7a63bf)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        // Validate ADF first before converting nested-table extensions into nested tables
        // This matches the renderer's behavior in render-document.ts
        const allowNestedTables = (0, $sxTNo.isNestedTablesSupported)(schema);
        const allowTableInPanel = (0, $sxTNo.isPanelNestingTableSupported)(schema);
        const validateADFEntityOptions = allowNestedTables || allowTableInPanel ? {
            allowNestedTables: allowNestedTables || undefined,
            allowTableInPanel: allowTableInPanel || undefined
        } : undefined;
        let entity = (0, $6aq5c.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent, validateADFEntityOptions);
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(entity, dispatchAnalyticsEvent));
        entity = transformedAdf;
        const newEntity = $c8ab5aa71274e362$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $5SAOw.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $juTiU.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $c8ab5aa71274e362$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $5SAOw.Fragment).from(adfEntities);
}
function $c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $c8ab5aa71274e362$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $hpdQE.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};
module.exports["processRawValueWithoutValidation"] = $c8ab5aa71274e362$export$cafe23194e65f591;
module.exports["processRawValue"] = $c8ab5aa71274e362$export$f1a0a61081c3ed62;
module.exports["processRawFragmentValue"] = $c8ab5aa71274e362$export$89b7989c347e6a7b;

});

parcelRegister("inmjk", function(module, exports) {
const $c51384942fa452cc$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });
module.exports["tableCell"] = $c51384942fa452cc$export$e1e720e5f4603e6a;

});

parcelRegister("8WrQo", function(module, exports) {
const $e620d19b8ea2ca65$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });
module.exports["tableRow"] = $e620d19b8ea2ca65$export$ce666bf02318c957;

});

parcelRegister("sxTNo", function(module, exports) {

var $id9O1 = parcelRequire("id9O1");


var $1oCLl = parcelRequire("1oCLl");

const $77ca0e272ecd92cd$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
const $77ca0e272ecd92cd$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
const $77ca0e272ecd92cd$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $id9O1.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};
const $77ca0e272ecd92cd$export$103fe177194b9cb8 = (schema)=>{
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    if (!table || !tableCell || !tableHeader) return false;
    // Check if table cells can contain table nodes by testing their content match
    const tableCellCanContainTable = tableCell.contentMatch.matchType(table)?.validEnd === true;
    const tableHeaderCanContainTable = tableHeader.contentMatch.matchType(table)?.validEnd === true;
    return tableCellCanContainTable || tableHeaderCanContainTable;
};
const $77ca0e272ecd92cd$export$da873e3c90937d2a = (schema)=>{
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    const panelC1CanContainTable = panel_c1.contentMatch.matchType(table)?.validEnd === true;
    return panelC1CanContainTable && (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};
module.exports["getParentOfTypeCount"] = $77ca0e272ecd92cd$export$d5cbd8b17958f08b;
module.exports["getPositionAfterTopParentNodeOfType"] = $77ca0e272ecd92cd$export$ae584b8f0be37f04;
module.exports["isSelectionTableNestedInTable"] = $77ca0e272ecd92cd$export$3dd46fa6c35aa514;
module.exports["isNestedTablesSupported"] = $77ca0e272ecd92cd$export$103fe177194b9cb8;
module.exports["isPanelNestingTableSupported"] = $77ca0e272ecd92cd$export$da873e3c90937d2a;

});

parcelRegister("id9O1", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $LmqWp = parcelRequire("LmqWp");

const $3161ce52b09cb4d1$export$1ae6a0a4f7784fc4 = (selection)=>(0, $8m4tT.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $3161ce52b09cb4d1$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $8m4tT.findParentNodeClosestToPos)($pos, predicate);
};
const $3161ce52b09cb4d1$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $8m4tT.findParentNodeClosestToPos)($pos, predicate);
};
const $3161ce52b09cb4d1$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $3161ce52b09cb4d1$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $3161ce52b09cb4d1$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};
module.exports["findTable"] = $3161ce52b09cb4d1$export$1ae6a0a4f7784fc4;
module.exports["findTableClosestToPos"] = $3161ce52b09cb4d1$export$9323c80f9a3e899f;
module.exports["findCellClosestToPos"] = $3161ce52b09cb4d1$export$3ac56532a0bf4018;
module.exports["findCellRectClosestToPos"] = $3161ce52b09cb4d1$export$68680ae223aebfa7;

});

parcelRegister("hpdQE", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $bqMS3 = parcelRequire("bqMS3");

function $5dc3e3095b1b3f43$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $bqMS3.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}
module.exports["sanitizeNodeForPrivacy"] = $5dc3e3095b1b3f43$export$8a32f625580e0a06;

});

parcelRegister("auTg8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f19f4e00be795c13$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $jZrBc = parcelRequire("jZrBc");


var $fswVK = parcelRequire("fswVK");

const $f19f4e00be795c13$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
class $f19f4e00be795c13$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jZrBc.EditorContext).Provider, {
            value: this.contextValue
        }, this.props.children);
    }
    constructor(props){
        super(props);
        this.editorActions = void 0;
        this.contextValue = void 0;
        this.editorActions = props.editorActions || new (0, $fswVK.default)();
        this.contextValue = {
            editorActions: this.editorActions
        };
    }
}
var $f19f4e00be795c13$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f19f4e00be795c13$export$797df872f5526664, {
        editorActions: props.editorActions
    }, props.children);
module.exports["useEditorContext"] = $f19f4e00be795c13$export$b119c82498f162a5;

});

parcelRegister("jZrBc", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ff30c9f22b7e82bd$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["EditorContext"] = $ff30c9f22b7e82bd$export$27b8dd149e32f6c7;

});

parcelRegister("6DQRK", function(module, exports) {

var $9ciHB = parcelRequire("9ciHB");

function $157ce49029366e0b$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $157ce49029366e0b$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $157ce49029366e0b$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $157ce49029366e0b$var$getSpellCheck(featureFlags)
    };
}
module.exports["createFeatureFlagsFromProps"] = $157ce49029366e0b$export$63102b0cbe181144;

});

parcelRegister("7lreV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a614873fe7dde33$export$2e2bcd8739ae039);
var $2a614873fe7dde33$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("75KVc", function(module, exports) {
const $23e0513e23b2d5c1$export$a8ff84c12d48cfa6 = "platform-pkg";
const $23e0513e23b2d5c1$export$83d89fbfd8236492 = "0.0.0-use.local";
module.exports["name"] = $23e0513e23b2d5c1$export$a8ff84c12d48cfa6;
module.exports["version"] = $23e0513e23b2d5c1$export$83d89fbfd8236492;

});

parcelRegister("56Wjx", function(module, exports) {
const $34f2b048c002519b$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $34f2b048c002519b$var$shortHash(type, isMark) {
    const code = $34f2b048c002519b$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $34f2b048c002519b$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$34f2b048c002519b$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$34f2b048c002519b$var$compactStringifier(node)).join(',');
    return marks(`${$34f2b048c002519b$var$shortHash(node.type, false)}(${content})`);
}
const $34f2b048c002519b$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $34f2b048c002519b$var$getBlockNode(doc, 0);
        if (options?.compact) return $34f2b048c002519b$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $34f2b048c002519b$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $34f2b048c002519b$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $34f2b048c002519b$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $34f2b048c002519b$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $34f2b048c002519b$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $34f2b048c002519b$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $34f2b048c002519b$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $34f2b048c002519b$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $34f2b048c002519b$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);
module.exports["getDocStructure"] = $34f2b048c002519b$export$6451b72139862cbd;

});

parcelRegister("bn5lP", function(module, exports) {
$parcel$export(module.exports, "default", () => $024596570cb688e3$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");

var $e2wMq = parcelRequire("e2wMq");


var $eTj7Y = parcelRequire("eTj7Y");


var $5vVM5 = parcelRequire("5vVM5");


var $9HtP4 = parcelRequire("9HtP4");

var $7541v = parcelRequire("7541v");


var $aAn37 = parcelRequire("aAn37");


var $92LVN = parcelRequire("92LVN");


var $9ciHB = parcelRequire("9ciHB");


var $jz9wK = parcelRequire("jz9wK");


var $8pwxt = parcelRequire("8pwxt");




const $09aa0f0eb93c969d$var$profileSSROperationImpl = (segmentName, fn, onSSRMeasure)=>{
    if (!onSSRMeasure) return fn();
    const startTimestamp = performance.now();
    try {
        return fn();
    } finally{
        onSSRMeasure({
            segmentName: segmentName,
            startTimestamp: startTimestamp,
            endTimestamp: performance.now()
        });
    }
};
const $09aa0f0eb93c969d$var$profileSSROperationNoOp = (_segmentName, fn, _onSSRMeasure)=>{
    return fn();
};
const $09aa0f0eb93c969d$export$69bfe89b2a668d26 = (0, $eTj7Y.isSSR)() ? $09aa0f0eb93c969d$var$profileSSROperationImpl : $09aa0f0eb93c969d$var$profileSSROperationNoOp;


var $lnATY = parcelRequire("lnATY");


var $a4TK8 = parcelRequire("a4TK8");


var $8Yfbq = parcelRequire("8Yfbq");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $b7atO = parcelRequire("b7atO");


var $6tl2G = parcelRequire("6tl2G");


var $gmyMu = parcelRequire("gmyMu");


var $ks2lK = parcelRequire("ks2lK");


var $1S4f7 = parcelRequire("1S4f7");

const $51c318c1c6cb814b$export$c701b355a31b2a13 = new (0, $ks2lK.PluginKey)('appearancePlugin');
const $51c318c1c6cb814b$var$DEFAULT_APPEARANCE = 'comment';
function $51c318c1c6cb814b$export$8eb39c7592eeb788(initialAppearance) {
    return new (0, $1S4f7.SafePlugin)({
        key: $51c318c1c6cb814b$export$c701b355a31b2a13,
        state: {
            init: ()=>({
                    appearance: initialAppearance ?? $51c318c1c6cb814b$var$DEFAULT_APPEARANCE
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($51c318c1c6cb814b$export$c701b355a31b2a13);
                if (meta?.appearance !== undefined) return {
                    ...pluginState,
                    appearance: meta.appearance
                };
                return pluginState;
            }
        }
    });
}



var $h9yJL = parcelRequire("h9yJL");







const $c623ea262c2cbc76$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $c623ea262c2cbc76$export$54fd2c36b5cc6731(node) {
    return $c623ea262c2cbc76$var$transformer.encode(node);
}
function $c623ea262c2cbc76$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const delayedCallbacks = [];
    const wrapperFn = (...args)=>{
        const lastArgsBefore = lastArgs;
        lastArgs = args;
        if (frameId) {
            if (lastArgsBefore) {
                const [_v, _c, _t, _f, alwaysFire] = lastArgsBefore;
                if (alwaysFire) delayedCallbacks.push(lastArgsBefore);
            }
            return;
        }
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) {
                delayedCallbacks.forEach((savedArgs)=>{
                    callback(...savedArgs);
                });
                callback(...lastArgs);
            }
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $c623ea262c2cbc76$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $c623ea262c2cbc76$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $5SAOw.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}
function $c623ea262c2cbc76$export$840661c1d4051b37(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    try {
        return $c623ea262c2cbc76$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire);
    } catch  {
        callback(undefined);
    }
}


const $9e9cac93742fed46$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $c623ea262c2cbc76$export$6a1dd68d75badcc7)((0, $c623ea262c2cbc76$export$dce79649e5264171));
    const scheduleDocumentRequestNoThrowError = (0, $c623ea262c2cbc76$export$6a1dd68d75badcc7)((0, $c623ea262c2cbc76$export$840661c1d4051b37));
    return {
        name: 'core',
        getSharedState (state) {
            const pluginState = state && (0, $51c318c1c6cb814b$export$c701b355a31b2a13).getState(state);
            return {
                schema: state?.schema,
                appearance: (0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true) ? pluginState?.appearance : undefined
            };
        },
        pmPlugins () {
            if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) return [
                {
                    name: 'appearancePlugin',
                    plugin: ()=>(0, $51c318c1c6cb814b$export$8eb39c7592eeb788)(config?.appearance)
                }
            ];
            return [];
        },
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $gmyMu.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            updateAppearance: (newAppearance)=>{
                if (!(0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) return false;
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                // Avoid dispatching a redundant transaction if appearance hasn't changed
                const currentAppearance = (0, $51c318c1c6cb814b$export$c701b355a31b2a13).getState(editorView.state)?.appearance;
                if (currentAppearance === newAppearance) return false;
                const tr = editorView.state.tr.setMeta((0, $51c318c1c6cb814b$export$c701b355a31b2a13), {
                    appearance: newAppearance
                });
                tr.setMeta('addToHistory', false);
                editorView.dispatch(tr);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $6tl2G.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $6tl2G.processRawFragmentValue)(schema, replaceValue, undefined, undefined, options?.transformer) : (0, $6tl2G.processRawValue)(schema, replaceValue, undefined, undefined, options?.transformer);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (content instanceof (0, $5SAOw.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) tr.setMeta('replaceDocument', true);
                    if (options?.addToHistory === false) tr.setMeta('addToHistory', false);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr.setMeta('scrollIntoView', false));
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent, options?.alwaysFire);
            },
            requestDocumentAsync: (options)=>{
                return new Promise((resolve)=>{
                    const view = config?.getEditorView() ?? null;
                    scheduleDocumentRequestNoThrowError(view, (doc)=>{
                        resolve(doc);
                    }, options?.transformer, config?.fireAnalyticsEvent, true);
                });
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            },
            getAnchorIdForNode (node, pos) {
                const view = config?.getEditorView() ?? null;
                if (!view) return undefined;
                const nodeIdProvider = (0, $b7atO.getNodeIdProvider)(view);
                const cachedId = nodeIdProvider.getIdForNode(node);
                if (cachedId) return cachedId;
                if (pos < 0) return undefined;
                // Check DOM first to avoid generating a new ID with a collision suffix
                // when the DOM already has a valid anchor. This prevents misalignment
                // of drag handles on first focus after clicking from the title.
                const nodeDOM = view.nodeDOM(pos);
                if (nodeDOM instanceof HTMLElement) {
                    const domAnchor = nodeDOM.getAttribute('data-node-anchor');
                    if (domAnchor) {
                        // Cache the DOM anchor for this node to maintain consistency
                        // This ensures subsequent calls return the same anchor
                        nodeIdProvider.setIdForNode(node, domAnchor);
                        return domAnchor;
                    }
                }
                // Only generate a new ID if DOM doesn't have one
                const generatedId = nodeIdProvider.getOrGenerateId(node, pos);
                if (generatedId) return generatedId;
                return undefined;
            }
        }
    };
};


function $a71d406c80bedd2b$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $a71d406c80bedd2b$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $a71d406c80bedd2b$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $a71d406c80bedd2b$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $a71d406c80bedd2b$var$hasGetSharedState(plugin));
const $a71d406c80bedd2b$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$a71d406c80bedd2b$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $a71d406c80bedd2b$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $a71d406c80bedd2b$export$855252f33d470a3f {
}
class $a71d406c80bedd2b$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$export$da7528f3fb233b4a {
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (_sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$a71d406c80bedd2b$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    // Drop every listener and pending update for a plugin that is no longer
    // registered. Without this, callbacks (and their captured closures) for
    // evicted plugins would linger in `listeners` until destroy(), and every
    // transaction would still walk their keys via filterPluginsWithListeners.
    removePluginListeners(pluginName) {
        this.listeners.delete(pluginName);
        this.updatesToNotifyQueue.delete(pluginName);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $a71d406c80bedd2b$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $a71d406c80bedd2b$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $a71d406c80bedd2b$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
    constructor({ getEditorState: getEditorState }){
        this.getEditorState = void 0;
        this.listeners = void 0;
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
}
const $a71d406c80bedd2b$var$editorAPICache = new WeakMap();
class $a71d406c80bedd2b$export$50ccbedb1c6559a0 {
    /**
   * Returns PM plugins from internally-registered plugins (e.g. the core plugin)
   * that are not processed through the normal preset builder flow.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getInternalPMPlugins() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = [];
        const corePlugin = this.plugins.get('core');
        if (corePlugin && typeof corePlugin.pmPlugins === 'function') {
            const pmPlugins = corePlugin.pmPlugins();
            if (pmPlugins) result.push(...pmPlugins);
        }
        return result;
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, _receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$a71d406c80bedd2b$var$editorAPICache.get(this)) $a71d406c80bedd2b$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $a71d406c80bedd2b$var$editorAPICache.get(this);
    }
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent, appearance: appearance }){
        this.sharedStateAPI = void 0;
        this.actionsAPI = void 0;
        this.commandsAPI = void 0;
        this.plugins = void 0;
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        // Internal cleanup helper used by ReactEditorView's reconfigureState to
        // reconcile the registered plugin set with the current preset. Removes
        // every registered plugin not in `keptPluginNames`; `core` is always
        // preserved. Returns the names that were removed. Intentionally not on
        // PluginInjectionAPIDefinition: this is an editor-internal control, not
        // part of the injection-API contract that plugins or external consumers
        // depend on.
        this.retainPlugins = (keptPluginNames)=>{
            const evicted = [];
            for (const name of this.plugins.keys())if (name !== 'core' && !keptPluginNames.has(name)) evicted.push(name);
            for (const name of evicted){
                this.plugins.delete(name);
                this.sharedStateAPI.removePluginListeners(name);
            }
            return evicted;
        };
        // Internal: snapshot the names of currently-registered plugins. Used by
        // reconfigureState to capture the previous plugin set before the new
        // preset registers its own plugins via onEditorPluginInitialized.
        this.getRegisteredPluginNames = ()=>Array.from(this.plugins.keys());
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $a71d406c80bedd2b$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $a71d406c80bedd2b$var$ActionsAPI();
        this.commandsAPI = new $a71d406c80bedd2b$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $9e9cac93742fed46$export$71ab138dd170c35)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent,
                appearance: appearance
            }
        }));
    }
}






var $40aJG = parcelRequire("40aJG");


var $lWghV = parcelRequire("lWghV");


var $2pjJ5 = parcelRequire("2pjJ5");








var $ftzrq = parcelRequire("ftzrq");

















var $4FxUL = parcelRequire("4FxUL");







const $483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/editorSSRRenderer';
/**
 * A lightweight EditorView implementation for SSR environments.
 *
 * It's kind of aggressive right now, we need to test and see how it works.
 * Probably, we will need to implement more methods/properties in the future.
 *
 * If it doesn't work, we can extend `EditorView` directly instead of implementing `Partial<EditorView>`,
 * but it will perform some DOM operation during the construction.
 */ class $483adb45b74576fd$var$SSREditorView {
    update() {
    // No-op in SSR
    }
    setProps() {
    // No-op in SSR
    }
    dispatchEvent() {
    // No-op in SSR
    }
    dispatch() {
    // No-op in SSR
    }
    hasFocus() {
        return false;
    }
    focus() {
    // No-op in SSR
    }
    updateRoot() {
    // No-op in SSR
    }
    posAtCoords() {
        return null;
    }
    coordsAtPos() {
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
    }
    domAtPos() {
        return {
            node: this.root,
            offset: 0
        };
    }
    nodeDOM() {
        return null;
    }
    posAtDOM() {
        return 0;
    }
    endOfTextblock() {
        return false;
    }
    pasteHTML() {
        return false;
    }
    pasteText() {
        return false;
    }
    destroy() {
    // No-op in SSR
    }
    updateState() {
    // No-op in SSR
    }
    someProp() {
        return undefined;
    }
    serializeForClipboard(slice) {
        // No-op in SSR - clipboard operations are not supported
        return {
            dom: document.createElement('div'),
            text: '',
            slice: slice
        };
    }
    constructor(place, props){
        this.state = void 0;
        this.dom = void 0;
        this.editable = void 0;
        this.dragging = void 0;
        this.composing = void 0;
        this.props = void 0;
        this.root = void 0;
        this.isDestroyed = void 0;
        this.state = props.state;
        this.dom = document.createElement('div');
        this.editable = true;
        this.dragging = null;
        this.composing = false;
        this.props = props;
        this.root = document;
        this.isDestroyed = false;
    }
}
class $483adb45b74576fd$var$SSREventDispatcher extends (0, $5vVM5.EventDispatcher) {
    emit() {
    // Don't notify about events in SSR
    }
}
function $483adb45b74576fd$export$8d417ec112d5c31c({ plugins: plugins, schema: schema, doc: doc, portalProviderAPI: portalProviderAPI, intl: intl, onSSRMeasure: onSSRMeasure, onEditorStateChanged: onEditorStateChanged, ...divProps }) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $42omo.useRef)(performance.now());
    // PMPluginFactoryParams use `getIntl` function to get current intl instance,
    // so we don't need to add `intl` as a dependency to `useMemo`.
    // We will store intl in ref and access to it dynamically in `getIntl` function call.
    const intlRef = (0, $42omo.useRef)(intl);
    intlRef.current = intl;
    const pmPlugins = (0, $42omo.useMemo)(()=>{
        const createPMPlugins = ()=>{
            const eventDispatcher = new $483adb45b74576fd$var$SSREventDispatcher();
            const providerFactory = new (0, $4FxUL.default)();
            const pmPluginFactoryParams = {
                dispatch: (0, $5vVM5.createDispatch)(eventDispatcher),
                dispatchAnalyticsEvent: ()=>{},
                eventDispatcher: eventDispatcher,
                featureFlags: {},
                getIntl: ()=>intlRef.current,
                nodeViewPortalProviderAPI: portalProviderAPI,
                portalProviderAPI: portalProviderAPI,
                providerFactory: providerFactory,
                schema: schema
            };
            return plugins.reduce((acc, editorPlugin)=>{
                editorPlugin.pmPlugins?.().forEach(({ plugin: plugin })=>{
                    try {
                        const pmPlugin = plugin(pmPluginFactoryParams);
                        if (pmPlugin) acc.push(pmPlugin);
                    } catch (error) {
                        if ("production" !== 'production') // eslint-disable-next-line no-console
                        console.warn(`[EditorSSR] Failed to create PM plugin (${plugin?.name}) during SSR. This plugin will be skipped.`, error);
                    }
                });
                return acc;
            }, []);
        };
        return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/createPMPlugins`, createPMPlugins, onSSRMeasure);
    }, [
        plugins,
        portalProviderAPI,
        schema,
        onSSRMeasure
    ]);
    const nodeViews = (0, $42omo.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.nodeViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const markViews = (0, $42omo.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.markViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const editorState = (0, $42omo.useMemo)(()=>{
        const createEditorState = ()=>{
            return (0, $ks2lK.EditorState).create({
                doc: doc,
                schema: schema,
                plugins: pmPlugins
            });
        };
        return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/createEditorState`, createEditorState, onSSRMeasure);
    }, [
        doc,
        pmPlugins,
        schema,
        onSSRMeasure
    ]);
    // In React 19 could be replaced by `useEffectEvent` hook.
    const onEditorStateChangedRef = (0, $42omo.useRef)(onEditorStateChanged);
    onEditorStateChangedRef.current = onEditorStateChanged;
    (0, $42omo.useLayoutEffect)(()=>{
        onEditorStateChangedRef.current?.(editorState);
    }, [
        editorState
    ]);
    const editorView = (0, $42omo.useMemo)(()=>{
        return new $483adb45b74576fd$var$SSREditorView(null, {
            state: editorState
        });
    }, [
        editorState
    ]);
    const { serializer: serializer, nodePositions: nodePositions } = (0, $42omo.useMemo)(()=>{
        const createSerializerAndNodePositions = ()=>{
            const nodePositions = new WeakMap();
            // ProseMirror View adds <br class="ProseMirror-trailingBreak" /> to empty nodes. Because we are using
            // DOMSerializer, we should simulate the same behaviour to get the same HTML document.
            //
            // There are a lot of conditions that check for adding `<br />` but we could implement only the case when we
            // are adding `<br />` to empty texblock, because if we add `<br />` in other cases it will change order of DOM nodes inside
            // this node (`<br />`) will be the first, after will be other nodes. It's because we are adding `<br />` to root node before
            // we are rendering child node.
            //
            // See: https://discuss.prosemirror.net/t/where-can-i-read-about-prosemirror-trailingbreak/6665
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L803
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L1365
            const addTrailingBreakIfNeeded = (node, contentDOM)=>{
                if (contentDOM && node.isTextblock && !node.lastChild) {
                    const br = document.createElement('br');
                    br.classList.add('ProseMirror-trailingBreak');
                    contentDOM.appendChild(br);
                }
            };
            const toDomNodeRenderers = Object.fromEntries(Object.entries(schema.nodes).map(([nodeName, nodeType])=>{
                return [
                    nodeName,
                    nodeType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const toDomMarkRenderers = Object.fromEntries(Object.entries(schema.marks).map(([markName, markType])=>{
                return [
                    markName,
                    markType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const nodeViewRenderers = Object.fromEntries(Object.entries(nodeViews).map(([nodeName, nodeViewFactory])=>{
                return [
                    nodeName,
                    (node)=>{
                        try {
                            const nodeViewInstance = nodeViewFactory(node, editorView, ()=>nodePositions.get(node) ?? 0, [], (0, $ftzrq.DecorationSet).create(node, []));
                            addTrailingBreakIfNeeded(node, nodeViewInstance.contentDOM);
                            return {
                                dom: nodeViewInstance.dom,
                                // Leaf nodes have no content, ProseMirror will throw an error if we pass contentDOM
                                contentDOM: node.isLeaf ? undefined : nodeViewInstance.contentDOM
                            };
                        } catch (error) {
                            // Fall back to schema-level toDOM for this node
                            const toDOM = schema.nodes[nodeName]?.spec.toDOM;
                            if (toDOM) return (0, $5SAOw.DOMSerializer).renderSpec(document, toDOM(node));
                            // Last resort: empty div
                            return {
                                dom: document.createElement('div')
                            };
                        }
                    }
                ];
            }));
            // Create renderers for textblock nodes that don't have custom NodeViews (e.g. paragraph, heading)
            const textblockRenderers = Object.fromEntries(Object.entries(schema.nodes).filter(([nodeName, nodeType])=>{
                // Only handle textblock nodes
                return nodeType.spec.toDOM && nodeType.isTextblock && !nodeViews[nodeName];
            }).map(([nodeName, nodeType])=>{
                const toDOM = nodeType.spec.toDOM;
                if (!toDOM) return [
                    nodeName,
                    undefined
                ];
                return [
                    nodeName,
                    (node)=>{
                        if (!node.lastChild) {
                            const result = (0, $5SAOw.DOMSerializer).renderSpec(document, toDOM(node));
                            addTrailingBreakIfNeeded(node, result.contentDOM);
                            return result;
                        }
                        return toDOM(node);
                    }
                ];
            }).filter(([, renderer])=>!!renderer));
            const markViewRenderers = Object.fromEntries(Object.entries(markViews).map(([markName, markViewFactory])=>{
                return [
                    markName,
                    (mark)=>{
                        const markViewInstance = markViewFactory(mark, editorView, false);
                        return {
                            dom: markViewInstance.dom,
                            contentDOM: markViewInstance.contentDOM
                        };
                    }
                ];
            }));
            const serializer = new (0, $5SAOw.DOMSerializer)({
                ...toDomNodeRenderers,
                ...textblockRenderers,
                ...nodeViewRenderers,
                text: $483adb45b74576fd$var$renderText
            }, {
                ...toDomMarkRenderers,
                ...markViewRenderers
            });
            return {
                serializer: serializer,
                nodePositions: nodePositions
            };
        };
        return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/createSerializerAndNodePositions`, createSerializerAndNodePositions, onSSRMeasure);
    }, [
        editorView,
        markViews,
        nodeViews,
        schema.marks,
        schema.nodes,
        onSSRMeasure
    ]);
    const editorHTML = (0, $42omo.useMemo)(()=>{
        const serializeFragment = ()=>{
            if (!doc) return undefined;
            doc.descendants((node, pos)=>{
                nodePositions.set(node, pos);
            });
            if ((0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) {
                const fragment = serializer.serializeFragment(doc.content);
                const wrapper = document.createElement('div');
                wrapper.appendChild(fragment);
                return wrapper.innerHTML;
            } else return serializer.serializeFragment(doc.content);
        };
        try {
            return (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME}/serializeFragment`, serializeFragment, onSSRMeasure);
        } catch (error) {
            return undefined;
        }
    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-usememo-deps -- Ignored via go/ees017 (to be fixed)
    }, [
        doc,
        serializer,
        nodePositions,
        onSSRMeasure
    ]);
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) {
            if (containerRef.current && editorHTML && typeof editorHTML !== 'string') {
                containerRef.current.innerHTML = '';
                containerRef.current.appendChild(editorHTML);
            }
        }
    }, [
        editorHTML
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lnATY.SSRRenderMeasure), {
        segmentName: $483adb45b74576fd$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        id: divProps.id,
        // eslint-disable-next-line react/no-danger -- It's intentional by design
        dangerouslySetInnerHTML: typeof editorHTML === 'string' && (0, $1oCLl.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? {
            __html: editorHTML
        } : undefined,
        // For some reason on SSR, the result `class` has a trailing space, that broke UFO,
        // because ReactEditorView produces a div with `class` without space.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: divProps.className.trim(),
        "aria-label": divProps['aria-label'],
        "aria-describedby": divProps['aria-describedby'],
        "data-editor-id": divProps['data-editor-id'],
        "data-vc-ignore-if-no-layout-shift": true,
        "data-ssr-placeholder": "editor-view",
        "data-ssr-placeholder-replace": "editor-view",
        "aria-multiline": true,
        role: "textbox",
        // @ts-expect-error - contenteditable is not exist in div attributes
        contenteditable: "true",
        "data-gramm": "false",
        translate: "no"
    }));
}
function $483adb45b74576fd$var$renderText(node) {
    return node.text || '';
}



var $dh538 = parcelRequire("dh538");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");





var $dZ8uq = parcelRequire("dZ8uq");




const $9dc7d15a9979d8e6$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $42omo.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};



var $6DQRK = parcelRequire("6DQRK");


var $hEPfr = parcelRequire("hEPfr");

function $873158ef753fe251$export$af7be2186992199(node) {
    const nodes = {};
    const extensionKeys = {};
    const extensionNodeNames = [
        'extension',
        'bodiedExtension',
        'inlineExtension',
        'multiBodiedExtension'
    ];
    node.nodesBetween(0, node.nodeSize - 2, (currentNode)=>{
        nodes[currentNode.type.name] = (nodes[currentNode.type.name] || 0) + 1;
        if (!extensionNodeNames.includes(currentNode.type.name)) return;
        const extensionKey = currentNode.attrs?.extensionKey;
        if (!extensionKey) return;
        extensionKeys[extensionKey] = (extensionKeys[extensionKey] || 0) + 1;
    });
    return {
        nodes: nodes,
        extensionKeys: extensionKeys
    };
}


/**
 * Check if a DOM element is visible within the viewport. We deem a node visible if the top left corner coordinate is within the viewport.
 * This may not look visible, and may include a node that looks below the fold – but it's more than 0 pixels within the viewport.
 */ const $668f6e52ed8ba3c9$export$9c8a351faafa8fbb = (node)=>{
    const rect = node.getBoundingClientRect();
    const isVisible = rect.x >= 0 && rect.x < window.innerWidth && rect.y >= 0 && rect.y < window.innerHeight;
    return isVisible;
};
const $668f6e52ed8ba3c9$export$f20e3cf045904cb = (editorDom)=>{
    const MAX_NODES_TO_COUNT = 200;
    const pmNodesList = editorDom.querySelectorAll('[data-prosemirror-node-name]');
    const nodesTypeCounter = {};
    for(let i = 0; i < Math.min(MAX_NODES_TO_COUNT, pmNodesList.length); i++){
        const node = pmNodesList[i];
        const type = node.getAttribute('data-prosemirror-node-name');
        // No valid prosemirrornode type, skip.
        if (!type) continue;
        const isVisible = $668f6e52ed8ba3c9$export$9c8a351faafa8fbb(node);
        // Not a visible node, end counting.
        if (!isVisible) break;
        nodesTypeCounter[type] = (nodesTypeCounter[type] || 0) + 1;
    }
    return nodesTypeCounter;
};


function $0085cb30af154789$export$73ae01d857526945(appearance) {
    return appearance === 'chromeless';
}



var $geLSP = parcelRequire("geLSP");


var $2oRGU = parcelRequire("2oRGU");


var $7lreV = parcelRequire("7lreV");

const $769e182f77e7bc85$export$646a6982857f2cd5 = 2000;
const $769e182f77e7bc85$export$79d7eac6cbb6352d = 3000;
const $769e182f77e7bc85$export$7d7bd496a5206996 = 100;



var $dSVmA = parcelRequire("dSVmA");


var $2oGxU = parcelRequire("2oGxU");
















const $4c2f9c6d3992052f$var$injectNodeViewNodeTypeList = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'rule',
    'decisionList',
    'taskList',
    'layoutColumn',
    'hardBreak'
];
const $4c2f9c6d3992052f$var$injectNodeViewNodeTypeConditionalList = [
    ...$4c2f9c6d3992052f$var$injectNodeViewNodeTypeList,
    // nodes that have custom nodeView behind experiment/FG
    'layoutSection'
];
const $4c2f9c6d3992052f$var$key = new (0, $ks2lK.PluginKey)('editorNativeAnchorSupportPlugin');
const $4c2f9c6d3992052f$export$dc8df63091e87b7a = (schema)=>{
    const nodeViewEntries = [];
    const injectList = (0, $1oCLl.expValEquals)('advanced_layouts', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? $4c2f9c6d3992052f$var$injectNodeViewNodeTypeList : $4c2f9c6d3992052f$var$injectNodeViewNodeTypeConditionalList;
    schema.spec.nodes.forEach((nodeName, nodeSpec)=>{
        if (injectList.includes(nodeName)) {
            if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
                const toDOM = nodeSpec.toDOM.bind(nodeSpec);
                nodeViewEntries.push([
                    nodeName,
                    (node)=>(0, $5SAOw.DOMSerializer).renderSpec(document, toDOM(node))
                ]);
            }
        }
    });
    return new (0, $1S4f7.SafePlugin)({
        key: $4c2f9c6d3992052f$var$key,
        props: {
            nodeViews: Object.fromEntries(nodeViewEntries)
        }
    });
};








const $0857bd5143cc04f2$var$key = new (0, $ks2lK.PluginKey)('editorStateNotificationPlugin');
const $0857bd5143cc04f2$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    const transactions = [];
    return new (0, $1S4f7.SafePlugin)({
        key: $0857bd5143cc04f2$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};


function $5b9727cf4df72475$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $5b9727cf4df72475$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $5b9727cf4df72475$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) {
            // Wrap with .bind(null) so we can annotate the function with the
            // plugin name without mutating the plugin's original hook reference.
            // MountPluginHooks reads `pluginName` to derive a stable React key.
            const named = plugin.usePluginHook.bind(null);
            named.pluginName = plugin.name;
            acc.pluginHooks.push(named);
        }
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $5b9727cf4df72475$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $2oGxU.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) pmPlugins.push((0, $4c2f9c6d3992052f$export$dc8df63091e87b7a)(config.schema));
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $0857bd5143cc04f2$export$e0355cecc74597d)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $5b9727cf4df72475$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $dSVmA.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}



var $1B55v = parcelRequire("1B55v");


var $9vHt3 = parcelRequire("9vHt3");





var $6VsTy = parcelRequire("6VsTy");





const $083bb79fcbe2f990$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $6VsTy.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $083bb79fcbe2f990$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $083bb79fcbe2f990$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $083bb79fcbe2f990$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $083bb79fcbe2f990$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $083bb79fcbe2f990$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $5b9727cf4df72475$export$ef6c09ff452189fa)(editorConfig.marks.sort((0, $2oGxU.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $9vHt3.sanitizeNodes)(editorConfig.nodes.sort((0, $2oGxU.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $5SAOw.Schema)({
        nodes: nodes,
        marks: marks
    });
}


function $d09f526acbee3ca1$export$1a7fe7567929e9de(editorPlugins, schema, previousPluginNames) {
    const availableNodeNames = new Set(Object.keys(schema.nodes));
    const availableMarkNames = new Set(Object.keys(schema.marks));
    const dropped = [];
    const kept = editorPlugins.filter((plugin)=>{
        if (!plugin) return false;
        if (previousPluginNames.has(plugin.name)) return true;
        const missingNodes = plugin.nodes ? plugin.nodes().map((n)=>n.name).filter((n)=>!availableNodeNames.has(n)) : [];
        const missingMarks = plugin.marks ? plugin.marks().map((m)=>m.name).filter((m)=>!availableMarkNames.has(m)) : [];
        if (missingNodes.length > 0 || missingMarks.length > 0) {
            dropped.push({
                name: plugin.name,
                missingNodes: missingNodes,
                missingMarks: missingMarks
            });
            return false;
        }
        return true;
    });
    return {
        kept: kept,
        dropped: dropped
    };
}





const $170f814baa647977$export$3b488057bfc1868f = (0, $aXWIB.defineMessages)({
    editorAssistiveLabel: {
        id: "fabric.editor.editorAssistiveLabel",
        defaultMessage: "Main content area, start typing to enter text."
    },
    fullPageEditorAssistiveLabel: {
        id: "fabric.editor.fullPageEditorAssistiveLabel",
        defaultMessage: "Page editing area, start typing to enter text."
    }
});


function $0d3266c92e7feda8$export$32ec9f77297f7957(editorId) {
    const parentElement = document.querySelector(`[data-focus-id="${editorId}"]`);
    if (!(parentElement instanceof HTMLElement)) return;
    parentElement.focus({
        preventScroll: true
    });
}



var $d7ZU3 = parcelRequire("d7ZU3");

function $f1dc1dfba26b7751$export$11a24c7b1b4aab81() {
    const browser = (0, $d7ZU3.getBrowserInfo)();
    if (browser.chrome) return 'ua-chrome';
    else if (browser.ie) return 'ua-ie';
    else if (browser.gecko) return 'ua-firefox';
    else if (browser.safari) return 'ua-safari';
    return '';
}








function $565b25adcfad3caf$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
    // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
    // Bail out in that scenario to prevent operating on an unmounted view.
    if (view?.isDestroyed) return;
    if (!window.getSelection) {
        view?.focus();
        return;
    }
    const domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount === 0) {
        view?.focus();
        return;
    }
    // If not mocked properly in tests, getRangeAt may not exist.
    const range = domSelection.getRangeAt?.(0);
    if (!range) return;
    // if selection is outside editor focus and exit
    try {
        if (view && range?.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
    } catch (error) {
        // If we get a SecurityError-type DOMException here, then we probably just tried to
        // access a cross-origin iframe's contents. In that case, we can ignore the error and
        // just reasonably assume the selection is outside the editor, since we can't access it.
        if (error instanceof DOMException && error.name === 'SecurityError' && (0, $1oCLl.expValEquals)('platform_editor_fix_cross_origin_editor_focus', 'isEnabled', true)) {
            if (view) {
                view.focus();
                return;
            }
        } else // re-throw other unexpected errors
        throw error;
    }
    // set cursor/selection and focus
    const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
    const head = view?.posAtDOM(range.endContainer, range.endOffset);
    // if anchor or head < 0 focus and exit
    if (anchor && anchor < 0 || head && head < 0) {
        view?.focus();
        return;
    }
    if (view && anchor) {
        const selection = (0, $ks2lK.TextSelection).create(view.state.doc, anchor, head);
        const tr = view.state.tr.setSelection(selection);
        view.dispatch(tr);
        view.focus();
    }
}








var $4VpM8 = parcelRequire("4VpM8");


var $h3X17 = parcelRequire("h3X17");


var $56Wjx = parcelRequire("56Wjx");


var $2T4ch = parcelRequire("2T4ch");

const $015e54f1cc15a3ff$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};





const $b985ded6f19ca760$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $b985ded6f19ca760$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $b985ded6f19ca760$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $b985ded6f19ca760$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($b985ded6f19ca760$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};








/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $1d60a1b0507e65ba$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;


const $a17905ab9de46c9b$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $a17905ab9de46c9b$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $a17905ab9de46c9b$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $a17905ab9de46c9b$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $a17905ab9de46c9b$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $a17905ab9de46c9b$export$735da5ee20c885d5 = false;
const $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE = 100;
const $a17905ab9de46c9b$var$noop = ()=>{};
class $a17905ab9de46c9b$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $a17905ab9de46c9b$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $a17905ab9de46c9b$var$noop,
                stopMeasure: $a17905ab9de46c9b$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $2T4ch.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $2T4ch.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $1d60a1b0507e65ba$export$a26b90db2c8f1b97)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}


const $e81162bdf75802d2$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check();
    } catch (error) {
        return false;
    }
    return true;
};
const $e81162bdf75802d2$export$996213f7c272fc6f = (nodes)=>nodes.every($e81162bdf75802d2$export$4c39e41e39b3c449);


const $f260cf531ae15748$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $42omo.useRef)(onChange);
    (0, $42omo.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $42omo.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $015e54f1cc15a3ff$export$cdc577fd3f583194)(unsafeTransaction);
        const changedNodesValid = (0, $e81162bdf75802d2$export$996213f7c272fc6f)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $b985ded6f19ca760$export$668aa008bdae439f)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $h3X17.isDirtyTransaction)(transaction);
                (0, $2T4ch.startMeasure)((0, $a17905ab9de46c9b$export$bb82e7cfb8987f35));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $2T4ch.stopMeasure)((0, $a17905ab9de46c9b$export$bb82e7cfb8987f35));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $e81162bdf75802d2$export$4c39e41e39b3c449)(node)).map((node)=>(0, $56Wjx.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $4VpM8.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};














const $2507994582b7e2f3$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $e2wMq.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $e2wMq.FULL_WIDTH_MODE).FIXED_WIDTH;
};


const $5953f1dbb50e9aa2$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $7541v.default)(appearance);
    (0, $42omo.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $2507994582b7e2f3$export$47d5b79f3ddf0b92)(previousAppearance),
                    newMode: (0, $2507994582b7e2f3$export$47d5b79f3ddf0b92)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};


const $024596570cb688e3$var$EDIT_AREA_ID = 'ak-editor-textarea';
const $024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView';
const $024596570cb688e3$var$bootStartTime = (0, $aAn37.isPerformanceAPIAvailable)() ? performance.now() : undefined;
// `markdown↔rich` toggles drop different node/mark sets, so the unique
// name set is enough to detect when a destructive rebuild is needed.
function $024596570cb688e3$var$sameNames(a, b) {
    const setA = new Set(a);
    const setB = new Set(b);
    if (setA.size !== setB.size) return false;
    for (const name of setA){
        if (!setB.has(name)) return false;
    }
    return true;
}
function $024596570cb688e3$var$schemaShapeChanged(current, next) {
    return !$024596570cb688e3$var$sameNames(Object.keys(current.nodes), next.nodes.map((n)=>n.name)) || !$024596570cb688e3$var$sameNames(Object.keys(current.marks), next.marks.map((m)=>m.name));
}
function $024596570cb688e3$export$e7d1b1cbca007e16(props) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $42omo.useRef)(performance.now());
    const { preset: preset, editorProps: { onSSRMeasure: onSSRMeasure, appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const ssrEditorStateRef = (0, $42omo.useRef)(undefined);
    const editorRef = (0, $42omo.useRef)(null);
    const viewRef = (0, $42omo.useRef)();
    const focusTimeoutId = (0, $42omo.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $42omo.useRef)(true);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const eventDispatcher = (0, $42omo.useMemo)(()=>new (0, $5vVM5.EventDispatcher)(), []);
    const config = (0, $42omo.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $42omo.useRef)(undefined);
    const featureFlags = (0, $42omo.useMemo)(()=>(0, $6DQRK.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $42omo.useCallback)(()=>ssrEditorStateRef.current ?? viewRef.current?.state, []);
    const getEditorView = (0, $42omo.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $42omo.useMemo)(()=>(0, $5vVM5.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $42omo.useMemo)(()=>(0, $5b9727cf4df72475$export$e98521bb0cea2db1)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        (0, $ajtqX.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        const dispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
        dispatch((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $42omo.useRef)(new (0, $a71d406c80bedd2b$export$50ccbedb1c6559a0)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent,
        appearance: nextAppearance
    }));
    const parseDoc = (0, $42omo.useCallback)((schema, api, options)=>{
        if (!options.doc) return undefined;
        // if the collabEdit API is set, skip this validation due to potential pm validation errors
        // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
        if ((0, $eTj7Y.isSSR)() || api?.collabEdit !== undefined || options.props.editorProps.skipValidation) return (0, $6tl2G.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
        else return (0, $6tl2G.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
    }, [
        dispatchAnalyticsEvent
    ]);
    const createEditorState = (0, $42omo.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
         * ReactEditorView currently does NOT handle dynamic schema,
         * We are reusing the existing schema, and rely on #reconfigureState
         * to update `this.config`
         */ schema = viewRef.current.state.schema;
            else {
                /**
         * There's presently a number of issues with changing the schema of a
         * editor inflight. A significant issue is that we lose the ability
         * to keep track of a user's history as the internal plugin state
         * keeps a list of Steps to undo/redo (which are tied to the schema).
         * Without a good way to do work around this, we prevent this for now.
         */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $5b9727cf4df72475$export$7265233e78178a4)((0, $1B55v.default)(options.props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current));
            if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) config.current.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            schema = (0, $083bb79fcbe2f990$export$5f4ce795563f4211)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        const doc = parseDoc(schema, api, options);
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $ks2lK.TextSelection)(doc.resolve(0));
                return (0, $ks2lK.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $ks2lK.Selection).atStart(doc) : (0, $ks2lK.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $ks2lK.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $ks2lK.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        parseDoc,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $42omo.useMemo)(()=>{
        if ((0, $eTj7Y.isSSR)()) // We don't need to create initial state in SSR, it would be done by EditorSSRRenderer,
        // so we can save some CPU time here.
        return undefined;
        return createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $geLSP.isFullPage)(nextAppearance)
        });
    }, // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $42omo.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $42omo.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $42omo.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $9HtP4.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).STARTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $e2wMq.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $9ciHB.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    });
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) return;
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // No cleanup in SSR should happened because SSR doesn't render a real editor.
        return;
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    // Bumped after `reconfigureState` so the render prop re-reads the
    // in-place-mutated `config.current` (contentComponents / toolbar
    // components from the rebuilt preset).
    const [, bumpConfigVersion] = (0, $42omo.useState)(0);
    // Preset reference last processed by reconfigureState. Used to skip the
    // destructive work (plugin filter, schema rebuild) when reconfigure is
    // called with the same preset.
    const lastProcessedPresetRef = (0, $42omo.useRef)(null);
    const reconfigureState = (0, $42omo.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        // Snapshot plugin names registered before createPluginsList runs, so
        // we can tell which plugins are newly added by the new preset vs.
        // which ones already coexisted with the current schema.
        const previousPluginNames = new Set(pluginInjectionAPI.current.getRegisteredPluginNames());
        let editorPlugins = (0, $1B55v.default)(props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current);
        // Capture once, before either downstream block updates the ref —
        // both the filter and the schema rebuild are destructive and only
        // want to run when the preset has actually changed.
        const presetChanged = lastProcessedPresetRef.current !== props.preset;
        // Build a candidate config from the *unfiltered* plugin list so we can
        // decide whether the schema rebuild path will run. Both the rebuild
        // decision and the drop-filter decision below depend on this answer,
        // so it has to be computed up-front.
        const buildConfig = (plugins)=>{
            const c = (0, $5b9727cf4df72475$export$7265233e78178a4)(plugins);
            if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) c.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            return c;
        };
        let nextConfig = buildConfig(editorPlugins);
        // `state.reconfigure` preserves the original schema, so a preset
        // toggle that should change schema (markdown↔rich) needs a fresh
        // `EditorState`. Resets all plugin state including undo history.
        //
        // Compare schema *shape* (node + mark name sets) rather than preset
        // identity: consumers commonly recreate the preset object on every
        // parent re-render, and a destructive rebuild on a no-op identity
        // change tears down all plugin state (e.g. unmounts the AI palette).
        const shouldRebuildSchema = presetChanged && $024596570cb688e3$var$schemaShapeChanged(viewRef.current.state.schema, nextConfig) && (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true);
        // `state.reconfigure` keeps the original schema, so switching presets
        // can leave the editor inconsistent in two ways:
        //   1. The new preset may add plugins that reference schema nodes or
        //      marks the original schema doesn't have.
        //   2. Plugins registered by a previous preset can linger in the
        //      injection API even when the new preset doesn't re-register
        //      them, so listeners still fire against a state that no longer
        //      has their pmPlugin.
        //
        // When the schema is being rebuilt below, the new schema is built
        // from the *unfiltered* plugin list — so dropping plugins whose
        // nodes/marks the OLD schema lacks would wrongly remove the very
        // plugins the rebuild is meant to admit. Skip the drop step in that
        // case (purpose 1) but always reconcile the injection API
        // (purpose 2). When NOT rebuilding, run both — even under the
        // `cc-markdown-mode` experiment, otherwise no-op preset identity
        // changes would silently leave a broken plugin/schema mismatch.
        if (presetChanged && (0, $dh538.fg)('platform_editor_reconfigure_filter_plugins')) {
            let dropped = [];
            if (!shouldRebuildSchema) {
                const result = (0, $d09f526acbee3ca1$export$1a7fe7567929e9de)(editorPlugins, viewRef.current.state.schema, previousPluginNames);
                if (result.dropped.length > 0) {
                    editorPlugins = result.kept;
                    // Plugin list changed — rebuild candidate config to match.
                    nextConfig = buildConfig(editorPlugins);
                }
                dropped = result.dropped;
            }
            const keptPluginNames = new Set(editorPlugins.map((p)=>p?.name).filter((n)=>Boolean(n)));
            const evictedFromApi = pluginInjectionAPI.current.retainPlugins(keptPluginNames);
            if (dropped.length > 0 || evictedFromApi.length > 0) // eslint-disable-next-line no-console
            console.warn('[reconfigureState] Cleanup summary:', {
                dropped: dropped,
                evictedFromApi: evictedFromApi
            });
        }
        config.current = nextConfig;
        const state = viewRef.current.state;
        let newState;
        if (shouldRebuildSchema) {
            const newSchema = (0, $083bb79fcbe2f990$export$5f4ce795563f4211)(config.current);
            let newDoc;
            try {
                newDoc = (0, $5SAOw.Node).fromJSON(newSchema, state.doc.toJSON());
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('[reconfigureState] Failed to migrate doc to new schema; resetting to empty doc', e);
                const empty = newSchema.topNodeType.createAndFill();
                if (!empty) throw new Error('reconfigureState: doc migration failed and new schema cannot create an empty top node');
                newDoc = empty;
            }
            let newSelection;
            try {
                newSelection = (0, $ks2lK.Selection).fromJSON(newDoc, state.selection.toJSON());
            } catch  {
                // Old selection's positions / node types may not map onto the new schema.
                newSelection = (0, $ks2lK.Selection).atStart(newDoc);
            }
            const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
                schema: newSchema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: config.current,
                eventDispatcher: eventDispatcher,
                providerFactory: props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                featureFlags: featureFlags,
                getIntl: ()=>props.intl,
                onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
            });
            newState = (0, $ks2lK.EditorState).create({
                schema: newSchema,
                doc: newDoc,
                selection: newSelection,
                plugins: plugins
            });
        } else {
            const plugins = (0, $5b9727cf4df72475$export$169329cb2979ef81)({
                schema: state.schema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: config.current,
                eventDispatcher: eventDispatcher,
                providerFactory: props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                featureFlags: featureFlags,
                getIntl: ()=>props.intl,
                onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
            });
            newState = state.reconfigure({
                plugins: plugins
            });
        }
        if (presetChanged) lastProcessedPresetRef.current = props.preset;
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        const result = viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
        // The new collab-edit plugin instance starts with `isReady=false`.
        // The rebind path in editor-plugin-collab-edit's initialize.ts is
        // gated on `provider.getInitPayload`, which the Confluence NCS
        // provider does not implement, so the placeholder spinner would
        // never clear. Re-seeding here is safe: the prior state must have
        // had `isReady=true` for the user to have triggered the toggle.
        //
        // Must run AFTER `view.update({ state: newState })`: that call resets
        // the view's state to the captured `newState` reference, so a
        // dispatch placed before it would advance `view.state` to a value
        // that `update` then silently overwrites — discarding the meta and
        // leaving `isReady=false`.
        if (shouldRebuildSchema) {
            // `state.collabEditPlugin$` is the property PM derives from the
            // collab plugin's PluginKey; cast through `unknown` to read it.
            const collabState = viewRef.current.state.collabEditPlugin$;
            if (collabState && collabState.isReady !== true) viewRef.current.dispatch(viewRef.current.state.tr.setMeta('collabInitialised', true));
        }
        // EDITOR-6702: gated until we have a broader gate; reconfigure is a
        // low-level path so use NoExposure.
        if ((0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true)) // Force a render so PluginSlot picks up the new preset's content
        // components against the new state.
        bumpConfigVersion((v)=>v + 1);
        return result;
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $42omo.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $f260cf531ae15748$export$b582387940572fe7)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $9dc7d15a9979d8e6$export$e4c19534640d7866)({
        editorApi: pluginInjectionAPI.current.api(),
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $42omo.useCallback)((state)=>{
        const stateToUse = state ?? getCurrentEditorState();
        if (!stateToUse) // This should not be happened, because initialState is only inavailable in SSR,
        // but in SSR this function should never be called.
        // In SSR we should use EditorSSRRenderer instead usual ProseMirror editor.
        throw new Error('No editor state found');
        return {
            state: stateToUse,
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $42omo.useCallback)((node)=>{
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $ftzrq.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        (0, $jz9wK.measureRender)((0, $7lreV.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $lWghV.getAnalyticsEventSeverity)(duration, (0, $769e182f77e7bc85$export$646a6982857f2cd5), (0, $769e182f77e7bc85$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodesAndExtensionKeys = (0, $1oCLl.expValEquals)('platform_editor_prosemirror_rendered_data', 'isEnabled', true) ? (0, $873158ef753fe251$export$af7be2186992199)(viewRef.current.state.doc) : undefined;
                const nodes = nodesAndExtensionKeys?.nodes ?? (0, $hEPfr.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $8pwxt.getResponseEndTime)();
                const requestToResponseTime = (0, $8pwxt.getRequestToResponseTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                const nodesInViewport = (0, $668f6e52ed8ba3c9$export$f20e3cf045904cb)(viewRef.current.dom);
                const nodeSize = viewRef.current.state.doc.nodeSize;
                const { totalNodes: totalNodes, nodeSizeBucket: nodeSizeBucket } = (0, $1oCLl.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true) ? {
                    totalNodes: Object.values(nodes).reduce((acc, curr)=>acc + curr, 0),
                    // Computed on client for dimension bucketing in Statsig
                    nodeSizeBucket: (()=>{
                        switch(true){
                            case nodeSize < 10000:
                                return '<10000';
                            case nodeSize < 20000:
                                return '<20000';
                            case nodeSize < 30000:
                                return '<30000';
                            case nodeSize < 40000:
                                return '<40000';
                            case nodeSize < 50000:
                                return '<50000';
                            default:
                                return '50000+';
                        }
                    })()
                } : {};
                if ((0, $1oCLl.expValEquals)('platform_editor_prosemirror_rendered_data', 'isEnabled', true)) {
                    const extensionKeys = nodesAndExtensionKeys?.extensionKeys ?? {};
                    const interaction = (0, $4u5NT.getActiveInteraction)();
                    const pageLoadType = interaction?.type;
                    const pageType = interaction?.routeName;
                    const timings = (()=>{
                        if (requestToResponseTime === undefined && $024596570cb688e3$var$bootStartTime === undefined) return undefined;
                        const timingValues = {};
                        if (requestToResponseTime !== undefined) timingValues['requestStart->responseEnd'] = Math.round(requestToResponseTime);
                        if ($024596570cb688e3$var$bootStartTime !== undefined) timingValues.bootToRender = Math.round(startTime - $024596570cb688e3$var$bootStartTime);
                        return timingValues;
                    })();
                    const attributes = {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        nodesInViewport: nodesInViewport,
                        nodeSize: nodeSize,
                        nodeSizeBucket: nodeSizeBucket,
                        totalNodes: totalNodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration,
                        pageLoadType: pageLoadType,
                        pageType: pageType,
                        timings: timings,
                        extensionKeys: extensionKeys,
                        ufoInteractionId: (0, $feexy.getInteractionId)().current
                    };
                    dispatchAnalyticsEvent({
                        action: (0, $d925B.ACTION).PROSEMIRROR_RENDERED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        attributes: attributes,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                } else {
                    const attributes = {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        nodesInViewport: nodesInViewport,
                        nodeSize: nodeSize,
                        nodeSizeBucket: nodeSizeBucket,
                        totalNodes: totalNodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    };
                    dispatchAnalyticsEvent({
                        action: (0, $d925B.ACTION).PROSEMIRROR_RENDERED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        attributes: attributes,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                }
            }
        });
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $42omo.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $42omo.useRef)(null);
    const isNestedEditorCalculated = (0, $42omo.useRef)(false);
    if (editorRef.current !== null && !isNestedEditorCalculated.current) {
        isNestedEditor.current = !!editorRef.current?.closest('.extension-editable-area');
        isNestedEditorCalculated.current = true;
    }
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(!isNestedEditor.current && (0, $geLSP.isFullPage)(props.editorProps.appearance) ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $geLSP.isFullPage)(props.editorProps.appearance) && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (shouldFocus && editorView?.props.editable?.(editorView.state)) {
            if (!mitigateScrollJump) {
                const liveDocWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(editorView);
                if ((0, $0085cb30af154789$export$73ae01d857526945)(props.editorProps.appearance)) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(editorView);
                if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                    if (!disabled && shouldFocus && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
                }
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump,
        disabled,
        props.editorProps.appearance
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef([]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // No event listeners should be attached to scroll element in SSR.
        return;
        return ()=>{
            if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollElement.current?.removeEventListener(...possibleListener);
            scrollElement.current = null;
        };
    }, []);
    const handleEditorViewRef = (0, $42omo.useCallback)((node)=>{
        if (node) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            scrollElement.current = document.querySelector('[data-editor-scroll-container]');
            const cleanupListeners = ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current?.removeEventListener(...possibleListener);
            };
            if (scrollElement.current) {
                const wheelAbortHandler = ()=>{
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $4u5NT.abortAll)('new_interaction', `wheel-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                possibleListeners.current.push([
                    'wheel',
                    wheelAbortHandler
                ]);
                const scrollAbortHandler = ()=>{
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $4u5NT.abortAll)('new_interaction', `scroll-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                possibleListeners.current.push([
                    'scroll',
                    scrollAbortHandler
                ]);
            }
        }
        if (!viewRef.current && node) {
            (0, $92LVN.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if (mitigateScrollJump) {
                const scrollElement = document.querySelector('[data-editor-scroll-container]');
                scrollElement?.scrollTo({
                    top: originalScrollToRestore.current,
                    behavior: 'instant'
                });
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).startTransition(()=>{
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            });
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $92LVN.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const isPageAppearance = (0, $geLSP.isFullPage)(nextAppearance) || nextAppearance === 'max';
    const createEditor = (0, $42omo.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $dh538.fg)('cc_editor_focus_before_editor_on_load') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            tabIndex: -1,
            "data-focus-id": editorId.current,
            "data-testid": "react-editor-view-inital-focus-element"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $f1dc1dfba26b7751$export$11a24c7b1b4aab81)()}`,
            key: "ProseMirror",
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || (isPageAppearance ? props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).editorAssistiveLabel)),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $024596570cb688e3$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            // eslint-disable-next-line react/no-danger -- needed for SSR and hydration so react keeps the HTML untouched
            dangerouslySetInnerHTML: {
                __html: ''
            }
        }));
    }, [
        handleEditorViewRef,
        isPageAppearance,
        props.intl
    ]);
    const previousPreset = (0, $7541v.default)(preset);
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // No state reconfiguration is supported in SSR.
        return;
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $7541v.default)(disabled);
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = (__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc);
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $565b25adcfad3caf$export$ebebb7f5b9271fd7)(viewRef.current);
            if ((0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $dh538.fg)('cc_editor_focus_before_editor_on_load')) {
                if (!disabled && shouldFocus && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc)) (0, $0d3266c92e7feda8$export$32ec9f77297f7957)(editorId.current);
            }
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_appearance_shared_state', 'isEnabled', true)) pluginInjectionAPI.current.api()?.core?.actions?.updateAppearance(nextAppearance);
    }, [
        nextAppearance
    ]);
    (0, $5953f1dbb50e9aa2$export$4998b7b36606f9c3)(nextAppearance, dispatchAnalyticsEvent);
    // This function uses as prop as `<EditorSSRRenderer>` so, that should be memoized,
    // to avoid extra rerenders.
    const buildDoc = (0, $42omo.useCallback)((schema)=>{
        return parseDoc(schema, undefined, {
            // Don't pass all props here, use only what you need to keep hook dependencies more stable.
            // Check what `parseDoc` consumes and pass only needed data.
            props: {
                providerFactory: props.providerFactory,
                editorProps: {
                    sanitizePrivateContent: props.editorProps.sanitizePrivateContent
                }
            },
            doc: defaultValue
        });
    }, [
        defaultValue,
        parseDoc,
        props.editorProps.sanitizePrivateContent,
        props.providerFactory
    ]);
    // We need to check `allowBlockType` in props, because it is now exist in EditorNextProps type.
    const { allowBlockType: allowBlockType } = 'allowBlockType' in props.editorProps ? props.editorProps : {
        allowBlockType: undefined
    };
    // In separate memo, because some props like `props.intl` that need only for rendering
    // changes many times, but we don't want to process plugins and ADF document for each unnecessary changes.
    const ssrDeps = (0, $42omo.useMemo)(()=>{
        if (!(0, $eTj7Y.isSSR)()) return null;
        const doCreatePluginList = ()=>(0, $1B55v.default)(props.preset, // Don't pass props.editorProps directly, because editoProps in the dependency will lead to
            // multiple repaints, because props.editorPros is not stable object.
            {
                allowBlockType: allowBlockType
            }, pluginInjectionAPI.current);
        const plugins = (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME}/createPluginsList`, doCreatePluginList, onSSRMeasure);
        const doCreateSchema = ()=>(0, $083bb79fcbe2f990$export$5f4ce795563f4211)((0, $5b9727cf4df72475$export$7265233e78178a4)(plugins));
        const schema = (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME}/createSchema`, doCreateSchema, onSSRMeasure);
        const doBuildDoc = ()=>buildDoc(schema);
        const doc = (0, $09aa0f0eb93c969d$export$69bfe89b2a668d26)(`${$024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME}/buildDoc`, doBuildDoc, onSSRMeasure);
        return {
            plugins: plugins,
            schema: schema,
            doc: doc
        };
    }, [
        allowBlockType,
        buildDoc,
        props.preset,
        onSSRMeasure
    ]);
    const { assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy } = props.editorProps;
    const handleSsrEditorStateChanged = (0, $42omo.useCallback)((state)=>{
        ssrEditorStateRef.current = state;
        // Notify listeners about the initial SSR state
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: state,
            oldEditorState: undefined
        });
    }, [
        pluginInjectionAPI
    ]);
    const memoizedReactEditorViewContext = (0, $42omo.useMemo)(()=>({
            editorRef: editorRef,
            // Use a getter so that consumers always read the live viewRef.current at access
            // time, not a stale snapshot captured when this memo was created.
            get editorView () {
                return viewRef.current;
            },
            popupsMountPoint: props.editorProps.popupsMountPoint
        }), // viewRef is intentionally omitted from the deps array — it's a stable ref object; the getter reads
    // .current lazily so there's no stale-closure risk.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        editorRef,
        props.editorProps.popupsMountPoint
    ]);
    // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017
    const reactEditorViewContext = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedReactEditorViewContext : {
        editorRef: editorRef,
        editorView: viewRef.current,
        popupsMountPoint: props.editorProps.popupsMountPoint
    };
    const ssrEditor = (0, $42omo.useMemo)(()=>{
        if (!ssrDeps) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $483adb45b74576fd$export$8d417ec112d5c31c), {
            intl: props.intl,
            doc: ssrDeps.doc,
            schema: ssrDeps.schema,
            plugins: ssrDeps.plugins,
            portalProviderAPI: props.portalProviderAPI,
            // IMPORTANT: Keep next props in sync with div that renders a real ProseMirror editor.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $f1dc1dfba26b7751$export$11a24c7b1b4aab81)()}`,
            key: "ProseMirror",
            "aria-label": assistiveLabel || (isPageAppearance ? props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $170f814baa647977$export$3b488057bfc1868f).editorAssistiveLabel)),
            id: $024596570cb688e3$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            onSSRMeasure: onSSRMeasure,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEditorStateChanged: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? handleSsrEditorStateChanged : (state)=>{
                ssrEditorStateRef.current = state;
                // Notify listeners about the initial SSR state
                pluginInjectionAPI.current.onEditorViewUpdated({
                    newEditorState: state,
                    oldEditorState: undefined
                });
            }
        });
    }, [
        ssrDeps,
        props.intl,
        props.portalProviderAPI,
        assistiveLabel,
        isPageAppearance,
        assistiveDescribedBy,
        onSSRMeasure,
        handleSsrEditorStateChanged
    ]);
    const editor = (0, $42omo.useMemo)(()=>{
        // SSR editor will be available only in SSR environment,
        // in a browser `ssrEditor` will be `null`, and we will render a normal one ProseMirror.
        if (ssrEditor) return ssrEditor;
        return createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy);
    }, // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy,
        ssrEditor
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lnATY.SSRRenderMeasure), {
        segmentName: $024596570cb688e3$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40aJG.default).Provider, {
        value: reactEditorViewContext
    }, renderTrackingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REACT_EDITOR_VIEW,
        handleAnalyticsEvent: handleAnalyticsEvent,
        useShallow: true
    }), props.render ? props.render?.({
        editor: editor,
        view: viewRef.current,
        config: config.current,
        eventDispatcher: eventDispatcher,
        transformer: contentTransformer.current,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorRef: editorRef,
        editorAPI: pluginInjectionAPI.current.api()
    }) ?? editor : editor));
}
var // Preserving exact type generated by TypeScript
// eslint-disable-next-line @typescript-eslint/ban-types
$024596570cb688e3$export$2e2bcd8739ae039 = (0, $aXWIB.injectIntl)($024596570cb688e3$export$e7d1b1cbca007e16);
module.exports["ReactEditorView"] = $024596570cb688e3$export$e7d1b1cbca007e16;

});

parcelRegister("92LVN", function(module, exports) {
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $1660546fee445dc4$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $1660546fee445dc4$var$editorObservers = new WeakMap();
const $1660546fee445dc4$var$callbackMap = new WeakMap();
const $1660546fee445dc4$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $1660546fee445dc4$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $1660546fee445dc4$var$callbackMap.set(observerConfig.element, observerConfig);
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($1660546fee445dc4$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($1660546fee445dc4$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $1660546fee445dc4$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $1660546fee445dc4$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $1660546fee445dc4$var$editorObservers.get(editorElement)?.disconnect();
        $1660546fee445dc4$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};
module.exports["nodeVisibilityManager"] = $1660546fee445dc4$export$565ab8668cdfbb7c;

});

parcelRegister("lnATY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");




function $795278da5b1bd758$export$8742d3f42739b0ac({ onRender: onRender }) {
    (0, $42omo.useLayoutEffect)(()=>{
        if (onRender) onRender();
    });
    return null;
}


function $0b18bc196bae511f$var$SSRRenderMeasureImpl({ onSSRMeasure: onSSRMeasure, segmentName: segmentName, startTimestampRef: startTimestampRef, children: children }) {
    const wasMeasured = (0, $42omo.useRef)(false);
    const handleOnRender = (0, $42omo.useCallback)(()=>{
        if (wasMeasured.current) return;
        onSSRMeasure?.({
            segmentName: segmentName,
            startTimestamp: startTimestampRef.current,
            endTimestamp: performance.now()
        });
        wasMeasured.current = true;
    }, [
        onSSRMeasure,
        segmentName,
        startTimestampRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $795278da5b1bd758$export$8742d3f42739b0ac), {
        onRender: handleOnRender
    }));
}
const $0b18bc196bae511f$var$SSRRenderMeasureNoOp = /*#__PURE__*/ (0, $42omo.memo)(({ children: children })=>{
    return children;
});
const $0b18bc196bae511f$export$9f2784dd4053b8a7 = (0, $eTj7Y.isSSR)() ? $0b18bc196bae511f$var$SSRRenderMeasureImpl : $0b18bc196bae511f$var$SSRRenderMeasureNoOp;
module.exports["SSRRenderMeasure"] = $0b18bc196bae511f$export$9f2784dd4053b8a7;

});

parcelRegister("b7atO", function(module, exports) {

var $2pjJ5 = parcelRequire("2pjJ5");

const $f78ec04c0c440d6c$var$DEFAULT_CHUNK_SIZE = 4096; // Default chunk size in bits
class $f78ec04c0c440d6c$export$fdc385e5a167108c {
    set(index, value) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        if (value) bitArray[byteIndex] |= 1 << bitOffset; // set the bit
        else bitArray[byteIndex] &= ~(1 << bitOffset); // clear the bit
    }
    get(index) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        return (bitArray[byteIndex] & 1 << bitOffset) !== 0; // Check if the bit is set
    }
    getChunk(index) {
        const chunkIndex = Math.floor(index / this.chunkTotalBitSize);
        if (!this.bitArrays[chunkIndex]) this.bitArrays[chunkIndex] = new Uint8Array(this.chunkSize);
        return this.bitArrays[chunkIndex];
    }
    constructor(chunkSize = $f78ec04c0c440d6c$var$DEFAULT_CHUNK_SIZE){
        this.chunkSize = void 0;
        this.chunkTotalBitSize = void 0;
        this.bitArrays = void 0;
        this.chunkSize = chunkSize;
        this.chunkTotalBitSize = this.chunkSize * 8;
        this.bitArrays = [];
    }
}



var $vDe3Q = parcelRequire("vDe3Q");

class $5d4c6b3ff36d75ac$export$d6cb5c66663ecf49 {
    isEmptyDoc() {
        return this.emptyDoc;
    }
    setEmptyDoc(isEmpty) {
        this.emptyDoc = isEmpty;
    }
    isLimitedMode() {
        return this.limitedMode;
    }
    // We use pos to generate unique ids for each node at a specific position
    // This is to ensure the same ADF will always generate the same DOM initially
    getOrGenerateId(node, pos) {
        if (this.limitedMode) return undefined;
        if (this.cache.has(node)) return this.cache.get(node);
        let idSuffix = '';
        if (this.existingPos.get(pos)) idSuffix = `-${(this.count++).toString(36)}`;
        else this.existingPos.set(pos, true);
        const anchorName = `--anchor-${node.type.name}-${pos}${idSuffix}`;
        this.cache.set(node, anchorName);
        return anchorName;
    }
    getIdForNode(node) {
        if (this.limitedMode) return undefined;
        return this.cache.get(node);
    }
    setIdForNode(node, id) {
        if (this.limitedMode) return;
        this.cache.set(node, id);
    }
    // After set to limited mode, we clear the cache to free up memory
    // and prevent further ids from being generated
    // Once in limited mode, we won't exit it
    setLimitedMode() {
        this.limitedMode = true;
        this.cache = new WeakMap();
        this.existingPos = new (0, $f78ec04c0c440d6c$export$fdc385e5a167108c)();
        this.count = BigInt(0);
    }
    constructor(limitedMode = false, emptyDoc = false){
        this.cache = new WeakMap();
        this.count = BigInt(0);
        this.existingPos = new (0, $f78ec04c0c440d6c$export$fdc385e5a167108c)();
        this.limitedMode = false;
        this.emptyDoc = false;
        this.limitedMode = limitedMode;
        this.emptyDoc = emptyDoc;
    }
}
const $5d4c6b3ff36d75ac$var$nodeIdProviderMap = new WeakMap();
/**
 * Determines whether limited mode should be enabled.
 * This logic mirrors the limited mode plugin implementation, but lives here to avoid a circular dependency.
 * If it changes, update the matching logic in `editor-plugin-limited-mode/src/pm-plugins/main.ts`.
 *
 * Limited mode is activated when ANY of the following conditions are met:
 * 1. Document size exceeds `LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD` — checked first as O(1)
 * 2. Node count exceeds `LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD`
 * 3. Document contains a legacy-content macro (LCM)
 *
 * Performance optimisations:
 * - Doc size is checked first (O(1)) - if it exceeds threshold, we skip traversal entirely.
 * - If we find an LCM during traversal, we exit early since limited mode will be enabled.
 */ const $5d4c6b3ff36d75ac$var$isLimitedModeEnabled = (editorView)=>{
    const doc = editorView.state.doc;
    const nodeCountThreshold = (0, $vDe3Q.LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD);
    const docSizeThreshold = (0, $vDe3Q.LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD);
    // Early exit: doc size exceeds threshold - O(1), no traversal needed
    if (doc.nodeSize > docSizeThreshold) return true;
    // Single traversal for node count and LCM detection
    let nodeCount = 0;
    let hasLcm = false;
    doc.descendants((node)=>{
        nodeCount += 1;
        if (node.attrs?.extensionKey === 'legacy-content') {
            hasLcm = true;
            // Early exit: LCM found — limited mode will be enabled
            return false;
        }
    });
    // LCM condition takes precedence (if we early exited traversal, this is why)
    if (hasLcm) return true;
    // Check node count threshold
    if (nodeCount > nodeCountThreshold) return true;
    return false;
};
const $5d4c6b3ff36d75ac$export$753ee9749f6df320 = (editorView)=>{
    if (!$5d4c6b3ff36d75ac$var$nodeIdProviderMap.has(editorView)) {
        // if the limited mode flag is on, enable limited mode based on the threshold
        // only for the first time
        const limitedMode = $5d4c6b3ff36d75ac$var$isLimitedModeEnabled(editorView);
        const isEmptyDoc = (0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
        const provider = new $5d4c6b3ff36d75ac$export$d6cb5c66663ecf49(limitedMode, isEmptyDoc);
        $5d4c6b3ff36d75ac$var$nodeIdProviderMap.set(editorView, provider);
        return provider;
    }
    const nodeIdProvider = $5d4c6b3ff36d75ac$var$nodeIdProviderMap.get(editorView);
    // in some cases we need to re-check limited mode state
    // Confluence editor can start with an empty doc and then load content later
    // so we need to check first time from an empty doc to a non-empty doc
    if (nodeIdProvider.isEmptyDoc() && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc)) {
        // set empty doc to false regardless of limited mode state
        nodeIdProvider.setEmptyDoc(false);
        if (!nodeIdProvider.isLimitedMode() && $5d4c6b3ff36d75ac$var$isLimitedModeEnabled(editorView)) nodeIdProvider.setLimitedMode();
    }
    // This is based on the fact that editorView is a singleton.
    return $5d4c6b3ff36d75ac$var$nodeIdProviderMap.get(editorView);
};
module.exports["getNodeIdProvider"] = $5d4c6b3ff36d75ac$export$753ee9749f6df320;

});

parcelRegister("2pjJ5", function(module, exports) {

var $3FxV8 = parcelRequire("3FxV8");


var $aXG5V = parcelRequire("aXG5V");


var $1oCLl = parcelRequire("1oCLl");


var $kTbzR = parcelRequire("kTbzR");

const $a5f7a02a123b6264$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            const docSize = transaction.doc.content.size;
            from = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(newStart < from || from === -1 ? newStart : from, 0, docSize);
            to = (0, (/*@__PURE__*/$parcel$interopDefault($3FxV8)))(newEnd > to || to === -1 ? newEnd : to, 0, docSize);
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $a5f7a02a123b6264$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $a5f7a02a123b6264$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $kTbzR.isEmptyParagraph)(nodeChild);
}
function $a5f7a02a123b6264$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $a5f7a02a123b6264$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $a5f7a02a123b6264$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $a5f7a02a123b6264$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $a5f7a02a123b6264$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $a5f7a02a123b6264$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $a5f7a02a123b6264$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $a5f7a02a123b6264$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $a5f7a02a123b6264$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $a5f7a02a123b6264$export$fd9c3e0f31aab835(tr) {
    return $a5f7a02a123b6264$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $a5f7a02a123b6264$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $aXG5V.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};
function $a5f7a02a123b6264$var$marksEqualInOrder(m1, m2) {
    if (m1.length !== m2.length) return false;
    return m1.every((m, i)=>m.eq(m2[i]));
}
function $a5f7a02a123b6264$var$marksEqualIgnoringOrder(m1, m2) {
    if (m1.length !== m2.length) return false;
    const m2Used = new Set();
    for (const mark1 of m1){
        const idx = m2.findIndex((mark2, i)=>!m2Used.has(i) && mark1.eq(mark2));
        if (idx === -1) return false;
        m2Used.add(idx);
    }
    return true;
}
function $a5f7a02a123b6264$export$e3b603f98921291f(node1, node2, attributesToIgnore, opts) {
    const ignoreMarkOrder = opts?.ignoreMarkOrder ?? (0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true);
    if (node1.isText) {
        if (ignoreMarkOrder) return node1.text === node2.text && $a5f7a02a123b6264$var$marksEqualIgnoringOrder(node1.marks, node2.marks);
        return node1.eq(node2);
    }
    const marksEqual = ignoreMarkOrder ? $a5f7a02a123b6264$var$marksEqualIgnoringOrder(node1.marks, node2.marks) : $a5f7a02a123b6264$var$marksEqualInOrder(node1.marks, node2.marks);
    // If no attributes to ignore, compare all attributes
    if (!attributesToIgnore || attributesToIgnore.length === 0) {
        if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node1.marks) && marksEqual && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content, undefined, opts);
        else return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node2.marks) && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content);
    }
    // Build attrs to compare by excluding ignored attributes
    const attrsToCompare = (0, $1oCLl.expValEquals)('platform_editor_show_diff_fix_missing_attrs', 'isEnabled', true) ? {
        ...node2.attrs
    } : node2.attrs;
    const ignoreSet = new Set(attributesToIgnore);
    for(const key in node2.attrs)if (ignoreSet.has(key)) attrsToCompare[key] = node1.attrs[key];
    if ((0, $1oCLl.expValEquals)('platform_editor_are_nodes_equal_ignore_mark_order', 'isEnabled', true)) return node1 === node2 || node1.type === node2.type && node1.hasMarkup(node2.type, attrsToCompare, node1.marks) && marksEqual && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content, attributesToIgnore, opts);
    else return node1 === node2 || node1.hasMarkup(node2.type, attrsToCompare, node2.marks) && $a5f7a02a123b6264$var$areFragmentsEqual(node1.content, node2.content, attributesToIgnore);
}
function $a5f7a02a123b6264$var$areFragmentsEqual(frag1, frag2, attributesToIgnore, opts) {
    if (frag1.content.length !== frag2.content.length) return false;
    let childrenEqual = true;
    frag1.content.forEach((child, i)=>{
        const otherChild = frag2.child(i);
        if (child === otherChild || otherChild && $a5f7a02a123b6264$export$e3b603f98921291f(child, otherChild, attributesToIgnore, opts)) return;
        childrenEqual = false;
    });
    return childrenEqual;
}
module.exports["getStepRange"] = $a5f7a02a123b6264$export$c8e611b6ac095e6d;
module.exports["hasDocAsParent"] = $a5f7a02a123b6264$export$f76a7d770092ea11;
module.exports["isEmptyDocument"] = $a5f7a02a123b6264$export$2da47a16c0b6bcb;
module.exports["bracketTyped"] = $a5f7a02a123b6264$export$df0539d254c75c33;
module.exports["nodesBetweenChanged"] = $a5f7a02a123b6264$export$f9e52d2e832a6aae;
module.exports["hasVisibleContent"] = $a5f7a02a123b6264$export$c9083db5521330d3;
module.exports["isSelectionEndOfParagraph"] = $a5f7a02a123b6264$export$435c1d4e61a8723b;
module.exports["getChangedNodes"] = $a5f7a02a123b6264$export$fd9c3e0f31aab835;
module.exports["isReplaceDocOperation"] = $a5f7a02a123b6264$export$b81ebf241519dbe1;
module.exports["areNodesEqualIgnoreAttrs"] = $a5f7a02a123b6264$export$e3b603f98921291f;

});

parcelRegister("3FxV8", function(module, exports) {

var $bCMS0 = parcelRequire("bCMS0");


var $abOaY = parcelRequire("abOaY");

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $2abf835653f9d26a$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $abOaY(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $abOaY(lower);
        lower = lower === lower ? lower : 0;
    }
    return $bCMS0($abOaY(number), lower, upper);
}
module.exports = $2abf835653f9d26a$var$clamp;

});

parcelRegister("kTbzR", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");


var $4vlwG = parcelRequire("4vlwG");

function $ab19fe955bb1fbb0$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $ab19fe955bb1fbb0$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $ab19fe955bb1fbb0$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$ab19fe955bb1fbb0$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $ab19fe955bb1fbb0$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $aXG5V.ReplaceStep)) && !(step instanceof (0, $aXG5V.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $ab19fe955bb1fbb0$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $ks2lK.TextSelection);
const $ab19fe955bb1fbb0$export$5588122b9eea7733 = (element)=>{
    return (0, $4vlwG.closest)(element, 'td, th');
};
const $ab19fe955bb1fbb0$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $ab19fe955bb1fbb0$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $ab19fe955bb1fbb0$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $ab19fe955bb1fbb0$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $ks2lK.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $ab19fe955bb1fbb0$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $7XFGZ.CellSelection).create(state.doc, anchor, head)));
}
function $ab19fe955bb1fbb0$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $ab19fe955bb1fbb0$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $ab19fe955bb1fbb0$export$2de06a6e688827fd = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $ab19fe955bb1fbb0$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $ab19fe955bb1fbb0$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($ab19fe955bb1fbb0$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $ab19fe955bb1fbb0$var$not = (fn)=>(arg)=>!fn(arg);
module.exports["isEmptyParagraph"] = $ab19fe955bb1fbb0$export$b648602b09795358;
module.exports["stepHasSlice"] = $ab19fe955bb1fbb0$export$53780b185b887309;
module.exports["stepAddsOneOf"] = $ab19fe955bb1fbb0$export$f4d51ccab05f55c9;
module.exports["extractSliceFromStep"] = $ab19fe955bb1fbb0$export$d0a9dfe2556a9577;
module.exports["isTextSelection"] = $ab19fe955bb1fbb0$export$38b50bf35e79aaf3;
module.exports["isElementInTableCell"] = $ab19fe955bb1fbb0$export$5588122b9eea7733;
module.exports["isLastItemMediaGroup"] = $ab19fe955bb1fbb0$export$142c0ee6457f50d6;
module.exports["setNodeSelection"] = $ab19fe955bb1fbb0$export$a367515ca2c9ace1;
module.exports["setTextSelection"] = $ab19fe955bb1fbb0$export$1df6d14df6b0b758;
module.exports["nonNullable"] = $ab19fe955bb1fbb0$export$26128561c93f5847;
module.exports["isValidPosition"] = $ab19fe955bb1fbb0$export$de0495c7bd37bf4e;
module.exports["isInLayoutColumn"] = $ab19fe955bb1fbb0$export$2de06a6e688827fd;
module.exports["filterChildrenBetween"] = $ab19fe955bb1fbb0$export$e46323d96cf32194;
module.exports["removeBlockMarks"] = $ab19fe955bb1fbb0$export$fba8af3b998832b9;

});

parcelRegister("vDe3Q", function(module, exports) {
/** Fixed document thresholds for limited (performance) mode (previously Statsig-driven). */ const $4616e34eca06f222$export$8817b3b4a899ccd1 = 5000;
const $4616e34eca06f222$export$9a6294e90d121a22 = 30000;
const $4616e34eca06f222$export$cea4e64227747fde = true;
module.exports["LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD"] = $4616e34eca06f222$export$8817b3b4a899ccd1;
module.exports["LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD"] = $4616e34eca06f222$export$9a6294e90d121a22;

});

parcelRegister("gmyMu", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

function $42952c725d367d8e$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $42952c725d367d8e$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $42952c725d367d8e$export$95069e054e554fa9 extends (0, $ks2lK.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}
module.exports["editorCommandToPMCommand"] = $42952c725d367d8e$export$bd352a83a17b2af8;
module.exports["PassiveTransaction"] = $42952c725d367d8e$export$95069e054e554fa9;

});

parcelRegister("1S4f7", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eTj7Y = parcelRequire("eTj7Y");


var $b7atO = parcelRequire("b7atO");


var $6VsTy = parcelRequire("6VsTy");


var $04H9b = parcelRequire("04H9b");

const $abdb2d00268489b8$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom, options: options })=>{
    const metadata = (0, $6VsTy.createProseMirrorMetadata)(nodeOrMark, options);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
        if (name === 'data-node-anchor' && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            // if browser doesn't support CSS anchor, won't need the style
            // Or if it supports CSS attr() function as the value of anchor-name,
            // We won't need set the style
            if (!(0, $04H9b.isCSSAnchorSupported)() || (0, $04H9b.isCSSAttrAnchorSupported)()) return;
            // otherwise, we set the CSS variable for anchor-name
            dom.style.setProperty((0, $04H9b.ANCHOR_VARIABLE_NAME), `${value}`);
            return;
        }
    });
};
/** Type guard to check if a Node is an HTMLElement in a safe way. */ const $abdb2d00268489b8$var$isHTMLElement = (element)=>{
    if (element === null || element === undefined) return false;
    // In SSR `HTMLElement` is not defined, so we need to use duck typing here
    return 'innerHTML' in element && 'style' in element && 'classList' in element;
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $abdb2d00268489b8$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    let nodeIdProvider;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    if (!nodeIdProvider && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) nodeIdProvider = (0, $b7atO.getNodeIdProvider)(view);
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement || // SSR result?.dom is not an instance of HTMLElement, but we still want to attach metadata to it
                    (0, $eTj7Y.isSSR)() && $abdb2d00268489b8$var$isHTMLElement(result?.dom) && (0, $dh538.fg)('platform_editor_native_anchor_patch_3')) {
                        // we only attach metadata to the dom if its position is known
                        const pos = safeGetPos();
                        const options = pos !== undefined && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? {
                            anchrorId: nodeIdProvider?.getOrGenerateId(node, pos)
                        } : undefined;
                        $abdb2d00268489b8$export$286bb6e3f51916b5({
                            nodeOrMark: node,
                            dom: result.dom,
                            options: options
                        });
                    }
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $abdb2d00268489b8$export$1d44e2741b8f180d extends (0, $ks2lK.Plugin) {
    constructor(spec){
        super($abdb2d00268489b8$var$wrapGetPosExceptions(spec));
        // This variable isn't (and shouldn't) be used anywhere. Its purpose is
        // to distinguish Plugin from SafePlugin, thus ensuring that an 'unsafe'
        // Plugin cannot be assigned as an item in EditorPlugin → pmPlugins.
        this._isATypeSafePlugin = void 0;
    }
}
module.exports["SafePlugin"] = $abdb2d00268489b8$export$1d44e2741b8f180d;

});

parcelRegister("04H9b", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $2XqLN = parcelRequire("2XqLN");

const $8c4e7e3e26200878$export$ef134ee0b603ec88 = '--ed-pm-node-anchor';
const $8c4e7e3e26200878$var$hasCssSupport = (0, $2XqLN.default)(()=>{
    if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.supports === 'function') return true;
    return false;
});
const $8c4e7e3e26200878$export$98ea10c5c22b6d19 = (0, $2XqLN.default)(()=>{
    if ($8c4e7e3e26200878$var$hasCssSupport()) return CSS.supports('anchor-name', 'attr(data-anchor-name type(<custom-ident>))');
    return false;
});
const $8c4e7e3e26200878$export$e43af301b4191f = (0, $2XqLN.default)(()=>{
    if ($8c4e7e3e26200878$var$hasCssSupport()) return CSS.supports('anchor-name', '--anchor');
});
const $8c4e7e3e26200878$export$abca45c45e682c01 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-node-anchor]': {
            anchorName: `var(${$8c4e7e3e26200878$export$ef134ee0b603ec88}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
module.exports["ANCHOR_VARIABLE_NAME"] = $8c4e7e3e26200878$export$ef134ee0b603ec88;
module.exports["isCSSAttrAnchorSupported"] = $8c4e7e3e26200878$export$98ea10c5c22b6d19;
module.exports["isCSSAnchorSupported"] = $8c4e7e3e26200878$export$e43af301b4191f;

});

parcelRegister("40aJG", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $737f8c3c28a9bc31$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
var $737f8c3c28a9bc31$export$2e2bcd8739ae039 = $737f8c3c28a9bc31$var$ReactEditorViewContext;
module.exports["default"] = $737f8c3c28a9bc31$export$2e2bcd8739ae039;

});

parcelRegister("ftzrq", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

const $b4450e5745e49325$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $b4450e5745e49325$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $b4450e5745e49325$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $b4450e5745e49325$var$textRange = function(node, from, to) {
    let range = $b4450e5745e49325$var$reusedRange || ($b4450e5745e49325$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $b4450e5745e49325$var$clearReusedRange = function() {
    $b4450e5745e49325$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $b4450e5745e49325$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, -1) || $b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $b4450e5745e49325$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $b4450e5745e49325$var$scanFor(node, off, targetNode, targetOff, dir) {
    var _a;
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $b4450e5745e49325$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $b4450e5745e49325$var$hasBlockDesc(node) || $b4450e5745e49325$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $b4450e5745e49325$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (child.nodeType == 1 && child.contentEditable == "false") {
                if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;
                else return false;
            } else {
                node = child;
                off = dir < 0 ? $b4450e5745e49325$var$nodeSize(node) : 0;
            }
        } else return false;
    }
}
function $b4450e5745e49325$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b4450e5745e49325$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $b4450e5745e49325$var$nodeSize(node);
        } else if (node.parentNode && !$b4450e5745e49325$var$hasBlockDesc(node)) {
            offset = $b4450e5745e49325$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $b4450e5745e49325$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$b4450e5745e49325$var$hasBlockDesc(node)) {
            offset = $b4450e5745e49325$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $b4450e5745e49325$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $b4450e5745e49325$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $b4450e5745e49325$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $b4450e5745e49325$var$nodeSize(node);
    }
}
function $b4450e5745e49325$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $b4450e5745e49325$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $b4450e5745e49325$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $b4450e5745e49325$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $b4450e5745e49325$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $b4450e5745e49325$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($b4450e5745e49325$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($b4450e5745e49325$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $b4450e5745e49325$var$nav = typeof navigator != "undefined" ? navigator : null;
const $b4450e5745e49325$var$doc = typeof document != "undefined" ? document : null;
const $b4450e5745e49325$var$agent = $b4450e5745e49325$var$nav && $b4450e5745e49325$var$nav.userAgent || "";
const $b4450e5745e49325$var$ie_edge = /Edge\/(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie_upto10 = /MSIE \d/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$ie = !!($b4450e5745e49325$var$ie_upto10 || $b4450e5745e49325$var$ie_11up || $b4450e5745e49325$var$ie_edge);
const $b4450e5745e49325$var$ie_version = $b4450e5745e49325$var$ie_upto10 ? document.documentMode : $b4450e5745e49325$var$ie_11up ? +$b4450e5745e49325$var$ie_11up[1] : $b4450e5745e49325$var$ie_edge ? +$b4450e5745e49325$var$ie_edge[1] : 0;
const $b4450e5745e49325$var$gecko = !$b4450e5745e49325$var$ie && /gecko\/(\d+)/i.test($b4450e5745e49325$var$agent);
$b4450e5745e49325$var$gecko && (/Firefox\/(\d+)/.exec($b4450e5745e49325$var$agent) || [
    0,
    0
])[1];
const $b4450e5745e49325$var$_chrome = !$b4450e5745e49325$var$ie && /Chrome\/(\d+)/.exec($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$chrome = !!$b4450e5745e49325$var$_chrome;
const $b4450e5745e49325$var$chrome_version = $b4450e5745e49325$var$_chrome ? +$b4450e5745e49325$var$_chrome[1] : 0;
const $b4450e5745e49325$var$safari = !$b4450e5745e49325$var$ie && !!$b4450e5745e49325$var$nav && /Apple Computer/.test($b4450e5745e49325$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $b4450e5745e49325$var$ios = $b4450e5745e49325$var$safari && (/Mobile\/\w+/.test($b4450e5745e49325$var$agent) || !!$b4450e5745e49325$var$nav && $b4450e5745e49325$var$nav.maxTouchPoints > 2);
const $b4450e5745e49325$var$mac = $b4450e5745e49325$var$ios || ($b4450e5745e49325$var$nav ? /Mac/.test($b4450e5745e49325$var$nav.platform) : false);
const $b4450e5745e49325$var$windows = $b4450e5745e49325$var$nav ? /Win/.test($b4450e5745e49325$var$nav.platform) : false;
const $b4450e5745e49325$var$android = /Android \d/.test($b4450e5745e49325$var$agent);
const $b4450e5745e49325$var$webkit = !!$b4450e5745e49325$var$doc && "webkitFontSmoothing" in $b4450e5745e49325$var$doc.documentElement.style;
const $b4450e5745e49325$var$webkit_version = $b4450e5745e49325$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $b4450e5745e49325$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $b4450e5745e49325$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $b4450e5745e49325$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $b4450e5745e49325$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;;){
        if (!parent) break;
        if (parent.nodeType != 1) {
            parent = $b4450e5745e49325$var$parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $b4450e5745e49325$var$windowRect(doc) : $b4450e5745e49325$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $b4450e5745e49325$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $b4450e5745e49325$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $b4450e5745e49325$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $b4450e5745e49325$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $b4450e5745e49325$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $b4450e5745e49325$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $b4450e5745e49325$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $b4450e5745e49325$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $b4450e5745e49325$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos)) break;
        parent = pos == "absolute" ? parent.offsetParent : $b4450e5745e49325$var$parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $b4450e5745e49325$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $b4450e5745e49325$var$scrollStack(view.dom)
    };
}
function $b4450e5745e49325$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $b4450e5745e49325$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $b4450e5745e49325$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $b4450e5745e49325$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $b4450e5745e49325$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $b4450e5745e49325$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $b4450e5745e49325$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($b4450e5745e49325$var$preventScrollSupported) return dom.focus($b4450e5745e49325$var$preventScrollSupported);
    let stored = $b4450e5745e49325$var$scrollStack(dom);
    dom.focus($b4450e5745e49325$var$preventScrollSupported == null ? {
        get preventScroll () {
            $b4450e5745e49325$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$b4450e5745e49325$var$preventScrollSupported) {
        $b4450e5745e49325$var$preventScrollSupported = false;
        $b4450e5745e49325$var$restoreScrollStack(stored, 0);
    }
}
function $b4450e5745e49325$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $b4450e5745e49325$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $b4450e5745e49325$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $b4450e5745e49325$var$findOffsetInNode(closest, coordsClosest);
}
function $b4450e5745e49325$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange(), result;
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $b4450e5745e49325$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($b4450e5745e49325$var$inRect(coords, rect)) {
            result = {
                node: node,
                offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
            };
            break;
        }
    }
    range.detach();
    return result || {
        node: node,
        offset: 0
    };
}
function $b4450e5745e49325$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $b4450e5745e49325$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $b4450e5745e49325$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $b4450e5745e49325$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $b4450e5745e49325$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $b4450e5745e49325$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($b4450e5745e49325$var$inRect(coords, rect)) return $b4450e5745e49325$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $b4450e5745e49325$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $b4450e5745e49325$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$b4450e5745e49325$var$inRect(coords, box)) return null;
        elt = $b4450e5745e49325$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($b4450e5745e49325$var$safari) {
        for(let p = elt; node && p; p = $b4450e5745e49325$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $b4450e5745e49325$var$targetKludge(elt, coords);
    if (node) {
        if ($b4450e5745e49325$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($b4450e5745e49325$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $b4450e5745e49325$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $b4450e5745e49325$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $b4450e5745e49325$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $b4450e5745e49325$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($b4450e5745e49325$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $b4450e5745e49325$var$nonZero) || target.getBoundingClientRect();
}
const $b4450e5745e49325$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $b4450e5745e49325$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $b4450e5745e49325$var$webkit || $b4450e5745e49325$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($b4450e5745e49325$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($b4450e5745e49325$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $b4450e5745e49325$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect($b4450e5745e49325$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $b4450e5745e49325$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $b4450e5745e49325$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $b4450e5745e49325$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $b4450e5745e49325$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $b4450e5745e49325$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $b4450e5745e49325$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $b4450e5745e49325$var$textRange(before, $b4450e5745e49325$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $b4450e5745e49325$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $b4450e5745e49325$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $b4450e5745e49325$var$flattenV($b4450e5745e49325$var$singleRect(node.nodeType == 3 ? $b4450e5745e49325$var$textRange(node) : node, -side), side >= 0);
}
function $b4450e5745e49325$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $b4450e5745e49325$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $b4450e5745e49325$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $b4450e5745e49325$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $b4450e5745e49325$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $b4450e5745e49325$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $b4450e5745e49325$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $b4450e5745e49325$var$maybeRTL = /[\u0590-\u08ac]/;
function $b4450e5745e49325$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$b4450e5745e49325$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $b4450e5745e49325$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $b4450e5745e49325$var$cachedState = null;
let $b4450e5745e49325$var$cachedDir = null;
let $b4450e5745e49325$var$cachedResult = false;
function $b4450e5745e49325$var$endOfTextblock(view, state, dir) {
    if ($b4450e5745e49325$var$cachedState == state && $b4450e5745e49325$var$cachedDir == dir) return $b4450e5745e49325$var$cachedResult;
    $b4450e5745e49325$var$cachedState = state;
    $b4450e5745e49325$var$cachedDir = dir;
    return $b4450e5745e49325$var$cachedResult = dir == "up" || dir == "down" ? $b4450e5745e49325$var$endOfTextblockVertical(view, state, dir) : $b4450e5745e49325$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $b4450e5745e49325$var$NOT_DIRTY = 0, $b4450e5745e49325$var$CHILD_DIRTY = 1, $b4450e5745e49325$var$CONTENT_DIRTY = 2, $b4450e5745e49325$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $b4450e5745e49325$var$ViewDesc {
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $b4450e5745e49325$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $b4450e5745e49325$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $b4450e5745e49325$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $b4450e5745e49325$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $b4450e5745e49325$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $b4450e5745e49325$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $b4450e5745e49325$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($b4450e5745e49325$var$gecko || $b4450e5745e49325$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $b4450e5745e49325$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($b4450e5745e49325$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $b4450e5745e49325$var$safari) && $b4450e5745e49325$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $b4450e5745e49325$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !(brKludge && $b4450e5745e49325$var$gecko)) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $b4450e5745e49325$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $b4450e5745e49325$var$CONTENT_DIRTY : $b4450e5745e49325$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    get ignoreForSelection() {
        return false;
    }
    isText(text) {
        return false;
    }
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $b4450e5745e49325$var$WidgetViewDesc extends $b4450e5745e49325$var$ViewDesc {
    matchesWidget(widget) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get ignoreForSelection() {
        return !!this.widget.type.spec.relaxedSide;
    }
    get side() {
        return this.widget.type.side;
    }
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
}
class $b4450e5745e49325$var$CompositionViewDesc extends $b4450e5745e49325$var$ViewDesc {
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $b4450e5745e49325$var$MarkViewDesc extends $b4450e5745e49325$var$ViewDesc {
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $5SAOw.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $b4450e5745e49325$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $b4450e5745e49325$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $b4450e5745e49325$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $b4450e5745e49325$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $b4450e5745e49325$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $b4450e5745e49325$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $b4450e5745e49325$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $b4450e5745e49325$var$NodeViewDesc extends $b4450e5745e49325$var$ViewDesc {
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $5SAOw.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $b4450e5745e49325$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $b4450e5745e49325$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $b4450e5745e49325$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $b4450e5745e49325$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $5SAOw.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && node.eq(this.node) && $b4450e5745e49325$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $b4450e5745e49325$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $b4450e5745e49325$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view, i);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $5SAOw.Mark).none : this.node.child(i).marks, inline, view, i);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view, i);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view, 0);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $b4450e5745e49325$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $b4450e5745e49325$var$renderDescs(this.contentDOM, this.children, view);
            if ($b4450e5745e49325$var$ios) $b4450e5745e49325$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $ks2lK.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $b4450e5745e49325$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $b4450e5745e49325$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $b4450e5745e49325$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($b4450e5745e49325$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $b4450e5745e49325$var$patchOuterDeco(this.dom, this.nodeDOM, $b4450e5745e49325$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $b4450e5745e49325$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.add("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.draggable = true;
        }
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $b4450e5745e49325$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $b4450e5745e49325$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $b4450e5745e49325$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $b4450e5745e49325$var$TextViewDesc extends $b4450e5745e49325$var$NodeViewDesc {
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY || this.dirty != $b4450e5745e49325$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $b4450e5745e49325$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $b4450e5745e49325$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $b4450e5745e49325$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $b4450e5745e49325$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $b4450e5745e49325$var$TrailingHackViewDesc extends $b4450e5745e49325$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $b4450e5745e49325$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $b4450e5745e49325$var$CustomNodeViewDesc extends $b4450e5745e49325$var$NodeViewDesc {
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b4450e5745e49325$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $b4450e5745e49325$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $b4450e5745e49325$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $b4450e5745e49325$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $b4450e5745e49325$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $b4450e5745e49325$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $b4450e5745e49325$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$b4450e5745e49325$var$OuterDecoLevel.prototype = Object.create(null);
const $b4450e5745e49325$var$noDeco = [
    new $b4450e5745e49325$var$OuterDecoLevel
];
function $b4450e5745e49325$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $b4450e5745e49325$var$noDeco;
    let top = needsWrap ? $b4450e5745e49325$var$noDeco[0] : new $b4450e5745e49325$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $b4450e5745e49325$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $b4450e5745e49325$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $b4450e5745e49325$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $b4450e5745e49325$var$noDeco && curComputed == $b4450e5745e49325$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $b4450e5745e49325$var$noDeco[0];
                curDOM = parent;
            }
        }
        $b4450e5745e49325$var$patchAttributes(curDOM, prev || $b4450e5745e49325$var$noDeco[0], deco);
    }
    return curDOM;
}
function $b4450e5745e49325$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $b4450e5745e49325$var$applyOuterDeco(dom, deco, node) {
    return $b4450e5745e49325$var$patchOuterDeco(dom, dom, $b4450e5745e49325$var$noDeco, $b4450e5745e49325$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $b4450e5745e49325$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $b4450e5745e49325$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $b4450e5745e49325$var$ViewTreeUpdater {
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view, parentIndex) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $b4450e5745e49325$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1, scanTo = this.top.children.length;
            if (parentIndex < this.preMatch.index) scanTo = Math.min(this.index + 3, scanTo);
            for(let i = this.index; i < scanTo; i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $b4450e5745e49325$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $b4450e5745e49325$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $b4450e5745e49325$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $b4450e5745e49325$var$NODE_DIRTY && $b4450e5745e49325$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $b4450e5745e49325$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $b4450e5745e49325$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$b4450e5745e49325$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $b4450e5745e49325$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $b4450e5745e49325$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $b4450e5745e49325$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $b4450e5745e49325$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $b4450e5745e49325$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($b4450e5745e49325$var$safari || $b4450e5745e49325$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $b4450e5745e49325$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $b4450e5745e49325$var$preMatch(top.node.content, top);
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes.
function $b4450e5745e49325$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $b4450e5745e49325$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $b4450e5745e49325$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $b4450e5745e49325$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($b4450e5745e49325$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $b4450e5745e49325$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $b4450e5745e49325$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $b4450e5745e49325$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $b4450e5745e49325$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($b4450e5745e49325$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $ks2lK.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $b4450e5745e49325$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $ks2lK.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $b4450e5745e49325$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $b4450e5745e49325$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $b4450e5745e49325$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $b4450e5745e49325$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $b4450e5745e49325$var$syncNodeSelection(view, sel);
    if (!$b4450e5745e49325$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $b4450e5745e49325$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $b4450e5745e49325$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $b4450e5745e49325$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($b4450e5745e49325$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $ks2lK.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $b4450e5745e49325$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $b4450e5745e49325$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($b4450e5745e49325$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $b4450e5745e49325$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $b4450e5745e49325$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $b4450e5745e49325$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $b4450e5745e49325$var$brokenSelectBetweenUneditable = $b4450e5745e49325$var$safari || $b4450e5745e49325$var$chrome && $b4450e5745e49325$var$chrome_version < 63;
function $b4450e5745e49325$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($b4450e5745e49325$var$safari && after && after.contentEditable == "false") return $b4450e5745e49325$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $b4450e5745e49325$var$setEditable(after);
        else if (before) return $b4450e5745e49325$var$setEditable(before);
    }
}
function $b4450e5745e49325$var$setEditable(element) {
    element.contentEditable = "true";
    if ($b4450e5745e49325$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $b4450e5745e49325$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $b4450e5745e49325$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$b4450e5745e49325$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $b4450e5745e49325$var$selectCursorWrapper(view) {
    let domSel = view.domSelection();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) domSel.collapse(node.parentNode, $b4450e5745e49325$var$domIndex(node) + 1);
    else domSel.collapse(node, 0);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $b4450e5745e49325$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $ks2lK.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $b4450e5745e49325$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $b4450e5745e49325$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $b4450e5745e49325$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $b4450e5745e49325$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $ks2lK.TextSelection).between($anchor, $head, bias);
}
function $b4450e5745e49325$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $b4450e5745e49325$var$hasSelection(view);
}
function $b4450e5745e49325$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $b4450e5745e49325$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $b4450e5745e49325$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $b4450e5745e49325$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $ks2lK.Selection).findFrom($start, dir);
}
function $b4450e5745e49325$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $b4450e5745e49325$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $ks2lK.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $ks2lK.NodeSelection)) return $b4450e5745e49325$var$apply(view, next);
            return false;
        } else if (!($b4450e5745e49325$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $ks2lK.NodeSelection).isSelectable(node)) return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($b4450e5745e49325$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $ks2lK.NodeSelection) && sel.node.isInline) return $b4450e5745e49325$var$apply(view, new (0, $ks2lK.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
        if (next) return $b4450e5745e49325$var$apply(view, next);
        return false;
    }
}
function $b4450e5745e49325$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b4450e5745e49325$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $b4450e5745e49325$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $b4450e5745e49325$var$skipIgnoredNodesBefore(view) : $b4450e5745e49325$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $b4450e5745e49325$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($b4450e5745e49325$var$gecko && node.nodeType == 1 && offset < $b4450e5745e49325$var$nodeLen(node) && $b4450e5745e49325$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($b4450e5745e49325$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($b4450e5745e49325$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $b4450e5745e49325$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $b4450e5745e49325$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $b4450e5745e49325$var$nodeLen(node);
            }
        }
    }
    if (force) $b4450e5745e49325$var$setSelFocus(view, node, offset);
    else if (moveNode) $b4450e5745e49325$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $b4450e5745e49325$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $b4450e5745e49325$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($b4450e5745e49325$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($b4450e5745e49325$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $b4450e5745e49325$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $b4450e5745e49325$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $b4450e5745e49325$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $b4450e5745e49325$var$setSelFocus(view, moveNode, moveOffset);
}
function $b4450e5745e49325$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $b4450e5745e49325$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$b4450e5745e49325$var$hasBlockDesc(node)){
        offset = $b4450e5745e49325$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $b4450e5745e49325$var$textNodeBefore(node, offset) {
    while(node && !offset && !$b4450e5745e49325$var$hasBlockDesc(node)){
        offset = $b4450e5745e49325$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $b4450e5745e49325$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $b4450e5745e49325$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $b4450e5745e49325$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($b4450e5745e49325$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $b4450e5745e49325$var$selectionToDOM(view);
    }, 50);
}
function $b4450e5745e49325$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($b4450e5745e49325$var$chrome || $b4450e5745e49325$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $b4450e5745e49325$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $ks2lK.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($b4450e5745e49325$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $b4450e5745e49325$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $ks2lK.NodeSelection)) return $b4450e5745e49325$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $ks2lK.AllSelection) ? (0, $ks2lK.Selection).near(side, dir) : (0, $ks2lK.Selection).findFrom(side, dir);
        return beyond ? $b4450e5745e49325$var$apply(view, beyond) : false;
    }
    return false;
}
function $b4450e5745e49325$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $ks2lK.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $b4450e5745e49325$var$safariDownArrowBug(view) {
    if (!$b4450e5745e49325$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $b4450e5745e49325$var$switchEditable(view, child, "true");
        setTimeout(()=>$b4450e5745e49325$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $b4450e5745e49325$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $b4450e5745e49325$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $b4450e5745e49325$var$getMods(event);
    if (code == 8 || $b4450e5745e49325$var$mac && code == 72 && mods == "c") return $b4450e5745e49325$var$stopNativeHorizontalDelete(view, -1) || $b4450e5745e49325$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $b4450e5745e49325$var$mac && code == 68 && mods == "c") return $b4450e5745e49325$var$stopNativeHorizontalDelete(view, 1) || $b4450e5745e49325$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $b4450e5745e49325$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $b4450e5745e49325$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $b4450e5745e49325$var$selectHorizontally(view, dir, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $b4450e5745e49325$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $b4450e5745e49325$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $b4450e5745e49325$var$selectHorizontally(view, dir, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $b4450e5745e49325$var$mac && code == 80 && mods == "c") return $b4450e5745e49325$var$selectVertically(view, -1, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $b4450e5745e49325$var$mac && code == 78 && mods == "c") return $b4450e5745e49325$var$safariDownArrowBug(view) || $b4450e5745e49325$var$selectVertically(view, 1, mods) || $b4450e5745e49325$var$skipIgnoredNodes(view, 1);
    else if (mods == ($b4450e5745e49325$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $b4450e5745e49325$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $5SAOw.DOMSerializer).fromSchema(view.state.schema);
    let doc = $b4450e5745e49325$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $b4450e5745e49325$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $b4450e5745e49325$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = !!text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) {
            slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0);
            view.someProp("transformPasted", (f)=>{
                slice = f(slice, view, true);
            });
            return slice;
        }
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $5SAOw.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $b4450e5745e49325$var$readHTML(html);
        if ($b4450e5745e49325$var$webkit) $b4450e5745e49325$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $5SAOw.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$b4450e5745e49325$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $b4450e5745e49325$var$addContext($b4450e5745e49325$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $5SAOw.Slice).maxOpen($b4450e5745e49325$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $b4450e5745e49325$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, asText);
    });
    return slice;
}
const $b4450e5745e49325$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $b4450e5745e49325$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $b4450e5745e49325$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $b4450e5745e49325$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $5SAOw.Fragment).from(result);
    }
    return fragment;
}
function $b4450e5745e49325$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $5SAOw.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $b4450e5745e49325$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $5SAOw.Fragment).from($b4450e5745e49325$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $b4450e5745e49325$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $b4450e5745e49325$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $5SAOw.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $b4450e5745e49325$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $b4450e5745e49325$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $5SAOw.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $b4450e5745e49325$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $5SAOw.Slice)($b4450e5745e49325$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $5SAOw.Slice)($b4450e5745e49325$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $b4450e5745e49325$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $b4450e5745e49325$var$_detachedDoc = null;
function $b4450e5745e49325$var$detachedDoc() {
    return $b4450e5745e49325$var$_detachedDoc || ($b4450e5745e49325$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $b4450e5745e49325$var$_policy = null;
function $b4450e5745e49325$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$b4450e5745e49325$var$_policy) $b4450e5745e49325$var$_policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $b4450e5745e49325$var$_policy.createHTML(html);
}
function $b4450e5745e49325$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $b4450e5745e49325$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $b4450e5745e49325$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $b4450e5745e49325$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $b4450e5745e49325$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($b4450e5745e49325$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $b4450e5745e49325$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $5SAOw.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $5SAOw.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $b4450e5745e49325$var$handlers = {};
const $b4450e5745e49325$var$editHandlers = {};
const $b4450e5745e49325$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $b4450e5745e49325$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: "",
            button: 0
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        this.badSafariComposition = false;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $b4450e5745e49325$var$initInput(view) {
    for(let event in $b4450e5745e49325$var$handlers){
        let handler = $b4450e5745e49325$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($b4450e5745e49325$var$eventBelongsToView(view, event) && !$b4450e5745e49325$var$runCustomHandler(view, event) && (view.editable || !(event.type in $b4450e5745e49325$var$editHandlers))) handler(view, event);
        }, $b4450e5745e49325$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($b4450e5745e49325$var$safari) view.dom.addEventListener("input", ()=>null);
    $b4450e5745e49325$var$ensureListeners(view);
}
function $b4450e5745e49325$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $b4450e5745e49325$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $b4450e5745e49325$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$b4450e5745e49325$var$runCustomHandler(view, event));
    });
}
function $b4450e5745e49325$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $b4450e5745e49325$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $b4450e5745e49325$var$dispatchEvent(view, event) {
    if (!$b4450e5745e49325$var$runCustomHandler(view, event) && $b4450e5745e49325$var$handlers[event.type] && (view.editable || !(event.type in $b4450e5745e49325$var$editHandlers))) $b4450e5745e49325$var$handlers[event.type](view, event);
}
$b4450e5745e49325$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($b4450e5745e49325$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($b4450e5745e49325$var$android && $b4450e5745e49325$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($b4450e5745e49325$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $b4450e5745e49325$var$captureKeyDown(view, event)) event.preventDefault();
    else $b4450e5745e49325$var$setSelectionOrigin(view, "key");
};
$b4450e5745e49325$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$b4450e5745e49325$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($b4450e5745e49325$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $b4450e5745e49325$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $ks2lK.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        let deflt = ()=>view.state.tr.insertText(text).scrollIntoView();
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text, deflt))) view.dispatch(deflt());
        event.preventDefault();
    }
};
function $b4450e5745e49325$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $b4450e5745e49325$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $b4450e5745e49325$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $b4450e5745e49325$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $b4450e5745e49325$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $ks2lK.NodeSelection).isSelectable(node)) {
        $b4450e5745e49325$var$updateSelection(view, new (0, $ks2lK.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $ks2lK.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $ks2lK.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $b4450e5745e49325$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $b4450e5745e49325$var$selectClickedNode(view, inside) : $b4450e5745e49325$var$selectClickedLeaf(view, inside));
}
function $b4450e5745e49325$var$handleDoubleClick(view, pos, inside, event) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $b4450e5745e49325$var$handleTripleClick(view, pos, inside, event) {
    return $b4450e5745e49325$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $b4450e5745e49325$var$defaultTripleClick(view, inside, event);
}
function $b4450e5745e49325$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $ks2lK.NodeSelection).isSelectable(node)) $b4450e5745e49325$var$updateSelection(view, (0, $ks2lK.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $b4450e5745e49325$var$forceDOMFlush(view) {
    return $b4450e5745e49325$var$endComposition(view);
}
const $b4450e5745e49325$var$selectNodeModifier = $b4450e5745e49325$var$mac ? "metaKey" : "ctrlKey";
$b4450e5745e49325$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $b4450e5745e49325$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $b4450e5745e49325$var$isNear(event, view.input.lastClick) && !event[$b4450e5745e49325$var$selectNodeModifier] && view.input.lastClick.button == event.button) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type,
        button: event.button
    };
    let pos = view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $b4450e5745e49325$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $b4450e5745e49325$var$handleDoubleClick : $b4450e5745e49325$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
class $b4450e5745e49325$var$MouseDown {
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$b4450e5745e49325$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
        else if ($b4450e5745e49325$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $b4450e5745e49325$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $b4450e5745e49325$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $b4450e5745e49325$var$updateSelection(this.view, (0, $ks2lK.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $b4450e5745e49325$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$b4450e5745e49325$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $ks2lK.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $b4450e5745e49325$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
    }
}
$b4450e5745e49325$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $b4450e5745e49325$var$forceDOMFlush(view);
    $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
$b4450e5745e49325$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $b4450e5745e49325$var$setSelectionOrigin(view, "pointer");
};
$b4450e5745e49325$var$handlers.contextmenu = (view)=>$b4450e5745e49325$var$forceDOMFlush(view);
function $b4450e5745e49325$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($b4450e5745e49325$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $b4450e5745e49325$var$timeoutComposition = $b4450e5745e49325$var$android ? 5000 : -1;
$b4450e5745e49325$var$editHandlers.compositionstart = $b4450e5745e49325$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $ks2lK.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false) || $b4450e5745e49325$var$chrome && $b4450e5745e49325$var$windows && $b4450e5745e49325$var$selectionBeforeUneditable(view))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $b4450e5745e49325$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $b4450e5745e49325$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($b4450e5745e49325$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $b4450e5745e49325$var$scheduleComposeEnd(view, $b4450e5745e49325$var$timeoutComposition);
};
function $b4450e5745e49325$var$selectionBeforeUneditable(view) {
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length) return false;
    let next = focusNode.childNodes[focusOffset];
    return next.nodeType == 1 && next.contentEditable == "false";
}
$b4450e5745e49325$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.badSafariComposition) view.domObserver.forceFlush();
        else if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $b4450e5745e49325$var$scheduleComposeEnd(view, 20);
    }
};
function $b4450e5745e49325$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$b4450e5745e49325$var$endComposition(view), delay);
}
function $b4450e5745e49325$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $b4450e5745e49325$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $b4450e5745e49325$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $b4450e5745e49325$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $b4450e5745e49325$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $b4450e5745e49325$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $b4450e5745e49325$var$endComposition(view, restarting = false) {
    if ($b4450e5745e49325$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $b4450e5745e49325$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $b4450e5745e49325$var$selectionFromDOM(view), cur = view.state.selection;
        if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $b4450e5745e49325$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $b4450e5745e49325$var$brokenClipboardAPI = $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version < 15 || $b4450e5745e49325$var$ios && $b4450e5745e49325$var$webkit_version < 604;
$b4450e5745e49325$var$handlers.copy = $b4450e5745e49325$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $b4450e5745e49325$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $b4450e5745e49325$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $b4450e5745e49325$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $b4450e5745e49325$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $b4450e5745e49325$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $b4450e5745e49325$var$doPaste(view, target.value, null, plain, event);
        else $b4450e5745e49325$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $b4450e5745e49325$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $b4450e5745e49325$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $5SAOw.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $b4450e5745e49325$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $b4450e5745e49325$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$b4450e5745e49325$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$b4450e5745e49325$var$android) return;
    let data = $b4450e5745e49325$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $b4450e5745e49325$var$doPaste(view, $b4450e5745e49325$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $b4450e5745e49325$var$capturePaste(view, event);
};
class $b4450e5745e49325$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $b4450e5745e49325$var$dragCopyModifier = $b4450e5745e49325$var$mac ? "altKey" : "ctrlKey";
function $b4450e5745e49325$var$dragMoves(view, event) {
    let moves = view.someProp("dragCopies", (test)=>!test(event));
    return moves != null ? moves : !event[$b4450e5745e49325$var$dragCopyModifier];
}
$b4450e5745e49325$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $ks2lK.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $ks2lK.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $ks2lK.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $b4450e5745e49325$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$b4450e5745e49325$var$chrome || $b4450e5745e49325$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($b4450e5745e49325$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$b4450e5745e49325$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $b4450e5745e49325$var$Dragging(slice, $b4450e5745e49325$var$dragMoves(view, event), node);
};
$b4450e5745e49325$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$b4450e5745e49325$var$editHandlers.dragover = $b4450e5745e49325$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$b4450e5745e49325$var$editHandlers.drop = (view, event)=>{
    try {
        $b4450e5745e49325$var$handleDrop(view, event, view.dragging);
    } finally{
        view.dragging = null;
    }
};
function $b4450e5745e49325$var$handleDrop(view, event, dragging) {
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($b4450e5745e49325$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, false);
    });
    else slice = $b4450e5745e49325$var$parseFromClipboard(view, $b4450e5745e49325$var$getText(event.dataTransfer), $b4450e5745e49325$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && $b4450e5745e49325$var$dragMoves(view, event));
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $5SAOw.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $aXG5V.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $ks2lK.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $ks2lK.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($b4450e5745e49325$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
}
$b4450e5745e49325$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $b4450e5745e49325$var$selectionToDOM(view);
        }, 20);
    }
};
$b4450e5745e49325$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$b4450e5745e49325$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($b4450e5745e49325$var$chrome && $b4450e5745e49325$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $b4450e5745e49325$var$editHandlers)$b4450e5745e49325$var$handlers[prop] = $b4450e5745e49325$var$editHandlers[prop];
function $b4450e5745e49325$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $b4450e5745e49325$var$WidgetType {
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $b4450e5745e49325$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $b4450e5745e49325$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
        this.side = this.spec.side || 0;
    }
}
class $b4450e5745e49325$var$InlineType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $b4450e5745e49325$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$InlineType && $b4450e5745e49325$var$compareObjs(this.attrs, other.attrs) && $b4450e5745e49325$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $b4450e5745e49325$var$InlineType;
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
    }
}
class $b4450e5745e49325$var$NodeType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $b4450e5745e49325$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $b4450e5745e49325$var$NodeType && $b4450e5745e49325$var$compareObjs(this.attrs, other.attrs) && $b4450e5745e49325$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b4450e5745e49325$var$noSpec;
    }
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $b4450e5745e49325$export$10e30b733df217ea {
    /**
    @internal
    */ copy(from, to) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(pos, pos, new $b4450e5745e49325$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, new $b4450e5745e49325$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $b4450e5745e49325$export$10e30b733df217ea(from, to, new $b4450e5745e49325$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $b4450e5745e49325$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $b4450e5745e49325$var$WidgetType;
    }
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
}
const $b4450e5745e49325$var$none = [], $b4450e5745e49325$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $b4450e5745e49325$export$93bf62eb445cec98 {
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $b4450e5745e49325$var$buildTree(decorations, doc, 0, $b4450e5745e49325$var$noSpec) : $b4450e5745e49325$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $b4450e5745e49325$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $b4450e5745e49325$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $b4450e5745e49325$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $b4450e5745e49325$export$93bf62eb445cec98(newLocal.sort($b4450e5745e49325$var$byPos), $b4450e5745e49325$var$none) : $b4450e5745e49325$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $b4450e5745e49325$var$empty) return $b4450e5745e49325$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $b4450e5745e49325$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $b4450e5745e49325$var$buildTree(found, childNode, baseOffset + 1, $b4450e5745e49325$var$noSpec));
            childIndex += 3;
        });
        let local = $b4450e5745e49325$var$moveSpans(childIndex ? $b4450e5745e49325$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $b4450e5745e49325$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($b4450e5745e49325$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $b4450e5745e49325$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $b4450e5745e49325$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $b4450e5745e49325$export$93bf62eb445cec98(local, children) : $b4450e5745e49325$var$empty;
    }
    forChild(offset, node) {
        if (this == $b4450e5745e49325$var$empty) return this;
        if (node.isLeaf) return $b4450e5745e49325$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $b4450e5745e49325$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $b4450e5745e49325$export$93bf62eb445cec98(local.sort($b4450e5745e49325$var$byPos), $b4450e5745e49325$var$none);
            return child ? new $b4450e5745e49325$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $b4450e5745e49325$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $b4450e5745e49325$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $b4450e5745e49325$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $b4450e5745e49325$var$empty) return $b4450e5745e49325$var$none;
        if (node.inlineContent || !this.local.some($b4450e5745e49325$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $b4450e5745e49325$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $b4450e5745e49325$var$none;
        this.children = children.length ? children : $b4450e5745e49325$var$none;
    }
}
/**
The empty set of decorations.
*/ $b4450e5745e49325$export$93bf62eb445cec98.empty = new $b4450e5745e49325$export$93bf62eb445cec98([], []);
/**
@internal
*/ $b4450e5745e49325$export$93bf62eb445cec98.removeOverlap = $b4450e5745e49325$var$removeOverlap;
const $b4450e5745e49325$var$empty = $b4450e5745e49325$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $b4450e5745e49325$var$DecorationGroup {
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $b4450e5745e49325$var$noSpec));
        return $b4450e5745e49325$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $b4450e5745e49325$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $b4450e5745e49325$var$empty) continue;
            if (result instanceof $b4450e5745e49325$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $b4450e5745e49325$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $b4450e5745e49325$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $b4450e5745e49325$var$removeOverlap(sorted ? result : result.sort($b4450e5745e49325$var$byPos)) : $b4450e5745e49325$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $b4450e5745e49325$var$empty;
            case 1:
                return members[0];
            default:
                return new $b4450e5745e49325$var$DecorationGroup(members.every((m)=>m instanceof $b4450e5745e49325$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $b4450e5745e49325$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
    constructor(members){
        this.members = members;
    }
}
function $b4450e5745e49325$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $b4450e5745e49325$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $b4450e5745e49325$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $b4450e5745e49325$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $b4450e5745e49325$export$93bf62eb445cec98(newLocal.sort($b4450e5745e49325$var$byPos), children);
}
function $b4450e5745e49325$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $b4450e5745e49325$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $b4450e5745e49325$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $b4450e5745e49325$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $b4450e5745e49325$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $b4450e5745e49325$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $b4450e5745e49325$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $b4450e5745e49325$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $b4450e5745e49325$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $b4450e5745e49325$var$moveSpans(hasNulls ? $b4450e5745e49325$var$withoutNulls(spans) : spans, -offset).sort($b4450e5745e49325$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $b4450e5745e49325$export$93bf62eb445cec98(locals, children) : $b4450e5745e49325$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $b4450e5745e49325$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $b4450e5745e49325$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $b4450e5745e49325$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $b4450e5745e49325$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $b4450e5745e49325$var$insertAhead(array, i, deco) {
    while(i < array.length && $b4450e5745e49325$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $b4450e5745e49325$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $b4450e5745e49325$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($b4450e5745e49325$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $b4450e5745e49325$var$DecorationGroup.from(found);
}
const $b4450e5745e49325$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $b4450e5745e49325$var$useCharData = $b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11;
class $b4450e5745e49325$var$SelectionState {
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
}
class $b4450e5745e49325$var$DOMObserver {
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $b4450e5745e49325$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$b4450e5745e49325$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $b4450e5745e49325$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $b4450e5745e49325$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $b4450e5745e49325$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $b4450e5745e49325$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $b4450e5745e49325$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($b4450e5745e49325$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $b4450e5745e49325$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        } else if (($b4450e5745e49325$var$chrome || $b4450e5745e49325$var$safari) && added.some((n)=>n.nodeName == "BR") && (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46)) {
            // Chrome/Safari sometimes insert a bogus break node if you
            // backspace out the last bit of text before an inline-flex node (#1552)
            for (let node of added)if (node.nodeName == "BR" && node.parentNode) {
                let after = node.nextSibling;
                if (after && after.nodeType == 1 && after.contentEditable == "false") node.parentNode.removeChild(node);
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $b4450e5745e49325$var$selectionCollapsed(sel) && (readSel = $b4450e5745e49325$var$selectionFromDOM(view)) && readSel.eq((0, $ks2lK.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $b4450e5745e49325$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $b4450e5745e49325$var$checkCSS(view);
            }
            if (view.input.badSafariComposition) {
                view.input.badSafariComposition = false;
                $b4450e5745e49325$var$fixUpBadSafariComposition(view, added);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $b4450e5745e49325$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $b4450e5745e49325$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $b4450e5745e49325$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $b4450e5745e49325$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            this.flushSoon();
            else if ($b4450e5745e49325$var$safari && view.composing && mutations.some((m)=>m.type == "childList" && m.target.nodeName == "TR")) {
                // Safari does weird stuff when finishing a composition in a
                // table cell, which tends to involve inserting inappropriate
                // nodes in the table row.
                view.input.badSafariComposition = true;
                this.flushSoon();
            } else this.flush();
        });
        if ($b4450e5745e49325$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
}
let $b4450e5745e49325$var$cssChecked = new WeakMap();
let $b4450e5745e49325$var$cssCheckWarned = false;
function $b4450e5745e49325$var$checkCSS(view) {
    if ($b4450e5745e49325$var$cssChecked.has(view)) return;
    $b4450e5745e49325$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $b4450e5745e49325$var$gecko;
        if ($b4450e5745e49325$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $b4450e5745e49325$var$cssCheckWarned = true;
    }
}
function $b4450e5745e49325$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($b4450e5745e49325$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $b4450e5745e49325$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $b4450e5745e49325$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $b4450e5745e49325$var$rangeToSelectionRange(view, found) : null;
}
function $b4450e5745e49325$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Kludge for a Safari bug where, on ending a composition in an
// otherwise empty table cell, it randomly moves the composed text
// into the table row around that cell, greatly confusing everything
// (#188).
function $b4450e5745e49325$var$fixUpBadSafariComposition(view, addedNodes) {
    var _a;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    for (let node of addedNodes)if (((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName) == "TR") {
        let nextCell = node.nextSibling;
        while(nextCell && nextCell.nodeName != "TD" && nextCell.nodeName != "TH")nextCell = nextCell.nextSibling;
        if (nextCell) {
            let parent = nextCell;
            for(;;){
                let first = parent.firstChild;
                if (!first || first.nodeType != 1 || first.contentEditable == "false" || /^(BR|IMG)$/.test(first.nodeName)) break;
                parent = first;
            }
            parent.insertBefore(node, parent.firstChild);
            if (focusNode == node) view.domSelection().collapse(node, focusOffset);
        } else node.parentNode.removeChild(node);
    }
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $b4450e5745e49325$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$b4450e5745e49325$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($b4450e5745e49325$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $5SAOw.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $b4450e5745e49325$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $b4450e5745e49325$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($b4450e5745e49325$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $b4450e5745e49325$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $b4450e5745e49325$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $b4450e5745e49325$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $b4450e5745e49325$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($b4450e5745e49325$var$chrome && $b4450e5745e49325$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $b4450e5745e49325$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $b4450e5745e49325$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($b4450e5745e49325$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $b4450e5745e49325$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$b4450e5745e49325$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $ks2lK.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $b4450e5745e49325$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $ks2lK.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($b4450e5745e49325$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && $from.pos < $to.pos && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", ""))) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $b4450e5745e49325$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $b4450e5745e49325$var$keyEvent(8, "Backspace")))) {
        if ($b4450e5745e49325$var$android && $b4450e5745e49325$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($b4450e5745e49325$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($b4450e5745e49325$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $b4450e5745e49325$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let mkTr = (base)=>{
        let tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = $b4450e5745e49325$var$resolveSelection(view, tr.doc, parse.sel);
            // Chrome will sometimes, during composition, report the
            // selection in the wrong place. If it looks like that is
            // happening, don't update the selection.
            // Edge just doesn't move the cursor forward when you start typing
            // in an empty block or between br nodes.
            if (sel && !($b4450e5745e49325$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $b4450e5745e49325$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
        }
        if (compositionID) tr.setMeta("composition", compositionID);
        return tr.scrollIntoView();
    };
    let markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($b4450e5745e49325$var$ie && $b4450e5745e49325$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$b4450e5745e49325$var$selectionToDOM(view), 20);
            }
            let tr = mkTr(view.state.tr.delete(chFrom, chTo));
            let marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            if (marks) tr.ensureMarks(marks);
            view.dispatch(tr);
        } else if (change.endA == change.endB && (markChange = $b4450e5745e49325$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            let tr = mkTr(view.state.tr);
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
            view.dispatch(tr);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            let deflt = ()=>mkTr(view.state.tr.insertText(text, chFrom, chTo));
            if (!view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text, deflt))) view.dispatch(deflt());
        } else view.dispatch(mkTr());
    } else view.dispatch(mkTr());
}
function $b4450e5745e49325$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $b4450e5745e49325$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $b4450e5745e49325$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $5SAOw.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $b4450e5745e49325$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $b4450e5745e49325$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($b4450e5745e49325$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $b4450e5745e49325$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $b4450e5745e49325$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $b4450e5745e49325$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $b4450e5745e49325$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $b4450e5745e49325$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $b4450e5745e49325$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $b4450e5745e49325$export$5d42ca91c11c9e4d = $b4450e5745e49325$var$parseFromClipboard;
/**
@internal
*/ const $b4450e5745e49325$export$76b14d3c719c32fc = $b4450e5745e49325$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $b4450e5745e49325$export$eece2fccabbb77c5 {
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $b4450e5745e49325$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($b4450e5745e49325$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $b4450e5745e49325$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $b4450e5745e49325$var$buildNodeViews(this);
            if ($b4450e5745e49325$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $b4450e5745e49325$var$ensureListeners(this);
        this.editable = $b4450e5745e49325$var$getEditable(this);
        $b4450e5745e49325$var$updateCursorWrapper(this);
        let innerDeco = $b4450e5745e49325$var$viewDecorations(this), outerDeco = $b4450e5745e49325$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $b4450e5745e49325$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($b4450e5745e49325$var$ie || $b4450e5745e49325$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $b4450e5745e49325$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $b4450e5745e49325$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $b4450e5745e49325$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $b4450e5745e49325$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && (!this.trackWrites || !this.dom.contains(this.trackWrites))) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $b4450e5745e49325$var$anchorInRightPlace(this))) $b4450e5745e49325$var$selectionToDOM(this, forceSelUpdate);
            else {
                $b4450e5745e49325$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $b4450e5745e49325$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $ks2lK.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $b4450e5745e49325$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $b4450e5745e49325$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $b4450e5745e49325$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $ks2lK.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($b4450e5745e49325$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $b4450e5745e49325$var$focusPreventScroll(this.dom);
        $b4450e5745e49325$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $b4450e5745e49325$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $b4450e5745e49325$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $b4450e5745e49325$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $b4450e5745e49325$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $b4450e5745e49325$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */ serializeForClipboard(slice) {
        return $b4450e5745e49325$var$serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $b4450e5745e49325$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $b4450e5745e49325$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $b4450e5745e49325$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $b4450e5745e49325$var$dispatchEvent(this, event);
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $b4450e5745e49325$var$safari && this.root.nodeType === 11 && $b4450e5745e49325$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $b4450e5745e49325$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $b4450e5745e49325$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($b4450e5745e49325$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $b4450e5745e49325$var$getEditable(this);
        $b4450e5745e49325$var$updateCursorWrapper(this);
        this.nodeViews = $b4450e5745e49325$var$buildNodeViews(this);
        this.docView = $b4450e5745e49325$var$docViewDesc(this.state.doc, $b4450e5745e49325$var$computeDocDeco(this), $b4450e5745e49325$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $b4450e5745e49325$var$DOMObserver(this, (from, to, typeOver, added)=>$b4450e5745e49325$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $b4450e5745e49325$var$initInput(this);
        this.updatePluginViews();
    }
}
$b4450e5745e49325$export$eece2fccabbb77c5.prototype.dispatch = function(tr) {
    let dispatchTransaction = this._props.dispatchTransaction;
    if (dispatchTransaction) dispatchTransaction.call(this, tr);
    else this.updateState(this.state.apply(tr));
};
function $b4450e5745e49325$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $b4450e5745e49325$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $b4450e5745e49325$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $b4450e5745e49325$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $b4450e5745e49325$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $b4450e5745e49325$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $b4450e5745e49325$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $b4450e5745e49325$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $b4450e5745e49325$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
module.exports["Decoration"] = $b4450e5745e49325$export$10e30b733df217ea;
module.exports["DecorationSet"] = $b4450e5745e49325$export$93bf62eb445cec98;
module.exports["EditorView"] = $b4450e5745e49325$export$eece2fccabbb77c5;

});

parcelRegister("hEPfr", function(module, exports) {
function $0f830263e94a6c1b$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}
module.exports["getNodesCount"] = $0f830263e94a6c1b$export$3674f49b2d541ad;

});

parcelRegister("geLSP", function(module, exports) {
function $636443110c5c1dfb$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}
module.exports["isFullPage"] = $636443110c5c1dfb$export$2800a15841f40ad7;

});

parcelRegister("h9Yad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ZkPRR = parcelRequire("ZkPRR");

function $3946837408650aa8$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $42omo.useRef)();
    const renderCountRef = (0, $42omo.useRef)(zeroBasedCount ? 0 : 1);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: componentId } = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    (0, $42omo.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $ZkPRR.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $ZkPRR.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}
module.exports["useComponentRenderTracking"] = $3946837408650aa8$export$ebce6d7d8ca67353;

});

parcelRegister("ZkPRR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $88475e86f62b9e57$export$74743eda5dda3ccf = Object.keys;
const $88475e86f62b9e57$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $88475e86f62b9e57$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $88475e86f62b9e57$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $88475e86f62b9e57$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value1),
                newValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $88475e86f62b9e57$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
module.exports["getPropsDifference"] = $88475e86f62b9e57$export$d438af18e3a25d10;
module.exports["getShallowPropsDifference"] = $88475e86f62b9e57$export$418b0a935c0a0030;

});

parcelRegister("dSVmA", function(module, exports) {
class $9e998316eee14f1b$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}
module.exports["ErrorReporter"] = $9e998316eee14f1b$export$88da0ac32d9c271e;

});

parcelRegister("2oGxU", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $1829e3410f9040f1$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'panel_c1',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $1829e3410f9040f1$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $1829e3410f9040f1$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}
module.exports["sortByOrder"] = $1829e3410f9040f1$export$49afdc3354d5c84e;
module.exports["sortByOrderWithTypeName"] = $1829e3410f9040f1$export$b4ae7ad1c009d0a1;

});

parcelRegister("1B55v", function(module, exports) {
$parcel$export(module.exports, "default", () => $a071074fd2398ee1$export$2e2bcd8739ae039);

var $6DQRK = parcelRequire("6DQRK");


var $geLSP = parcelRequire("geLSP");

const $a071074fd2398ee1$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $a071074fd2398ee1$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $geLSP.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $a071074fd2398ee1$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent,
            pasteWarningOptions: props.pasteWarningOptions
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $a071074fd2398ee1$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.disableDefaultItems || false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web',
            autoLinkOnBlur: props.linking?.autoLinkOnBlur
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $a071074fd2398ee1$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$a071074fd2398ee1$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}
module.exports["getDefaultPresetOptionsFromEditorProps"] = $a071074fd2398ee1$export$fdea1e40b8747a5b;

});

parcelRegister("4VpM8", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");

function $62c5e4b0ecece381$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $jy7VG.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}
module.exports["getAnalyticsEventsFromTransaction"] = $62c5e4b0ecece381$export$d9985be1ece4b7ee;

});

parcelRegister("f8zg2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $2dfeb0eb8ad08222$var$useCheckIntlContext = ()=>(0, $42omo.useContext)((0, $aXWIB.IntlContext)) === null;
function $2dfeb0eb8ad08222$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $2dfeb0eb8ad08222$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: "en"
    }, children);
    return children;
}
module.exports["IntlProviderIfMissingWrapper"] = $2dfeb0eb8ad08222$export$742fe272b8921eea;

});

parcelRegister("eEmxu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b623af3ab0506ee$export$2e2bcd8739ae039);

var $iScNA = parcelRequire("iScNA");

var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $9b623af3ab0506ee$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $iScNA.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});

parcelRegister("6cQbn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aXWIB = parcelRequire("aXWIB");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $1Oo9w = parcelRequire("1Oo9w");

var $eiA8Z = parcelRequire("eiA8Z");


var $61p3e = parcelRequire("61p3e");


var $bWRlG = parcelRequire("bWRlG");


var $5Gwdo = parcelRequire("5Gwdo");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $kXpLO = parcelRequire("kXpLO");


var $45E6y = parcelRequire("45E6y");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");


var $4cy2V = parcelRequire("4cy2V");


var $1xxAs = parcelRequire("1xxAs");


var $uq7dM = parcelRequire("uq7dM");





var $cPCP8 = parcelRequire("cPCP8");


var $5ZzFz = parcelRequire("5ZzFz");


var $eUp7e = parcelRequire("eUp7e");

const $7b17ca9ed479c680$export$48156340a1673791 = ({ editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>component.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR);
    if (!components || !(0, $5ZzFz.isToolbar)(toolbar)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eUp7e.ToolbarNext), {
        toolbar: toolbar,
        components: components,
        editorView: editorView,
        editorAPI: editorAPI,
        editorAppearance: editorAppearance,
        isDisabled: disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $dh538 = parcelRequire("dh538");




function $e32357fdc808702d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $e32357fdc808702d$var$akEditorMenuZIndex = 500;
const $e32357fdc808702d$var$akEditorToolbarKeylineHeight = 2;
const $e32357fdc808702d$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
/** keep default padding for entire toolbar */ const $e32357fdc808702d$var$mainToolbarWithoutLeftPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`
});
const $e32357fdc808702d$var$mainToolbarWithPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"}`
});
const $e32357fdc808702d$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
const $e32357fdc808702d$var$mainToolbarWithRadiusStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    borderRadius: `${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"} 0 0`
});
const $e32357fdc808702d$var$mainToolbarRadius = /*#__PURE__*/ (0, $9K4OG.css)({
    borderRadius: `${"var(--ds-radius-medium, 6px)"} ${"var(--ds-radius-medium, 6px)"} 0 0`
});
const $e32357fdc808702d$var$stickyToolbarWrapperStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'sticky',
    paddingBottom: "var(--ds-space-100, 8px)",
    zIndex: $e32357fdc808702d$var$akEditorMenuZIndex,
    transition: 'box-shadow ease-in-out 0.2s',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: `0 ${$e32357fdc808702d$var$akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`
    }
});
const $e32357fdc808702d$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $42omo.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $42omo.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $e32357fdc808702d$var$mainToolbarTwoLineStylesNew,
            $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh,
            $e32357fdc808702d$var$stickyToolbarWrapperStyleNew,
            props.isNewToolbarEnabled && $e32357fdc808702d$var$mainToolbarWithPadding,
            (0, $1oCLl.expValEquals)('platform_editor_fix_comment_border', 'isEnabled', true) && (0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && $e32357fdc808702d$var$mainToolbarRadius,
            (0, $1oCLl.expValEquals)('platform_editor_fix_comment_border', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_comments_border_radius') && $e32357fdc808702d$var$mainToolbarWithRadiusStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $e32357fdc808702d$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $e32357fdc808702d$var$mainToolbarTwoLineStylesNew,
            $e32357fdc808702d$var$mainToolbarWrapperStylesVisualRefresh,
            props.isNewToolbarEnabled && $e32357fdc808702d$var$mainToolbarWithoutLeftPadding,
            !(0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_comments_border_radius') && $e32357fdc808702d$var$mainToolbarWithRadiusStyle,
            (0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) && $e32357fdc808702d$var$mainToolbarRadius
        ],
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $e32357fdc808702d$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $e32357fdc808702d$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isNewToolbarEnabled: isNewToolbarEnabled })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $9K4OG.jsx)($e32357fdc808702d$var$StickyToolbar, {
        ...$e32357fdc808702d$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($e32357fdc808702d$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled
    }, children);
};


function $9cfcad4a35f316a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9cfcad4a35f316a8$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
// Remove when platform_editor_comment_editor_border_radius is cleaned up
const $9cfcad4a35f316a8$var$commentEditorStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $9cfcad4a35f316a8$var$commentEditorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    boxSizing: 'border-box',
    borderRadius: "var(--ds-radius-medium, 6px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $9cfcad4a35f316a8$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleNew = {
    name: "4cnzc6",
    styles: "display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);> div{display:flex;flex-shrink:0;}"
};
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStylePaddingOverride = {
    name: "jjyo93",
    styles: "padding-right:0"
};
const $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [`@media (max-width: ${$9cfcad4a35f316a8$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        paddingRight: 0
    }
});
const $9cfcad4a35f316a8$var$appearance = 'comment';
const $9cfcad4a35f316a8$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>({
            maxContentSizeReached: !!states.maxContentSizeState?.maxContentSizeReached,
            primaryToolbarComponentsState: states.primaryToolbarState?.components,
            editorViewMode: states.editorViewModeState?.mode
        }));
    const primaryToolbarState = (0, $4cy2V.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $1Oo9w.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $aXWIB.useIntl)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $42omo.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $42omo.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $42omo.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $42omo.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const memoizedContentAreaStyles = (0, $42omo.useMemo)(()=>[
            maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null
        ], [
        maxHeight
    ]);
    const contentAreaStyles = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedContentAreaStyles : [
        maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `${maxHeight}px`,
            // When maxHeight is set, content area should have overflow-y explicitly set as auto
            // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
            // This will cause the content area to have content overflowing the container
            // so need to set overflow-y as auto to make sure the content area is scrollable
            overflowY: 'auto'
        }) : null
    ];
    const customToolbarSlot = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleNew,
            isTwoLineToolbarEnabled && $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew,
            isToolbarAIFCEnabled && $9cfcad4a35f316a8$var$mainToolbarCustomComponentsSlotStylePaddingOverride
        ]
    }, customPrimaryToolbarComponents);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $uq7dM.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            (0, $1oCLl.expValEquals)('platform_editor_comment_editor_border_radius', 'isEnabled', true) ? $9cfcad4a35f316a8$var$commentEditorStyles : $9cfcad4a35f316a8$var$commentEditorStylesOld,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e32357fdc808702d$export$f7e5e5a2fbd99270), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled,
        isNewToolbarEnabled: isToolbarAIFCEnabled
    }, isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7b17ca9ed479c680$export$48156340a1673791), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        disabled: !!disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1xxAs.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $9cfcad4a35f316a8$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), customToolbarSlot)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kXpLO.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default), {
            ref: containerElement,
            css: contentAreaStyles,
            isScrollable: maxHeight ? true : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('ak-editor-content-area', {
                'less-margin': width < (0, $aFUXX.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewMode,
            appearance: $9cfcad4a35f316a8$var$appearance,
            useStandardNodeWidth: useStandardNodeWidth
        }, customContentComponents && 'before' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $9cfcad4a35f316a8$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $9cfcad4a35f316a8$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, !!onSave && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $61p3e.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancel,
        testId: "comment-cancel-button",
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $61p3e.default).cancelButton))), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$9cfcad4a35f316a8$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';
module.exports["CommentEditorWithIntl"] = $9cfcad4a35f316a8$export$7b9f3a51cd0c1967;

});

parcelRegister("1Oo9w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $50e773a4bc80d240$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $50e773a4bc80d240$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $50e773a4bc80d240$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $50e773a4bc80d240$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $50e773a4bc80d240$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $50e773a4bc80d240$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $42omo.useState)($50e773a4bc80d240$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $42omo.useRef)({});
    const mounted = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $50e773a4bc80d240$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}
module.exports["useSharedPluginState"] = $50e773a4bc80d240$export$a4c4fd90e2b72baa;

});

parcelRegister("5Gwdo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dK4ZR = parcelRequire("dK4ZR");


var $8aWkM = parcelRequire("8aWkM");


var $b0RMS = parcelRequire("b0RMS");


var $f9zLy = parcelRequire("f9zLy");

function $75d74c57448b9b48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75d74c57448b9b48$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $75d74c57448b9b48$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $75d74c57448b9b48$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const selectedItemIndex = (0, $42omo.useRef)(0);
    const incrementIndex = (0, $42omo.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $42omo.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRightMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $42omo.useCallback)(()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = (0, $42omo.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $dK4ZR.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $b0RMS.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: editorAppearance === 'comment' && $75d74c57448b9b48$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $8aWkM.messages).toolbarLabel),
        "aria-controls": (0, $f9zLy.EDIT_AREA_ID)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($75d74c57448b9b48$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $75d74c57448b9b48$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $75d74c57448b9b48$var$isElementOrAncestorHiddenOrDisabled(element, rootNode) {
    let currentElement = element;
    while(currentElement && currentElement !== rootNode && currentElement !== document.body){
        const style = window.getComputedStyle(currentElement);
        // Check if current element is hidden
        if (style.visibility === 'hidden' || style.display === 'none') return true;
        // Check if current element is disabled
        if (currentElement.hasAttribute('disabled') || currentElement.getAttribute('aria-disabled') === 'true' || currentElement.disabled === true) return true;
        // Move to parent element
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $75d74c57448b9b48$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $75d74c57448b9b48$var$getFocusableElements(rootNode).filter((elm)=>{
        // Check if element or any ancestor is hidden or disabled
        const isHiddenOrDisabled = $75d74c57448b9b48$var$isElementOrAncestorHiddenOrDisabled(elm, rootNode);
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && !isHiddenOrDisabled;
    });
}
module.exports["KeyDownHandlerContext"] = $75d74c57448b9b48$export$5455406531e3792c;
module.exports["ToolbarArrowKeyNavigationProvider"] = $75d74c57448b9b48$export$9837e395eba6f527;

});

parcelRegister("dK4ZR", function(module, exports) {
const $75f348dd52cc6fb8$export$bc90872e265d166e = 8;
const $75f348dd52cc6fb8$export$1f1798e92fa75806 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 40,
    medium: $75f348dd52cc6fb8$export$bc90872e265d166e * 75,
    large: $75f348dd52cc6fb8$export$bc90872e265d166e * 128
};
const $75f348dd52cc6fb8$export$69bde1b03e8b5224 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 50,
    medium: $75f348dd52cc6fb8$export$1f1798e92fa75806.medium,
    large: $75f348dd52cc6fb8$export$1f1798e92fa75806.large
};
const $75f348dd52cc6fb8$export$780035d9fe48eb32 = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 25}px`;
const $75f348dd52cc6fb8$export$95b62a1773aa5ebe = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 6}px`;
const $75f348dd52cc6fb8$export$387950d54d372827 = '12px';
const $75f348dd52cc6fb8$export$51a2d6b2c009fbfd = '54px';
const $75f348dd52cc6fb8$export$df8bcac60101d466 = '20px';
const $75f348dd52cc6fb8$export$9a6bb2acef5e644a = 15;
const $75f348dd52cc6fb8$export$3b8e93b2c0f295b0 = 2;
const $75f348dd52cc6fb8$export$6d221f35db1b75aa = 60;
const $75f348dd52cc6fb8$export$ab53450bc5fd5b7d = 10;
const $75f348dd52cc6fb8$export$6ee360fa4b93ee8e = 'editor-element-browser';
const $75f348dd52cc6fb8$export$f5c254b5428bf7c6 = 'editor-element-browser-list';
module.exports["GRID_SIZE"] = $75f348dd52cc6fb8$export$bc90872e265d166e;
module.exports["DEVICE_BREAKPOINT_NUMBERS"] = $75f348dd52cc6fb8$export$1f1798e92fa75806;
module.exports["FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS"] = $75f348dd52cc6fb8$export$69bde1b03e8b5224;
module.exports["SIDEBAR_WIDTH"] = $75f348dd52cc6fb8$export$780035d9fe48eb32;
module.exports["SIDEBAR_HEADING_WRAPPER_HEIGHT"] = $75f348dd52cc6fb8$export$95b62a1773aa5ebe;
module.exports["INLINE_SIDEBAR_HEIGHT"] = $75f348dd52cc6fb8$export$51a2d6b2c009fbfd;
module.exports["SEARCH_ITEM_HEIGHT_WIDTH"] = $75f348dd52cc6fb8$export$df8bcac60101d466;
module.exports["SCROLLBAR_WIDTH"] = $75f348dd52cc6fb8$export$9a6bb2acef5e644a;
module.exports["ELEMENT_LIST_PADDING"] = $75f348dd52cc6fb8$export$3b8e93b2c0f295b0;
module.exports["ELEMENT_ITEM_HEIGHT"] = $75f348dd52cc6fb8$export$6d221f35db1b75aa;
module.exports["ELEMENT_ITEM_PADDING"] = $75f348dd52cc6fb8$export$ab53450bc5fd5b7d;
module.exports["ELEMENT_BROWSER_ID"] = $75f348dd52cc6fb8$export$6ee360fa4b93ee8e;
module.exports["ELEMENT_BROWSER_LIST_ID"] = $75f348dd52cc6fb8$export$f5c254b5428bf7c6;

});

parcelRegister("f9zLy", function(module, exports) {
const $12841799d44c3fc4$export$b16ce0826b76e795 = 'ak-editor-textarea';
module.exports["EDIT_AREA_ID"] = $12841799d44c3fc4$export$b16ce0826b76e795;

});

parcelRegister("kXpLO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $h3X17 = parcelRequire("h3X17");


var $dhoHU = parcelRequire("dhoHU");


var $1zPzM = parcelRequire("1zPzM");


var $4vlwG = parcelRequire("4vlwG");


var $45E6y = parcelRequire("45E6y");

// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $fdee4aa7754cfd6c$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $fdee4aa7754cfd6c$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $fdee4aa7754cfd6c$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $4vlwG.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $4vlwG.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $4vlwG.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = target?.parentElement?.closest(`[${(0, $45E6y.ignoreAttribute)}]`);
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $4vlwG.closestElement)(target, 'div[offset]'));
    const isAnchorButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'a')) || Boolean((0, $4vlwG.closestElement)(target, 'a')) || event.currentTarget?.nodeName === 'A' || target?.nodeName === 'A';
    const isButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'button')) || Boolean((0, $4vlwG.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON' || isAnchorButtonClicked;
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $fdee4aa7754cfd6c$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $fdee4aa7754cfd6c$export$c5a7a653c4681bfd(view, event);
};
const $fdee4aa7754cfd6c$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $dhoHU.addParagraphAtEnd)(tr);
    }
    (0, $1zPzM.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $h3X17.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};


function $d312f85c475dacb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d312f85c475dacb6$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $d312f85c475dacb6$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $d312f85c475dacb6$var$clickWrapper,
        onMouseDown: handleMouseDown,
        // This div is a presentational container that captures mouse events
        // for programmatic editor focus management, not user interaction.
        role: "presentation"
    }, children);
};
var $d312f85c475dacb6$export$2e2bcd8739ae039 = $d312f85c475dacb6$export$68468c5dbde37b99;
module.exports["default"] = $d312f85c475dacb6$export$2e2bcd8739ae039;

});

parcelRegister("dhoHU", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $afcIe = parcelRequire("afcIe");

function $1d2e8dba41928471$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $1d2e8dba41928471$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $1d2e8dba41928471$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $1d2e8dba41928471$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$b637dda807357427 = (align)=>(tr)=>{
        const { from: from, to: to } = tr.selection;
        const initialDoc = tr.doc;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === tr.doc.type.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (!tr.doc.eq(initialDoc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const parentAllowsMark = state?.schema?.nodes?.blockTaskItem && parent?.type === state?.schema?.nodes?.blockTaskItem && markType === state?.schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$8614a16deba8906f = (markType, getAttrs, allowedBlocks)=>(from, to, tr)=>{
        let markApplied = false;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const schema = tr.doc.type.schema;
            const parentAllowsMark = schema?.nodes?.blockTaskItem && parent?.type === schema?.nodes?.blockTaskItem && markType === schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(tr.doc.type.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $7XFGZ.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$23f118e134ed2228 = (markType, getAttrs, allowedBlocks)=>(tr)=>{
        let markApplied = false;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$8614a16deba8906f(markType, getAttrs, allowedBlocks);
        const initialDoc = tr.doc;
        const { selection: selection } = tr;
        if (selection instanceof (0, $7XFGZ.CellSelection)) selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr);
        });
        else {
            const { from: from, to: to } = selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr);
        }
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (markApplied && !initialDoc.eq(tr.doc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $ks2lK.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $1d2e8dba41928471$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $1d2e8dba41928471$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $7XFGZ.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}
module.exports["addParagraphAtEnd"] = $1d2e8dba41928471$export$fc18809329b5ff08;
module.exports["changeImageAlignment"] = $1d2e8dba41928471$export$774cc08dd90b6a6a;
module.exports["changeImageAlignmentNext"] = $1d2e8dba41928471$export$b637dda807357427;
module.exports["createToggleBlockMarkOnRange"] = $1d2e8dba41928471$export$1115c4cf51ae1924;
module.exports["createToggleBlockMarkOnRangeNext"] = $1d2e8dba41928471$export$8614a16deba8906f;
module.exports["createToggleInlineMarkOnRange"] = $1d2e8dba41928471$export$a10bb5a1a10022f6;
module.exports["toggleBlockMark"] = $1d2e8dba41928471$export$72d6145976985e8c;
module.exports["toggleBlockMarkNext"] = $1d2e8dba41928471$export$23f118e134ed2228;
module.exports["findCutBefore"] = $1d2e8dba41928471$export$ad1078cb3917e860;

});

parcelRegister("afcIe", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $fde5eb025de1bc5c$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $8m4tT.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};
module.exports["insertBlock"] = $fde5eb025de1bc5c$export$f51280337625031;

});

parcelRegister("1zPzM", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $adhil = parcelRequire("adhil");


var $1gpr6 = parcelRequire("1gpr6");

// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $4bfd6331a10a8378$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $adhil.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $adhil.Side).LEFT : (0, $adhil.Side).RIGHT;
            let position;
            if (side === (0, $adhil.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $4bfd6331a10a8378$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $4bfd6331a10a8378$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $adhil.Side).LEFT ? (0, $1gpr6.isValidTargetNode)($pos.nodeAfter) : (0, $1gpr6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $adhil.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $adhil.GapCursorSelection)) tr.setSelection((0, $ks2lK.Selection).near($pos));
        else tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $ks2lK.Selection).findFrom($pos, cursorCoords.side === (0, $adhil.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $4bfd6331a10a8378$export$44fdd7840a0a11f2 = (position, side = (0, $adhil.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $adhil.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };
module.exports["setSelectionTopLevelBlocks"] = $4bfd6331a10a8378$export$1b305efb24649ca5;
module.exports["setGapCursorAtPos"] = $4bfd6331a10a8378$export$44fdd7840a0a11f2;

});

parcelRegister("adhil", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $1gpr6 = parcelRequire("1gpr6");

var $51f4ad1a1d4c86a3$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd = 'gapcursor';
class $51f4ad1a1d4c86a3$export$7d98c58ca1423246 extends (0, $ks2lK.Selection) {
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $1gpr6.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $1gpr6.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, this.side) : (0, $ks2lK.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $51f4ad1a1d4c86a3$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $5SAOw.Slice).empty;
    }
    getBookmark() {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
    /**
   * Construct a GapCursorSelection
   * @param {ResolvedPos} $pos resolved position
   * @param {Side} side side where the gap cursor is drawn
   */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side;
        this.visible = false;
    }
}
(0, $ks2lK.Selection).jsonID($51f4ad1a1d4c86a3$export$d9f9f34e18094ffd, $51f4ad1a1d4c86a3$export$7d98c58ca1423246);
class $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos) : (0, $ks2lK.Selection).near($pos);
    }
    constructor(pos){
        this.pos = pos;
    }
}
module.exports["Side"] = $51f4ad1a1d4c86a3$export$80a00690bda7f17e;
module.exports["JSON_ID"] = $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd;
module.exports["GapCursorSelection"] = $51f4ad1a1d4c86a3$export$7d98c58ca1423246;

});

parcelRegister("1gpr6", function(module, exports) {

var $4Wd8f = parcelRequire("4Wd8f");

const $27b8041df1cc92a4$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $4Wd8f.isIgnored)(node);
};
module.exports["isValidTargetNode"] = $27b8041df1cc92a4$export$b485b49b5e1715ef;

});

parcelRegister("4Wd8f", function(module, exports) {
// we don't show gap cursor for those nodes
const $f3b25ae2912922b3$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $f3b25ae2912922b3$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $f3b25ae2912922b3$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};
module.exports["isIgnored"] = $f3b25ae2912922b3$export$ac3f691269cd6d9b;

});

parcelRegister("45E6y", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $938cf1eec2ff4dc1$export$72d101e93c081651 = 'data-editor-content-component';
const $938cf1eec2ff4dc1$export$57a965c23051130d = (reactComponents)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-editor-content-component": 'true'
    }, reactComponents);
};
module.exports["ignoreAttribute"] = $938cf1eec2ff4dc1$export$72d101e93c081651;
module.exports["contentComponentClickWrapper"] = $938cf1eec2ff4dc1$export$57a965c23051130d;

});

parcelRegister("axOCf", function(module, exports) {
parcelRequire("42omo");


var $9JpPs = parcelRequire("9JpPs");


var $1oCLl = parcelRequire("1oCLl");

/* EditorContentContainer-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: EDITOR-6833 - Expected across this entire file, future violations are expected. Will try to remove them later after fully migration
/* eslint-disable @atlaskit/platform/use-motion-token-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-invalid-css-map, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/platform/expand-spacing-shorthand, @atlaskit/platform/expand-border-shorthand, @atlaskit/platform/expand-background-shorthand */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $d7ZU3 = parcelRequire("d7ZU3");


var $aNOZD = parcelRequire("aNOZD");

const $b1ab53ae0aa17ace$export$fa2ee2d78c59d944 = (0, $aNOZD.mapBackgroundColors)();



var $aFUXX = parcelRequire("aFUXX");

/**
 * Compiled CSS-compatible variant of {@link overflowShadow}. Returns a plain
 * CSS string (stack of `linear-gradient` layers) suitable for assignment to a
 * `background-image` property in a `cssMap`/`css` declaration.
 *
 * @param options.leftCoverWidth - Width of the left cover layer. Defaults to `token('space.100')`.
 * @param options.rightCoverWidth - Width of the right cover layer. Defaults to `token('space.100')`.
 */ const $bfb4214ec776d51e$export$bb4a61a93a1e5360 = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    return [
        /* shadow cover left */ `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${leftCoverWidthResolved},
			transparent ${leftCoverWidthResolved}
		)`,
        /* shadow cover background left */ `linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${leftCoverWidthResolved},
			transparent ${leftCoverWidthResolved}
		)`,
        /* shadow cover right */ `linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${rightCoverWidthResolved},
			transparent ${rightCoverWidthResolved}
		)`,
        /* shadow cover background right */ `linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${rightCoverWidthResolved},
			transparent ${rightCoverWidthResolved}
		)`,
        /* overflow shadow right spread */ `linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
		)`,
        /* overflow shadow right perimeter */ `linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
		)`,
        /* overflow shadow left spread */ `linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
		)`,
        /* overflow shadow left perimeter */ `linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
		)`
    ].join(',');
};



var $dh538 = parcelRequire("dh538");





var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $cOrQJ = parcelRequire("cOrQJ");


var $jTtEd = parcelRequire("jTtEd");

const $c893e88acf4c2038$var$akEditorCalculatedWideLayoutWidth = 1011; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $c893e88acf4c2038$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $c893e88acf4c2038$var$akEditorGutterPadding = 32;
const $c893e88acf4c2038$var$akEditorDefaultLayoutWidth = 760;
const $c893e88acf4c2038$var$akEditorFullWidthLayoutWidth = 1800; // The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $c893e88acf4c2038$var$akEditorBreakpointForSmallDevice = `1266px`;
const $c893e88acf4c2038$var$akEditorGutterPaddingReduced = 24;
const $c893e88acf4c2038$var$akEditorFullPageNarrowBreakout = 600;
const $c893e88acf4c2038$var$akEditorUltraWideLayoutWidth = 4000; // Layout responsiveness breakpoints — chosen to align editor layout responsiveness with the renderer.
// Applied to the editor-area container query (max-width) for layout sections.
const $c893e88acf4c2038$var$akEditorLayoutFullWidthBreakpoint = 724;
const $c893e88acf4c2038$var$akEditorLayoutFixedWidthBreakpoint = 788;
const $c893e88acf4c2038$var$akEditorLayoutResizedBreakpoint = 820; // Originally copied from packages/editor/editor-core/src/ui/Appearance/Comment/Comment.tsx
const $c893e88acf4c2038$var$CommentEditorMargin = 14;
const $c893e88acf4c2038$var$GRID_GUTTER = 12;
const $c893e88acf4c2038$var$blockNodesVerticalMargin = '0.75rem';
const $c893e88acf4c2038$var$fontSize14px = `${0.875}rem`;
const $c893e88acf4c2038$var$scaledBlockNodesVerticalMargin = '0.75em'; // emoji constants — values inlined from packages/elements/emoji/src/util/constants.ts
// If you need to update these values, please also update packages/elements/emoji/src/util/constants.ts
const $c893e88acf4c2038$var$defaultEmojiHeight = 20;
const $c893e88acf4c2038$var$defaultDenseEmojiHeight = 16.25;
const $c893e88acf4c2038$var$scaledEmojiHeightH1 = 28;
const $c893e88acf4c2038$var$scaledEmojiHeightH2 = 26;
const $c893e88acf4c2038$var$scaledEmojiHeightH3 = 24;
const $c893e88acf4c2038$var$scaledEmojiHeightH4 = 22;
const $c893e88acf4c2038$var$denseEmojiHeightH1 = 24.25;
const $c893e88acf4c2038$var$denseEmojiHeightH2 = 22.25;
const $c893e88acf4c2038$var$denseEmojiHeightH3 = 20.25;
const $c893e88acf4c2038$var$denseEmojiHeightH4 = 18.25; // TODO: EDITOR-6932 - inline them at the end of migration
const $c893e88acf4c2038$var$emojiSelectionStyles = null;
const $c893e88acf4c2038$var$gutterDangerOverlay = null;
const $c893e88acf4c2038$var$blanketSelectionStyles = null; // copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $c893e88acf4c2038$var$akEditorLineHeight = 1.714;
const $c893e88acf4c2038$var$listsStylesSafariFixMultiSelector = `
	.ProseMirror:not(.blockCardView-content-wrap) > li > p:first-child,
	.ProseMirror:not(.blockCardView-content-wrap) > li > .code-block:first-child,
	.ProseMirror:not(.blockCardView-content-wrap) > li > .ProseMirror-gapcursor:first-child + .code-block`;
const $c893e88acf4c2038$var$editorAreaNonSmallDeviceContainerQuery = `@container editor-area (width >= ${$c893e88acf4c2038$var$akEditorBreakpointForSmallDevice})`;
const $c893e88acf4c2038$var$editorAreaNarrowPageContainerQuery = `@container editor-area (max-width: ${$c893e88acf4c2038$var$akEditorFullPageNarrowBreakout}px)`;
const $c893e88acf4c2038$var$editorAreaLayoutFullWidthMaxWidthContainerQuery = `@container editor-area (max-width: ${$c893e88acf4c2038$var$akEditorLayoutFullWidthBreakpoint}px)`;
const $c893e88acf4c2038$var$editorAreaLayoutFixedWidthMaxWidthContainerQuery = `@container editor-area (max-width: ${$c893e88acf4c2038$var$akEditorLayoutFixedWidthBreakpoint}px)`;
const $c893e88acf4c2038$var$editorAreaLayoutResizedMaxWidthContainerQuery = `@container editor-area (max-width: ${$c893e88acf4c2038$var$akEditorLayoutResizedBreakpoint}px)`;
const $c893e88acf4c2038$var$placeholderFadeInKeyframes = null;
const $c893e88acf4c2038$var$fadeIn = null;
const $c893e88acf4c2038$var$hideNativeBrowserTextSelectionStyles = null;
const $c893e88acf4c2038$var$boxShadowSelectionStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $c893e88acf4c2038$var$dangerBorderStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $c893e88acf4c2038$var$backgroundSelectionStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $c893e88acf4c2038$var$dangerBackgroundStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $c893e88acf4c2038$var$mentionsSelectedColor = null;
const $c893e88acf4c2038$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $c893e88acf4c2038$var$gapCursorTwoImagesSideBySideFixSelector = `
  .ProseMirror-gapcursor[layout="wrap-left"] + span + [layout="wrap-left"],
  .ProseMirror-gapcursor[layout="wrap-right"] + span + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-left"] + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-right"] + [layout="wrap-left"],
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"],
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"],
  [layout="wrap-left"] + .ProseMirror-gapcursor + span [layout="wrap-right"],
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"],
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"],
  [layout="wrap-left"] + .ProseMirror-gapcursor`;
const $c893e88acf4c2038$var$gapCursorMarginFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] > div,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] > div,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] > div,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-right"] + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-left"] + [layout="wrap-right"] > div,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] > div`;
const $c893e88acf4c2038$var$gapCursorFloatLeftFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor,
  [layout="wrap-right"] + .ProseMirror-gapcursor`;
const $c893e88acf4c2038$var$gapCursorAfterPseudoSelector = `
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"]::after,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"]::after,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"]::after,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"]::after,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"]::after,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"]::after`;
const $c893e88acf4c2038$var$gapCursorMarginDeepChildrenFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + span + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + span + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] + *,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] + *,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + * > *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + span + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + span + * > *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] + * > *,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] + * > *,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] + * > *,
  .ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"]) + .ProseMirror-gapcursor + *,
  .ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"]) + .ProseMirror-gapcursor + span + *`;
const $c893e88acf4c2038$var$gapCursorBlink = null;
const $c893e88acf4c2038$var$pulseIn = null;
const $c893e88acf4c2038$var$pulseOut = null;
const $c893e88acf4c2038$var$pulseInDuringTr = null;
const $c893e88acf4c2038$var$pulseOutDuringTr = null;
const $c893e88acf4c2038$var$syncBlockCreationLoadingKeyframes = null; /**
                                                 * aiPanelStyles
                                                 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
                                                 */ 
const $c893e88acf4c2038$var$rotationAnimation = null;
const $c893e88acf4c2038$var$rotationAnimationFirefox = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c893e88acf4c2038$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, #0065FF 0%, #0469FF 12%, #BF63F3 24%, #FFA900 48%, #BF63F3 64%, #0469FF 80%, #0065FF 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c893e88acf4c2038$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), #0065FF 0%, #0469FF 20%, #BF63F3 50%, #FFA900 56%, #0065FF 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c893e88acf4c2038$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, #0065FF80 0%, #0469FF80 12%, #BF63F380 24%, #FFA90080 48%, #BF63F380 64%, #0469FF80 80%, #0065FF80 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c893e88acf4c2038$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), #0065FF80 0%, #0469FF80 20%, #BF63F380 50%, #FFA90080 56%, #0065FF80 100%)`; // TODO: EDITOR-6932 - inline them at the end of migration
const $c893e88acf4c2038$var$borderSelectionStyles = null;
const $c893e88acf4c2038$var$overflowShadowStyles = null; /**
                                    * editorContentStyles is WIP to migrate styles from EditorContentContainer/styles
                                    *
                                    * The value {} is placeholder, fill in styles when migrating each style file
                                    * Add/Delete/Re-order keys are discouraged during incremental migration due to potential merge conflicts.
                                    */ 
const $c893e88acf4c2038$var$editorContentStyles = {
    aiPanelBaseFirefoxStyles: "_dci5qo0w _1rg4qo0w _1g3g15ob _26cn15ob _tyke17vv _jcgg17vv _4jlg9cwz _1ali9cwz _1t914jg8 _g7vh4jg8",
    aiPanelBaseStyles: "_uxukn7od _op0fn7od _13cd1uzo _1jlk1uzo _1q1s1vlr _bi6a1vlr _1sa6b3bt _1xx3b3bt _phzastnw _1xq8stnw _8ved1mrw _1s2t1mrw _1fvc1b4h _1gzy1b4h _1oc51b4h _jx4g1b4h _1ujg1n1a _1hrr1n1a _1rpp1n1a _1lft1n1a _1eus161g _nr43161g _pdovfajl _1wzd1t4y _1upkh2mm _1sidglyw _igie1t4y _6kversbi _1o19rsbi _1c8bglyw _1mheglyw _zkj1glyw _tyke194d _jcgg194d _4jlgymdr _1aliymdr _1u8dp3kn _qfmzp3kn _w13212c5 _1pmn12c5 _4nc8bimv _4g8dgrf3 _7psugrf3 _clq7grf3 _qbxqgrf3",
    aiPanelDarkFirefoxStyles: "_1q1s1yt2 _bi6a1yt2 _1eqs15ob _1cmi15ob",
    aiPanelDarkStyles: "_1q1sa6bd _bi6aa6bd",
    alignMultipleWrappedImageInLayoutStyles: "_ali2idpf _14i5idpf _pru0idpf",
    annotationStyles: "_1x2nt94y _1xqtt94y _1s25t94y _17qpt94y _1ubhidpf _172zidpf _9neqidpf _jydlidpf _1k26yh40 _1613yh40 _wmhayh40 _1qihyh40 _w0epidpf _ghwiidpf _6f0lidpf _1f3widpf _x81614y2 _9onx14y2 _1hbb14y2 _1p9g14y2 _1pjt14y2 _1t8514y2 _1fqx14y2 _1jyp14y2 _1m2zidpf _jd6pidpf _1nl9idpf _1vgtidpf _1edaidpf _du1kidpf _1g35idpf _17clidpf _92g41l7b _1wys1l7b _1xgk1l7b _7kmy1l7b _1xm91l7b _1owy1l7b _iqym1l7b _1dyh1l7b _1c0fidpf _o1p8idpf _3nq8idpf _q353idpf _km2cidpf _1xktidpf _1t0tidpf _1cr2idpf _iwzr1vrj _u5bs1vrj _1ibg1vrj _xkuf1vrj _66yetlke _19vztlke _dnsrtlke _drnbtlke _10h6v77o _1v9ev77o _ah88v77o _8grqv77o _x53a1o1l _1d6qfeiv _ojmct7xp _kn991o1l _o5elfeiv _o7dvt7xp _19vz1wug _1n0xibhp _1xmbfeiv _l0rkaetg _1c20feiv _168dt7xp",
    backgroundColorStyles: "_1l4zlb4i _11q31i5q _19n6t94y _b3ovyh40 _1150qvcn _642in7od _1vp0n7od",
    baseStyles: "_t7ab1vi7 _anrdukw8 _n6a11fwx _uw641q08 _fo6014dc _1gvnmqba _j03f1qop _qmjbxjz2 _zy25uj17 _pg931osq _121i1r31 _dcmgglyw _nv9v1o36 _19rk1uph _u8en3mia _3iqe18il _988v1osq _pi27grho _10zo1osq _1j8i1xb4",
    baseStylesMaxContainerWidthFixes: "_19rk1l99",
    blockMarksStyles: "_1244idpf _1qkxidpf _1e6iidpf _dvqjidpf _etngidpf _1jl2idpf _1je9idpf _1db9idpf _15i0idpf _16d4idpf _17liidpf _pxvridpf _1v4iidpf _s8m8idpf _16fuidpf _1543idpf _4offidpf _ttnbidpf _ujemidpf _1171idpf _mzasidpf _r8oxidpf _1pycidpf _6shmidpf _1bd0idpf _54e7idpf _1tenidpf _jzq1idpf _czpfidpf _1oraidpf _1kg4idpf _ksblidpf _1af7idpf _72x4idpf _zlwmidpf _7m6lidpf _1x2sidpf _3q5uidpf _11ukidpf _n65sidpf _1nn0idpf _1hwxidpf _j2goidpf _rfl4idpf _qhe2idpf _h4bbidpf _rjmvidpf _183yidpf _fk2nidpf _3429idpf _j543idpf _1op6idpf _mcklidpf _1uf8idpf _110lidpf _17agidpf _d9tridpf _f5slidpf _b9adidpf _1859idpf _1hrzidpf _1du2idpf _gdx6idpf _1av3idpf _1uj7idpf _s6y9idpf _ocz2idpf _129midpf _kj6kidpf _1uv9idpf _1tieidpf _ri4ridpf _tw0uidpf _15epidpf _12uhidpf _12i1idpf _vm1cidpf _jj6didpf _3d3tidpf _1xdsidpf",
    blockquoteDangerStyles: "_10d41gly _13641bqt",
    blockquoteSelectedNodeStyles: "_13521dy8 _vee2q98m _vmcm1kdv _10ue1j28 _1fn81j28 _11781j28 _1o6w1j28",
    blocktypeStyles: "_6st2oqnp _g09oidpf _19vkidpf _17vdidpf _1gtxusvi _1htf1kw7 _a3pn1osq _lqso1o8l _19v7idpf _oql5idpf _1w3ipxbi _1sz21dm9 _1nehnqa1 _95mn1l7x _1ezqidpf _s6l1pxbi _1j9eidpf _ymd7b3bt _1cbmglyw _ew481ule _104r17hw _1mzi17hw _15l01ule _12lj1ule _q4ju1ule _yqzd1ule _1ohls05q _13dhs0v8 _1qup44jv _mhqkq19t _fziqs05q _12sp1aa5 _ab5gidpf _10u5idpf _f850idpf",
    blocktypeStyles_fg_platform_editor_nested_dnd_styles_changes: "_t9o3v47k _iqu9pxbi",
    blocktypeStyles_fg_platform_editor_typography_ugc: "_1nit1gso _rec2idpf _140c15tv _f50o1j5o _dkhuhd14 _3kuhidpf _x3di14vx _as951j5o _1wg21bjq _1hijidpf _apdb1t5o _wylb1j5o _1i421gfe _k3ws1xfb _h0b91j5o _1uvf1sei _1wzi15tv _qg7oglyw _180c1j5o _a4utehg4 _1dzb6yhe _1k54glyw _pgjg1j5o",
    blocktypeStyles_without_fg_platform_editor_typography_ugc: "_7yqie01w _myzt1kw7 _1xm41tc5 _1tzri7uo _f3d81wq8 _5mgiz5jk _rec2idpf _140cs05q _1nip1bvj _1hmq1kw7 _1cllcjiy _jt2ui7uo _cah11wq8 _1yh6vkfx _x3dis0v8 _3kuhidpf _emxw59la _17rf1kw7 _1lng10nf _l2nti7uo _1wfa1pd9 _1cs1qdok _apdb44jv _1hijidpf _1mlf1x4e _138n1kw7 _f5pc1xde _coici7uo _uh5u1pd9 _1blq44hb _k3wsq19t _lmfnvz0p _1eut1kw7 _1hxvye00 _1fyni7uo _12rk1pd9 _1wzis05q _qg7oglyw _cnsrx6qu _1ot51kw7 _xmetlpk9 _14jf1rpy _17m4wu06 _1dzb1aa5 _1k54glyw",
    codeBlockStyles: "_rv60kb7n _fcmlkb7n _yh39f1ug _1mel1txw _124dkb7n _1wjzqvpr _qt48fajl _s5gzoqnp _at5bidpf _xldsidpf _ano2idpf _1jp6fajl _1vnn1kew _1wdeh2mm _vln5i8nm _123d1txw _19pw1osq _1uue1mxr _18hp1wug _de6kmgnk _ald71cn9 _ip0144v4 _6w9s1o0l _1m9i15vq _1pyru2gc _1y79i8nm _1sg0h2mm _ou5ucuwt _19wyidpf _puavoxwj _155d1ntv _1xgih8dc _c4n5glyw _m7kfglyw _1m67cuwt _48wmidpf _rhzrstnw _tucgoxwj _7q4h1k8s _1sgkusic _muxp1rpy _uq761ntv _1744h2mm _rv0ahp5a _1y8rzzfg _d19zckbl _4ryltlke _aneu1hrf _e8554jg8 _1s981isi _1r0kstnw _i2t315vq _aatx1k8s _4nofidpf _1y3zidpf _6udpstnw _4b4b15vq _1op21k8s _1ljoidpf _1wysidpf _abre6hgr _1r6r15vq _o85roxwj _uazj1k8s _hdw8fajl _16iru2gc _hleuegat _1itz1kdv _c7r7i7uo _19kmoxwj _1rjz1k8s _44nb1j28 _ayedr4us _vpdlh2mm _fmi51kdv _45xostnw _vlc6b3bt _ncseidpf _cfapidpf _4l45idpf _eaptidpf _1bao1osq _812dglyw _u96x1ial _vi8r7wq0 _ffe41j28 _msbp1j28 _4ae31j28 _kfw11j28 _yv3iu2gc _1xtl1ule _1fh01hna _1lr11jtm _naf3oqnp _o60fidpf _3t04idpf _ui89idpf _1de7idpf _1lezidpf _11acoqnp _lr83oqnp _lnhebimv _jvh11gly _16nl1tmw _1fyh1osq _80qob3bt _qgcnstnw _1rakidpf _ue9bidpf _90e31tcg _ja1jrprw _pdshrprw _15ve1gly _b0ld1tmw _s6jz1osq _12qtb3bt _12dbstnw _ce0yidpf _1jh6idpf _ndx01tcg _ytehrprw _i521rprw",
    codeBlockStylesWithEmUnits: "_1af5ok4x _1cbn1q5e _19km1wqq _1rjz1q5e",
    codeMarkStyles: "_59uzyh40 _6p44m5ip _1i9tyh40 _2lvxm5ip _9g7rfajl _1iyw1wug _syi51wug _pwh8glyw _af7gi8nm _1bsc1nu9 _1atv187e _1srjqvcn _z49mi7uo _95t2zzfg _ri7p1wqq _5061i7a9 _9ef31hna _or5e1jtm",
    codeMarkStylesA11yFix: "_1iywn7od _syi5n7od",
    commentEditorStyles: "_16jlkb7n _1reozryt _vwz41tcg _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _1lbautpp _2k8xutpp _4aknutpp _1r9butpp _1pg2v77o _1ocsv77o _8ctj1b4h",
    cursorStyles: "_178n1j28 _1xy6glyw _102f1j28",
    dangerDateStyles: "_o7sybimv",
    dangerRuleStyles: "_zih31bqt",
    dateStyles: "_15n6n7od _munn4jg8 _m1d5tlke _dgh21j28 _1ex4r4us _1kx81j28 _xi121j28 _wi4l1j28 _1a3o1j28 _rn5mbimv",
    dateVanillaStyles: "_vkeh12b0 _wg06idpf _ra5tt94y _tsrtidpf _el4et94y _3sy0i8nm _eflqi7uo _lgf9v77o _pzcb1b66 _1190v77o _kf7b1b66 _6klsh2mm _dfkj1k9t _gtia188d _h3z91q9c _1jt6n7od _13fl1vk5 _1eqh9lu1 _1b2hplhp _jdyf1rtt",
    decisionDangerStyles: "_urj01gly _foen1gly _1ca5bimv _k1fkbimv",
    decisionIconWithVisualRefresh: "_thflglyw _1p25usvi _oro41igz _r2uz1mb9 _1l8y93q1 _r9pv1r8n _13lc1ejb _1lv01ejb",
    decisionStyles: "_dpx312b0 _19pb12b0 _1y9e1j28 _6olx1j28 _1jr9r4us _1onur4us _pnjfh2mm _gptrh2mm _jpyq1kdv _18m61kdv _bmm0stnw _k5rqstnw _q5x9b3bt _yh80b3bt _1gfnidpf _13m9idpf _1mtdidpf _ad3aidpf _ise9idpf _hxjcidpf _1nylidpf _15peidpf _1eyt1osq _1hjy1osq _15hdglyw _v756glyw _4yxh1ial _19vq1ial _1wio7wq0 _1n897wq0 _1y6l1j28 _e2bm1j28 _ca2s1j28 _1hxi1j28 _w4bt1j28 _p0351j28 _1hmn1j28 _1btv1j28 _w1ckbimv _1o1krprw _1p19glyw _1qm9v0yc _1on8u2gc _1ta512b0 _xm1gtlke _sz6h1txw _az4vvrvc _sbp7utpp _gly4i8nm _1q7bh2mm _g52lidpf _1jttidpf _1hmbexct _1kk7l6jh _lvwq7vkz _ky807vkz _1uwodgkc _348v1txw _1tke1h6o _122n1h6o _4uli15vq _zzeo15vq _fjhfglyw _1sic1r31 _1kudyfq0 _18otidpf _ccbmidpf _14igidpf _11a6tu8f _9gq015vq _n4v415vq _x049stnw _phnn1rpy _jtxaglyw _1don1l2s _su171q9c _18j91dza _gsu5idpf _15vgidpf _om3bidpf _1ebmidpf _k75vkb7n _ucdskb7n _nvoj1wug _jhti1hna _1vjnidpf _106mglyw _12ag4pcx _tnrm1o8l _1fbtidpf _rvuckb7n _15a2glyw",
    diffListStyles: "_10a5ox06",
    editorControlsSmartCardStyles: "_1vgqidpf",
    editorLargeGutterPuddingBaseStyles: "_1vk21ex1",
    editorLargeGutterPuddingBaseStylesEditorControls: "_1vk2t9kd",
    editorLargeGutterPuddingReducedBaseStyles: "_lh101tcg",
    editorUGCTokensDefault: "_da23275c _ocu01rwh _2s1dh9f3 _15hx9q8f _1qs3ddzq _1u7xm9w9 _1g2sncm8 _11d01fw0",
    editorUGCTokensRefreshed: "_da23111w _ocu0mnnt _2s1d1xgx _15hxe8o0 _1qs312nz _1u7x1v8p _1g2st7zq _11d01fw0",
    editorUGCSmallText: "_1v2gnkc8",
    embedCardStyles: "_bxhh1osq _1xquh2mm _1do8cs5v _15no1e5h _z75ousic _197w1hrf",
    emojiDangerStyles: "_lcgdbimv _tnzqbimv _1szw1gly _4ijz1gly",
    emojiStyles: "_1f4mixwd _1gq31o8l _gof5gktf _1kubgktf _p8rdtlke _1ub4nkob _1rml1rj4 _ps8p1o8l _1h3zlb4i _11pulb4i _6p5k1j28 _1nt01j28 _1uvbh2mm _114kh2mm _1qer1kdv _2qa91kdv _4qcustnw _9ggastnw _80x0b3bt _f7p0b3bt _kxdfidpf _2zbkidpf _1oq4idpf _11ividpf _1fg6idpf _1r2pidpf _iz9gidpf _1v08idpf _rldy1osq _sdlb1osq _1focglyw _199fglyw _1x5q1ial _pyxt1ial _1rvo7wq0 _1x187wq0 _1608r4us _13ffr4us _1ip21j28 _11ut1j28 _1gjf1j28 _1g5r1j28 _rii71j28 _1vmi1j28 _2gbi1j28 _1usv1j28",
    emojiDenseStyles: "_2f9he0wb _gof5e0wb _1kube0wb _1jg61osq _ik5u1osq _7vzk1f51 _1n9bv47k _7pqpv47k",
    expandStyles: "_1fkbxmi2 _vx27xmi2 _1n9xxmi2 _1oymxmi2",
    expandStylesBase: "_1dcv12b0 _vir8sm61 _nshtskji _1ffuu2gc _eyk7fyzg _1ia1h2mm _ullp1kdv _1ci8stnw _14zzb3bt _1psiidpf _9apoidpf _t1ygidpf _1dr7idpf _py7e1osq _q9kpglyw _2jyr1ial _1tv57wq0 _63an1j28 _g5xu1j28 _5u1u1j28 _1oif1j28 _age41gly _1ymq1bqt _v5bbe4h9 _1husnqa1 _1xt11j28 _1t5a10yn _o7hy9c8s _1rdsfs2f _1kd91qdr _1x8yidpf _3tz5idpf _1b7utlke _1vuvusvi _372tidpf _g7u3dgkc _8va114w8 _bc4d1r31 _1d0tglyw _4fj21o36 _1fbsglyw _1p5p1j28 _1gxpkb7n _1245kb7n _1fmjf1ug _ig0i4w17 _18mboxwj _1ev778tn _15uri7a9 _caue1rpy _149p1txw _u29r1osq _1icakb7n _hiyf1rpy _oemsidpf _ux5uidpf _im3nidpf _4uf1idpf _8q99glyw _2gbkglyw _wn6j1r31 _m5xjglyw _eu2zidpf _11pmewfl _oi2iewfl _1otu1txw _rrwboxwj _ikp21osq _txkaazsu _1wtktlke _ar4h1h6o _3emmglyw _14wj12b0 _18x1sm61 _qg62idpf _3dscidpf _1xnzidpf _1l2jidpf _1aljidpf _kb94idpf _bqovidpf _1dx5idpf _sma4dfik _1slov77o _wo9i1dpa _bj9o180e _1rrkdgkc _m4h31ul7 _zsbmglyw _upeu1ejb _1hr01ejb _13mr1txw _a0pq1h6o _1gdo1h6o _kinytlke _wyq613gf _hl71sm61 _n4fm1l7x _sv44u2gc _2xjk14w8 _czgd1txw _1i7i15vq _1pnt15vq _wz3i15vq _1g6m15vq _9s8f1osq _10zo1osq _1ish1ule _zkn71ule _19mvidpf _vkxwidpf _ay4r7mnp _1m2q7mnp _1io9glyw _1gwnglyw _vgp2ze3t _svkwu2gc _157n1ejb _1c011b66 _1dwdj4ch _fqkm1osq _9n6nusvi _1xgj1kdv _70nuglyw _11qn1osq _1q2615vq _vffj15vq _o1nxstnw _1j9kt94y _1u1ft94y _1s0y7mnp _17sv1q9c _1a5m1j28 _317nsm61 _1srh1l7x _kh951j28 _19lwdgkc _194h1ul7",
    expandStylesMixin_experiment_platform_editor_chromeless_expand_fix: "_mklmidpf _nnniidpf",
    expandStylesMixin_fg_platform_editor_nested_dnd_styles_changes: "_109wc7mi _vx27c7mi _15klc7mi _1oymc7mi _smy6idpf _g8xr1b66",
    expandStylesMixin_fg_platform_visual_refresh_icons: "_1ev7kb7n _1ocgttxp",
    expandStylesMixin_without_fg_platform_editor_nested_dnd_styles_changes: "_1w8qq98m _omzvglyw _bqvk1osq _1h9p16ux _19lestnw _14j01n1a _1pm0idpf _1p3gidpf _1d9kt94y _113e1o8l",
    expandDenseStyles: "_18mb3mia _rrwb3mia",
    extensionStyles: "_1a64bimv _hdxx1gly _xxyv1rtt _1xxp1tmw _1yb8kb7n _1g5bglyw _15vp15s3 _s9d56x5g _efyrkb7n _bp3fglyw _1tfz1nu9 _14ao1nu9 _1hpkkb7n _1e6ukb7n _1wcvidpf _1pt1idpf _1iq2r4us _1j23bimv _17xs1rtt _7u261tmw _1oo0glyw _1sfk1j28 _z5jxclii _et601yvi _gwkf1j28 _ul13r4us _4kr1h2mm _1qyx1kdv _1clfstnw _pj5bb3bt _1q5aidpf _1mvvidpf _1r6qidpf _1o9tidpf _1g3g1osq _1mglglyw _1cx01ial _am787wq0 _11mi1j28 _bw1x1j28 _ucr81j28 _12mi1j28 _jn1o1osq _6bv41osq _1oxabimv _1qn21gly _f2dr1j28 _68b9clii _1wb01yvi _mwpb1j28 _yyxzr4us _1eah1j28 _thp91j28 _11vt1j28 _4t5m1j28 _lnnb1rtt _wwen1tmw _1uw8kb7n _1kckglyw _1y3y15s3 _w5kn6x5g _1nq1kb7n _1nl0glyw _itji1nu9 _1bby1nu9 _vy7vkb7n _1dtlkb7n _l3rpidpf _wwmdidpf _1r6wr4us _1we4bimv _1nx11rtt _iehe1tmw _7hj6glyw _1gw2oqnp _1nb7oqnp _1890oqnp _mxneidpf _nzqyidpf _1ey5idpf _10qboqnp _mkj8oqnp _1o70oqnp _1oaoidpf _d40vidpf _1xipidpf _pgy3idpf _1ft6idpf _1gfbidpf _fkv9idpf _18gqidpf _jchyidpf _16uk1j28 _1h9u1j28 _36v61j28 _gg19r4us _1g5dr4us _oackr4us _1jtp1j28 _1f311j28 _18rv1j28 _swvw1j28 _1j9x1j28 _1dva1j28 _1mnz1j28 _bq4v1j28 _hl5f1j28 _crev1j28 _1d631j28 _28m71j28 _vi00bimv _1b2sbimv _124rbimv _1hvp1gly _gu7z1gly _1otv1gly _vpzk1rtt _1cas1rtt _o16g1tmw _14ye1tmw _6bknkb7n _1u6pkb7n _1vx5glyw _b841glyw _1oek15s3 _cw2a15s3 _6qzd6x5g _1xbj6x5g _1oa1kb7n _14ookb7n _rst4glyw _31aeglyw _1mwo1nu9 _iahl1nu9 _1abbbimv _1td9bimv _61jobimv _pzvn1gly _1mqj1gly _11bn1gly _qyzc1sou _1cjx1sou _1ie21sou _11dk1nu9 _hle21nu9 _dtkmkb7n _jf2hkb7n _h7tgkb7n _dwq7kb7n _ujyhidpf _1upkidpf _1mrzidpf _1tsoidpf _ib8er4us _15wnr4us _ko3dbimv _v8pmbimv _1hux1rtt _10ke1rtt _a3hl1tmw _1yqx1tmw _1y96glyw _505cglyw _5l361j28 _1ryt1j28 _1n4tclii _1oztclii _qkq9clii _1n5a1yvi _jn3m1yvi _btw31yvi _13is15vq _8cmh15vq _1qmbewfl _14thewfl _190516cs _15z51osq _b4z71osq _1iizoqnp _1vsooqnp _o1s4idpf _1swgidpf _1oknoqnp _1bs5oqnp _13e0idpf _1mxyidpf _wwc7oqnp _8vqxoqnp _1wmeidpf _la9widpf _1yssoqnp _xxgeoqnp _mkvnidpf _1by3idpf _6yf3idpf _ibadidpf _oeksidpf _miq6idpf _9bm6idpf _1noyidpf _b6ceidpf _dlfnidpf",
    extensionStylesDense: "_1s773mia _bqje3mia",
    extensionStylesLegacyDense: "_1r7aqlaa",
    extensionDiffStyles: "_ur7x49jj",
    bodiedExtensionLayoutShiftFix: "_16ng1gkc _klqg1n1a _ptek1n1a _e1ae1n1a _13ey10ni _1bh8dik7 _1v7bia51 _1v3nfajl _1i6iidpf _gc15idpf _1utjidpf _csmsidpf _gogjidpf _gt60idpf _15kbidpf _sve5idpf _pmyyidpf _1jpsidpf _a3m4idpf _pfwgidpf _fo78glyw _1j2jidpf",
    findReplaceStyles: "_9laafajl _1trh7xuz _1h36j5v0 _1uddtdv8",
    findReplaceStylesNewWithA11Y: "_xph31b66 _rq281nka _1bk513ow _17vzi7uo _ar1b1b18 _1ybwjocv _1mni17v8 _tfy618hq _11gt15cr _1bx3vj2t _1j061dxm _oa091nka _1ybf1nka _u1hx1up9 _1rn91up9 _wn3j1up9 _1ydu1up9 _11wp1up9 _u12f1ypf _13q91ypf _or3e1s89 _gzgh1s89 _ipvl1s89 _15r21s89 _1cpz1s89 _1lh5kz84 _1pvf1xf3 _7pge1xf3 _1h271xf3 _1us91xf3 _mxi51xf3 _1o191dzh _b9gt1dzh _rdw3qlfy _11bbqlfy _v91uqlfy _1k4sqlfy _1ecxqlfy _7gsu17v8 _12xo17v8 _briz1wdg _1cis1wdg _midr1wdg _1kd91wdg _1t9u1wdg _1me2qxcq _r8mlqxcq _1im23ney _1r5e3ney _1oci3ney _13bv3ney _1kac3ney _h2391jcr _1r791fb9 _1ebn1fb9 _1s101fb9 _1p5e1fb9 _1bkc1fb9 _50231ph4 _1c101ph4 _1s5oiro1 _1w9miro1 _w8rkiro1 _u854iro1 _o9w6iro1 _1sch1b66 _ztqp1nka _4temv9ra _r79ei7uo _1e4d1b18 _hje11ckf _sopm17v8 _4q84eawv _1t2d15cr _12dfvj2t _cle21ok8",
    findReplaceStylesNewWithCodeblockColorContrastFix: "_64o84viv",
    findReplaceStylesWithCodeblockColorContrastFix: "_1blo4viv",
    firstBlockNodeStyles: "_1qikidpf _6itxidpf _js9kidpf _i3wvidpf _1wh8idpf _8uqaidpf _umh5idpf _jav3idpf",
    firstCodeBlockWithNoMargin: "_jz6vgrf3 _11dkgrf3 _p3gngrf3 _1qg7grf3 _v1mkgrf3 _1oa0grf3 _19gqgrf3 _12qwgrf3 _1j14grf3 _1adogrf3 _1aolgrf3 _b3evgrf3",
    firstCodeBlockWithNoMarginOld: "_p3gngrf3 _1oa0grf3 _1j14grf3 _b3evgrf3",
    firstFloatingToolbarButtonStyles: "_j9yv7g83",
    firstWrappedMediaStyles: "_e519idpf _pxl0idpf _1sn3idpf _ripsidpf",
    fontSizeStyles: "_hym9vvzz _ir60vvzz _1di9vvzz _zy611kw7",
    fullPageEditorStyles: "_16jlkb7n _4t3i1osq _18m915zi _kqswh2mm _1e0c1txw _2lx21bp4 _1dm8q5uf",
    gapCursorStyles: "_3y8g1j28 _d3za1ule _1fzu1j28 _1ug81hdd _lh5tdrnj _bmfv9cwz _8md310zz _1ag412c5 _9ubpb3bt _1o0g1ule _11h1stnw _19sfidpf _1z0n1osq _5cxqglyw _l4vzglyw _npmhh2mm _1ci21j28 _vtgestnw _1yi41osq _gdp01osq _3n591ule _1pjtr5cr _19upr5cr _14ib1ssb _y1fl1ssb _fzk41ssb _1f6mzr6s _1eaezr6s _yd46zr6s _1texusic _bur2idpf _n4szidpf _jlwvidpf _1fusidpf _4ieeidpf _187pidpf _18efidpf _aycbidpf _1t6mglyw _sb9fglyw _lf1tglyw _15haglyw _1g4eglyw _d27rglyw _ajy9glyw _1syzglyw _10zwglyw _1qypglyw _y41iglyw _uk93idpf _1eobidpf _1ghsidpf _1rpoidpf _cggnidpf _1supidpf _yyaxidpf _stw0idpf _7hwtidpf _1x70idpf _nh0eidpf _k8k0idpf _xpqwidpf _1ancidpf _iauqidpf _1762idpf _1fbjidpf _1le7idpf _14f4idpf _4wchidpf _18uvidpf _1gklidpf _736didpf _7fayidpf _1q471e5h _1nuq1e5h _97xa15vq _1u0115vq _kklf15vq _1xcb15vq _f7xi15vq _drld15vq _fk7o1ule _17291ule _1z0h1ule _1em21ule _70jd1ule _1xog1ule _beg3idpf _1xfvidpf _js8cidpf _zzusidpf _ft1bidpf _1duxidpf _5sz3f705 _oq4if705 _17kkf705 _awp7f705 _1kxaf705 _1e60f705 _p31f1hrf _1rcq1hrf _1uer1hrf _15a61hrf _1lbj1hrf _1l3q1hrf _1ab3idpf _16k0idpf _r6joidpf _mpruidpf _x74zidpf _18pfidpf _1gvgidpf _1q0gidpf _sdnkidpf _zgemidpf _1vyzidpf _ydciidpf _1g35idpf _ieodidpf _vr8nidpf _1vtyidpf _ndfaidpf _4gkwidpf _1x5zidpf _1wgaidpf _o0lfidpf _knnuidpf _1afyidpf _1hb9idpf",
    gapCursorStylesVisibilityFix: "_1ys91j28",
    gridStyles: "_1qw3ia51 _155q1o8l _p3p6usvi _z2xw1osq _nbea1n1a _1yn7uhok _1dod6ebc _1sncp3kn _1kbpidpf _8nch188o _8ctjfknx _1pg2xmi2 _1ocsxmi2 _17ht1h7a _1713cs5v _3ojs1n9t _dai01kxc _c94u1osq _1p0gglyw",
    hideCursorWhenHideSelectionStyles: "_uuop1j28",
    hideSelectionStyles: "_nuih1j28 _9o1p1j28",
    hyperLinkFloatingToolbarStyles: "_14olidpf _1499idpf _w11vidpf _162zidpf",
    indentationStyles: "_10pe1ul9 _ygai1wqb _1czel1r9 _126j68cl _cnga1w81 _14uamgvx",
    InlineNodeViewSharedStyles: "_omad1nu9 _64cs1rj4 _fukv1q9c _1rhx1jtm _1bbqglyw _1v741j28 _17xw1j28 _kdjsglyw _6q1jryon",
    layoutBaseStyles: "_o2as1f61 _3t6qixl8 _19z7kb7n _e6qzkb7n _c9uhf1ug _19eyia51 _1r5q12b0 _cx2xutpp _2wy7h2mm _14hwidpf _1ed8usvi _navqidpf _84fsidpf _gt3aidpf _13jnidpf _1iuzidpf _15nuidpf _4fc0idpf _cs4didpf _1iwn1osq _10q81kdv _i6821hrf _16fxtlke _ez6hglyw _17igidpf _1ayiyh40 _x1d2idpf _9m42yh40",
    layoutBaseStylesAdvanced: "_19eyidpf",
    layoutBaseStylesFixesUnderNestedDnDFG: "_o2as17in _1v5d1crf _5jfcgktf _3mtd1crf _c82wgktf",
    layoutBaseStylesFixesUnderNestedDnDFGExcludingBodiedSync: "_o2as17in _157i1f61 _1v5d1crf _5jfcgktf _3mtd1crf _c82wgktf",
    layoutBaseStylesWithTableExcerptsFix: "_1jqfaq80",
    layoutColumnDividerStyles: "_zh8m12b0 _ev4yz97a _jcll1v6z _16vz1osq _holl1txw _5vab1h6o _1uro1h6o _1frpglyw _i4je1l7x _an061qi0 _1vm41l7b _6k9c122h _1j3iglyw _gjds1if8 _mnwgutpp _22p4utpp _18id15s3 _10961v1w _14pw1nnf _1adfidpf _1dpr1ntv _1ez111mm _5jm5h2mm _bdsqcs5v _1qkw1fhb _hse11txw _eyy71h6o _eb7w1h6o",
    layoutColumnDividerStylesNestedDnD: "_14pwatyr",
    layoutColumnMartinTopFixesNew: "_1g1uidpf",
    layoutColumnMartinTopFixesOld: "_1g92idpf _1quqidpf _kevbidpf _2m5ridpf _a30kidpf",
    layoutColumnResizeStyles: "_cekk1dpx _f6io10o2",
    layoutColumnResponsiveStyles: "_g3q7u2gc _18rfkb7n _133ckb7n _33n8f1ug _1gfqidpf _179s1txw _1fsyvrvc _120l1wug _1f6715wb _1rxifs5d",
    layoutColumnStylesAdvanced: "_6ybqidpf _19721y44 _1ga8idpf _1yp01y44 _1wv7idpf _1hn6idpf _1gykidpf _rt1midpf _usxwidpf _1sm9idpf _1sugfajl _1bkq11dc _g27h1y44 _yhf4h2mm _13ml1kdv _i2tlstnw _1lecb3bt _g27hidpf _1kwfidpf _135lidpf _kqjnidpf _1bkq1osq _1bp1glyw _g9hd1ial _1lg57wq0 _regq1j28 _zo5f1j28 _1a1t1j28 _15061j28",
    layoutColumnStylesNotAdvanced: "_1qenftgi _1sm9idpf",
    layoutResponsiveBaseStyles: "_k2nx1bp4 _1x08j0fz _xeigj0fz _13nwj0fz _3w7dj0fz _k7u3n7od _cav5n7od _18tgn7od _17mdn7od _r88kb3bt _1b78b3bt _1vhob3bt _qxiwb3bt _i8f5stnw _1gtustnw _tb7dstnw _dnuvstnw _1oro1kdh _irrd1kdh _131c1kdh _23qu1kdh _17mnnh1r _w49tnh1r _1ma8nh1r _1v0anh1r _13rgn7od _i8btn7od _a4v0n7od _1s6xn7od _4wj2n7od _h6usn7od _11arn7od _tix7n7od _om4l1bp4 _tisjj0fz _1imxj0fz _dfy0j0fz _4oltj0fz _vpohn7od _61j2n7od _1sfln7od _1wg5n7od _11tob3bt _i9tgb3bt _1wfpb3bt _1l2hb3bt _1480stnw _9r2ostnw _w8ojstnw _9ug0stnw _1hbv1kdh _1c6i1kdh _1d0a1kdh _5e4l1kdh _1xuqnh1r _1528nh1r _f6hznh1r _15nknh1r _14wsn7od _1waln7od _qaadn7od _1b0mn7od _q3obn7od _xd4gn7od _1n5nn7od _1e2ln7od _13x81bp4 _1aa5j0fz _1ba4j0fz _8z09j0fz _140yj0fz _mhzhn7od _1ud7n7od _1c0mn7od _3h45n7od _5dzzb3bt _g90ub3bt _fy9eb3bt _1j0ab3bt _1jh1stnw _1p9ystnw _1azustnw _desrstnw _lpto1kdh _1msf1kdh _trz31kdh _1rgt1kdh _zximnh1r _17umnh1r _1p2knh1r _19f3nh1r _1y6en7od _mkein7od _1jbrn7od _nu48n7od _1ison7od _ai7zn7od _1kven7od _q26cn7od",
    layoutResponsiveStylesForView: "_1x08idpf _xeigidpf _13nwidpf _3w7didpf _tisjidpf _1imxidpf _dfy0idpf _4oltidpf _1aa5idpf _1ba4idpf _8z09idpf _140yidpf",
    layoutSectionStylesAdvanced: "_1dwlidpf _9qwgidpf _12o61wug _inlhr5cr _peb2tcjq _156lstnw _1yayidpf _s3jaidpf _ice31wug _6l8f1p41 _4l4otcjq _1m00idpf _e1ffidpf _1cvgidpf _cp58idpf _slibidpf _mju21h7z _1cea1h7z _xypuidpf _fnc9idpf _63lcidpf _1emlidpf _kec0kb7n _xfo5agmp",
    layoutSectionStylesNotAdvanced: "_18rfkb7n _133ckb7n _33n8f1ug _1gfqidpf _1siyidpf _1u7yidpf _1f351wug _4ha6h2mm _179s1txw _1fsyvrvc _120l1wug _1e0i1bp4",
    layoutSelectedStylesAdvanced: "_hkqaj0fz _czynj0fz _1blyj0fz _u1w0j0fz _1tsaj0fz _1tw6j0fz _3mz4j0fz _18csj0fz _59krj0fz _1smwj0fz _1ko4b3bt _12wlb3bt _10v9b3bt _1f0xb3bt _hd3jb3bt _1rykb3bt _1mx0b3bt _1xlrb3bt _1kvxb3bt _1p8eb3bt _ch2xstnw _ji6rstnw _ic9istnw _5dccstnw _5ejestnw _18u1stnw _1igostnw _vw7istnw _1ildstnw _k9ixstnw _1kkcoskh _1lteoskh _11enoskh _1goqoskh _lrq1oskh _prsvoskh _1b3aoskh _1npkoskh _85fvoskh _lvhloskh _9vwq1mi1 _1t231mi1 _vyx61mi1 _1r3x1mi1 _8wi61mi1 _vr1i1mi1 _14x21mi1 _tesc1mi1 _11ka1mi1 _g5of1mi1 _1xab12b0 _1j2m12b0 _wp8w1gly _evu61gly _fz9xbimv _fpkgbimv _1oxk12b0 _9kbj12b0 _4ca6idpf _12z0idpf _47ulh2mm _104qh2mm _18v41kdv _1jjn1kdv _h8yxstnw _1o13stnw _6wxgb3bt _1lsib3bt _1nw2idpf _1cccidpf _4lrcidpf _fyp6idpf _1td8idpf _xbowidpf _b3l7idpf _sd1fidpf _1m321osq _1gwq1osq _11ujglyw _6tn6glyw _3m4f1ial _15hr1ial _z2s87wq0 _1q5c7wq0 _6mng1j28 _1bnx1j28 _geet1j28 _eyyf1j28 _128e1j28 _pf7d1j28 _1v7a1j28 _13uz1j28 _z2s81j28 _1q5c1j28 _12x3r4us _k1isr4us _1oae15s3 _1egw15s3",
    layoutSelectedStylesAdvancedFix: "_fz9x12xe _fpkg12xe _12x31cc3 _k1is1cc3",
    layoutSelectedStylesForViewAdvanced: "_hkqaidpf _czynidpf _1blyidpf _u1w0idpf _1tsaidpf _1tw6idpf _3mz4idpf _18csidpf _59kridpf _1smwidpf _fz9xpufw _fpkgpufw _12x3fzyd _k1isfzyd",
    layoutSelectedStylesForViewNotAdvanced: "_4nsvidpf _q96bidpf _j159idpf _j6cmidpf",
    layoutSelectedStylesNotAdvanced: "_4nsvj0fz _q96bj0fz _j159j0fz _j6cmj0fz _1vas1bqt _1rjw1bqt _r7ao1gly _c0oz1gly _1gr5hueu _ltwwhueu _dmwoq98m _1o9pq98m _b1wxglyw _zgyzglyw _16pr1osq _parp1osq _stck16ux _atbw16ux _hr6mstnw _1yj9stnw _1wr91n1a _10y51n1a _124jidpf _1pljidpf _sva6idpf _1lg4idpf _j4h4t94y _np4xt94y _osi71o8l _sm9f1o8l _bmvah2mm _n5yrh2mm _9b251kdv _10tu1kdv _yhd9stnw _1xutstnw _re0hb3bt _124nb3bt _zrdwidpf _1wcmidpf _1fxzidpf _1xbkidpf _jnn8idpf _3d5lidpf _ftgeidpf _iihvidpf _ciqu1osq _oj2q1osq _1ntuglyw _1tsjglyw _1tz91ial _1m1k1ial _oz757wq0 _grya7wq0 _78qp1j28 _oay31j28 _1c3t1j28 _1div1j28 _fva51j28 _15bw1j28 _16am1j28 _ir1d1j28 _1jwy1j28 _v7np1j28",
    layoutStylesForView: "_19eyidpf _16fx73ad",
    linkingVisualRefreshV1Styles: "_yg3j1kw7 _v4d81kw7",
    linkStyles: "_259w1r31 _rv8p8stv _1rxqnqa1 _1cw81ule _4m8e1r31 _b05uglyw _1pxsnqa1",
    listDangerStyles: "_3xd61gly",
    listItemHiddenMarkerStyles: "_dhzqagmp _15cjagmp _1qvtgrf3 _od11grf3 _6jbkgrf3 _13q2grf3 _b1o8grf3 _kyt0grf3 _sneogrf3 _14xl126e",
    listSelectedNodeStyles: "_1dmg1dy8 _1mej1kdv _1iwv1j28 _n5n31j28 _2wpz1j28 _1x671j28",
    listsStyles: "_gtdbusvi _qd3musvi _87u1cuai _s7xpcuai _dlgt1o8l _j6t01o8l _wlqz1o8l _5rje1o8l _9b45j4ch _10i7j4ch _4ded1wth _17kl1wth _e08p1p3b _11311p3b _1xqjw4vn _1bq9w4vn _1n111fbg _1nq21fbg _14gj1k9k _1rnf1k9k _9j0yxfcs _1l0sxfcs _1a6x1fbg _fbx71fbg _huyw1k9k _132p1k9k _16oexfcs _1ir6xfcs _haa41wth _yw541wth _w39w1p3b _qok21p3b _8r0ew4vn _hubiw4vn _d10bhq3d _1q5dh2mm _8wmvoqnp",
    listsStylesMarginLayoutShiftFix: "_1wb5utpp _ul3mutpp _1orf1b66 _44741b66",
    listsStylesSafariFix: "_omxdf705 _11t078tn _96x216px _14e716px _s8y916px",
    listsDenseStyles: "_tmq91tuv _1bzj1tuv _si4z1tuv _1tud1tuv _rajy1tuv _1orf1tuv _44741tuv",
    maxModeReizeFixStyles: "_1gpc1lj4 _4q241osq _w33agrho",
    mediaAlignmentStyles: "_17wyglyw _y8rbusic _18hp1e5h _1ckw1h6o _1p7w1osq _z0v11osq _skdx1osq",
    mediaCaptionStyles: "_16993mia",
    mediaDangerStyles: "_19pubimv _ae5ebimv _1duzbimv",
    mediaGroupStyles: "_z1osidpf _h8pgidpf _ehr6idpf _1q2uidpf",
    mediaStyles: "_1owdidpf _3ikcidpf _hd90idpf _1p9fidpf _1u19b3bt _1rfo1ule _uov4idpf _1x09glyw _4w8p1kdv _1kyg15ya _imlv15ya _ur50h2mm _1qc7cs5v _1hsl1osq _rwhn1kw7 _1tcf1hrf _1vptutpp _9js3utpp _1evb1hrf _1wk8glyw _18j6glyw _1y15utpp _1u09utpp _1cq71hrf _k3s4idpf _xqgtidpf _1ehzidpf _1dvfidpf _15fkidpf _vppwidpf _1bqpidpf _219didpf _13s61wug _1p781wug _1j2k1wug _1s8t1wug _bqhe1wug _1riw1wug _1fzj1wug _1e0d1wug _vfny5uws _2pdo5uws _1lfp5uws _a25p5uws _nz73glyw _275iglyw _1tajglyw _1juhglyw _1q1z1ssb _1lqi1ssb _8i8bzr6s _11phzr6s _1vvnglyw _15q4m0zr _1752m0zr _dnlnm0zr _hvttm0zr _2w21m0zr _ok62m0zr _1dm2m0zr _1uc7m0zr _tivjm0zr _v3vym0zr _4a1yidpf _18niidpf _1sf1qslr _km6up1qy _cajk14no _1oqj14no _2nnb14no _pm9i14no _ksg217vv _17rd17vv _1pi817vv _3a5x17vv _1k21d6z3 _1y8dd6z3 _1nd9d6z3 _1jw5d6z3 _59re17vv _wyfm17vv _1tot17vv _1c6u17vv _1i1010yn _ywvi10yn _wgjz10yn _182k10yn _zum4p1qy _73oop1qy _vkygp1qy _dpu9p1qy _4x2q1gkc _43501gkc _dygm1gkc _16qm1gkc _l3h6p1qy _127vp1qy _b23zp1qy _fmnnp1qy _11mggktf _ldgngktf _t3hqgktf _19uygktf _r8jvp1qy _1tvap1qy _jldnp1qy _enj9p1qy _om23f6fq _jo73f6fq _1gl9f6fq _1onnf6fq _cnvup1qy _aoe7p1qy _e5s4p1qy _1trqp1qy _xwl91e5h _1yjqusic _hphj1hrf _432j1vh9 _63ry1vh9 _wc52idpf _zvyiidpf _hzyyidpf _n3btidpf _wnyk1qi0 _1oeg1qi0 _18zpf705 _zeu3f705 _s7au1txw _1i5q1txw _htjx1l7b _bo7r1l7b _1ot0vbgk _6v8nvbgk _1yxl1l7x _zrp01l7x _s2ud1v1w _4avh1v1w _71gu1v1w _1ndc1v1w _98x21v1w _mxg71v1w _1vbx16tk _pyf516tk _pj951gly _88s71gly _1bf21149 _uu1m1149 _p3lu1txw _186w1txw _1lte1bp4 _la471bp4 _d5wy1h6o _86511h6o _1v1sesu3 _1gclutpp _d90xmyb0 _1w491y6m _jv52utpp _owanmyb0 _knit261p _ple11h90 _m1xp1h90 _116fzg2b _bsrczg2b _b172wrdo _165awrdo _1wqewrdo _1hte8kn1 _c57q8kn1 _trv5rprw _bjw3rprw _rsxf19k1 _1l4iglyw _bzdq1cgb _150s1cgb _3s5mwi5u _1onu97pp _2cyhtlke _u4nwr4us _13v3glyw",
    mentionDangerStyles: "_gtdrbimv _9qsdbimv _2eqbbimv _16mx1gly _1iqr1gly _1srh1gly",
    mentionNodeStyles: "_n9nt1rr0 _tsa3t94y _12tyzjw7 _te0it94y _1raq1poh _9y08i8nm _49vlokh7 _1t47plhp _11h11gdz _nck11nu9 _1w5mtlke _pdsn78tn _1qs3i7a9 _1wet1hna _1tqsazsu _42pj1j28 _o0ds5rkr _8tic1j28 _ey371j28 _1ucti7uo _e2i01856 _arowokh7 _1y0dhf2y _vskfg6ey _g91j15cr",
    mentionsSelectionStyles: "_1wwxbimv _1gf31gly _ic7s1j28 _aa1g1j28 _1v8i1j28 _2qpjr4us _jhe3r4us _2mn9r4us _17xq15s3 _pyh015s3 _uput15s3 _hte21j28 _qzx91j28 _slqe1j28 _m5j31j28 _242x1j28 _173j1j28 _tw4v1j28 _nw2u1j28 _zanp1j28 _1f6f1j28 _42an1j28 _dafh1j28 _1jnyazsu _bzk5azsu _1yg7azsu _pvcj15s3 _ufew15s3 _chqr15s3 _opx215s3 _12dx15s3 _1orw15s3",
    mentionsSelectionStylesWithSearchMatch: "_1wwxbimv _1gf31gly _17xq15s3 _pyh015s3 _uput15s3 _hte21j28 _qzx91j28 _slqe1j28 _m5j31j28 _242x1j28 _173j1j28 _tw4v1j28 _nw2u1j28 _zanp1j28 _1f6f1j28 _42an1j28 _dafh1j28 _1jnyazsu _bzk5azsu _1yg7azsu _pvcj15s3 _ufew15s3 _chqr15s3 _opx215s3 _12dx15s3 _1orw15s3 _1pyq1j28 _uhe21j28 _igra1j28 _1oqxr4us _1iyqr4us _16atr4us",
    mentionsStyles: "_1v6z1j28 _gzj3r4us _14ew15s3 _h2zmazsu _tqacbimv _yy7y1gly _1nhdi8nm _1o02azsu",
    nestedPanelBorderStylesMixin: "_1bbgj0fz",
    nestedPanelDangerStyles: "_16gbrprw _109as4qr _3beorprw _1rfhs4qr _1t1yrprw _92lqs4qr _19plrprw _1mebs4qr _1503rprw _w0ams4qr",
    panelStyles: "_60zxfajl _144h15ge _bcvb1pcn _1x82kb7n _1epnidpf _vu3nf1ug _4dkwidpf _qtw5tlke _18hibimv _17er1do8 _pn62wrdo _1ddmu2gc _1m2kpxbi _191gu2gc _dvd0u2gc _18cwckbl _o4za1txw _1nqeh2mm _10qt4jg8 _w0c11hna _1p5l1s93 _1x7z1kw7 _foaaidpf _1n9b1ejb _7pqp1ejb _16pa1ntv _2py1u2gc _luzi1h6o _1305glyw _j75oglyw _1ydjglyw _kw4vglyw _8l34vq3b _1d54nkob _1g12116y _bkmb12gs _6bmtj39m _1lk11o8l _9fmhp2ly _nq831kw7 _da7in729 _1krp1kw7 _1yqxibhp _xyed1kw7 _1iu21vk5 _wfj11kw7 _2n8sn729 _u5bi1kw7 _u0jv1kdv _q1d2rprw _6149s4qr _9zpl1j28 _1wsxr4us _prvjh2mm _13az1kdv _ndxcstnw _tnheb3bt _1twbidpf _1p9vidpf _l1qiidpf _1d98idpf _jd7v1osq _79ymglyw _2m4f1ial _1p647wq0 _r6zr1j28 _1x881j28 _m2j51j28 _146b1j28",
    panelStylesMixin: "_1f20yhbg _1lviqm1h _uck94pcx _1qngervl _n32is4qr _i1t94pcx",
    panelStylesMixin_fg_platform_editor_nested_dnd_styles_changes: "_15brutpp _sz15utpp _1kz5utpp _1e01v47k _6kguv47k _d2uyu2gc _qooputpp _rhh5utpp",
    panelViewStyles: "_47vvusvi",
    paragraphStylesOld: "_1tlp1x4e _11jf78tn _15zti7a9 _poq4oqnp _z9wpidpf _181jdjp5",
    paragraphStylesOldWithScaledMargin: "_1tlp1x4e _11jf78tn _15zti7a9 _poq41xs6 _z9wpidpf _181jdjp5",
    paragraphStylesUGCRefreshed: "_1fi2t7zq _poq4oqnp _z9wpidpf",
    paragraphStylesWithScaledMargin: "_1fi2t7zq _poq41xs6 _z9wpidpf",
    placeholderOverflowStyles: "_pa0l15vq _14r215vq _1abn1q9c _1ue41l2s",
    placeholderStyles: "_h9qo1r31 _y5fkglyw _1eui1o36 _bzatglyw _12wvglyw _fpn9stnw _ups11rpy _14uo1osq _14ijglyw _16j6glyw _g0ho1wwu _1vpk188d _18j96ui8 _1gikq7pw",
    placeholderTextStyles: "_1qnc1rpy _gv641nu9 _67ch1nu9 _mekn1rpy _18et1nu9 _lm211rpy _177515s3 _wgub1j28 _2nre1j28 _1gej1j28 _78lz1j28 _5h7k1rpy _1xbs1kdv _x07nrrda _ug3m1nu9 _14gpj0fz _ux32b3bt _1pzi1nu9 _ga7midpf _rejjstnw _wets1nu9 _smxnglyw _v284h2mm _jtpj1nu9 _nyhtglyw _1enqh2mm _pichgir2 _x6bu11lh",
    placeholderWrapStyles: "_12te1q9c",
    pragmaticResizerStyles: "_16e11mi1 _qmao1mi1 _1rt11mi1 _1ug01mi1 _1wjtmslj _5gt311dc _c5pk1osq _zjao12b0 _nmt510ym _me2115s3 _1a471v1w _54jwh2mm _1crm1txw _1cbm1h6o _8r2l1h6o _1dh91osq _1bdt11mm _um2ics5v _1jhcidpf _o8oz15s3 _e89f1v1w _1fh31l7x _lvol1qi0 _15d61l7b _1j6b122h _1abr1if8 _u6kkutpp _xsr0utpp _f73nkb7n _1wljkb7n _rxyqh2mm _1bjlh9n0 _11m91osq _573b1v6z _19kyv2br _11xjh9n0 _ik9mstnw _i0hyidpf _16sfidpf _j4ne1fm0 _i4qa1fm0 _1dx5idpf",
    pragmaticResizerStylesCodeBlockLegacy: "_91ca1lpd _77bl1lpd _evnizd3w _c5pk1osq",
    pragmaticResizerStylesCodeBlockSyncedBlockPatch: "_ahxl1lpd _274k1lpd _1dzvzd3w _nyks1osq",
    pragmaticResizerStylesForTooltip: "_1vw512b0 _5qeg1txw _1oid1h6o _1e0d1h6o _c9p61osq _iz7l11mm _1a53cs5v _kgf01osq _1d1f1osq _djjh1osq",
    pragmaticResizerStylesSyncedBlock: "_hjc32bgk _wkbz2bgk _qrrd2bgk _1lm92bgk _1qvdzd3w _lukrzd3w",
    pragmaticResizerStylesWithReducedEditorGutter: "_m10eidpf _1b68idpf _1nur15vq _1j0a15vq _1ae51ea5 _1sjs15vq _d5z315vq _191gidpf _dmjjidpf",
    pragmaticStylesLayoutFirstNodeResizeHandleFix: "_13is11dc",
    resizerStyles: "_16pckt5e _10gt1txw _1a7b15vq _9klwidpf _ydkr1bp4 _1p6p1h6o _i5751h6o _mz7q1v6z _c1pr1osq _351g1osq _w71a1txw _cwvb1bp4 _n0x91h6o _13o01h6o _pp57mgjw _svmg4jg8 _1bo71y6m _17h6esu3 _2e7gajfg _1pgzvbgk _1ynz16xz _ivms1h8x _xv4o1if8 _15c6utpp _ao45utpp _i4oz1v1w _1oimewfl _6x25105o _mle11nxw _1pf6z97a _2j3s1qi0 _uufeidpf _t6uyidpf _5drkidpf _1yk7idpf _1jyuidpf _1reh1r31 _1l7jglyw _de791o36 _1v2p1l7x _1hjoq98m _1ehevp1g _103n1kw7 _1qsab3bt _1lqhstnw _14u4r5cr _5nd3r5cr _1sq7r5cr _1g77r5cr _1koh1mrw _11uyf705 _k31i1txw _dw2y1l7b _1fxgvbgk _f561cs5v _aakq1tcg _3f0s11mm _8fzb12b0 _exlk10ym _e3z7glyw _1om315s3 _1v2n15s3 _mgxs1osq _10cy14no _1nzz15vq _1l7xstnw _7ko61v6z _172f1f9d _ooctidpf _1b5hn7od _xf6qn7od _vpm4n7od _q381n7od _1qwmn7od _1rq3n7od _61j5n7od _ew2in7od _sa1qn7od _y41ln7od _1ful1ea5 _64blewfl _1cvqewfl _l5mpkb7n _13y1kb7n _1pzr1v1w _1qngglyw _168ss4qr _10ns1v1w _6rj41l7x _d8sss8vo _11ujxmi2 _zuk5h2mm _1061j4ch _k6mw1osq",
    ruleStyles: "_3vafglyw _yhgjt94y _1uh7swc3 _1cnzgx6n _874g1l7x _rc9pyh40 _qgb1tlke _12vh1ntv _dl0n1r31 _43nwglyw _1iod1o36 _9pd8q98m",
    scaledEmojiStyles: "_1f4mixwd _1gq31o8l _gof5gktf _1ldlgktf _gpgbgktf _1kub1f4h _yjsg1f4h _p8rdtlke _1ub4nkob _1rml1rj4 _ps8p1o8l _1h3zlb4i _11pulb4i _6p5k1j28 _1nt01j28 _1uvbh2mm _114kh2mm _1qer1kdv _2qa91kdv _4qcustnw _9ggastnw _80x0b3bt _f7p0b3bt _kxdfidpf _2zbkidpf _1oq4idpf _11ividpf _1fg6idpf _1r2pidpf _iz9gidpf _1v08idpf _rldy1osq _sdlb1osq _1focglyw _199fglyw _1x5q1ial _pyxt1ial _1rvo7wq0 _1x187wq0 _1608r4us _13ffr4us _1ip21j28 _11ut1j28 _1gjf1j28 _1g5r1j28 _rii71j28 _1vmi1j28 _2gbi1j28 _1usv1j28 _1uoi1f4h _73k21f4h _pwhh1ou6 _nzjn1ou6 _z6pc1tcg _1m2p1tcg _iljcqslr _kdk7qslr _1dpngktf _vx7egktf",
    scaledEmojiDenseStyles: "_2f9he0wb _gof5e0wb _1ldle0wb _gpgbe0wb _1kub1w2o _yjsg1w2o _1jg61osq _ik5u1osq _7vzk1f51 _1n9bv47k _7pqpv47k _d8rx1w2o _1cw91w2o _1m6zojke _5w3hojke _1lzrw31d _e6t0w31d _1yqj16ch _1m4816ch _kifh1w2o _1lg71w2o _9ut8ojke _1ailojke _1u2ww31d _1b4zw31d _1xkp16ch _18zg16ch _1dpne0wb _vx7ee0wb",
    scrollbarStyles: "_1fpfolhs _1khk1mok _123b1aqn _jaboglyw _aaynsm61 _1ogl1ibz",
    selectedNodeStyles: "_1vqj1r31 _1fkoglyw _m3b01o36 _g4fm7g83",
    selectionToolbarAnimationStyles: "_bbrv19by _e9pffnf5 _uw601ku9",
    shadowStyles: "_txt11rqd _10l0idpf _1qomidpf _92xt1ule _7xotcd8q _1vs6idpf _kkfiidpf _nj021ule _j0guglyw _92xtglyw _nj02glyw _1h99glyw _11h4stnw _7nbfstnw _7sqtstnw _9o0ystnw _wfdzglyw _9jfyglyw _1ol3glyw _1fq7glyw _120fcs5v _1ssocs5v _197qcs5v _1y55cs5v _5gqnftgi _s94sftgi _odc0ftgi _qokmftgi _1ezhb3bt _xhe7b3bt _opw2b3bt _17wjb3bt _862v1osq _12i31osq _q8c11osq _jdud1osq _w9ivh2mm _1tiyh2mm _w1tc1osq _qv61idpf _ngbzidpf _1yzk1osq _b9ejidpf _1botidpf",
    showDiffDeletedNodeStyles: "_xxqm1j28 _6w2tuh72 _d1z31j28 _1mxp1s99 _zdge1j28 _1ek01xlz _1odm1j28 _1fyjrq1m _1z0u1j28 _1uw3rq1m _mi7d1ck0 _1iac12b0 _bvo6uh72 _52e51ck0 _15xd12b0 _ez501s99 _1u1h12b0 _1tai1xlz _65c912b0 _1n07rq1m _cfrg12b0 _16kmrq1m _1edc1ck0 _ssis1r31 _1uo51911 _3tvjnqa1 _1y1t1r31 _xznn1911 _m644nqa1 _1y1t16y8 _iola1r31 _3vri1911 _b761nqa1 _iola16y8",
    showDiffDeletedNodeStylesNew: "_xxqm1j28 _6w2t1s99 _d1z31j28 _1mxp1s99 _zdge1j28 _1ek01xlz _1odm1j28 _1fyjrq1m _1z0u1j28 _1uw3rq1m _mi7dtxnc _1iac12b0 _bvo61s99 _52e5txnc _15xd12b0 _ez5019og _1u1h12b0 _1tai1xlz _65c912b0 _1n07rq1m _cfrg12b0 _16kmrq1m _1edctxnc _ssis1r31 _1uo51911 _3tvjnqa1 _1y1t1r31 _xznn1911 _m644nqa1 _1y1t16y8 _iola1r31 _3vri1911 _b761nqa1 _iola16y8",
    smartCardDiffStyles: "_71hk1j28 _18vn49jj",
    smartCardStyles: "_2gdboqnp _1crlidpf _jg40idpf _657hidpf _sqna1mok _thnl1j28 _1bgvr4us _yxg21j28 _tq5y1j28 _b63e1j28 _183h1j28 _711y1ule _5eojukw8 _lfjo19k1 _g0hxidpf _1m1didpf _177yidpf _1vm3idpf _1aol1773 _1sy71i04 _62my130s _136s1j28 _6bz7r4us _1q8j1j28 _1gm11j28 _ab8t1j28 _19651j28 _1xjewgn3 _1gjijp4b _3k5n9jpi _jzh41j28 _1gr5r4us _10ks1j28 _1tkg1j28 _gzlt1j28 _obfm1j28 _1f8zv77o _74w8v77o _1rm4u2gc _xx4cu2gc _1hlix0bf _e64bkb7n _ago7h2mm _1bgnbimv _i6dhcs5v _g26e1mok _pb54j0fz _1tc815vq _19pc15vq _9ifhtlke _oygpsm61 _1k8j1osq _hxa21txw _spvm1h6o _1mgn1j28 _j20nr4us _1uxg1j28 _e6xr1j28 _ugtt1j28 _1n661j28 _1um6ufnl _mzu4ufnl _14vjbimv _jc9z1j28 _1w4lr4us _1f781j28 _g9w41j28 _s5c21j28 _bvii1j28 _3ijseweo _wiz6tlke _9kf71do8 _1w9719k1 _1s3d1bqt _11gi1bqt",
    smartCardStylesWithSearchMatch: "_2gdboqnp _1crlidpf _jg40idpf _657hidpf _sqna1mok _thnl1j28 _1bgvr4us _yxg21j28 _tq5y1j28 _b63e1j28 _183h1j28 _711y1ule _5eojukw8 _lfjo19k1 _g0hxidpf _1m1didpf _177yidpf _1vm3idpf _1aol1773 _1sy7277m _62my130s _1jhk1j28 _619jr4us _1xjewgn3 _1gjijp4b _3k5n9jpi _jzh41j28 _1gr5r4us _10ks1j28 _1tkg1j28 _gzlt1j28 _obfm1j28 _1f8zv77o _74w8v77o _1rm4u2gc _xx4cu2gc _1hlix0bf _1q8j1j28 _1gm11j28 _ab8t1j28 _19651j28 _e64bkb7n _ago7h2mm _1bgnbimv _i6dhcs5v _g26e1mok _pb54j0fz _1tc815vq _19pc15vq _9ifhtlke _oygpsm61 _1k8j1osq _hxa21txw _spvm1h6o _1mgn1j28 _j20nr4us _1uxg1j28 _e6xr1j28 _ugtt1j28 _1n661j28 _1um6ufnl _mzu4ufnl _14vjbimv _3ijseweo _wiz6tlke _1f781j28 _g9w41j28 _s5c21j28 _bvii1j28 _1xvj1j28 _19lmr4us _9kf71do8 _1w9719k1 _1s3d1bqt _11gi1bqt",
    smartCardStylesWithSearchMatchAndBlockMenuDangerStyles: "_2gdboqnp _1crlidpf _jg40idpf _657hidpf _sqna1mok _thnl1j28 _1bgvr4us _yxg21j28 _tq5y1j28 _b63e1j28 _183h1j28 _711y1ule _5eojukw8 _lfjo19k1 _g0hxidpf _1m1didpf _177yidpf _1vm3idpf _1aol1773 _1sy7277m _62my130s _1dm11j28 _1tx5r4us _1xjewgn3 _1gjijp4b _3k5n9jpi _jzh41j28 _1gr5r4us _10ks1j28 _1tkg1j28 _gzlt1j28 _obfm1j28 _1f8zv77o _74w8v77o _1rm4u2gc _xx4cu2gc _1hlix0bf _1q8j1j28 _1gm11j28 _ab8t1j28 _19651j28 _e64bkb7n _ago7h2mm _1bgnbimv _i6dhcs5v _g26e1mok _pb54j0fz _1tc815vq _19pc15vq _9ifhtlke _oygpsm61 _1k8j1osq _hxa21txw _spvm1h6o _1mgn1j28 _j20nr4us _1uxg1j28 _e6xr1j28 _ugtt1j28 _1n661j28 _1um6ufnl _mzu4ufnl _14vjbimv _3ijseweo _wiz6tlke _1f781j28 _g9w41j28 _s5c21j28 _bvii1j28 _1xvj1j28 _19lmr4us _9kf71do8 _1w9719k1 _1s3d1bqt _11gi1bqt",
    smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness: "_im2q1mok _1tqn1j28 _1on8r4us _1ksw1j28 _pukq1j28 _140r1j28 _kpkg1j28 _1wdnutpp",
    smartLinksInLivePagesStyles: "_t9d7tlke _1k8g1wug _15fr1wug",
    syncBlockFirstNodeStyles: "_ve9oidpf _m8swidpf",
    syncBlockOverflowStyles: "_11gbj4ch _1n6dj4ch",
    syncBlockStyles: "_802o12et _1fzc12et _1r8i12et _1pg112et",
    syncBlockStylesBase: "_fignfajl _ndd2fajl _81bamihd _1uimmihd _175ucu6h _z7qocu6h _1nt1kb7n _cbt1kb7n _1cijewfl _m6zxewfl _f55g1tsb _9fus1tsb _w3sjokh7 _16k7okh7 _w5y5tyq1 _nkbmtyq1 _1va4mihd _1h9lmihd _hcn5st3y _1i8kst3y _1kqmymdr _jx2uymdr _1w6ap3kn _i6q6p3kn _885k12c5 _177j12c5 _i6psbx47 _1ua7bx47 _i2g5glyw _10b5glyw _18nvglyw _1wuuglyw _xennutpp _ulg8utpp _1xrfh2mm _r2nsh2mm _17thtlke _12ijtlke _12rjidpf _andtidpf _1e2q12x7 _rzjc12x7 _6ltb1kw7 _70g31kw7 _15n01tsb _bvwr1tsb _1y6jkb7n _7wwkkb7n _1hmsewfl _od5newfl _vzxo127p _v7ki127p _k2ggkb7n _1otekb7n _eb52ewfl _z7s5ewfl _1q8w15s3 _1gzq15s3 _etvrd439 _1p4gd439 _1i781b66 _ygxf1b66 _3mra1b66 _nrxu1b66 _1jfi1bgf _o4x21bgf _59c3bimv _1y1pbimv _e8mcwrdo _1ib3wrdo _13e21gly _15mp1gly _ptgad439 _m1o1d439 _p96k1b66 _120m1b66 _2blv1b66 _f4wb1b66 _1ato5u61 _81645u61 _oxhkby5v _4f83by5v _11n769va _qcib69va _df96glyw _1up3glyw _ft7jglyw _m3u5glyw _wsnlvuon _1ndtvuon _1lpfby5v _zsi2by5v _nxsk1tsb _1ojl1tsb _36y5idpf _xvmhidpf _yio215vq _1s2g15vq _fvpcglyw _1fjjglyw _w8xhn7od _1n97n7od _oigxidpf _1mopidpf _12aj15vq _rikw15vq _18bz1tsb _gbpf1tsb _18k9kb7n _1euekb7n _1vpdewfl _zzsvewfl _ngstidpf _1cnfidpf _1m7ridpf _1k5hidpf _13hx8jkm _674q8jkm _1f3mf6fq _mm5uf6fq _tq9g1kdv _1fwh1kdv _1q8iidpf _1cimidpf _upkyidpf _98epidpf _1xh58jkm _x0l08jkm _1x7pf6fq _b7hjf6fq _amkyidpf _1e4yidpf _wxspfajl _1owl1b66 _18d9stnw _7kxw1h6o _zir21h6o _19vz1txw _14u2idpf _k50g15vq _wi0pglyw _6e1zkb7n _8c1au2gc _16o3u2gc _1sdw14id _ke4wutpp _1iizvuon _zaei11ux",
    tableCommentEditorStyles: "_s9qz1mok _1quk1aqn _1tb2idpf _8vyeidpf _1igzolhs _ux48glyw _giavsm61 _axu71ibz",
    tableContainerStyles: "_18ml1osq _9e5g1wug _uwd31osq _12wgusvi _nnhzewfl _1gbz1osq _10va1osq _lkzl1n9t _1mca1wug",
    tableContentModeStyles: "_1lxan7od _11a2n7od _19iin7od _1vpzn7od _l6b9n7od _9v33vi1l _poet1ris _9loxvi1l _1dsv1wug _r83tvi1l _cbmx261p",
    tableEmptyRowStyles: "_1rgmmh6f _u0mgmh6f",
    tableLayoutFixes: "_1f5xidpf _28dsidpf _f30jidpf _jr291hrf",
    tableLayoutFixesWithFontSize: "_1f5xidpf _156tidpf _f30jidpf _jr291hrf",
    tableSharedStyle: "_ad1u99ee _9d0e7qp0 _1mml7qp0 _1u4a1ule _1w721ule _1gr6t94y _ihzat94y _zi6e1vmz _1uln1vmz _wqm3stnw _1o0wstnw _1aho1ejb _uqg71ejb _g971h2mm _fzt6usvi _1nd8idpf _1j1lidpf _e364idpf _7vb2pzf8 _5cdi6z83 _kc8l11ss _9vqg11ss _up97ia51 _jz731rb6 _13ax1rb6 _b7zl1rb6 _10kw1rb6 _1u451rb6 _1gep1rb6 _14oi1rb6 _3yki1rb6 _185t1rb6 _13heu2gc _1uj1u2gc _1ssuu2gc _lqdju2gc _1waku2gc _1nzzu2gc _7xl8ckbl _1jykckbl _1m6qckbl _sellckbl _11t9ckbl _866vckbl _1dlzi7a9 _irzhi7a9 _15t1i7a9 _1ivxi7a9 _16k4i7a9 _1vo6i7a9 _q0zvjp4b _1junjp4b _ixm7jp4b _17dpjp4b _dzhmjp4b _15pyjp4b _dj9oidpf _8zz2idpf _1hwbidpf _1lxyidpf _yqeuidpf _mzo1idpf _9ex2idpf _1805idpf _1iphidpf _qkm8idpf _17v9idpf _4p8kidpf _6o4midpf _1edridpf _5908idpf _1d63idpf _1j36idpf _hlqnidpf _gw0eutpp _1n42utpp _762vutpp _g62yutpp _1y9hutpp _bjiqutpp _5dtjutpp _dclrutpp _1j94utpp _5o16utpp _946yutpp _1kffutpp _13bnglyw _1ekgglyw _nvt3glyw _v91rcfaq _byukcfaq _4oczcfaq _17xf1j28 _6ggl1j28 _wxs41j28 _1h3k1j28 _1e811j28 _w9wp1j28 _3aim1n9t _xsax1n9t _1hz91n9t _vqlp1x4e _1a0i1x4e _m5f81x4e _12j81osq _135a1osq _vkob1osq _dujf1wug _jr3h1wug _1ei91wug _kq5rusvi _31x2usvi _pavrusvi _14jm1ntv _1rfm1ntv _100i1ntv _1ciasm61 _5gm1sm61 _t176sm61 _1az4vuon _1mdwvuon _9l08vuon _vrwbysee _nwuhysee _1qxuysee _go9a1e5h _ktc91e5h _lr001e5h _komfhp5a _1lj5hp5a _96m3hp5a _s2681tsb _15bz1tsb _1skp1tsb _iley2lzm _ay9u2lzm _8zqr2lzm _qxl3i8nm _3gtki8nm _1nu9i8nm _lezgi8nm _1574i8nm _1yd8i8nm _ywut18tx _cee918tx _17h918tx _1esgtoke _1q0atoke _4waqtoke _1syri8nm _pvtri8nm _12jli8nm _dbl6pzf8 _4e711hrf _1hy1bokp _1bxo1ea5",
    tableSharedStyleBackgroundClipFix: "_m6yo1u8q _19il1u8q _10gj1u8q _tbd61u8q _12ly1u8q _1l071u8q",
    taskItemCheckboxStyles: "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28 _v0qsidpf _19oaidpf _1czgidpf _3iyuidpf _198v1tcg _floh1tcg _1hee1r31 _1i061r31 _zbwkglyw _7699glyw _v7qn1o36 _rr8m1o36 _1p3xidpf _pp1tidpf _7m6kidpf _rqg8idpf _24k6idpf _9di4idpf _gfk0idpf _14l7idpf _sh9t1mn3 _180c1mn3 _4fox11so _1mx211so _1r3dhteq _1bnfhteq _xxwze4h9 _1ol7e4h9 _ould93zu _phuq93zu _b4hh1gyf _1lrm1gyf _1ord14p8 _fyhw14p8 _812smov0 _a2yomov0 _1kcx1cni _19gt1cni _aixtusvi _113wusvi _1mds1nu9 _1aim1nu9 _1mqkstnw _1h14stnw _3yx41ssb _znw11ssb _1cw71ssb _8vye1ssb _16zj1ooe _322b1ooe _tvm38r4n _1x7s8r4n _rie88r4n _1cqg8r4n _otexdfik _1s0ydfik _4rp7dfik _nu6mdfik _dlrj1i6y _9mji1i6y _w3lc1i6y _2hkb1i6y _2qpqidpf _o5sfidpf _twmg1osq _11kk1osq _1cma1osq _p4wq1osq _1292kb7n _1lp9kb7n _k76btlke _1g4gtlke _ekb2stnw _3shystnw _1fs173ad _1gc173ad _1myqkivo _k9eskivo _18cr199y _m2w9199y _1gij180l _qek6180l _qlex1g3k _1ew11g3k _2f1l1ps2 _oide1ps2 _nbkc170n _a3x2170n _1et317cl _et2r17cl _180w155b _245q155b _h1671vek _1st71vek _bxjv155b _co5y155b _ihto1vek _1yvb1vek _1ozu18jz _zghr18jz _1icymz2b _1b9kmz2b _1u7ymz2b _s1jlmz2b _1x9vmz2b _1e1gmz2b _1g0kmz2b _z797mz2b _im81mz2b _1pp7mz2b _12oz1diq _6mj51diq _1aj21diq _xk451diq _ijgu1diq _1jw81diq _qmfv1diq _1sqd1diq _1jk91diq _dgg11diq _1wgw13gf _16xd13gf _1l9u13gf _x0ik13gf _7z9f13gf _7pi113gf _ek7i13gf _1nhw13gf _rc8813gf _19e613gf _1ehvglyw _xu7mglyw _2p31glyw _uuxfglyw _1i0iglyw _vfpvglyw _1ttmglyw _39dzglyw _zykmglyw _ut9vglyw _zvr81hou _18ab1hou _1d9u1tcg _1icn1tcg _1tcx1tcg _1x5a1tcg _1y55h2mm _hiy2h2mm _1hmgv2br _1v5iv2br",
    taskItemStyles: "_7jefglyw _gx5jidpf _d6qyidpf _f7rwidpf _swedhwpb _hewr15vq _2s2x15vq _1sntstnw _sobi1rpy _1mcuglyw _1qil1l2s _xw4d1q9c _c67e1dza _1cq5glyw _1crwidpf _r861idpf _tf4jidpf _18fxidpf _ec0rkb7n _1e3xkb7n _sxzf1wug _141u1hna _v919idpf _1rtu1txw _dfxtvrvc _1njsh2mm _19tl1ule",
    taskItemStylesWithBlockTaskItem: "_2ichglyw _7jefglyw _edhnidpf _gx5jidpf _5c1cidpf _d6qyidpf _629ridpf _f7rwidpf _11gbhwpb _swedhwpb _kcgj15vq _hewr15vq _1jba15vq _2s2x15vq _15l5stnw _1sntstnw _16xj1rpy _sobi1rpy _onreglyw _1mcuglyw _7df91l2s _1qil1l2s _limd1q9c _xw4d1q9c _uwnz1dza _c67e1dza _5cgrglyw _1cq5glyw _re0hidpf _1crwidpf _l5scidpf _r861idpf _q0xbidpf _tf4jidpf _137bidpf _18fxidpf _n6v6kb7n _ec0rkb7n _1u29kb7n _1e3xkb7n _mfp71wug _sxzf1wug _1h341hna _141u1hna _174ridpf _v919idpf _1t881txw _1rtu1txw _j745vrvc _dfxtvrvc _kzf2h2mm _1njsh2mm _1m4z1ule _19tl1ule",
    tasksAndDecisionsStyles: "_1g40h2mm _oj2bh2mm _56o2ckbl _18lyckbl _13skidpf _dax2mh6f _1e0878tn _wx2kmh6f _150amh6f _l3e11ie7 _11961b66 _gx3t1b66 _1vo21ejb _17lhgrf3 _1f96grf3 _1wmugrf3 _jcnagrf3",
    tasksAndDecisionsDenseStyles: "_kbdlvn6p _72a11tuv _456h1tuv _ck1p1tuv",
    statusDangerStyles: "_ss5sssxh",
    statusStyles: "_19lm1osq _1qne1osq _1hoa1osq _1omqidpf _1c2ridpf _185zidpf _5g3i1osq _1c4k1osq _1s9j1osq _u7fhtlke _1b1iidpf _1vdkd096 _1hwsbimv _mh6ofajl _5i9r15vq _1joz15vq _gx1oglyw _23me1b66 _6eqhi8nm _ze8c1osq _4reg116y _bjga184x _jetmpfqs _gae8usvi _e1gmglyw _15vn15vq _1x4315vq _1drv1skh _pmav4jg8 _brz2ttxp _jlqawu06 _1lx57vkz _1w6y1l2s _1fmnangw _m2jl1q9c _1ohu1o28",
    statusStylesMixin_fg_platform_component_visual_refresh: "_1ev3w5lj _a2gxwwip _2cv31fkg _b72jshej _rlaw1ymo _zyzfxmjf _1m7i1366 _16293uhp",
    statusStylesMixin_fg_platform_component_visual_refresh_with_search_match: "_ofyww5lj _a2gxwwip _2cv31fkg _b72jshej _rlaw1ymo _zyzfxmjf _1m7i1366 _16293uhp",
    statusStylesMixin_without_fg_platform_component_visual_refresh: "_1cqj1j28 _1ev3r4us _gvya1j28 _181a1j28 _lau51j28 _1c451j28 _19isi8nm _tjbxazsu _1iej6vm6 _7ilpdv2p _yz0y19ip _1c8xu3tg _hkkl1917 _1xq21xn9 _1oug1gly _16a71tmw _sifs1y9u _1p14gsak",
    statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match: "_92281j28 _ofywr4us _1hgt1j28 _rm3h1j28 _1jc61j28 _xt5o1j28 _19isi8nm _tjbxazsu _1iej6vm6 _7ilpdv2p _yz0y19ip _1c8xu3tg _hkkl1917 _1xq21xn9 _1oug1gly _16a71tmw _sifs1y9u _1p14gsak",
    statusStylesTeam26: "_mh6o12b0 _gx1o1d85 _xddov77o _3foov77o _1tzc1b66 _3l7v1b66 _1o6c1h6o _pit21k92 _b080wadc _1fmnglyw _16o2sn1s _1i3e1q2y _2cv3i8nm _tjbxi7uo _wtboshej _f72f8lpu _b72je670 _7ilp1g72 _1tw01ymo _sz281q0g _rlaw8lbg _1c8x1qd9 _pfcw1366 _1kap14o6 _1m7i18wg _16a71blx _1lns6qd6 _1n4y1szp _zyzf10f4 _1xq2mgs1 _iwfe3uhp _1hf518rl _162914j0 _1p141p1e _ofyww5lj _1yh3ssxh",
    telepointerColorAndCommonStyle: "_66xp46kq _mgp11vg9 _1ji11vg9 _15cgjt0p _uqqyh2mm _1kk7brmi _1by9fnf5 _1xemcjiy _vmt0glyw _u2jdglyw _1us5sxj9 _gkev15cr _144ruibq _1pjl15cr _18tb16e3 _1rg715cr _v91w1e5c _1md215cr _1ubf1vop _xlm615cr _15eyya33 _1luc15cr _1j8ac3uk _1lm915cr _vwip2c8p _1p9315cr _1pye1qg1 _14dm15cr _18vwtde4 _11rg15cr _poz81i45 _6w3a1tmo _htkd115i _al8b1tmo _3gvxkrt9 _zkkp1tmo _51zm1kkj _zo131tmo _9fge8y3s _sx0p1tmo _2b661rsu _wsn51tmo _li04tdv8 _1gi61tmo _1xr818ah _dhht1tmo _35ci1mi6 _1inzj35l _vdlzei1s _y5edfk4f _k6qpoly4",
    telepointerStyle: "_1pbgwadc _x96nwadc _1gna19qg _1tpb19qg _1e4lstnw _flesstnw _1u701ule _w6dp1ule _10c7glyw _1q09glyw _1ki7qvpr _63b3qvpr _aof7d439 _1br5d439 _vgzaidpf _r397idpf _1r8c1b66 _5m891b66 _e73x1b66 _vdne1b66 _1gifkb7n _1506brmi _4tu36ebc _o9ii6ui8 _edxtidpf _1d8u546l _1vic5d63 _1otj1rjc _19p11u4t _ufoh1lfe _nfsm1xbj _o0dm16z4 _7xjx1ytf _9cv91cra _fhbe16z4 _1p171ytf _fsoe13gw _2ss61y2m _gcu91ytf _4z8q1vyj _1p281y2m _1ku31ytf _q7vcidpf _ay6b6ebc _b82712n9 _yxs7kb7n _v9kukb7n",
    textColorStyles: "_c0871i5q _lv7dn7od",
    textDangerStyles: "_1n4v1gly _1oi31k79",
    textHighlightPaddingStyles: "_1fwwv77o _1jbz1i6y _1n37v77o _1tdl1i6y",
    textHighlightStyle: "_1ny71t12 _wnl31s93",
    textSelectedNodeStyles: "_nx361dy8 _gdg21kdv _ozidmk5s _1cbl1j28 _imnz1j28 _18gf1j28 _1p4y1j28",
    unsupportedStyles: "_mpdktlke _1b22tlke _k9adhueu _ygeohueu _ye0rq98m _k4r0q98m _1f82glyw _1mc7glyw _iqou1osq _12yq1osq _1cub16ux _4ssh16ux _fc0tstnw _5xhvstnw _ubim1n1a _mjjq1n1a _ffpwidpf _1otoidpf _4666idpf _16j6idpf _1v6tt94y _zfb0t94y _1azw1o8l _e4bx1o8l _1mat15s3 _g6l115s3 _yhcc1j28 _uvar1j28 _1xoh1j28 _oz7r1j28 _1hd21j28 _16r81j28 _6jk61j28 _trbp1j28 _141yzg2b _vy5czg2b _1cfbrprw _3jj9rprw",
    whitespaceStyles: "_18031hna _18qq1jtm"
};
const $c893e88acf4c2038$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $c893e88acf4c2038$export$b9e04e68e256861a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode, useStandardNodeWidth: useStandardNodeWidth } = props;
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width' || ((0, $dZ8uq.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max';
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const baseFontSize = (0, $jTtEd.getBaseFontSize)(appearance, contentMode);
    const isDense = !!baseFontSize && baseFontSize !== (0, $aFUXX.akEditorFullPageDefaultFontSize);
    const tableOverflowShadow = (0, $bfb4214ec776d51e$export$bb4a61a93a1e5360)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    const style = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? {
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: {
                baseFontSize: baseFontSize
            }
        })}px`,
        '--ak-editor--table-overflow-shadow': tableOverflowShadow
    } : {
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: {
                baseFontSize: baseFontSize
            }
        })}px`,
        '--ak-editor--large-gutter-padding': `${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px`,
        '--ak-editor--table-overflow-shadow': tableOverflowShadow
    };
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c893e88acf4c2038$var$editorContentStyles.baseStyles,
            $c893e88acf4c2038$var$editorContentStyles.maxModeReizeFixStyles,
            $c893e88acf4c2038$var$editorContentStyles.baseStylesMaxContainerWidthFixes,
            (0, $dh538.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? $c893e88acf4c2038$var$editorContentStyles.editorLargeGutterPuddingBaseStylesEditorControls : $c893e88acf4c2038$var$editorContentStyles.editorLargeGutterPuddingBaseStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && $c893e88acf4c2038$var$editorContentStyles.editorLargeGutterPuddingReducedBaseStyles,
            $c893e88acf4c2038$var$editorContentStyles.whitespaceStyles,
            $c893e88acf4c2038$var$editorContentStyles.indentationStyles,
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.fontSizeStyles,
            $c893e88acf4c2038$var$editorContentStyles.shadowStyles,
            $c893e88acf4c2038$var$editorContentStyles.InlineNodeViewSharedStyles,
            $c893e88acf4c2038$var$editorContentStyles.hideSelectionStyles,
            $c893e88acf4c2038$var$editorContentStyles.hideCursorWhenHideSelectionStyles,
            $c893e88acf4c2038$var$editorContentStyles.selectedNodeStyles,
            $c893e88acf4c2038$var$editorContentStyles.cursorStyles,
            $c893e88acf4c2038$var$editorContentStyles.firstFloatingToolbarButtonStyles,
            $c893e88acf4c2038$var$editorContentStyles.placeholderTextStyles,
            $c893e88acf4c2038$var$editorContentStyles.placeholderStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && $c893e88acf4c2038$var$editorContentStyles.placeholderOverflowStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder') && $c893e88acf4c2038$var$editorContentStyles.placeholderWrapStyles,
            $c893e88acf4c2038$var$editorContentStyles.codeBlockStyles,
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $c893e88acf4c2038$var$editorContentStyles.codeBlockStylesWithEmUnits,
            !(0, $dh538.fg)('platform_editor_typography_ugc') && $c893e88acf4c2038$var$editorContentStyles.editorUGCTokensDefault,
            (0, $dh538.fg)('platform_editor_typography_ugc') && $c893e88acf4c2038$var$editorContentStyles.editorUGCTokensRefreshed,
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.editorUGCSmallText,
            $c893e88acf4c2038$var$editorContentStyles.blocktypeStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && $c893e88acf4c2038$var$editorContentStyles.blockquoteSelectedNodeStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && $c893e88acf4c2038$var$editorContentStyles.listSelectedNodeStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && $c893e88acf4c2038$var$editorContentStyles.textSelectedNodeStyles,
            (0, $dh538.fg)('platform_editor_typography_ugc') ? $c893e88acf4c2038$var$editorContentStyles.blocktypeStyles_fg_platform_editor_typography_ugc : $c893e88acf4c2038$var$editorContentStyles.blocktypeStyles_without_fg_platform_editor_typography_ugc,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && $c893e88acf4c2038$var$editorContentStyles.blocktypeStyles_fg_platform_editor_nested_dnd_styles_changes,
            $c893e88acf4c2038$var$editorContentStyles.codeMarkStyles,
            (0, $1oCLl.expValEquals)('platform_editor_a11y_scrollable_region', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.codeMarkStylesA11yFix,
            $c893e88acf4c2038$var$editorContentStyles.textColorStyles,
            $c893e88acf4c2038$var$editorContentStyles.backgroundColorStyles,
            $c893e88acf4c2038$var$editorContentStyles.textHighlightPaddingStyles,
            $c893e88acf4c2038$var$editorContentStyles.listsStyles,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.listItemHiddenMarkerStyles,
            $c893e88acf4c2038$var$editorContentStyles.diffListStyles,
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && isDense && $c893e88acf4c2038$var$editorContentStyles.listsDenseStyles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'listLayoutShiftFix', true) && isFullPage && $c893e88acf4c2038$var$editorContentStyles.listsStylesMarginLayoutShiftFix,
            $c893e88acf4c2038$var$editorContentStyles.ruleStyles,
            $c893e88acf4c2038$var$editorContentStyles.smartCardDiffStyles,
            (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.showDiffDeletedNodeStylesNew : $c893e88acf4c2038$var$editorContentStyles.showDiffDeletedNodeStyles,
            $c893e88acf4c2038$var$editorContentStyles.mediaStyles,
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $c893e88acf4c2038$var$editorContentStyles.mediaCaptionStyles,
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $c893e88acf4c2038$var$editorContentStyles.firstWrappedMediaStyles,
            $c893e88acf4c2038$var$editorContentStyles.telepointerStyle,
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ $c893e88acf4c2038$var$editorContentStyles.telepointerColorAndCommonStyle,
            $c893e88acf4c2038$var$editorContentStyles.gapCursorStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $c893e88acf4c2038$var$editorContentStyles.gapCursorStylesVisibilityFix,
            $c893e88acf4c2038$var$editorContentStyles.panelStyles,
            $c893e88acf4c2038$var$editorContentStyles.nestedPanelBorderStylesMixin,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && $c893e88acf4c2038$var$editorContentStyles.panelStylesMixin_fg_platform_editor_nested_dnd_styles_changes,
            $c893e88acf4c2038$var$editorContentStyles.panelStylesMixin,
            $c893e88acf4c2038$var$editorContentStyles.mentionsStyles,
            $c893e88acf4c2038$var$editorContentStyles.tasksAndDecisionsStyles,
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && isDense && $c893e88acf4c2038$var$editorContentStyles.tasksAndDecisionsDenseStyles,
            $c893e88acf4c2038$var$editorContentStyles.gridStyles,
            $c893e88acf4c2038$var$editorContentStyles.blockMarksStyles,
            $c893e88acf4c2038$var$editorContentStyles.dateStyles,
            $c893e88acf4c2038$var$editorContentStyles.extensionStyles,
            (contentMode === 'compact' && (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $c893e88acf4c2038$var$editorContentStyles.extensionStylesDense,
            contentMode === 'compact' && (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && !(0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) && !(0, $dh538.fg)('platform_editor_content_mode_button_mvp') && $c893e88acf4c2038$var$editorContentStyles.extensionStylesLegacyDense,
            (0, $1oCLl.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.bodiedExtensionLayoutShiftFix,
            $c893e88acf4c2038$var$editorContentStyles.extensionDiffStyles,
            $c893e88acf4c2038$var$editorContentStyles.expandStylesBase,
            !useStandardNodeWidth && $c893e88acf4c2038$var$editorContentStyles.expandStyles,
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && isDense && $c893e88acf4c2038$var$editorContentStyles.expandDenseStyles,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $c893e88acf4c2038$var$editorContentStyles.expandStylesMixin_fg_platform_editor_nested_dnd_styles_changes : $c893e88acf4c2038$var$editorContentStyles.expandStylesMixin_without_fg_platform_editor_nested_dnd_styles_changes,
            $c893e88acf4c2038$var$editorContentStyles.expandStylesMixin_fg_platform_visual_refresh_icons,
            isChromeless && (0, $1oCLl.expValEquals)('platform_editor_chromeless_expand_fix', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.expandStylesMixin_experiment_platform_editor_chromeless_expand_fix,
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.findReplaceStylesNewWithA11Y : $c893e88acf4c2038$var$editorContentStyles.findReplaceStyles,
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.findReplaceStylesNewWithCodeblockColorContrastFix,
            !(0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.findReplaceStylesWithCodeblockColorContrastFix,
            $c893e88acf4c2038$var$editorContentStyles.textHighlightStyle,
            $c893e88acf4c2038$var$editorContentStyles.decisionStyles,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.taskItemStylesWithBlockTaskItem : $c893e88acf4c2038$var$editorContentStyles.taskItemStyles,
            $c893e88acf4c2038$var$editorContentStyles.taskItemCheckboxStyles,
            $c893e88acf4c2038$var$editorContentStyles.decisionIconWithVisualRefresh,
            $c893e88acf4c2038$var$editorContentStyles.statusStyles,
            (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $c893e88acf4c2038$var$editorContentStyles.statusStylesTeam26 : (0, $dh538.fg)('platform-component-visual-refresh') ? (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.statusStylesMixin_fg_platform_component_visual_refresh_with_search_match : $c893e88acf4c2038$var$editorContentStyles.statusStylesMixin_fg_platform_component_visual_refresh : (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match : $c893e88acf4c2038$var$editorContentStyles.statusStylesMixin_without_fg_platform_component_visual_refresh,
            $c893e88acf4c2038$var$editorContentStyles.annotationStyles,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? $c893e88acf4c2038$var$editorContentStyles.smartCardStylesWithSearchMatchAndBlockMenuDangerStyles : $c893e88acf4c2038$var$editorContentStyles.smartCardStylesWithSearchMatch : $c893e88acf4c2038$var$editorContentStyles.smartCardStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $c893e88acf4c2038$var$editorContentStyles.smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness,
            ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) && $c893e88acf4c2038$var$editorContentStyles.editorControlsSmartCardStyles,
            $c893e88acf4c2038$var$editorContentStyles.embedCardStyles,
            $c893e88acf4c2038$var$editorContentStyles.unsupportedStyles,
            $c893e88acf4c2038$var$editorContentStyles.resizerStyles,
            $c893e88acf4c2038$var$editorContentStyles.layoutBaseStyles,
            (0, $1oCLl.expValEquals)('platform_editor_table_excerpts_fix', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.layoutBaseStylesWithTableExcerptsFix,
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $c893e88acf4c2038$var$editorContentStyles.alignMultipleWrappedImageInLayoutStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $c893e88acf4c2038$var$editorContentStyles.syncBlockStylesBase,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // Apply sync block delta styles conditionally based on useStandardNodeWidth (negative margins or not)
            !useStandardNodeWidth && $c893e88acf4c2038$var$editorContentStyles.syncBlockStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $c893e88acf4c2038$var$editorContentStyles.syncBlockOverflowStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $c893e88acf4c2038$var$editorContentStyles.syncBlockFirstNodeStyles,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && $c893e88acf4c2038$var$editorContentStyles.layoutBaseStylesAdvanced,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $c893e88acf4c2038$var$editorContentStyles.layoutSectionStylesAdvanced : $c893e88acf4c2038$var$editorContentStyles.layoutSectionStylesNotAdvanced,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && $c893e88acf4c2038$var$editorContentStyles.layoutColumnDividerStyles,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && $c893e88acf4c2038$var$editorContentStyles.layoutColumnDividerStylesNestedDnD,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $c893e88acf4c2038$var$editorContentStyles.layoutColumnStylesAdvanced : $c893e88acf4c2038$var$editorContentStyles.layoutColumnStylesNotAdvanced,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && $c893e88acf4c2038$var$editorContentStyles.layoutColumnResizeStyles,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $c893e88acf4c2038$var$editorContentStyles.layoutSelectedStylesAdvanced : $c893e88acf4c2038$var$editorContentStyles.layoutSelectedStylesNotAdvanced,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $c893e88acf4c2038$var$editorContentStyles.layoutSelectedStylesAdvancedFix,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && $c893e88acf4c2038$var$editorContentStyles.layoutColumnResponsiveStyles,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && $c893e88acf4c2038$var$editorContentStyles.layoutResponsiveBaseStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && $c893e88acf4c2038$var$editorContentStyles.layoutBaseStylesFixesUnderNestedDnDFGExcludingBodiedSync,
            !(0, $iu6m9.editorExperiment)('platform_synced_block', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && $c893e88acf4c2038$var$editorContentStyles.layoutBaseStylesFixesUnderNestedDnDFG,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $c893e88acf4c2038$var$editorContentStyles.layoutColumnMartinTopFixesNew : $c893e88acf4c2038$var$editorContentStyles.layoutColumnMartinTopFixesOld,
            $c893e88acf4c2038$var$editorContentStyles.smartLinksInLivePagesStyles,
            $c893e88acf4c2038$var$editorContentStyles.linkingVisualRefreshV1Styles,
            $c893e88acf4c2038$var$editorContentStyles.dateVanillaStyles,
            (0, $dh538.fg)('platform_editor_typography_ugc') ? contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? $c893e88acf4c2038$var$editorContentStyles.paragraphStylesWithScaledMargin : $c893e88acf4c2038$var$editorContentStyles.paragraphStylesUGCRefreshed : contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? $c893e88acf4c2038$var$editorContentStyles.paragraphStylesOldWithScaledMargin : $c893e88acf4c2038$var$editorContentStyles.paragraphStylesOld,
            $c893e88acf4c2038$var$editorContentStyles.linkStyles,
            browser.safari && $c893e88acf4c2038$var$editorContentStyles.listsStylesSafariFix,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $c893e88acf4c2038$var$editorContentStyles.pragmaticResizerStylesSyncedBlock,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && "",
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? $c893e88acf4c2038$var$editorContentStyles.pragmaticResizerStylesCodeBlockSyncedBlockPatch : $c893e88acf4c2038$var$editorContentStyles.pragmaticResizerStylesCodeBlockLegacy,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.pragmaticStylesLayoutFirstNodeResizeHandleFix,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.pragmaticResizerStylesForTooltip,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && ((0, $iu6m9.editorExperiment)('advanced_layouts', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) && $c893e88acf4c2038$var$editorContentStyles.pragmaticResizerStylesWithReducedEditorGutter,
            $c893e88acf4c2038$var$editorContentStyles.aiPanelBaseStyles,
            $c893e88acf4c2038$var$isFirefox && $c893e88acf4c2038$var$editorContentStyles.aiPanelBaseFirefoxStyles,
            colorMode === 'dark' && $c893e88acf4c2038$var$editorContentStyles.aiPanelDarkStyles,
            colorMode === 'dark' && $c893e88acf4c2038$var$isFirefox && $c893e88acf4c2038$var$editorContentStyles.aiPanelDarkFirefoxStyles,
            viewMode === 'view' && $c893e88acf4c2038$var$editorContentStyles.layoutStylesForView,
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && $c893e88acf4c2038$var$editorContentStyles.layoutSelectedStylesForViewAdvanced,
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', false) && $c893e88acf4c2038$var$editorContentStyles.layoutSelectedStylesForViewNotAdvanced,
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && $c893e88acf4c2038$var$editorContentStyles.layoutResponsiveStylesForView,
            isComment && $c893e88acf4c2038$var$editorContentStyles.commentEditorStyles,
            isComment && $c893e88acf4c2038$var$editorContentStyles.tableCommentEditorStyles,
            isFullPage && $c893e88acf4c2038$var$editorContentStyles.fullPageEditorStyles,
            isFullPage && $c893e88acf4c2038$var$editorContentStyles.scrollbarStyles,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $c893e88acf4c2038$var$editorContentStyles.firstCodeBlockWithNoMargin : $c893e88acf4c2038$var$editorContentStyles.firstCodeBlockWithNoMarginOld,
            $c893e88acf4c2038$var$editorContentStyles.firstBlockNodeStyles,
            $c893e88acf4c2038$var$editorContentStyles.mentionNodeStyles,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.mentionsSelectionStylesWithSearchMatch : $c893e88acf4c2038$var$editorContentStyles.mentionsSelectionStyles,
            (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.scaledEmojiStyles : $c893e88acf4c2038$var$editorContentStyles.emojiStyles,
            contentMode === 'compact' && isDense && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.scaledEmojiDenseStyles,
            contentMode === 'compact' && isDense && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && !(0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.emojiDenseStyles,
            $c893e88acf4c2038$var$editorContentStyles.panelViewStyles,
            $c893e88acf4c2038$var$editorContentStyles.mediaGroupStyles,
            $c893e88acf4c2038$var$editorContentStyles.mediaAlignmentStyles,
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? $c893e88acf4c2038$var$editorContentStyles.tableLayoutFixesWithFontSize : $c893e88acf4c2038$var$editorContentStyles.tableLayoutFixes,
            $c893e88acf4c2038$var$editorContentStyles.tableContainerStyles,
            $c893e88acf4c2038$var$editorContentStyles.tableSharedStyle,
            (browser.gecko || browser.ie || browser.mac && browser.chrome) && $c893e88acf4c2038$var$editorContentStyles.tableSharedStyleBackgroundClipFix,
            $c893e88acf4c2038$var$editorContentStyles.tableEmptyRowStyles,
            (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && $c893e88acf4c2038$var$editorContentStyles.tableContentModeStyles,
            $c893e88acf4c2038$var$editorContentStyles.hyperLinkFloatingToolbarStyles,
            $c893e88acf4c2038$var$editorContentStyles.selectionToolbarAnimationStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.blockquoteDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.textDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.listDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.dangerDateStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.emojiDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.mentionDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.decisionDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.statusDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.dangerRuleStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.mediaDangerStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $c893e88acf4c2038$var$editorContentStyles.nestedPanelDangerStyles,
            className
        ]),
        ref: ref,
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, (0, $b1ab53ae0aa17ace$export$fa2ee2d78c59d944)), children);
});


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");

var $6dGgK = parcelRequire("6dGgK");





var $gnMzP = parcelRequire("gnMzP");

var $1zav4 = parcelRequire("1zav4");






















/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $30cdf9ef77478b9f$var$rotationAnimation = (0, $9K4OG.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg'
    },
    '100%': {
        '--panel-gradient-angle': '360deg'
    }
});
const $30cdf9ef77478b9f$var$rotationAnimationFirefox = (0, $9K4OG.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        backgroundPosition: '100%'
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        backgroundPosition: '-100%'
    }
});
const $30cdf9ef77478b9f$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $30cdf9ef77478b9f$var$aiPrismColorStep1Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.1']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep2Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.2']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep3Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.3']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep4Light = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.4']['light'];
const $30cdf9ef77478b9f$var$aiPrismColorStep1Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.1']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep2Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.2']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep3Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.3']['dark'];
const $30cdf9ef77478b9f$var$aiPrismColorStep4Dark = $30cdf9ef77478b9f$var$aiPrismColor['prism.border.step.4']['dark'];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 12%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 24%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Light} 48%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 64%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 80%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Light} 20%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Light} 50%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Light} 56%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 12%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 24%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Dark} 48%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 64%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 80%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $30cdf9ef77478b9f$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 0%, ${$30cdf9ef77478b9f$var$aiPrismColorStep2Dark} 20%, ${$30cdf9ef77478b9f$var$aiPrismColorStep3Dark} 50%, ${$30cdf9ef77478b9f$var$aiPrismColorStep4Dark} 56%, ${$30cdf9ef77478b9f$var$aiPrismColorStep1Dark} 100%)`;
const $30cdf9ef77478b9f$export$7d2a5652980d3808 = /*#__PURE__*/ (0, $9K4OG.css)({
    '@property --panel-gradient-angle': {
        syntax: '<angle>',
        initialValue: '270deg',
        inherits: false
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        /* This hides the label for the extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-label': {
            display: 'none'
        },
        /* This styles the ai panel correctly when its just sitting on the page and there
    is no user interaction */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            position: 'relative',
            boxShadow: 'none',
            overflow: 'unset',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
            // prismBorderBaseStyles
            '&::before, &::after': {
                content: "''",
                position: 'absolute',
                zIndex: -1,
                width: `calc(100% + 2px)`,
                height: `calc(100% + 2px)`,
                top: `-1px`,
                left: `-1px`,
                borderRadius: `calc(${"var(--ds-radius-small, 3px)"} + 1px)`,
                transform: 'translate3d(0, 0, 0)',
                background: $30cdf9ef77478b9f$var$prismBorderBaseBackground
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.with-hover-border': {
                '&::before, &::after': {
                    //prismBorderHoverStyles
                    background: "var(--ds-border-input, #8C8F97)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .with-margin-styles': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
                borderRadius: "var(--ds-radius-small, 3px)"
            }
        }
    },
    /* This styles the ai panel correctly when its streaming */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                // prismBorderAnimationStyles
                animationName: $30cdf9ef77478b9f$var$rotationAnimation,
                animationDuration: '2s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
                '@media (prefers-reduced-motion)': {
                    animation: 'none'
                }
            }
        }
    },
    /* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"].danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    },
    /* This removes the margin from the action list when inside an ai panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensiontype="com.atlassian.ai-blocks"][extensionkey="ai-action-items-block:aiActionItemsBodiedExtension"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-node-type="actionList"]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $30cdf9ef77478b9f$export$541b06daf7fd8fce = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        '&::before, &::after': {
            background: $30cdf9ef77478b9f$var$prismBorderBaseBackgroundFirefox,
            backgroundSize: '200%'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                animationName: $30cdf9ef77478b9f$var$rotationAnimationFirefox,
                animationDirection: 'normal',
                animationDuration: '1s'
            }
        }
    }
});
const $30cdf9ef77478b9f$export$9a2d17c0df63f635 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $30cdf9ef77478b9f$var$prismBorderDarkBackground
            }
        }
    }
});
const $30cdf9ef77478b9f$export$18b242302a502e32 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $30cdf9ef77478b9f$var$prismBorderDarkBackgroundFirefox,
                backgroundSize: '200%'
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $6ESsx = parcelRequire("6ESsx");

const $e744a1f22573fa53$export$65cde0a0b7e7c1c1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}, .${(0, $6ESsx.AnnotationSharedClassNames).focus}, .${(0, $6ESsx.AnnotationSharedClassNames).draft}, .${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ function $680457c62c4e856c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $680457c62c4e856c$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $680457c62c4e856c$export$e4cca17cf56e99d = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $0c8159821f1481e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidth = 1011;
// from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $0c8159821f1481e1$var$akEditorGutterPadding = 32;
const $0c8159821f1481e1$var$akEditorDefaultLayoutWidth = 760;
const $0c8159821f1481e1$var$akEditorFullWidthLayoutWidth = 1800;
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $0c8159821f1481e1$var$akEditorBreakpointForSmallDevice = `1266px`;
const $0c8159821f1481e1$var$akEditorGutterPaddingReduced = 24;
const $0c8159821f1481e1$var$akEditorFullPageNarrowBreakout = 600;
const $0c8159821f1481e1$var$akEditorUltraWideLayoutWidth = 4000;
const $0c8159821f1481e1$export$6a08aa478781aaec = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--default-gutter-padding': `${$0c8159821f1481e1$var$akEditorGutterPadding}px`,
    '--ak-editor--default-layout-width': `${$0c8159821f1481e1$var$akEditorDefaultLayoutWidth}px`,
    '--ak-editor--resizer-handle-spacing': `12px`,
    '--ak-editor--full-width-layout-width': `${$0c8159821f1481e1$var$akEditorFullWidthLayoutWidth}px`,
    /* calculate editor line length, 100cqw is the editor container width */ '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--default-layout-width))',
    '--ak-editor--max-width-layout-width': `${$0c8159821f1481e1$var$akEditorUltraWideLayoutWidth}px`,
    '--ak-editor--breakout-wide-layout-width': `${$0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidthSmallViewport}px`,
    '--ak-editor--breakout-full-page-guttering-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding))',
    '--ak-editor--breakout-fallback-width': 'calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))',
    '--ak-editor--breakout-min-width': '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--full-width-layout-width))',
        /* in full width appearances it's not possible to rely on cqw because it doesn't account for the page scrollbar, which depends on users system settings */ '--ak-editor--breakout-fallback-width': '100%',
        '--ak-editor--breakout-min-width': '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        '--ak-editor-max-container-width': 'calc(100cqw - var(--ak-editor--large-gutter-padding))',
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-editor-base-font-size)'
    },
    /* We can't allow nodes that are inside other nodes to bleed from the parent container */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block]': {
        '--ak-editor-max-container-width': '100%'
    },
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (width >= ${$0c8159821f1481e1$var$akEditorBreakpointForSmallDevice})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            '--ak-editor--breakout-wide-layout-width': `${$0c8159821f1481e1$var$akEditorCalculatedWideLayoutWidth}px`
        }
    }
});
const $0c8159821f1481e1$export$8ccf5563eb1fc2f7 = {
    name: "1s8lswm",
    styles: ".fabric-editor--max-width-mode{--ak-editor--line-length:min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--max-width-layout-width));--ak-editor--breakout-fallback-width:100%;--ak-editor--breakout-min-width:0px;}"
};
const $0c8159821f1481e1$export$247cd720d09b9b61 = {
    name: "7glde6",
    styles: ".ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding)*2);}"
};
const $0c8159821f1481e1$export$9e26088fca9327a2 = {
    name: "ituy02",
    styles: "--ak-editor--large-gutter-padding:52px"
};
const $0c8159821f1481e1$export$cc6d483a79f2d275 = {
    name: "n99on3",
    styles: "--ak-editor--large-gutter-padding:72px"
};
const $0c8159821f1481e1$export$23029c6a73ca6b8c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${$0c8159821f1481e1$var$akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--large-gutter-padding': `${$0c8159821f1481e1$var$akEditorGutterPaddingReduced}px`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $7a303160bb76f51c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a303160bb76f51c$export$e561f1e4e17b129d = {
    name: "12yhdlz",
    styles: "*:not(.fabric-editor-block-mark) >, *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment):not(.fabric-editor-font-size), .fabric-editor-alignment:first-of-type:first-child, .fabric-editor-font-size:first-of-type:first-child, .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p, h1, h2, h3, h4, h5, h6, .heading-wrapper{&:first-child:not(style), style:first-child + *{margin-top:0;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $375f45f3b6bd3ab6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $375f45f3b6bd3ab6$export$610a2509037eaf6 = {
    name: "gpthf0",
    styles: ".ProseMirror{& blockquote{box-sizing:border-box;color:inherit;width:100%;display:inline-block;padding-top:0;padding-bottom:0;padding-left:var(--ds-space-200, 16px);border-left-width:var(--ds-border-width-selected, 2px);border-left-style:solid;border-left-color:var(--ds-border, #0B120E24);margin:0.75rem 0 0 0;margin-right:0;[dir=\"rtl\"] &{padding-left:0;padding-right:var(--ds-space-200, 16px);}&:first-child{margin-top:0;}&::before{content:'';}&::after{content:none;}& p{display:block;}& table, & table:last-child{display:inline-table;}> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child{display:block;}> .extensionView-content-wrap:last-child{display:block;}}.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;}> h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}}"
};
const $375f45f3b6bd3ab6$export$cf79be04c8e54f95 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror blockquote.danger': {
        backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
        borderLeftColor: `${"var(--ds-border-danger, #E2483D)"}`
    }
});
const $375f45f3b6bd3ab6$export$9be2adf7cb8aa3a1 = {
    name: "ihldpu",
    styles: ".ProseMirror blockquote.ak-editor-selected-node{background:var(--ds-background-accent-blue-subtler, #CFE1FD);border-left-color:var(--ds-border-selected, #1868DB);-webkit-user-select:text;&::selection, *::selection{background-color:transparent;}&::-moz-selection, *::-moz-selection{background-color:transparent;}}"
};
const $375f45f3b6bd3ab6$export$36460e974c9904b9 = {
    name: "jrdqfj",
    styles: ".ProseMirror{& h1{font:var(--editor-font-ugc-token-heading-h1);margin-bottom:0;margin-top:1.45833em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h2{font:var(--editor-font-ugc-token-heading-h2);margin-bottom:0;margin-top:1.4em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h3{font:var(--editor-font-ugc-token-heading-h3);margin-bottom:0;margin-top:1.31249em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h4{font:var(--editor-font-ugc-token-heading-h4);margin-top:1.25em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h5{font:var(--editor-font-ugc-token-heading-h5);margin-top:1.45833em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h6{font:var(--editor-font-ugc-token-heading-h6);margin-top:1.59091em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}}"
};
const $375f45f3b6bd3ab6$export$4a8301858e3f950 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h1': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(24em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(28 / 24)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h2': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(20em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(24 / 20)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.008em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h3': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(16em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(20 / 16)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.006em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h4': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(14em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 14)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.003em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h5': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(12em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 12)',
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h6': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(11em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 11)',
            color: "var(--ds-text-subtlest, #6B6E76)",
            fontWeight: "var(--ds-font-weight-bold, 653)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em',
            textTransform: 'none'
        }
    }
});
const $375f45f3b6bd3ab6$export$13d8dd04b9497c9a = {
    name: "18w6jtp",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror blockquote{padding-left:var(--ds-space-250, 20px);}.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote{padding-left:var(--ds-space-200, 16px);}"
};
// This class applies when the node is selected directly or is included in the selected range
const $375f45f3b6bd3ab6$var$isSelectedNode = `.${(0, $aFUXX.akEditorSelectedNodeClassName)}`;
const $375f45f3b6bd3ab6$var$isOuterMostSelectedNode = `${$375f45f3b6bd3ab6$var$isSelectedNode}:not(${$375f45f3b6bd3ab6$var$isSelectedNode} *)`;
const $375f45f3b6bd3ab6$var$isList = ':is(ul, ol, div[data-node-type="actionList"])';
const $375f45f3b6bd3ab6$var$isOuterMostList = `${$375f45f3b6bd3ab6$var$isList}:not(${$375f45f3b6bd3ab6$var$isList} *)`;
const $375f45f3b6bd3ab6$export$8a07948e3f1777 = /*#__PURE__*/ (0, $9K4OG.css)({
    // only apply selected styles to the outermost list to avoid nested selection styles for lists within lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isOuterMostList}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}`]: {
        background: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        WebkitUserSelect: 'text',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $375f45f3b6bd3ab6$export$adeff2341d3e8864 = /*#__PURE__*/ (0, $9K4OG.css)({
    // only apply danger styles to the outermost list to avoid nested danger styles for lists within lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isOuterMostList}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}.danger`]: {
        background: "var(--ds-background-danger, #FFECEB)"
    }
});
const $375f45f3b6bd3ab6$var$isText = `:is(p, h1, h2, h3, h4, h5, h6)`;
const $375f45f3b6bd3ab6$var$isRootText = `${$375f45f3b6bd3ab6$var$isText}:not(${$375f45f3b6bd3ab6$var$isList} ${$375f45f3b6bd3ab6$var$isText})`;
const $375f45f3b6bd3ab6$export$3683cb70e936c4c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isRootText}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}`]: {
        background: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        WebkitUserSelect: 'text',
        boxShadow: `0 -4px 0 ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}, 0 4px 0 ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $375f45f3b6bd3ab6$export$162efa362a1cdef5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror ${$375f45f3b6bd3ab6$var$isRootText}${$375f45f3b6bd3ab6$var$isOuterMostSelectedNode}.danger`]: {
        background: "var(--ds-background-danger, #FFECEB)",
        boxShadow: `0 -4px 0 ${"var(--ds-background-danger, #FFECEB)"}, 0 4px 0 ${"var(--ds-background-danger, #FFECEB)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $e93d54020f263515$export$cd7bee32f3fef345 = /*#__PURE__*/ (0, $9K4OG.css)({
    backgroundImage: `
		linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		)
	`
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $65bb5c5a687b3665$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65bb5c5a687b3665$export$a716852a0c5e54d5 = {
    name: "1fqpa4w",
    styles: "&::selection,*::selection{background-color:transparent;}&::-moz-selection,*::-moz-selection{background-color:transparent;}"
};
const $65bb5c5a687b3665$export$48dd9ca0c16e4625 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    border: `1px solid ${"var(--ds-border-selected, #1868DB)"}`,
    // Fixes ED-15246: Trello card is visible through a border of a table border
    '&::after': {
        height: '100%',
        content: "'\\00a0'",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        background: "var(--ds-border-selected, #1868DB)",
        position: 'absolute',
        right: -1,
        top: 0,
        bottom: 0,
        width: 1,
        border: 'none',
        display: 'inline-block'
    }
});
const $65bb5c5a687b3665$export$a8e8bf15b18b52a0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    borderColor: 'transparent'
});
const $65bb5c5a687b3665$export$b2937e5c446645ec = {
    name: "16c0srz",
    styles: "background-color:var(--ds-background-selected, #E9F2FE)"
};
const $65bb5c5a687b3665$export$e7c1f2908e268236 = {
    name: "na0ofp",
    styles: "position:relative;-webkit-user-select:text;&::before{position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;z-index:12;background-color:var(--ds-blanket-selected, #388BFF14);}"
};
const $65bb5c5a687b3665$export$b8cc3f8fc9e3d56a = {
    name: "105gl83",
    styles: ".ProseMirror-hideselection{*::selection{background:transparent;}*::-moz-selection{background:transparent;}}"
};
const $65bb5c5a687b3665$export$cc1dcabcf4a29354 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
const $65bb5c5a687b3665$export$a3d8f4cb8a14da43 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode:empty': {
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $65bb5c5a687b3665$export$57f48b634c3a2512 = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
});
const $65bb5c5a687b3665$export$fd4ac125b4ba4c28 = {
    name: "74cays",
    styles: "background-color:var(--ds-background-danger, #FFECEB)"
};


function $1e5fdc47935572b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e5fdc47935572b3$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $1e5fdc47935572b3$var$fontSize14px = `${0.875}rem`;
const $1e5fdc47935572b3$var$blockNodesVerticalMargin = '0.75rem';
const $1e5fdc47935572b3$var$gutterDangerOverlay = {
    name: "110x2n0",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, #EF5C4814);}"
};
const $1e5fdc47935572b3$export$4baaed2b257b830 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            marginRight: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                display: 'block',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            display: 'flex',
            flex: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                flexGrow: 1,
                whiteSpace: 'pre'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            borderRadius: "var(--ds-radius-small, 3px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${$1e5fdc47935572b3$var$blockNodesVerticalMargin} 0 0 0`,
            fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: 48,
            cursor: 'pointer',
            clear: 'both',
            // This is necessary to allow for arrow key navigation in/out of code blocks in Firefox.
            whiteSpace: 'normal',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                content: 'attr(data-label)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_START}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                top: 0,
                left: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_END}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                bottom: 0,
                right: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $e93d54020f263515$export$cd7bee32f3fef345),
                {
                    position: 'relative',
                    backgroundColor: "var(--ds-background-neutral, #0515240F)",
                    display: 'flex',
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: '100%',
                    counterReset: 'line',
                    overflowX: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
                    backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%`,
                    backgroundPosition: `0 0,
	                             0 0,
                               100% 0,
                               100% 0,
                               100% 0,
                               100% 0,
	                             0 0,
	                             0 0`,
                    // Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers.
                    overflowY: 'hidden'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                backgroundColor: "var(--ds-background-neutral, #0515240F)",
                position: 'relative',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                padding: "var(--ds-space-100, 8px)",
                flexShrink: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                boxSizing: 'content-box'
            },
            // This is a fix of marker of list item with code block.
            // The list item marker in Chrome is aligned by the baseline of the text,
            // that's why we need to add a text (content: "1") to the line number gutter to align
            // the list item marker with the text.
            // Without it, the list item marker will be aligned by the bottom of the code block. */
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
                content: "'1'",
                visibility: 'hidden',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    tabSize: 4,
                    cursor: 'text',
                    color: "var(--ds-text, #292A2E)",
                    borderRadius: "var(--ds-radius-small, 3px)",
                    margin: "var(--ds-space-100, 8px)",
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: $1e5fdc47935572b3$var$fontSize14px,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5rem'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
                pointerEvents: 'none',
                userSelect: 'none',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                left: 0,
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $1e5fdc47935572b3$var$fontSize14px,
                padding: `0px ${"var(--ds-space-100, 8px)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem',
                textAlign: 'right',
                color: "var(--ds-text-subtlest, #6B6E76)",
                boxSizing: 'content-box'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        li: {
            // if same list item has multiple code blocks we need top margin for all but first
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${$1e5fdc47935572b3$var$blockNodesVerticalMargin} 0 0 0`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .code-block:first-child, > .ProseMirror-gapcursor:first-child + .code-block': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> div:last-of-type.code-block, > pre:last-of-type.code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginBottom: $1e5fdc47935572b3$var$blockNodesVerticalMargin
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.code-block.ak-editor-selected-node:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // Danger when top level node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger.code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $1e5fdc47935572b3$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        },
        // Danger when nested node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $1e5fdc47935572b3$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});
const $1e5fdc47935572b3$export$921fec04d268c00a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                display: 'flow',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5em'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$1e5fdc47935572b3$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: '0.875em',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5em'
                }
            }
        }
    }
});
const $1e5fdc47935572b3$export$ddc3dd3ba723d1af = {
    name: "1pwqusk",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child, > .ProseMirror-widget:first-child + .code-block, > .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block{margin:0!important;}}}"
};
const $1e5fdc47935572b3$export$50458a606d5c37d0 = {
    name: "1jcwwg4",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child{margin:0!important;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $9fb7690d6af70e31$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9fb7690d6af70e31$export$2029176b06e1b241 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        borderRadius: "var(--ds-radius-small, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #292A2E)",
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $9fb7690d6af70e31$export$a1c093cc2c35593e = {
    name: "1o0vvbu",
    styles: ".code{overflow:unset;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $8ba9ce11757ecee6$var$CommentEditorMargin = 14;
const $8ba9ce11757ecee6$var$GRID_GUTTER = 12;
const $8ba9ce11757ecee6$export$d6e7bceefcc20e27 = /*#__PURE__*/ (0, $9K4OG.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$8ba9ce11757ecee6$var$CommentEditorMargin - $8ba9ce11757ecee6$var$GRID_GUTTER}px)`
    },
    padding: "var(--ds-space-250, 20px)"
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $034503d6cd31c145$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $034503d6cd31c145$export$f21d9f928c6ae322 = {
    name: "l350f4",
    styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}.ProseMirror:has(.ProseMirror-hide-cursor){caret-color:transparent;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



const $332bd83257b23222$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $332bd83257b23222$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-text, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span:hover`]: {
        backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red`]: {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red:hover`]: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $332bd83257b23222$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $332bd83257b23222$export$f9f3f08b750aaa7d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node.danger .${$332bd83257b23222$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
    ]
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $8c084c7e0576e8c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c084c7e0576e8c1$export$87e0522332cd3719 = {
    name: "u5gvmr",
    styles: "--editor-font-ugc-token-heading-h1:normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$95588e746468319e = {
    name: "14r7dlz",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$63adc0ebe3278d31 = {
    name: "1maftdw",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $8c084c7e0576e8c1$export$3bdf5e0c4fe1eac4 = {
    name: "tk4rtd",
    styles: "--editor-font-ugc-token-body-small:normal 400 0.875em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $92bd659d1ad36350$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92bd659d1ad36350$export$5a1f57c6600b90f1 = {
    name: "1tw1dm8",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;position:relative;z-index:2;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");





function $64073fed169900b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64073fed169900b9$var$emojiSelectionStyles = {
    name: "1h3rhjl",
    styles: "border-radius:var(--ds-radius-xsmall, 2px)"
};
const $64073fed169900b9$export$d73b97ac20f33f4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $64073fed169900b9$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    }
});
const $64073fed169900b9$export$3db84a979dc69b56 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        minHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        minWidth: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxWidth: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $64073fed169900b9$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH1)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH2)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH2)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH3)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH3)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.scaledEmojiHeightH4)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.scaledEmojiHeightH4)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.ProseMirror :is(h5, h6, p) .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        width: `${(0, $fhsiz.defaultEmojiHeight)}px`
    }
});
var $64073fed169900b9$var$_ref2 = {
    name: "0",
    styles: ""
};
const $64073fed169900b9$export$1cdf865bc84cef4 = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $64073fed169900b9$var$_ref2;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            minHeight: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: (0, $fhsiz.defaultDenseEmojiHeight),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            maxWidth: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'contain'
            }
        },
        // Scale panel icon in dense mode
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror .ak-editor-panel .ak-editor-panel__icon': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: "var(--ds-space-250, 20px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: "var(--ds-space-250, 20px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH1)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH2)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH2)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH3)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH3)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH4)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH4)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h1 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH1)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h2 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH2)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH2)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h3 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH3)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH3)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror h4 .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.denseEmojiHeightH4)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.denseEmojiHeightH4)}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-selectors
        [`.ProseMirror :is(h5, h6, p) .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            width: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`
        }
    });
};
/**
 * Gets dynamic emoji styles that scale emoji size based on the base font size.
 * This allows emojis to scale proportionally when the base font size changes.
 * @param baseFontSize - The base font size in pixels (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with emoji size overrides if baseFontSize is provided and different from default.
 */ var $64073fed169900b9$var$_ref = {
    name: "0",
    styles: ""
};
const $64073fed169900b9$export$2a2707475ad11d76 = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $64073fed169900b9$var$_ref;
    // Calculate emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    const emojiSize = (0, $fhsiz.defaultEmojiHeight) * baseFontSize / (0, $aFUXX.akEditorFullPageDefaultFontSize);
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.ProseMirror :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE})`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: emojiSize,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'contain'
            }
        },
        // Scale panel icon in dense mode
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror .ak-editor-panel .ak-editor-panel__icon': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: "var(--ds-space-250, 20px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            width: "var(--ds-space-250, 20px)"
        }
    });
};
const $64073fed169900b9$export$df03c70a9b9671c1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512),
                (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28)
            ]
        ]
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $35750f0b594d4ce9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $35750f0b594d4ce9$export$ed25ef5a9db895f7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon > div': {
        display: 'flex'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand': {
        // sharedExpandStyles.containerStyles({ expanded: false, focused: false })(),
        borderWidth: "var(--ds-border-width, 1px)",
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderRadius: "var(--ds-radius-small, 4px)",
        minHeight: '25px',
        background: "var(--ds-background-neutral-subtle, #00000000)",
        margin: `${"var(--ds-space-050, 4px)"} 0 0`,
        transition: 'background 0.3s cubic-bezier(0.15, 1, 0.3, 1), border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > :not(style):first-child, td > style:first-child + *': {
            marginTop: 0
        },
        cursor: 'pointer',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > &': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(90deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.ak-editor-selected-node:not(.danger)': {
            // SelectionStyle.Blanket
            position: 'relative',
            // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
            // in Safari. Looks like it's caused by user-select: all in the emoji element
            WebkitUserSelect: 'text',
            '&::before': {
                position: 'absolute',
                content: "''",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: '100%',
                pointerEvents: 'none',
                zIndex: 12,
                // akEditorStickyheaderZIndex (11) + 1
                backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
            },
            // SelectionStyle.Border (common case)
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
            // If fg('platform_editor_nested_dnd_styles_changes') is true,
            // then we'll also need the rest of the selection styles for blanket
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            background: "var(--ds-background-danger, #FFECEB)",
            borderColor: "var(--ds-border-danger, #E2483D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__content': {
        // sharedExpandStyles.contentStyles({ expanded: false, focused: false })(),
        paddingTop: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-050, 4px)",
        display: 'flow-root',
        /* The follow rules inside @supports block are added as a part of ED-8893
    	The fix is targeting mobile bridge on iOS 12 or below,
    	We should consider remove this fix when we no longer support iOS 12 */ '@supports not (display: flow-root)': {
            width: '100%',
            boxSizing: 'border-box'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.expand-content-wrapper, .nestedExpand-content-wrapper': {
            /* We visually hide the content here to preserve the content during copy+paste */ /* Do not add text nowrap here because inline comment navigation depends on the location of the text */ width: '100%',
            display: 'block',
            height: 0,
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            userSelect: 'none'
        },
        cursor: 'text',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-expand__content--collapsed': {
            display: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
        // sharedExpandStyles.titleInputStyles(),
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #6B6E76)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #6B6E76)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-container': {
        // sharedExpandStyles.titleContainerStyles(),
        padding: 0,
        display: 'flex',
        // Omitting alignItems: 'flex-start' as it would be overridden
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        width: '100%',
        color: "var(--ds-text-subtle, #505258)",
        // Omitting overflow: 'hidden' as it would be overridden
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus': {
            outline: 0
        },
        alignItems: 'center',
        overflow: 'visible'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon-button': {
        appearance: 'none',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        border: 'none',
        borderRadius: "var(--ds-radius-small, 4px)",
        background: "var(--ds-background-neutral-subtle, #00000000)",
        padding: 0,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:disabled': {
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
            outlineOffset: "var(--ds-space-025, 2px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:hover:not(:disabled)': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(0deg)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)};`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__expanded': {
        background: "var(--ds-background-neutral-subtle, #00000000)",
        borderColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            paddingTop: "var(--ds-space-100, 8px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-button': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-expand__icon-svg': {
                transform: 'rotate(90deg)'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__input-container': {
        width: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-expand:not(.ak-editor-expand__expanded)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            position: 'absolute',
            height: '1px',
            width: '1px',
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            whiteSpace: 'nowrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #505258)",
            transform: 'rotate(0deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.ak-editor-selected-node):not(.danger)': {
            background: 'transparent',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: "var(--ds-border, #0B120E24)",
                background: "var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    }
});
const $35750f0b594d4ce9$export$4bb28258452e3b9a = {
    name: "1tkdo8v",
    styles: ".ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:var(--ds-space-negative-150, -12px);margin-right:var(--ds-space-negative-150, -12px);}"
};
/**
 * This function gets the dynamic styles that scale the expand title font size based on the base font size.
 * If the base font size is not the default font size, we want the expand title font size to match the base font size.
 * @param baseFontSize - The base font size in pixels. (e.g., 16 for default, 13 for dense mode)
 * @returns SerializedStyles with expand title font size override if baseFontSize is provided and different from default.
 */ var $35750f0b594d4ce9$var$_ref = {
    name: "0",
    styles: ""
};
const $35750f0b594d4ce9$export$9f08fc5d3959d07e = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $35750f0b594d4ce9$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-container': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize: `${baseFontSize}px`
        }
    });
};
const $35750f0b594d4ce9$export$20843fd014d7530c = {
    name: "1j6g9xo",
    styles: ".ak-editor-expand__title-input{line-height:1;font-family:var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}"
};
const $35750f0b594d4ce9$export$26d7f96b2bb98b5b = {
    name: "1nxi2gf",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:var(--ds-space-negative-250, -20px);margin-right:var(--ds-space-negative-250, -20px);}.ak-editor-expand__expanded{.ak-editor-expand__content{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}> div.ak-editor-expand[data-node-type=\"nestedExpand\"]{margin-top:var(--ds-space-050, 4px);}}}"
};
const $35750f0b594d4ce9$export$bdee15c929dd4423 = {
    name: "vfk8pi",
    styles: ".ProseMirror > .ak-editor-expand{margin-left:0;margin-right:0;}"
};
const $35750f0b594d4ce9$export$4dd1b2c2505a38a = {
    name: "yqkk6p",
    styles: ".ak-editor-expand{&.ak-editor-selected-node:not(.danger){&::after{height:100%;content:'\\00a0';background:var(--ds-border-selected, #1868DB);position:absolute;right:-1px;top:0;bottom:0;width:1px;border:none;display:inline-block;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 












function $91793a38cb990edb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Creates the extension styles with the ability to use feature flags and experiments.
 * @returns Complete SerializedStyles including base styles and any feature-gated styles
 */ var $91793a38cb990edb$var$_ref = {
    name: "0",
    styles: ""
};
var $91793a38cb990edb$var$_ref2 = {
    name: "0",
    styles: ""
};
var $91793a38cb990edb$var$_ref3 = {
    name: "pwxs72",
    styles: ".extension-container [data-macro-name=\"toc\"] * :not(.status-lozenge-span *){font-size:var(--ak-editor-base-font-size);}.extension-container .ak-excerpt-include :not([data-inline-card-lozenge] *, code, .status-lozenge-span *, .code-block *){font-size:var(--ak-editor-base-font-size);}"
};
const $91793a38cb990edb$export$9abdb593a2600bc6 = (contentMode)=>{
    const baseExtensionStyles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.multiBodiedExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .multiBodiedExtension--container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.multiBodiedExtension--overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .multiBodiedExtension--container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.multiBodiedExtension--container': {
                width: '100%',
                maxWidth: '100%' // ensure width can't go over 100%
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.inlineExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .with-danger-overlay': {
                /* If the macro turned used to red before, not setting the background to be transparent will cause the
        danger state to have two layers of red which we don't want. */ backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            }
        },
        /* This is referenced in the toDOM of a bodied extension and is used to put
    label content into the bodied extension.
    We do this so that we don't serialise the label (which causes the label to be
    copied to the clipboard causing copy-paste issues). */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodied-extension-to-dom-label::after': {
            content: 'attr(data-bodied-extension-label)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap, .multiBodiedExtensionView-content-wrap, .bodiedExtensionView-content-wrap': {
            margin: `0.75rem 0`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-of-type': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:last-of-type': {
                marginBottom: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                '& > span > .extension-container': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
                ]
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .extension-container': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            },
            // ...extensionLabelStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                opacity: 1,
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                color: "var(--ds-text-selected, #1868DB)",
                opacity: 1,
                boxShadow: 'none'
            },
            /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > div > .extension-label > span': {
                display: 'inline'
            },
            /** Targets legacy content header in LCM extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger > span > .legacy-content-header': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& .status-lozenge-span > span': {
                    backgroundColor: `${"var(--ds-background-accent-red-subtle-hovered, #FD9891)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
                display: 'inline'
            },
            /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
                opacity: 1
            },
            /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
                opacity: 0
            },
            /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                color: "var(--ds-text-danger, #AE2E24)",
                boxShadow: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&.danger > span > .with-danger-overlay': {
                backgroundColor: 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.extension-overlay': {
                    // ...dangerOverlayStyles
                    opacity: 0.3,
                    backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.inline': {
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extensionView-content-wrap .extension-container': {
            overflow: 'hidden',
            /* Don't hide overflow for editors inside extensions. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.extension-editable-area)': {
                overflow: 'visible'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container': {
            width: '100%',
            maxWidth: '100%' // ensure width can't go over 100%
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "[data-mark-type='fragment']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                margin: '0.75rem 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > [data-mark-type='dataConsumer']": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    margin: '0.75rem 0'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginTop: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginTop: 0
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:nth-last-of-type(-n + 2):not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginBottom: 0
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "& > [data-mark-type='dataConsumer']": {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                        marginBottom: 0
                    }
                }
            }
        }
    });
    // Dense content mode extensions styling fix - addresses EDITOR-1992
    // When cleaning up the experiment, move this logic into the baseExtensionStyles above
    const fontSize = (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') ? (0, $aFUXX.relativeFontSizeToBase16)((0, $aFUXX.akEditorFullPageDenseFontSize)) : undefined;
    const denseExtensionStyles = contentMode === 'compact' && (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $91793a38cb990edb$var$_ref3 : contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) ? /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container a span': {
            fontSize: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            fontSize
        }
    }) : $91793a38cb990edb$var$_ref2;
    const bodiedExtensionLayoutShiftFixStyles = (0, $1oCLl.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.bodiedExtensionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.bodiedExtension-content-outer-wrapper': {
                margin: '23px -1px -1px -1px' // Reserve space for lozenge (24px) then subtract 1px to account for the border of the inner wrapper preventing layoutshift
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.bodiedExtension-content-inner-wrapper': {
                margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
                padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`,
                border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                borderRadius: "var(--ds-radius-small, 3px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.extension-container': {
                // Remove styling when Prosemirror moves content inside
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.bodiedExtension-content-outer-wrapper': {
                    margin: '0'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.bodiedExtension-content-inner-wrapper': {
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    borderRadius: 0
                }
            }
        }
    }) : $91793a38cb990edb$var$_ref;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    return /*#__PURE__*/ (0, $9K4OG.css)(baseExtensionStyles, denseExtensionStyles, bodiedExtensionLayoutShiftFixStyles);
};
const $91793a38cb990edb$export$c6823b394e119a7e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.show-diff-changed-decoration-node > span .extension-container`]: {
        boxShadow: `0 0 0 var(--diff-decoration-marker-ring-width, 1px) var(--diff-decoration-marker-color)`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $5MaNT = parcelRequire("5MaNT");

const $19957a194e4b6622$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match': {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `${"var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"}, inset 0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.selected-search-match': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});
const $19957a194e4b6622$export$a5471dc947aff188 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #292A2E)"} !important`
        }
    }
});
const $19957a194e4b6622$export$fae24dca059c5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER} .search-match-text.selected-search-match`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            // we need to use !important here as we need to override inline selection styles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            color: `${"var(--ds-text, #292A2E)"} !important`
        }
    }
});
const $19957a194e4b6622$export$2ad4be5f6c1e4bbf = /*#__PURE__*/ (0, $9K4OG.css)({
    // text - inactive match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #292A2E)"
    },
    // text - active match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"} !important`
    },
    // text - inactive match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // text - active match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    // block node - inactive match - light mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0px 0px 0px 5px ${"var(--ds-border-accent-magenta, #CD519D)"}
			`
        }
    },
    // block node - active match - light mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        }
    },
    // block node - inactive match - light mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0px 0px 0px 5px ${"var(--ds-border-accent-magenta, #CD519D)"}
			`
        }
    },
    // block node - active match - light mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        }
    },
    // block node - inactive match - dark mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // block node - active match - dark mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // block node - inactive match - dark mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // block node - active match - dark mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `
			0 0 0 1px ${"var(--ds-border-selected, #1868DB)"},
			0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}
			`
        }
    },
    // expand title - inactive match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text, #292A2E)"
        }
    },
    // expand title - active match - light mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"
    },
    // expand title - inactive match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // expand title - active match - dark mode
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});
const $19957a194e4b6622$export$c6bd0332f9f90d1b = /*#__PURE__*/ (0, $9K4OG.css)({
    // sync block (reference) - inactive match - light mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-sync-block': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    // sync block (reference) - active match - light mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-sync-block': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"
    },
    // sync block (reference) - inactive match - light mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-sync-block.ak-editor-selected-node': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-border-accent-magenta, #CD519D)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
		0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    // sync block (reference) - active match - light mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-sync-block.ak-editor-selected-node': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"
    },
    // sync block (reference) - inactive match - dark mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-sync-block': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)"
    },
    // sync block (reference) - active match - dark mode - without node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-sync-block': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    },
    // sync block (reference) - inactive match - dark mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-sync-block.ak-editor-selected-node': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #77325B)"},
		0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)"
    },
    // sync block (reference) - active match - dark mode - with node selection
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-sync-block.ak-editor-selected-node': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $DoNsZ = parcelRequire("DoNsZ");


var $iMS6j = parcelRequire("iMS6j");

var $cV5SN = parcelRequire("cV5SN");


const $563563a54a51d8c3$export$2d6e8a1d666d4a60 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $DoNsZ.PanelSharedCssClassName).prefix}, > .${(0, $1e5fdc47935572b3$export$42659c26f026f6ea).CODEBLOCK_CONTAINER}, > .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $iMS6j.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-child, > .ProseMirror-widget:first-child + hr': {
            marginTop: 0
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $b08ecd070af20ccb$export$f06cff4aa315bcf9 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'button.first-floating-toolbar-button:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $a227b436ae91f932$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a227b436ae91f932$export$5efd6032566fe395 = {
    name: "1qqozmq",
    styles: ".ProseMirror{.fabric-editor-font-size{&[data-font-size='small']{font:var(--editor-font-ugc-token-body-small);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--editor-font-ugc-token-body-small);}[data-prosemirror-node-name='blockTaskItem']:has(.fabric-editor-font-size[data-font-size='small']){font:var(--editor-font-ugc-token-body-small);.fabric-editor-font-size{font:inherit;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $8478647a8b452658$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8478647a8b452658$export$eb88bb4706d67f65 = {
    name: "1ro9jdo",
    styles: "flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $ba96bd4668ffc758$var$gapCursorBlink = (0, $9K4OG.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $ba96bd4668ffc758$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $ba96bd4668ffc758$var$gapCursorSelector = '.ProseMirror-gapcursor';
const $ba96bd4668ffc758$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $ba96bd4668ffc758$var$wrapLeft = '[layout="wrap-left"]';
const $ba96bd4668ffc758$var$wrapRight = '[layout="wrap-right"]';
const $ba96bd4668ffc758$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $ba96bd4668ffc758$var$twoImagesSideBySideFixSelector = `
  ${$ba96bd4668ffc758$var$gapCursorSelector}${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$gapCursorSelector}${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span ${$ba96bd4668ffc758$var$wrapRight},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft},
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector}`;
const $ba96bd4668ffc758$var$marginFixSelector = `
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$wrapRight} > div,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} > div`;
const $ba96bd4668ffc758$var$floatLeftFixSelector = `
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector},
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector}`;
const $ba96bd4668ffc758$var$afterPresudoSelector = `
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft}::after,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight}::after,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft}::after,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft}::after`;
const $ba96bd4668ffc758$var$marginDeepChildrenFixSelector = `
${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} + *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} + *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + * > *,
  ${$ba96bd4668ffc758$var$wrapLeft} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$wrapRight} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapLeft} + span + ${$ba96bd4668ffc758$var$wrapRight} + * > *,
  ${$ba96bd4668ffc758$var$gapCursorSelector} + ${$ba96bd4668ffc758$var$wrapRight} + span + ${$ba96bd4668ffc758$var$wrapLeft} + * > *,
  ${$ba96bd4668ffc758$var$prosemirrorwidgetNotBlock} + ${$ba96bd4668ffc758$var$gapCursorSelector} + *,
  ${$ba96bd4668ffc758$var$prosemirrorwidgetNotBlock} + ${$ba96bd4668ffc758$var$gapCursorSelector} + span + *`;
const $ba96bd4668ffc758$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$ba96bd4668ffc758$export$8adc5edbc4a22166}`]: {
            // Clean this up with platform_synced_block
            caretColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$ba96bd4668ffc758$var$gapCursorSelector]: {
            display: 'none',
            pointerEvents: 'none',
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span': {
                caretColor: 'transparent',
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: 'block'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span::after': {
                animation: `1s ${$ba96bd4668ffc758$var$gapCursorBlink} step-start infinite`,
                borderLeft: '1px solid',
                content: "''",
                display: 'block',
                position: 'absolute',
                top: 0,
                height: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-left span::after': {
                left: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-right span::after': {
                right: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span[layout="full-width"], & span[layout="wide"], & span[layout="fixed-width"]': {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginLeft: '50%',
                transform: 'translateX(-50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`&${$ba96bd4668ffc758$var$wrapRight}`]: {
                float: 'right'
            },
            /* fix vertical alignment of gap cursor */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$ba96bd4668ffc758$var$fixVerticalAlignmentSelector]: {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ProseMirror-focused ${$ba96bd4668ffc758$var$gapCursorSelector}`]: {
            display: 'block',
            borderColor: 'transparent'
        }
    },
    /* This hack below is for two images aligned side by side */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$twoImagesSideBySideFixSelector]: {
        clear: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$marginFixSelector]: {
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$floatLeftFixSelector]: {
        float: 'left'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$afterPresudoSelector]: {
        visibility: 'hidden',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        content: "' '",
        clear: 'both',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$ba96bd4668ffc758$var$marginDeepChildrenFixSelector]: {
        marginTop: 0
    }
});
const $ba96bd4668ffc758$export$bfbb8fb576027812 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&:has(${$ba96bd4668ffc758$var$gapCursorSelector})`]: {
            caretColor: 'transparent'
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $3b9a5370a72c9df5$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + 24px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        zIndex: 2
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $e776189f3c3af959$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e776189f3c3af959$export$fc74cf03693076b4 = {
    name: "86ymtv",
    styles: ".ProseMirror{.fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $3b65c10c9ad50286$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b65c10c9ad50286$export$3fc32cdc53f6edeb = {
    name: "n6ftfq",
    styles: ".ProseMirror{.inlineNodeView{display:inline;user-select:all;white-space:nowrap;& > *:not(.zeroWidthSpaceContainer){white-space:pre-wrap;}& > .assistive{user-select:none;}}&.ua-safari{.inlineNodeView{&::selection, *::selection{background:transparent;}}}&.ua-chrome .inlineNodeView > span{user-select:none;}.inlineNodeViewAddZeroWidthSpace{&::after{content:'\u200B';}}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



function $07d5bf3f0b10fce1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07d5bf3f0b10fce1$var$gridMediumMaxWidth = 1024;
const $07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
// Class names for the column resize divider widget — must stay in sync with main.ts in editor-plugin-layout
const $07d5bf3f0b10fce1$var$layoutColumnDividerClassName = 'layout-column-divider';
const $07d5bf3f0b10fce1$var$layoutColumnDividerRailClassName = 'layout-column-divider-rail';
const $07d5bf3f0b10fce1$var$layoutColumnDividerThumbClassName = 'layout-column-divider-thumb';
const $07d5bf3f0b10fce1$export$2e7c649d642e8659 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
        // Negative margin removes the applied 'gap' from the parent's flex box
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginInline: '-15px 0px',
        flexShrink: 0,
        boxSizing: 'content-box',
        cursor: 'col-resize',
        position: 'relative',
        zIndex: 2,
        alignSelf: 'stretch',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&:hover .${$07d5bf3f0b10fce1$var$layoutColumnDividerRailClassName}`]: {
            background: "var(--ds-background-selected, #E9F2FE)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&:hover .${$07d5bf3f0b10fce1$var$layoutColumnDividerThumbClassName}`]: {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // Rail and thumb styles intentionally mirror the breakout resize handle
    // (see .pm-breakout-resize-handle-rail and .pm-breakout-resize-handle-thumb in resizerStyles.ts).
    // If updating these styles, consider keeping both in sync.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerRailClassName}`]: {
        width: 7,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerThumbClassName}`]: {
        minWidth: 3,
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        pointerEvents: 'none',
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $07d5bf3f0b10fce1$export$ed4b77c142cd3096 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginInline: '0 -7px'
    }
});
const $07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor = '.fabric-editor--full-width-mode .ProseMirror > .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor = '.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror > .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor = '.ProseMirror .fabric-editor-breakout-mark .layoutSectionView-content-wrap';
const $07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector = `&.selected, &:hover, &.selected.danger, &.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`;
const $07d5bf3f0b10fce1$var$layoutSelectedSelector = `&.selected, [data-empty-layout='true'], &:hover, &.selected.danger [data-layout-section], &.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`;
const $07d5bf3f0b10fce1$export$8dd21c7c24132a82 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: '0 4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:first-of-type': {
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:last-of-type': {
            marginRight: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`> [data-layout-column].${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                // layout column selection shorter after layout border has been removed
                '::before': {
                    width: 'calc(100% - 8px)',
                    left: 4,
                    borderRadius: "var(--ds-radius-small, 3px)"
                }
            }
        ]
    }
});
const $07d5bf3f0b10fce1$export$67aba4052ecc5648 = {
    name: "svgls9",
    styles: ".ProseMirror [data-layout-section]{> [data-layout-column][style*=\"--column-width\"]{flex-basis:var(--column-resize-width, var(--column-width));flex:var(--column-resize-flex, 1);}}"
};
const $07d5bf3f0b10fce1$export$fe39d5414c0135d3 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-column] + [data-layout-column]': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: 8
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                marginLeft: 0
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$55890fd3e3be7f1b = {
    name: "4jflbi",
    styles: ".ProseMirror [data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $07d5bf3f0b10fce1$export$d9912ef7f698aab8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .layout-section-container [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .ProseMirror-widget': {
            flex: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'contents !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-blocks-drag-handle-container] div': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                display: 'contents !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-blocks-drop-target-container]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                display: 'block !important',
                margin: "var(--ds-space-negative-050, -4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-drop-target-for-element]': {
                    position: 'absolute'
                }
            },
            // Column resize divider: always in DOM, hidden via opacity by default
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                display: 'block !important',
                flex: 'none',
                opacity: 0,
                transition: 'opacity 0.2s'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: 0
        }
    },
    // On hover: fade in drag divider and hide the 1px separator
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror .layoutSectionView-content-wrap:hover .layout-section-container [data-layout-section]`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`> .ProseMirror-widget.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`> .ProseMirror-widget.${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName} ~ [data-layout-column] [data-layout-content]::before`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        }
    }
});
const $07d5bf3f0b10fce1$export$17d7fe9c8be65e97 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`& > .${$07d5bf3f0b10fce1$var$layoutColumnDividerClassName}`]: {
            flex: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${$07d5bf3f0b10fce1$var$gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $07d5bf3f0b10fce1$export$cdcbf2d4bffabda6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // Shows the border when cursor is inside a layout
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected [data-layout-column], &:hover [data-layout-column]': {
                border: `1px solid ${"var(--ds-border, #0B120E24)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-column]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                borderColor: "var(--ds-border-danger, #E2483D)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$48dd9ca0c16e4625),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                    {
                        '::after': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
// TODO: ED-28075 - inline rowSeparatorBaseStyles to unblock Compiled CSS migration
const $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
        content: "''",
        borderTop: `1px solid ${"var(--ds-border, #0B120E24)"}`,
        position: 'absolute',
        width: 'calc(100% - 32px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: -13,
        // clear styles for column separator
        borderLeft: 'unset',
        marginLeft: 'unset',
        height: 'unset'
    }
});
const $07d5bf3f0b10fce1$export$fe59793079ccb11a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$07d5bf3f0b10fce1$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    content: "''",
                    borderLeft: `1px solid ${"var(--ds-border, #0B120E24)"}`,
                    position: 'absolute',
                    height: 'calc(100% - 24px)',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                    marginLeft: -25
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:is([data-valign="middle"], [data-valign="bottom"]):not(:first-of-type) [data-layout-content]::before': {
                    top: "var(--ds-space-150, 12px)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                borderRadius: "var(--ds-radius-small, 4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                    {
                        border: 0,
                        '::before': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$1ce35d5e797e3173 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `inset 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `inset 0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$c1454bb6dd8837f5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:724px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:788px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:820px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$203a03d09c37c555 = /*#__PURE__*/ (0, $9K4OG.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$07d5bf3f0b10fce1$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$07d5bf3f0b10fce1$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$ce383b8d82e44bf5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            margin: `${"var(--ds-space-100, 8px)"} -12px 0`,
            transition: 'border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
            cursor: 'pointer',
            // Inner cursor located 26px from left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column]': {
                flex: 1,
                position: 'relative',
                minWidth: 0,
                /* disable 4 borders when in view mode and advanced layouts is on */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                borderRadius: "var(--ds-radius-small, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                padding: "var(--ds-space-150, 12px)",
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> div': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .embedCardView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .mediaSingleView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor.-right:first-child + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor.-right + .mediaSingleView-content-wrap .rich-media-item, > .ProseMirror-gapcursor.-right:first-of-type + .embedCardView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor + span + .mediaSingleView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down and shrinking layout's node selectable area (leniency margin)
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "> [data-node-type='decisionList']": {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                        'li:first-of-type [data-decision-wrapper]': {
                            marginTop: 0
                        }
                    }
                },
                // Make the 'content' fill the entire height of the layout column to allow click handler of layout section nodeview to target only data-layout-column
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-layout-content]': {
                    height: '100%',
                    cursor: 'text',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '.mediaGroupView-content-wrap': {
                        clear: 'both'
                    }
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '&[data-valign="middle"], &[data-valign="bottom"]': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '&[data-valign="middle"]': {
                    justifyContent: 'center'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '&[data-valign="bottom"]': {
                    justifyContent: 'flex-end'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '&[data-valign="middle"] > [data-layout-content], &[data-valign="bottom"] > [data-layout-content]': {
                    height: 'auto'
                }
            }
        }
    },
    // hide separator when element is dragging on top of a layout column
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode .ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-table-container': {
                margin: '0 2px'
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$4921bd0cd96a70c2 = {
    name: "1k5f3br",
    styles: ".ProseMirror{[data-layout-section]{[data-layout-column]{> div{.pm-table-container{width:100% !important;}}}}}"
};
const $07d5bf3f0b10fce1$export$74ce03ae8f7cbe1a = {
    name: "14on7sz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column]{border:0;}"
};
const $07d5bf3f0b10fce1$export$4d009f8d3cbd5535 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $07d5bf3f0b10fce1$export$b371e818feeb9ba8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // Apply -20px margin to all sections
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // Reset to default margin when inside bodied sync block
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-prosemirror-node-name="bodiedSyncBlock"] [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -12px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $07d5bf3f0b10fce1$export$20e6a345585c5c3c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
            [$07d5bf3f0b10fce1$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    borderLeft: 0
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `0 0 0 0 ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
            [`&.${$07d5bf3f0b10fce1$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 0 ${"var(--ds-border-selected, #1868DB)"}`
            }
        }
    }
});
const $07d5bf3f0b10fce1$export$70038a77af1ac7b5 = {
    name: "1nqe1o0",
    styles: ".ProseMirror{[data-layout-section], .layoutSectionView-content-wrap{&.selected [data-layout-column], &:hover [data-layout-column]{border:0;}}}"
};
const $07d5bf3f0b10fce1$export$ec8bdd18ecbadae7 = {
    name: "1xloaqb",
    styles: ".ProseMirror{[data-layout-section]{cursor:default;[data-layout-column]{border:0;}}}"
};
const $07d5bf3f0b10fce1$export$c60086c81c0ffabf = {
    name: "1gk7267",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}}"
};
const $07d5bf3f0b10fce1$export$598dd68f26eb7eff = {
    name: "uvfuhz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :not(style):first-child, > style:first-child + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + span + *{margin-top:0;}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $9be63d8bc680ee45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9be63d8bc680ee45$export$4ea5976125a01ffa = {
    name: "aj1leh",
    styles: ".ProseMirror a.blockLink{display:block;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $9be63d8bc680ee45$export$889b949305b162f9 = {
    name: "1cwtun1",
    styles: ".hyperlink-floating-toolbar{padding:0;}"
};
const $9be63d8bc680ee45$export$e696625219a66da6 = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $7ea00528076df401$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $7ea00528076df401$var$akEditorLineHeight = 1.714;
// copied from packages/editor/editor-common/src/styles/shared/smart-card.ts
const $7ea00528076df401$var$BLOCK_CARD_CONTAINER = 'blockCardView-content-wrap';
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $7ea00528076df401$var$blockNodesVerticalMargin = '0.75rem';
const $7ea00528076df401$export$5f95d55c83a3b7bc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* =============== INDENTATION SPACING ========= */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            boxSizing: 'border-box',
            paddingLeft: `var(--ed--list--item-counter--padding, 24px)`
        },
        // Firefox does not handle empty block element inside li tag.
        // If there is not block element inside li tag,	then firefox sets inherited height to li
        // However, if there is any block element and if it's empty	(or has empty inline element) then
        // firefox sets li tag height to zero.
        //
        // More details at
        // https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            'ul, ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                'li p:empty, li p > span:empty': {
                    display: 'inline-block'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-ol, .ak-ul': {
            // Ensures list item content adheres to the list's margin instead
            // of filling the entire block row. This is important to allow
            // clicking interactive elements which are floated next to a list.
            //
            // For some history and context on this block, see PRs related to tickets.:
            // @see ED-6551 - original issue.
            // @see ED-7015 - follow up issue.
            // @see ED-7447 - flow-root change.
            //
            // @see https://css-tricks.com/display-flow-root/
            //
            // For older browsers the do not support flow-root. */
            // stylelint-disable declaration-block-no-duplicate-properties */
            display: 'flow-root'
        },
        /* =============== INDENTATION AESTHETICS ========= */ // We support nested lists up to six levels deep.
        /*  ======== LEGACY LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ul ul ul ul': {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul, ul ul ul ul ul': {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul ul, ul ul ul ul ul ul': {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol, ol ol ol ol': {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol, ol ol ol ol ol': {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol ol, ol ol ol ol ol ol': {
            listStyleType: 'lower-roman'
        },
        /* ======== PREDICTABLE LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='1'], ol[data-indent-level='4']": {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='2'], ol[data-indent-level='5']": {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='3'], ol[data-indent-level='6']": {
            listStyleType: 'lower-roman'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='1'], ul[data-indent-level='4']": {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='2'], ul[data-indent-level='5']": {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='3'], ul[data-indent-level='6']": {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        li: {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > p:not(:first-child)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
            },
            /* In SSR the above rule will apply to all p tags because first-child would be a style tag.
      	The following rule resets the first p tag back to its original margin
      	defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > style:first-child + p': {
                marginTop: $7ea00528076df401$var$blockNodesVerticalMargin
            }
        }
    }
});
const $7ea00528076df401$export$b5b1b7a81c86d94e = {
    name: "2ngyxg",
    styles: "li[data-testid=\"show-diff-changed-decoration-node\"]::marker{color:var(--diff-decoration-marker-color);}"
};
const $7ea00528076df401$export$3861aadd8944b16f = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Root lists: 12px top margin (design system value), except first content child. Uses :not(:nth-child(1 of ...)) to exclude first content lists.
        // A more complex selector is used here to ensure this style is not applied to block quotes and panels, as they do not have a margin-top property already, and this will incorrectly add a margin-top to them.
        // This is unlike tables and expands, which do have a margin-top property already, and this style would not change their top margin, even without the :not(:nth-child(1 of ...)) selector.
        // This targeted approach reduces the blast radius of the fix. Instead of modifying numerous existing styles, we add this single selector until the issue with bundle.css & aui-reset.less is fixed.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'ul:not(li > ul):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))), ol:not(li > ol):not(:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)))': {
            marginTop: `var(--ds-space-150, 12px)`
        },
        // Nested lists: 4px top margin (design system value)
        // Applies to both OL and UL nested inside list items
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'li > ol, li > ul': {
            marginTop: `var(--ds-space-050, 4px)`
        }
    }
});
const $7ea00528076df401$export$dba87c9b43c1033d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li::before`]: {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        lineHeight: $7ea00528076df401$var$akEditorLineHeight
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > p:first-child, .ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > .code-block:first-child, .ProseMirror:not(.${$7ea00528076df401$var$BLOCK_CARD_CONTAINER}) > li > .ProseMirror-gapcursor:first-child + .code-block`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: `-${$7ea00528076df401$var$akEditorLineHeight}em !important`
    }
});
const $7ea00528076df401$export$b9f4317d28be80aa = `max(0px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * (4 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
var $7ea00528076df401$var$_ref = {
    name: "0",
    styles: ""
};
const $7ea00528076df401$export$dc36e8e603594c1d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $7ea00528076df401$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ '.ProseMirror': {
            // Adjacent list items
            'li + li': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $7ea00528076df401$export$b9f4317d28be80aa
            },
            // Nested lists directly under an li (unordered and ordered)
            'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $7ea00528076df401$export$b9f4317d28be80aa
            }
        }
    });
};
const $7ea00528076df401$export$66dd3b7a524cdd20 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Hide markers and remove spacing for wrapper list items (items containing only nested lists)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'li:has(> ul:only-child), li:has(> ol:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            listStyleType: 'none !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: '0 !important',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginBottom: '0 !important'
        },
        // Remove margin from nested lists inside wrapper list items to avoid double spacing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: '0 !important'
        },
        // Remove top margin from nested taskLists not preceded by a sibling taskItem.
        // The base rule (tasksAndDecisionsStyles) sets margin-top on all nested taskLists,
        // but with flexible indentation a taskList can be the first child with no taskItem above.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-task-list-local-id] > div[data-task-list-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: '0 !important'
        },
        // Restore margin when a nested taskList follows a taskItem
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-task-local-id] + div[data-task-list-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            marginTop: `${"var(--ds-space-050, 4px)"} !important`
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $fhm10 = parcelRequire("fhm10");


var $gAARK = parcelRequire("gAARK");


var $ag6aQ = parcelRequire("ag6aQ");







var $jTudT = parcelRequire("jTudT");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $fDGbV = parcelRequire("fDGbV");


var $ieXGd = parcelRequire("ieXGd");

var $b38UX = parcelRequire("b38UX");

/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $4bc6aca00a4d4c4d$var$getSelectedBorderStyle = (selected)=>`
    ${selected ? (0, $ieXGd.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      border-radius: ${"var(--ds-radius-small, 3px)"};
      ${selected ? (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $4bc6aca00a4d4c4d$export$70bc5d30fe886af = 'media-card-inline-player';
const $4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $9K4OG.css)("width:", (0, $fDGbV.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $fDGbV.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:var(--ds-radius-small, 3px);position:relative;max-width:100%;max-height:100%;", $4bc6aca00a4d4c4d$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';


var $8jrlU = parcelRequire("8jrlU");


function $8b8a9e34027bcb70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $8b8a9e34027bcb70$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $8b8a9e34027bcb70$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $8b8a9e34027bcb70$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $gnMzP.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $gnMzP.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $gnMzP.richMediaClassName}, & [layout='wide'] .${0, $gnMzP.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $8b8a9e34027bcb70$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $ag6aQ.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: "var(--ds-radius-medium, 6px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #4688EC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $aFUXX.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $4bc6aca00a4d4c4d$export$70bc5d30fe886af}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E06C00)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $4bc6aca00a4d4c4d$export$70bc5d30fe886af}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E06C00)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E06C00)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E06C00)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $aFUXX.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});
const $8b8a9e34027bcb70$export$c47a18e5da2466ef = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.mediaInlineView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [` .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            '>span> span[role="button"]': [
                (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.mediaGroupView-content-wrap.danger #newFileExperienceWrapper`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        [
            (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
        ]
    }
});
const $8b8a9e34027bcb70$export$cbc2f5b7ba4a5b45 = {
    name: "efqvbk",
    styles: ".mediaGroupView-content-wrap ul{padding:0;}"
};
const $8b8a9e34027bcb70$export$228abfa0106fa708 = {
    name: "1u86ffv",
    styles: ".fabric-editor-block-mark[class^=\"fabric-editor-align\"]{clear:none;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block, .extension-container, .multiBodiedExtension--container{max-width:100%;}}}"
};
const $8b8a9e34027bcb70$export$1cac2710e369d647 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.mediaSingleView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`span#${0, $gAARK.CAPTION_PLACEHOLDER_ID}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'var(--ak-editor-base-font-size)'
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $1d1e174580119dab$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};






function $d6f1b5d8b6185b26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* need to specify dark text colour because personal mentions
(in dark blue) have white text by default */ const $d6f1b5d8b6185b26$var$mentionsSelectedColor = {
    name: "5703k4",
    styles: "color:var(--ds-text-subtle, #505258)"
};
const $d6f1b5d8b6185b26$export$1445f2e2b3a1d9c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER}`]: {
        // TODO: ED-28075 - refactor selection styles to unblock Compiled CSS migration
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $aFUXX.akEditorSelectedNodeClassName} [data-mention-id] > span`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER}.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span > span > span': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $1d1e174580119dab$export$e5f60e08987c4e73).MENTION_CONTAINER} > span > span > span`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            color: "var(--ds-text-subtle, #505258)"
        }
    }
});
const $d6f1b5d8b6185b26$export$5fb9b21e3678e9ac = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: "var(--ds-radius-full, 9999px)",
        cursor: 'pointer',
        padding: '1px 0.3em 1px 0.23em',
        // To match `packages/elements/mention/src/components/Mention/PrimitiveMention.tsx` implementation
        // we match the line height exactly
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.714',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #0515240F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #505258)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
        color: "var(--ds-text, #292A2E)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #1868DB)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #1558BC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #144794)"
        }
    }
});
const $d6f1b5d8b6185b26$export$8697a9554aac2a5a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    }
});
const $d6f1b5d8b6185b26$export$13ab2f17ccaf48f6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            $d6f1b5d8b6185b26$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.search-match-block)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ]
    }
});
const $d6f1b5d8b6185b26$export$1091a37fb36d77e5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.search-match-block).danger`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            (0, $65bb5c5a687b3665$export$57f48b634c3a2512),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28)
        ]
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $9add2684ad964103$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9add2684ad964103$export$8290cf129669d0cb = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                }
            },
            // panelSharedStyles()
            // panelSharedStylesWithoutPrefix()
            borderRadius: "var(--ds-radius-small, 3px)",
            margin: `0.75rem 0 0`,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            minWidth: '48px',
            display: 'flex',
            position: 'relative',
            alignItems: 'normal',
            wordBreak: 'break-word',
            // mainDynamicStyles(PanelType.INFO)
            // > getPanelTypeBackground(PanelType.INFO)
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
            color: 'inherit',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                flexShrink: 0,
                height: "var(--ds-space-300, 24px)",
                width: "var(--ds-space-300, 24px)",
                boxSizing: 'content-box',
                paddingRight: "var(--ds-space-100, 8px)",
                textAlign: 'center',
                userSelect: 'none',
                MozUserSelect: 'none',
                WebkitUserSelect: 'none',
                msUserSelect: 'none',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginTop: '0.1em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> span': {
                    verticalAlign: 'middle',
                    display: 'inline-flex'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-sprite': {
                    verticalAlign: '-2px' // -(8*3-20)/2 [px]
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-image': {
                    verticalAlign: '-3px',
                    // panelEmojiSpriteVerticalAlignment - 1 [px]
                    /* Vertical align only works for inline-block elements in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '@-moz-document url-prefix()': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        img: {
                            display: 'inline-block'
                        }
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content': {
                margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
                flex: '1 0 0',
                /*
        	https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
        	The default value for min-width is auto, which is computed to zero.
        	When an element is a flex item, the value of min-width doesn’t compute to zero.
        	The minimum size of a flex item is equal to the size of its contents.
        */ minWidth: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                // mainDynamicStyles(PanelType.NOTE)
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="tip"]': {
                // mainDynamicStyles(PanelType.TIP)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                // mainDynamicStyles(PanelType.WARNING)
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                // mainDynamicStyles(PanelType.ERROR)
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                // mainDynamicStyles(PanelType.SUCCESS)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            cursor: 'text'
        },
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-panel.ak-editor-selected-node:not(.danger)': {
        // getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket]),
        // SelectionStyle.BoxShadow
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
        borderColor: 'transparent',
        // SelectionStyle.Blanket
        position: 'relative',
        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        WebkitUserSelect: 'text',
        '&::before': {
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            pointerEvents: 'none',
            zIndex: 12,
            // akEditorSmallZIndex
            backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
        },
        // hideNativeSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $9add2684ad964103$export$fb05379f8218158 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            // Support nested panel
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content .ak-editor-panel': {
                border: `1px solid ${"var(--ds-border, #0B120E24)"}`
            }
        }
    }
});
const $9add2684ad964103$export$1bea98aa89006044 = {
    name: "icrrk4",
    styles: ".ProseMirror{.ak-editor-panel{&.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}}.ak-editor-content-area.appearance-full-page .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-150, 12px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-left:var(--ds-space-250, 20px);padding-right:var(--ds-space-250, 20px);}}.ak-editor-content-area .ak-editor-content-area .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-100, 8px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}"
};
const $9add2684ad964103$export$59d3d90d4141195 = {
    name: "1rtu9jn",
    styles: ".ProseMirror{.ak-editor-panel{&[data-panel-type=\"info\"]{.ak-editor-panel__icon[data-panel-type=\"info\"]{color:var(--ds-icon-information, #357DE8);}}&[data-panel-type=\"note\"]{.ak-editor-panel__icon[data-panel-type=\"note\"]{color:var(--ds-icon-discovery, #AF59E1);}}&[data-panel-type=\"tip\"]{.ak-editor-panel__icon[data-panel-type=\"tip\"]{color:var(--ds-icon-success, #6A9A23);}}&[data-panel-type=\"warning\"]{.ak-editor-panel__icon[data-panel-type=\"warning\"]{color:var(--ds-icon-warning, #E06C00);}}&[data-panel-type=\"error\"]{.ak-editor-panel__icon[data-panel-type=\"error\"]{color:var(--ds-icon-danger, #C9372C);}}&[data-panel-type=\"success\"]{.ak-editor-panel__icon[data-panel-type=\"success\"]{color:var(--ds-icon-success, #6A9A23);}}}}"
};
const $9add2684ad964103$export$21dc022a1db4e807 = {
    name: "5hfp5c",
    styles: ".panelView-content-wrap{box-sizing:border-box;}"
};
const $9add2684ad964103$export$9addcfe7a096a01d = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="info"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="info"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="note"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="success"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="warning"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon[data-panel-type="error"]': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"}`
                }
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $b0ef43f6c63956f4$var$blockNodesVerticalMargin = '0.75rem';
const $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin = '0.75em';
const $b0ef43f6c63956f4$export$63635a8b56f58eca = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$3de2f7ce686aadc2 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $b0ef43f6c63956f4$var$scaledBlockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $b0ef43f6c63956f4$export$29f6e72d2a83d55a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$a251c8dae8d8433a = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $b0ef43f6c63956f4$export$855ac5a16d662324 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $b0ef43f6c63956f4$var$blockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $56a35bdc54338480$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $56a35bdc54338480$var$placeholderFadeInKeyframes = (0, $9K4OG.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $56a35bdc54338480$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #6B6E76)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #6B6E76)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder.ak-editor-selected-node': {
        // ...backgroundSelectionStyles
        backgroundColor: "var(--ds-background-selected, #E9F2FE)",
        // ...backgroundSelectionStyles -> hideNativeBrowserTextSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection,*::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection,*::-moz-selection': {
            backgroundColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text[data-placeholder]::after': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        cursor: 'text',
        content: 'attr(data-placeholder)',
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor::after': {
            content: '""',
            display: 'inline',
            top: 0,
            position: 'absolute',
            borderRight: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-selection': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative',
            // Follow the system highlight colour to match native text selection
            backgroundColor: 'Highlight',
            // We should also match the text colour to the system highlight text colour.
            // That way if the system highlight background is dark, the text will still be readable.
            color: 'HighlightText'
        }
    }
});
const $56a35bdc54338480$export$d3bdc0d52bb6c2c8 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .placeholder-decoration': {
        color: "var(--ds-text-subtlest, #6B6E76)",
        width: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.placeholder-android': {
            pointerEvents: 'none',
            outline: 'none',
            userSelect: 'none',
            position: 'absolute'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror .placeholder-decoration-fade-in': {
        animation: `${$56a35bdc54338480$var$placeholderFadeInKeyframes} 300ms ease-out forwards`
    }
});
const $56a35bdc54338480$export$ec7b3b2c50356d2e = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $56a35bdc54338480$export$959bd343ec1d44de = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





function $8ca5e17fea10ef42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ca5e17fea10ef42$export$a06160db3520e5a2 = 'resizer-item';
const $8ca5e17fea10ef42$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $8ca5e17fea10ef42$export$10b67c6ff1748bd = 'resizer-is-extended';
const $8ca5e17fea10ef42$export$6afc20f0ff6d041 = 'resizer-handle';
const $8ca5e17fea10ef42$export$a5792d7e2a486d41 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-track`;
const $8ca5e17fea10ef42$export$2201bc1aaee73f36 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-thumb`;
const $8ca5e17fea10ef42$export$97a99610b6f0a178 = `${$8ca5e17fea10ef42$export$6afc20f0ff6d041}-danger`;
const $8ca5e17fea10ef42$export$b5fa87f62ced4967 = 3;
const $8ca5e17fea10ef42$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $8ca5e17fea10ef42$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$a06160db3520e5a2}`]: {
        willChange: 'width',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:hover, &.display-handle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& > .${$8ca5e17fea10ef42$export$b123b2c8a2536d05} > .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
                visibility: 'visible',
                opacity: 1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.is-resizing': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #4688EC)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8ca5e17fea10ef42$export$97a99610b6f0a178}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                transition: 'none',
                background: "var(--ds-icon-danger, #C9372C)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
        display: 'flex',
        visibility: 'hidden',
        opacity: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 7,
        transition: 'visibility 0.2s, opacity 0.2s',
        // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
        // into the tooltip
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& div[role='presentation']": {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: "var(--ds-space-negative-200, -16px)",
            whiteSpace: 'normal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.left': {
            alignItems: 'flex-start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.right': {
            alignItems: 'flex-end'
        },
        // Handle Sizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.small': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 43
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.medium': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 64
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.large': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 96
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.clamped': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                height: 'clamp(43px, calc(100% - 32px), 96px)'
            }
        },
        // Handle Alignment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.sticky': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                position: 'sticky',
                top: "var(--ds-space-150, 12px)",
                bottom: "var(--ds-space-150, 12px)"
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #4688EC)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
                visibility: 'visible',
                opacity: 0.5
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        content: "' '",
        display: 'flex',
        width: 3,
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        height: 64,
        transition: 'background-color 0.2s',
        borderRadius: "var(--ds-radius-medium, 6px)",
        border: 0,
        padding: 0,
        zIndex: 2,
        outline: 'none',
        minHeight: 24,
        background: "var(--ds-border, #0B120E24)",
        '&:hover': {
            cursor: 'col-resize'
        },
        '&:focus': {
            background: "var(--ds-border-selected, #1868DB)",
            '&::after': {
                content: "''",
                position: 'absolute',
                top: "var(--ds-space-negative-050, -4px)",
                right: "var(--ds-space-negative-050, -4px)",
                bottom: "var(--ds-space-negative-050, -4px)",
                left: "var(--ds-space-negative-050, -4px)",
                border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
                borderRadius: 'inherit',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
        visibility: 'hidden',
        position: 'absolute',
        width: 7,
        height: 'calc(100% - 40px)',
        borderRadius: "var(--ds-radius-small, 4px)",
        opacity: 0,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.none': {
            background: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.shadow': {
            background: "var(--ds-background-selected, #E9F2FE)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.full-height': {
            background: "var(--ds-background-selected, #E9F2FE)",
            height: '100%',
            minHeight: 36
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ak-editor-no-interaction .ak-editor-selected-node .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}:not(:hover) .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        background: "var(--ds-border, #0B120E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$c42cdcfd48254bda}`]: {
        position: 'relative',
        display: 'flow-root',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8ca5e17fea10ef42$export$10b67c6ff1748bd}`]: {
            padding: `0 ${"var(--ds-space-150, 12px)"}`,
            left: "var(--ds-space-negative-150, -12px)"
        }
    },
    // This below style is here to make sure the image width is correct when nested in a table
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`table .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}, table .${$8ca5e17fea10ef42$export$c42cdcfd48254bda}.${$8ca5e17fea10ef42$export$10b67c6ff1748bd}`]: {
        padding: 'unset',
        left: 'unset'
    }
});
const $8ca5e17fea10ef42$export$23b92c67b0c07892 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}.bottom`]: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        width: '100%',
        height: 7,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
            width: 64,
            height: 3,
            minWidth: 24,
            minHeight: 0,
            margin: `${"var(--ds-space-025, 2px)"} 0`,
            '&:hover': {
                cursor: 'row-resize'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$8ca5e17fea10ef42$export$a5792d7e2a486d41}`]: {
            width: 'calc(100% - 40px)',
            height: 7
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$8ca5e17fea10ef42$export$a5792d7e2a486d41}.full-height`]: {
            width: '100%',
            height: 7,
            minWidth: 36,
            minHeight: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}.small.bottom .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        width: 43,
        height: 3
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}.medium.bottom .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        width: 64,
        height: 3
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}.large.bottom .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        width: 96,
        height: 3
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8ca5e17fea10ef42$export$6afc20f0ff6d041}.clamped.bottom .${$8ca5e17fea10ef42$export$2201bc1aaee73f36}`]: {
        width: 'clamp(43px, calc(100% - 32px), 96px)',
        height: 3
    }
});
const $8ca5e17fea10ef42$export$21b363e15a3a4b0b = {
    name: "1rqtth7",
    styles: ".pm-breakout-resize-handle-rail-wrapper{display:flex;align-items:center;justify-content:center;height:100%;cursor:col-resize;border-radius:var(--ds-radius-small, 4px);z-index:2;[role=\"presentation\"]{height:100%;width:100%;}.pm-breakout-resize-handle-rail-inside-tooltip{height:100%;}}"
};
const $8ca5e17fea10ef42$export$241444dc11ae22d6 = {
    name: "zqeg2w",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"layoutSection\"].first-node-in-document){> .pm-breakout-resize-handle-container{height:calc(100% - 8px);}}}"
};
const $8ca5e17fea10ef42$export$10ee78d9e73a5e96 = {
    name: "1itvsdi",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"codeBlock\"]){> .pm-breakout-resize-handle-container--left{left:-5px;}> .pm-breakout-resize-handle-container--right{right:-5px;}> .pm-breakout-resize-handle-container{height:calc(100% - 12px);}}&:has(.first-node-in-document){> .pm-breakout-resize-handle-container{height:100%;}}}"
};
const $8ca5e17fea10ef42$export$d199c4fcac4ebc3a = {
    name: "38i0y8",
    styles: ".fabric-editor-breakout-mark{&:has(> .fabric-editor-breakout-mark-dom > [data-prosemirror-node-name=\"codeBlock\"]){> .pm-breakout-resize-handle-container--left{left:-5px;}> .pm-breakout-resize-handle-container--right{right:-5px;}> .pm-breakout-resize-handle-container{height:calc(100% - 12px);}}&:has(.first-node-in-document.first-node-in-document){> .pm-breakout-resize-handle-container{height:100%;}}}"
};
const $8ca5e17fea10ef42$export$62cd5dfd9881f590 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-25px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-25px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // Rail and thumb styles intentionally mirror the layout column divider
    // (see layoutColumnDividerRailClassName and layoutColumnDividerThumbClassName in layout.ts).
    // If updating these styles, consider keeping both in sync.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: "var(--ds-radius-small, 4px)",
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #4688EC)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FE)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #4688EC)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $8ca5e17fea10ef42$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-medium, 6px)",
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $8ca5e17fea10ef42$export$f4810475f3f405bd = {
    name: "riwidy",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"syncBlock\"]), &:has([data-prosemirror-node-name=\"bodiedSyncBlock\"]){> .pm-breakout-resize-handle-container--left{left:-24px;}> .pm-breakout-resize-handle-container--right{right:-24px;}> .pm-breakout-resize-handle-container{height:calc(100% - 12px);}}}"
};
const $8ca5e17fea10ef42$export$2785010673d864e4 = /*#__PURE__*/ (0, $9K4OG.css)({
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                [`.${$8ca5e17fea10ef42$export$a06160db3520e5a2}`]: {
                    willChange: 'width',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '&:hover, &.display-handle': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
                        [`& > .${$8ca5e17fea10ef42$export$b123b2c8a2536d05} > .${$8ca5e17fea10ef42$export$6afc20f0ff6d041}`]: {
                            visibility: 'hidden',
                            opacity: 0
                        }
                    }
                }
            }
        }
    }
});


/* eslint-disable @atlaskit/design-system/use-tokens-shape -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 





const $0e823357fa8df654$export$2413e968422424ec = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        height: '2px',
        borderRadius: '1px',
        // this should use token('radius.full') but cannot since the element has padding which increases its height beyond 2px
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #1868DB)"
    }
});
const $0e823357fa8df654$export$e425548b5cacd57 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}.danger`]: {
        backgroundColor: "var(--ds-border-danger, #E2483D)"
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $887f0254bcb2b3a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $887f0254bcb2b3a0$export$b2380b18b089518f = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};



/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ 


const $14a90d57d6df814c$var$fadeIn = (0, $9K4OG.keyframes)({
    from: {
        opacity: 0,
        transform: 'translateY(16px)'
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)'
    }
});
const $14a90d57d6df814c$export$1629cb32bbba3a7e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[aria-label='Selection toolbar']": {
        animationName: $14a90d57d6df814c$var$fadeIn,
        animationDuration: `0.2s`,
        animationTimingFunction: `cubic-bezier(0.6, 0, 0, 1)`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $f08f86940ab6d6a2$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
const $f08f86940ab6d6a2$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $f08f86940ab6d6a2$export$9750a92ac0203c10 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::before, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: 2,
            width: 8,
            content: "''",
            height: 'calc(100%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}, .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before`]: {
            background: `linear-gradient(to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px)`,
            top: 0,
            left: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px)`,
            right: 0,
            top: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$1cbe0bb16052178d.SENTINEL_LEFT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$f08f86940ab6d6a2$export$1cbe0bb16052178d.SENTINEL_RIGHT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 






const $535dd5d33c38cc84$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $535dd5d33c38cc84$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $535dd5d33c38cc84$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $535dd5d33c38cc84$export$f64b12e3fb171ebc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
const $535dd5d33c38cc84$export$1fef993256efc96e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&[data-testid="show-diff-changed-decoration-node"] .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 var(--diff-decoration-marker-ring-width, 1px) var(--diff-decoration-marker-color)`,
            borderColor: 'transparent'
        }
    }
});
const $535dd5d33c38cc84$export$4d8f0e547724198 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER}`]: {
            opacity: 0.6
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.6
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.6
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node': {
        textDecoration: 'line-through'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="embedCard"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    }
});
const $535dd5d33c38cc84$export$5e70718283e43349 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node-traditional.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node.show-diff-deleted-active .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
        [`&.show-diff-deleted-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER}`]: {
            opacity: 0.8
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.8
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 var(--diff-decoration-marker-ring-width, 1px) ${"var(--ds-border-accent-red, #E2483D)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-outline-new .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node-traditional.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.show-diff-deleted-node.show-diff-deleted-active .media-card-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            opacity: 0.8
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node': {
        textDecoration: 'line-through'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="blockquote"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="embedCard"].show-diff-deleted-node-traditional': {
        textDecoration: 'line-through',
        textDecorationColor: "var(--ds-border-accent-red, #E2483D)"
    }
});
const $535dd5d33c38cc84$export$b346a5d6d598424c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            marginBottom: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$56d86af0724ad29e = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            marginBottom: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$42b66ad40efe5bbe = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            marginBottom: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block):not(.danger) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-radius-large, 8px)",
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$535dd5d33c38cc84$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $535dd5d33c38cc84$export$fefb174a4d9f4c0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
            marginTop: "var(--ds-space-150, 12px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}.ak-editor-selected-node .${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5),
            {
                borderRadius: "var(--ds-radius-large, 8px)"
            }
        ]
    }
});
const $535dd5d33c38cc84$export$cb0683bb9c4e1322 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    }
});
const $535dd5d33c38cc84$export$1a87a16059da4299 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}:not(.${$535dd5d33c38cc84$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER})`]: {
        // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $8daea92ba3be6a6e$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-table-cell-content-wrap, .pm-table-header-content-wrap, [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap': {
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > span': {
                width: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > span': {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0 // Prevent responsive layouts increasing height of container.
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.status-lozenge-span > span': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: 'rgba(255, 189, 173, 0.5)' // akEditorDeleteBackgroundWithOpacity
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.status-lozenge-span > span': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 653)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $8daea92ba3be6a6e$export$7c209f30e9068068 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $8daea92ba3be6a6e$export$8b4cca12f7a094c7 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $8daea92ba3be6a6e$export$bd58d1bcb934912c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node.danger .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});
const $8daea92ba3be6a6e$export$dc185896d75d4b4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #505258)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #803FA5)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #1558BC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #9E4C00)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #EFFFD6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #4C6B1F)"
    }
});
const $8daea92ba3be6a6e$export$60b421c3da7a2a99 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #505258)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #803FA5)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FE)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #1558BC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #9E4C00)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #EFFFD6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #4C6B1F)"
    }
});
const $8daea92ba3be6a6e$export$5bacb3eba124de20 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        paddingBlockStart: "var(--ds-space-025, 2px)",
        paddingBlockEnd: "var(--ds-space-025, 2px)",
        paddingInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        height: '1.25rem',
        border: `solid ${"var(--ds-border-width, 1px)"} transparent`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    },
    /* Border, background and text colors
   * These colors are copied from @atlaskit/lozenge
   * DST is currently using oklch with different light and dark lightness factors
   * and suggest using hex colors until the design tokens are added
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#CACBCF'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#63666B'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text, #292A2E)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery-subtler, #EED7FC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#D8A0F7'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#803FA5'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery-bolder, #48245D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information-subtler, #CFE1FD)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#8FB8F6'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#1558BC'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information-bolder, #123263)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger-subtler, #FFD5D2)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#FD9891'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#AE2E24'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger-bolder, #5D1F1A)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning-subtler, #FCE4A6)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#FBC828'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#9E4C00'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning-bolder, #693200)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success-subtler, #D3F1A7)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html:not([data-color-mode=dark]) &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#B3DF72'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'html[data-color-mode=dark] &': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor: '#4C6B1F'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success-bolder, #37471F)"
    },
    /* Find and Replace Styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.statusView-content-wrap:not(.search-match-block).ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



var $e6n00 = parcelRequire("e6n00");

const $7a476f61d60131cb$export$9ce40bb672aef33b = /*#__PURE__*/ (0, $9K4OG.css)({
    '@property --angle': {
        syntax: '"<angle>"',
        initialValue: '0deg',
        inherits: 'false'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            position: 'relative',
            cursor: 'pointer',
            borderRadius: "var(--ds-radius-small, 3px)",
            marginBottom: 0,
            marginTop: "var(--ds-space-075, 6px)",
            paddingBlock: "var(--ds-space-150, 12px)",
            color: 'inherit',
            /* Hover state */ '&:hover': {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`,
                transition: 'box-shadow 200ms ease-in',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible',
                    transition: 'opacity 200ms ease-in, visibility 200ms ease-in'
                }
            },
            /* Selection state when cursor inside sync block */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).selectionInside}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible'
                }
            },
            /* Node selection state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.ak-editor-selected-node': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible',
                    backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                    top: '-14px',
                    paddingBottom: "var(--ds-space-050, 4px)",
                    paddingTop: "var(--ds-space-050, 4px)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '> span': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                        color: `${"var(--ds-text-selected, #1868DB)"} !important`
                    }
                }
            },
            /* Danger state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    top: '-14px',
                    paddingBottom: "var(--ds-space-050, 4px)",
                    paddingTop: "var(--ds-space-050, 4px)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '> span': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                        color: `${"var(--ds-text-danger, #AE2E24)"} !important`
                    }
                }
            },
            /* Node disabled state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).disabledClassName}`]: {
                backgroundColor: "var(--ds-background-disabled, #17171708)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-disabled, #0515240F)"}`,
                userSelect: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,  @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    backgroundColor: "var(--ds-surface, #FFFFFF)",
                    '&::before': {
                        border: 'none'
                    }
                }
            },
            /* Creation loading state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).creationLoadingClassName}`]: {
                animation: `${(0, $9K4OG.keyframes)({
                    from: {
                        '--angle': '0deg'
                    },
                    to: {
                        '--angle': '360deg'
                    }
                })} 2s linear infinite`,
                border: '1px solid transparent',
                background: `linear-gradient(${"var(--ds-surface, #FFFFFF)"}, ${"var(--ds-surface, #FFFFFF)"}) padding-box, conic-gradient(from var(--angle), #1868DB, ${"var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)"}, #3279E0, #1868DB) border-box`,
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'none',
                transition: 'boxShadow 200ms ease-in',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,  @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    display: 'none'
                }
            },
            /* Error state */ /* In error state sync block should have disabled background colour */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`:has(.${(0, $e6n00.SyncBlockSharedCssClassName).error})`]: {
                backgroundColor: "var(--ds-background-disabled, #17171708)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`:has(.${(0, $e6n00.SyncBlockSharedCssClassName).loading})`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            /* Live doc view mode state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).viewModeClassName}`]: {
                boxShadow: 'none',
                backgroundColor: 'unset',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            /* Dragging state */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $e6n00.SyncBlockStateCssClassName).draggingClassName}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
                    opacity: 1,
                    visibility: 'visible'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
                paddingTop: 0,
                paddingBottom: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingLeft: '19px',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingRight: '18px',
                cursor: 'text'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
                paddingTop: 0,
                paddingBottom: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingLeft: '19px',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                paddingRight: '18px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
            // First child node that has drag handle widget next to it is overridden with marginTop: 0, see globalStyles in editor-plugin-block-controls/src/ui/global-styles.tsx
            // Hence we set marginTop: 0 when by default to avoid flickering when hovering on and off the first node
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
            // First child node in bodiedSyncBlock is overridden with marginTop: 0, hence apply the same style to syncBlock for consistency
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-renderer-document > :first-child': {
                marginTop: 0
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $e6n00.SyncBlockLabelSharedCssClassName).labelClassName}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        position: 'absolute',
        gap: "var(--ds-space-050, 4px)",
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        opacity: 0,
        visibility: 'hidden',
        boxShadow: 'none',
        zIndex: 1,
        paddingLeft: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-100, 8px)",
        top: '-10px',
        right: "var(--ds-space-150, 12px)",
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        maxWidth: '140px'
    }
});
const $7a476f61d60131cb$export$2ef961ae194ff4dc = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            marginRight: `-19px`,
            marginLeft: `-19px`
        }
    }
});
const $7a476f61d60131cb$export$bb6880bfac80a2d6 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`]: {
            // Contain floated elements (wrap-left/wrap-right) within synced block borders
            // Use display: flow-root to create a block formatting context without clipping other content e.g. telepointers
            display: 'flow-root'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
            // Contain floated elements (wrap-left/wrap-right) within synced block borders
            // Use display: flow-root to create a block formatting context without clipping other content e.g. telepointers
            display: 'flow-root'
        }
    }
});
const $7a476f61d60131cb$export$15f9ecbc224279eb = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ProseMirror > .fabric-editor-breakout-mark:first-child`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $e6n00.SyncBlockSharedCssClassName).prefix}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`]: {
            marginTop: 0
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



function $e5ba48b9f959e381$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e5ba48b9f959e381$export$696afa9d8a2fe544 = {
    name: "p382o5",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $e5ba48b9f959e381$export$b216471059d2ae73 = {
    name: "1hbwduk",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment, .fabric-editor-font-size), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $e5ba48b9f959e381$export$5dc8ab529dc33316 = {
    name: "mlsake",
    styles: "margin-left:0;margin-right:0"
};
const $e5ba48b9f959e381$export$61a2da566f69d1df = /*#__PURE__*/ (0, $9K4OG.css)({
    // TODO: ED-28075 - refactor array include to unblock Compiled CSS migration
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .pm-table-wrapper > table`]: [
        $e5ba48b9f959e381$export$5dc8ab529dc33316,
        (0, $887f0254bcb2b3a0$export$b2380b18b089518f)
    ]
});
const $e5ba48b9f959e381$export$d4422e89f15370f2 = {
    name: "1c5wbsb",
    styles: ".ProseMirror .pm-table-wrapper{max-width:100%;overflow-x:auto;width:100%;box-sizing:border-box;}.ProseMirror .pm-table-wrapper.pm-table-wrapper-no-overflow{overflow-x:visible;}.ProseMirror .pm-table-wrapper table{max-width:100%;width:100%;table-layout:fixed;min-width:auto;}"
};
const $e5ba48b9f959e381$export$97207509673d0dfa = {
    name: "1091p55",
    styles: ".ProseMirror .pm-table-wrapper{.pm-table-cell-content-wrap, .pm-table-header-content-wrap{p:empty{min-height:1.714em;}}}"
};
const $e5ba48b9f959e381$export$f19584fc2286b857 = {
    name: "1u49qsn",
    styles: ".pm-table-resizer-container:has(table[data-initial-width-mode=\"content\"]){width:max-content !important;--ak-editor-table-width:max-content;}.resizer-item:has(table[data-initial-width-mode=\"content\"]){width:max-content !important;}.resizer-item:has(table[data-initial-width-mode=\"content\"]) > .resizer-hover-zone.resizer-is-extended{padding:unset;left:unset;}.ProseMirror .pm-table-wrapper table[data-initial-width-mode=\"content\"]{table-layout:auto;width:max-content !important;}.ProseMirror .pm-table-wrapper table[data-initial-width-mode=\"content\"] > colgroup > col{width:unset !important;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 







function $b92d63900d735dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b92d63900d735dfd$var$akEditorLineHeight = 1.714;
const $b92d63900d735dfd$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $b92d63900d735dfd$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $b92d63900d735dfd$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.taskItemView-content-wrap, .${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: 48
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "span[contenteditable='false']": {
                height: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: $b92d63900d735dfd$var$akEditorLineHeight
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false']": {
            height: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false'] + div": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${$b92d63900d735dfd$var$akEditorLineHeight}em`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    // When action list is inside panel
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $b92d63900d735dfd$var$TASKLIST_CONTAINER_MARGIN_DENSE = `max(0px, calc(10px + (var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * (2 / 3)))`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $b92d63900d735dfd$var$_ref = {
    name: "0",
    styles: ""
};
const $b92d63900d735dfd$export$715995201f735e2d = (baseFontSize)=>{
    if (!baseFontSize || baseFontSize === (0, $aFUXX.akEditorFullPageDefaultFontSize)) return $b92d63900d735dfd$var$_ref;
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '.ProseMirror': {
            // Task lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER]: {
                // Task lists: container top margin
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                marginTop: $b92d63900d735dfd$var$TASKLIST_CONTAINER_MARGIN_DENSE
            },
            // Task lists: sibling items and nested lists
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} > * + *`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $7ea00528076df401$export$b9f4317d28be80aa)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER} ${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_LIST_CONTAINER}, .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER} .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                marginTop: (0, $7ea00528076df401$export$b9f4317d28be80aa)
            }
        }
    });
};
const $b92d63900d735dfd$export$c2f467e1dc47f4f1 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName} > [data-decision-wrapper], ol[data-node-type='decisionList'].${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [
        {
            borderRadius: "var(--ds-radius-small, 4px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$a8e8bf15b18b52a0),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$e7c1f2908e268236),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
    ],
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$b92d63900d735dfd$export$a7172b75d403a0e4.DECISION_CONTAINER}.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
            '&::after': {
                content: 'none' // reset the Blanket selection style
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #505258)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #6A9A23)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $b92d63900d735dfd$export$27a4e7e55add38c4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}.danger > [data-decision-wrapper], ol[data-node-type='decisionList'].${$b92d63900d735dfd$var$akEditorSelectedNodeClassName}.danger`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [
        (0, $65bb5c5a687b3665$export$fd4ac125b4ba4c28),
        (0, $65bb5c5a687b3665$export$57f48b634c3a2512)
    ]
});
const $b92d63900d735dfd$export$e237513ae3de60b5 = {
    name: "b3ew8y",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $b92d63900d735dfd$export$921eec0bd8c26b90 = {
    name: "s6v8rd",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $b92d63900d735dfd$export$2a9fa9bb25fe40d2 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $b92d63900d735dfd$export$7356f32af3715d83 = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * Background
   */ '--local-background': "var(--ds-background-input, #FFFFFF)",
    '--local-background-active': "var(--ds-background-input-pressed, #FFFFFF)",
    '--local-background-checked': "var(--ds-background-selected-bold, #1868DB)",
    '--local-background-checked-hover': "var(--ds-background-selected-bold-hovered, #1558BC)",
    '--local-background-disabled': "var(--ds-background-disabled, #17171708)",
    '--local-background-hover': "var(--ds-background-input-hovered, #F8F8F8)",
    /**
   * Border
   */ '--local-border': "var(--ds-border-input, #8C8F97)",
    '--local-border-active': "var(--ds-border, #0B120E24)",
    '--local-border-checked': "var(--ds-background-selected-bold, #1868DB)",
    '--local-border-checked-hover': "var(--ds-background-selected-bold-hovered, #1558BC)",
    '--local-border-checked-invalid': "var(--ds-border-danger, #E2483D)",
    '--local-border-disabled': "var(--ds-background-disabled, #17171708)",
    '--local-border-focus': "var(--ds-border-focused, #4688EC)",
    '--local-border-hover': "var(--ds-border-input, #8C8F97)",
    '--local-border-invalid': "var(--ds-border-danger, #E2483D)",
    /**
   * Tick
   */ '--local-tick-active': "var(--ds-icon-inverse, #FFFFFF)",
    '--local-tick-checked': "var(--ds-icon-inverse, #FFFFFF)",
    '--local-tick-disabled': "var(--ds-icon-disabled, #080F214A)",
    '--local-tick-rest': 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name="taskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}, [data-prosemirror-node-name="blockTaskItem"] .${$b92d63900d735dfd$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            opacity: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& + svg': {
                '--checkbox-background-color': 'var(--local-background)',
                '--checkbox-border-color': 'var(--local-border)',
                '--checkbox-tick-color': 'var(--local-tick-rest)',
                color: 'var(--checkbox-background-color)',
                fill: 'var(--checkbox-tick-color)',
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                boxSizing: 'border-box',
                display: 'inline',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                'rect:first-of-type': {
                    stroke: 'var(--checkbox-border-color)',
                    strokeWidth: "var(--ds-border-width, 1px)",
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:focus + svg, &:checked:focus + svg': {
                borderRadius: "var(--ds-radius-small, 0.25rem)",
                outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + svg': {
                '--checkbox-background-color': 'var(--local-background-hover)',
                '--checkbox-border-color': 'var(--local-border-hover)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + svg': {
                '--checkbox-background-color': 'var(--local-background-checked-hover)',
                '--checkbox-border-color': 'var(--local-border-checked-hover)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked + svg': {
                '--checkbox-background-color': 'var(--local-background-checked)',
                '--checkbox-border-color': 'var(--local-border-checked)',
                '--checkbox-tick-color': 'var(--local-tick-checked)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:active + svg': {
                '--checkbox-background-color': 'var(--local-background-active)',
                '--checkbox-border-color': 'var(--local-border-active)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:active + svg': {
                '--checkbox-background-color': 'var(--local-background-active)',
                '--checkbox-border-color': 'var(--local-border-active)',
                '--checkbox-tick-color': 'var(--local-tick-active)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'var(--local-background-disabled)',
                '--checkbox-border-color': 'var(--local-border-disabled)',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:disabled:checked + svg': {
                '--checkbox-tick-color': 'var(--local-tick-disabled)'
            }
        }
    }
});
const $b92d63900d735dfd$export$a261a5b04a85ad9c = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"], [data-prosemirror-node-name="blockTaskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"], [data-prosemirror-node-name="blockTaskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"], [data-prosemirror-node-name="blockTaskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #6B6E76)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder'], [data-prosemirror-node-name='blockTaskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"], [data-prosemirror-node-name="blockTaskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


function $4287605bd9e53ba0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4287605bd9e53ba0$var$pulseIn = (0, $9K4OG.keyframes)({
    '0%, 100%': {
        transform: 'scaleX(0)',
        opacity: 0
    },
    '10%': {
        transform: 'scaleX(1.4)',
        opacity: 1
    },
    '15%, 85%': {
        transform: 'scaleX(1)',
        opacity: 1
    }
});
const $4287605bd9e53ba0$var$pulseOut = (0, $9K4OG.keyframes)({
    '0%, 90%, 100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '10%, 80%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$var$pulseInDuringTr = (0, $9K4OG.keyframes)({
    '0%, 95%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$var$pulseOutDuringTr = (0, $9K4OG.keyframes)({
    '100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '0%, 90%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $4287605bd9e53ba0$export$3f28e75e37279280 = {
    name: "ig2c5x",
    styles: ".ProseMirror .telepointer{position:relative;transition:opacity 200ms;&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-dim{opacity:0.2;}&.color-0{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-red-bolder, #C9372C);}&.color-1{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-blue-bolder, #1868DB);}&.color-2{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-green-bolder, #1F845A);}&.color-3{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-bolder, #946F00);}&.color-4{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-purple-bolder, #964AC0);}&.color-5{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-bolder, #AE4787);}&.color-6{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-teal-bolder, #227D9B);}&.color-7{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-orange-bolder, #BD5B00);}&.color-8{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-lime-bolder, #5B7F24);}&.color-9{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-gray-bolder, #6B6E76);}&.color-10{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-blue-subtle, #669DF1);}&.color-11{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-red-subtle, #F87168);}&.color-12{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-orange-subtle, #FCA700);}&.color-13{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-subtle, #EED12B);}&.color-14{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-green-subtle, #4BCE97);}&.color-15{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-teal-subtle, #6CC3E0);}&.color-16{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-purple-subtle, #C97CF4);}&.color-17{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #1E1F21);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-subtle, #E774BB);}html:not([data-color-mode=dark]) &{--telepointer-participant-background-first-stop:-850000%;--telepointer-participant-background-second-stop:150000%;}html[data-color-mode=dark] &{--telepointer-participant-background-first-stop:-800000%;--telepointer-participant-background-second-stop:200000%;}&[class*=\"color-\"]{background:linear-gradient(to bottom, var(--telepointer-participant-bg-color) var(--telepointer-participant-background-first-stop), transparent var(--telepointer-participant-background-second-stop));&::after{background-color:var(--telepointer-participant-bg-color);color:var(--telepointer-participant-text-color);border-color:var(--telepointer-participant-bg-color);}}}"
};
const $4287605bd9e53ba0$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9K4OG.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge': {
            '.telepointer-initial, .telepointer-fullname': {
                position: 'absolute',
                display: 'block',
                userSelect: 'none',
                whiteSpace: 'pre',
                top: -14,
                left: 0,
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                paddingLeft: "var(--ds-space-050, 4px)",
                paddingRight: "var(--ds-space-050, 4px)",
                borderRadius: `0 ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0`
            },
            '.telepointer-initial': {
                opacity: 1,
                transition: 'opacity 0.15s ease-out'
            },
            '.telepointer-fullname': {
                opacity: 0,
                transform: 'scaleX(0)',
                transformOrigin: 'top left',
                transition: 'transform 0.15s ease-out, opacity 0.15s ease-out'
            }
        },
        '&.telepointer-pulse-animate': {
            '.telepointer-initial': {
                animation: `${$4287605bd9e53ba0$var$pulseOut} 2.5s ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$4287605bd9e53ba0$var$pulseIn} 2.5s ease-in-out`
            }
        },
        '&.telepointer-pulse-during-tr': {
            '.telepointer-initial': {
                animation: `${$4287605bd9e53ba0$var$pulseOutDuringTr} 7500ms ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$4287605bd9e53ba0$var$pulseInDuringTr} 7500ms ease-in-out`
            }
        },
        '&:hover': {
            '.telepointer-initial': {
                opacity: 0,
                transitionDelay: '150ms'
            },
            '.telepointer-fullname': {
                transform: 'scaleX(1)',
                opacity: 1,
                zIndex: 1
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $d945351f1977281b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d945351f1977281b$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 


const $1fcafd3026b21a26$export$b286500adc7d91cd = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.text-highlight': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        borderBottom: `2px solid ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"}`
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 



const $6b97cbd24a9f84ae$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $6b97cbd24a9f84ae$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, .${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
        cursor: 'pointer'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b2937e5c446645ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$48dd9ca0c16e4625),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a716852a0c5e54d5)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$6b97cbd24a9f84ae$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$6b97cbd24a9f84ae$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
                border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ function $c13a16cba860d543$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c13a16cba860d543$export$2ee83b65ab9fac74 = {
    name: "1e3eb5t",
    styles: ".ProseMirror{word-wrap:break-word;white-space:pre-wrap;}"
};


const $2ae0c99ab8c8a396$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $2ae0c99ab8c8a396$var$alignMultipleWrappedImageInLayoutStyles = {
    '.ProseMirror [data-layout-section] [data-layout-column] > div': {
        // apply marginTop to wrapped mediaSingle that has preceding wrapped mediaSingle (even when there's gap cursor in between them)
        // Given the first wrapped mediaSingle in layout has 0 marginTop, this is needed to make sure fellow wrapped mediaSingle align with it horizontally
        '.mediaSingleView-content-wrap[layout^=wrap] + .mediaSingleView-content-wrap[layout^=wrap], .mediaSingleView-content-wrap[layout^=wrap] + .ProseMirror-gapcursor + .mediaSingleView-content-wrap[layout^=wrap]': {
            '.rich-media-item': {
                marginTop: 0
            }
        },
        // Due to the above rule, wrapped mediaSingle (not the first node in layout) that are followed by wrapped mediaSingle should also have 0 marginTop
        // so it's aligned with the following wrapped mediaSingle
        '.mediaSingleView-content-wrap[layout^=wrap]:has( + .mediaSingleView-content-wrap[layout^=wrap])': {
            '.rich-media-item': {
                marginTop: 0
            }
        }
    }
};
const $2ae0c99ab8c8a396$var$firstWrappedMediaStyles = {
    '.ProseMirror': {
        // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
        "& [layout^='wrap-']:has(+ [layout^='wrap-']), & [layout^='wrap-']:has(+ .ProseMirror-gapcursor + [layout^='wrap-'])": {
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        }
    }
};
const $2ae0c99ab8c8a396$export$43e0225d90a33f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode, useStandardNodeWidth: useStandardNodeWidth } = props;
    const theme = (0, $6dGgK.u)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width' || ((0, $dZ8uq.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $dZ8uq.expValEqualsNoExposure)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max';
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const baseFontSize = (0, $jTtEd.getBaseFontSize)(appearance, contentMode);
    const style = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: theme
        })}px`
    } : {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
            theme: theme
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        '--ak-editor--large-gutter-padding': `${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px`
    };
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$6a08aa478781aaec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$8ccf5563eb1fc2f7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$247cd720d09b9b61),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$cc6d483a79f2d275) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$9e26088fca9327a2),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0c8159821f1481e1$export$23029c6a73ca6b8c),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $c13a16cba860d543$export$2ee83b65ab9fac74),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e776189f3c3af959$export$fc74cf03693076b4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && (0, $a227b436ae91f932$export$5efd6032566fe395),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $f08f86940ab6d6a2$export$9750a92ac0203c10),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3b65c10c9ad50286$export$3fc32cdc53f6edeb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$b8cc3f8fc9e3d56a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$cc1dcabcf4a29354),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $65bb5c5a687b3665$export$a3d8f4cb8a14da43),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $034503d6cd31c145$export$f21d9f928c6ae322),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b08ecd070af20ccb$export$f06cff4aa315bcf9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$56bce713f2cb8aa7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$d3bdc0d52bb6c2c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $56a35bdc54338480$export$ec7b3b2c50356d2e),
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $56a35bdc54338480$export$959bd343ec1d44de),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$4baaed2b257b830),
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$921fec04d268c00a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $dh538.fg)('platform_editor_typography_ugc') && (0, $8c084c7e0576e8c1$export$87e0522332cd3719),
            (0, $dh538.fg)('platform_editor_typography_ugc') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8c084c7e0576e8c1$export$63adc0ebe3278d31),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && (0, $8c084c7e0576e8c1$export$3bdf5e0c4fe1eac4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$610a2509037eaf6),
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$9be2adf7cb8aa3a1),
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$8a07948e3f1777),
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$3683cb70e936c4c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$36460e974c9904b9) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$4a8301858e3f950),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $375f45f3b6bd3ab6$export$13d8dd04b9497c9a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9fb7690d6af70e31$export$2029176b06e1b241),
            (0, $1oCLl.expValEquals)('platform_editor_a11y_scrollable_region', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9fb7690d6af70e31$export$a1c093cc2c35593e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d945351f1977281b$export$a518ea5d00002b38),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $680457c62c4e856c$export$e4cca17cf56e99d),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $680457c62c4e856c$export$a365082c2a191514),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$5f95d55c83a3b7bc),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$66dd3b7a524cdd20),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$b5b1b7a81c86d94e),
            // Condense vertical spacing between list items when content mode dense is active
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$dc36e8e603594c1d)(baseFontSize),
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'listLayoutShiftFix', true) && isFullPage && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7ea00528076df401$export$3861aadd8944b16f),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $0e823357fa8df654$export$2413e968422424ec),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$1fef993256efc96e),
            (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$5e70718283e43349) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$4d8f0e547724198),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$abd2efc27ac7e809),
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$1cac2710e369d647),
            // merge firstWrappedMediaStyles with mediaStyles when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $2ae0c99ab8c8a396$var$firstWrappedMediaStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4287605bd9e53ba0$export$c94087d6ea5127ad),
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4287605bd9e53ba0$export$3f28e75e37279280),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ba96bd4668ffc758$export$f6b9d90c2745834e),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ba96bd4668ffc758$export$bfbb8fb576027812),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$8290cf129669d0cb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$fb05379f8218158),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$1bea98aa89006044),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$59d3d90d4141195),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$1445f2e2b3a1d9c8),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$df437277fbc8b4f5),
            // condense vertical spacing between tasks/decisions items when content mode dense is active
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$715995201f735e2d)(baseFontSize),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3b9a5370a72c9df5$export$61d0da483c72dda3),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a303160bb76f51c$export$e561f1e4e17b129d),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $332bd83257b23222$export$37579fbc35dcc1a9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $91793a38cb990edb$export$9abdb593a2600bc6)(contentMode),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $91793a38cb990edb$export$c6823b394e119a7e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$ed25ef5a9db895f7),
            // Apply expand delta styles conditionally based on useStandardNodeWidth (negative margins or not)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !useStandardNodeWidth && (0, $35750f0b594d4ce9$export$4bb28258452e3b9a),
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$9f08fc5d3959d07e)(baseFontSize),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$26d7f96b2bb98b5b) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$4dd1b2c2505a38a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$20843fd014d7530c),
            isChromeless && (0, $1oCLl.expValEquals)('platform_editor_chromeless_expand_fix', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $35750f0b594d4ce9$export$bdee15c929dd4423),
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$2ad4be5f6c1e4bbf) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$c5ceb9c726010930),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$c6bd0332f9f90d1b),
            (0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$fae24dca059c5),
            !(0, $1oCLl.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $19957a194e4b6622$export$a5471dc947aff188),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1fcafd3026b21a26$export$b286500adc7d91cd),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$c2f467e1dc47f4f1),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$a261a5b04a85ad9c) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$2a9fa9bb25fe40d2),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$7356f32af3715d83),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b92d63900d735dfd$export$e237513ae3de60b5),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$79c8c9ad308bbe07),
            (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$5bacb3eba124de20) : (0, $dh538.fg)('platform-component-visual-refresh') ? (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$8b4cca12f7a094c7) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$7c209f30e9068068) : (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$60b421c3da7a2a99) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8daea92ba3be6a6e$export$dc185896d75d4b4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e744a1f22573fa53$export$65cde0a0b7e7c1c1),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$42b66ad40efe5bbe) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$56d86af0724ad29e) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$b346a5d6d598424c),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$fefb174a4d9f4c0),
            ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$f64b12e3fb171ebc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92bd659d1ad36350$export$5a1f57c6600b90f1),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6b97cbd24a9f84ae$export$637bcb89343f7ef4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$ce55ec61aa49b942),
            (0, $1oCLl.expValEquals)('databases-native-embeds-v2', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$23b92c67b0c07892),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$ce383b8d82e44bf5),
            (0, $1oCLl.expValEquals)('platform_editor_table_excerpts_fix', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$4921bd0cd96a70c2),
            // merge alignMultipleWrappedImageInLayoutStyles with layoutBaseStyles when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $2ae0c99ab8c8a396$var$alignMultipleWrappedImageInLayoutStyles,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$9ce40bb672aef33b),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // Apply sync block delta styles conditionally based on useStandardNodeWidth (negative margins or not)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !useStandardNodeWidth && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$2ef961ae194ff4dc),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && (0, $7a476f61d60131cb$export$bb6880bfac80a2d6),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7a476f61d60131cb$export$15f9ecbc224279eb),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$74ce03ae8f7cbe1a),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$d9912ef7f698aab8) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$17d7fe9c8be65e97),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$2e7c649d642e8659),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$ed4b77c142cd3096),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$8dd21c7c24132a82) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$fe39d5414c0135d3),
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $iu6m9.editorExperiment)('platform_editor_layout_column_resize_handle', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$67aba4052ecc5648),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$fe59793079ccb11a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$cdcbf2d4bffabda6),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$1ce35d5e797e3173),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$55890fd3e3be7f1b),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $07d5bf3f0b10fce1$export$c1454bb6dd8837f5),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && ((0, $iu6m9.editorExperiment)('platform_synced_block', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$b371e818feeb9ba8) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$4d009f8d3cbd5535)),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$c60086c81c0ffabf) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$598dd68f26eb7eff),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$cb0683bb9c4e1322),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $535dd5d33c38cc84$export$1a87a16059da4299),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $332bd83257b23222$export$b89fadc5134d50fa),
            (0, $dh538.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$63635a8b56f58eca) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$29f6e72d2a83d55a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$3de2f7ce686aadc2) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $b0ef43f6c63956f4$export$855ac5a16d662324),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9be63d8bc680ee45$export$4ea5976125a01ffa),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            browser.safari && (0, $7ea00528076df401$export$dba87c9b43c1033d),
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$f4810475f3f405bd),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$62cd5dfd9881f590) : undefined,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$d199c4fcac4ebc3a) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$10ee78d9e73a5e96) : undefined,
            (0, $iu6m9.editorExperiment)('advanced_layouts', true) && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$241444dc11ae22d6),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$21b363e15a3a4b0b),
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && ((0, $iu6m9.editorExperiment)('advanced_layouts', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8ca5e17fea10ef42$export$2785010673d864e4),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $30cdf9ef77478b9f$export$7d2a5652980d3808),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $2ae0c99ab8c8a396$var$isFirefox && (0, $30cdf9ef77478b9f$export$541b06daf7fd8fce),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $30cdf9ef77478b9f$export$9a2d17c0df63f635),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && $2ae0c99ab8c8a396$var$isFirefox && (0, $30cdf9ef77478b9f$export$18b242302a502e32),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $07d5bf3f0b10fce1$export$ec8bdd18ecbadae7),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$20e6a345585c5c3c),
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', false) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$70038a77af1ac7b5),
            viewMode === 'view' && (0, $iu6m9.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $07d5bf3f0b10fce1$export$203a03d09c37c555),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $8ba9ce11757ecee6$export$d6e7bceefcc20e27),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $e5ba48b9f959e381$export$61a2da566f69d1df),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $8478647a8b452658$export$eb88bb4706d67f65),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $887f0254bcb2b3a0$export$b2380b18b089518f),
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$ddc3dd3ba723d1af) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1e5fdc47935572b3$export$50458a606d5c37d0),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $563563a54a51d8c3$export$2d6e8a1d666d4a60),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$5fb9b21e3678e9ac),
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$13ab2f17ccaf48f6) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d6f1b5d8b6185b26$export$8697a9554aac2a5a),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$3db84a979dc69b56) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$d73b97ac20f33f4),
            // Dense emoji scaling based on base font size
            contentMode === 'compact' && ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) ? (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$1cdf865bc84cef4)(baseFontSize) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $64073fed169900b9$export$2a2707475ad11d76)(baseFontSize) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9add2684ad964103$export$21dc022a1db4e807),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$cbc2f5b7ba4a5b45),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8b8a9e34027bcb70$export$228abfa0106fa708),
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$b216471059d2ae73) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$696afa9d8a2fe544),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$d4422e89f15370f2),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1zav4.tableSharedStyle)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$97207509673d0dfa),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $e5ba48b9f959e381$export$f19584fc2286b857),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9be63d8bc680ee45$export$889b949305b162f9),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $14a90d57d6df814c$export$1629cb32bbba3a7e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $375f45f3b6bd3ab6$export$cf79be04c8e54f95),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $375f45f3b6bd3ab6$export$162efa362a1cdef5),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $375f45f3b6bd3ab6$export$adeff2341d3e8864),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $332bd83257b23222$export$f9f3f08b750aaa7d),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $64073fed169900b9$export$df03c70a9b9671c1),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $d6f1b5d8b6185b26$export$1091a37fb36d77e5),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $b92d63900d735dfd$export$27a4e7e55add38c4),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8daea92ba3be6a6e$export$bd58d1bcb934912c),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $0e823357fa8df654$export$e425548b5cacd57),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $8b8a9e34027bcb70$export$c47a18e5da2466ef),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $9add2684ad964103$export$9addcfe7a096a01d)
            ]
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined
    }, children);
});


/**
 * Compiled Migration is WIP
 * If you are touching EditorContentContainerEmotion, please contact with #proj-cc-editor-full-compiled-css-migration
 * https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-120555
 */ const $ad78489f7c19358a$var$EditorContentContainer = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_static_css', 'isEnabled', true), (0, $c893e88acf4c2038$export$b9e04e68e256861a), (0, $2ae0c99ab8c8a396$export$43e0225d90a33f7));
var $ad78489f7c19358a$export$2e2bcd8739ae039 = $ad78489f7c19358a$var$EditorContentContainer;
module.exports["default"] = $ad78489f7c19358a$export$2e2bcd8739ae039;

});

parcelRegister("6ESsx", function(module, exports) {
const $a4c21b9fb66bf546$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $a4c21b9fb66bf546$export$b0aeb22a160e5b4c = {
    focus: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-focus`,
    blur: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-blur`,
    draft: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-draft`,
    hover: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-hover`
};
const $a4c21b9fb66bf546$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $a4c21b9fb66bf546$export$ac15f3ad21fefeac = {
    focus: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-focus`,
    blur: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-blur`,
    draft: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-draft`
};
module.exports["AnnotationSharedClassNames"] = $a4c21b9fb66bf546$export$b0aeb22a160e5b4c;
module.exports["BlockAnnotationSharedClassNames"] = $a4c21b9fb66bf546$export$ac15f3ad21fefeac;

});

parcelRegister("DoNsZ", function(module, exports) {

var $dGKc1 = parcelRequire("dGKc1");


var $6icEc = parcelRequire("6icEc");

const $2d8620dcf810155b$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $2d8620dcf810155b$var$prefix = 'ak-editor-panel';
const $2d8620dcf810155b$export$6dd740b6c888e050 = {
    prefix: $2d8620dcf810155b$var$prefix,
    content: `${$2d8620dcf810155b$var$prefix}__content`,
    icon: `${$2d8620dcf810155b$var$prefix}__icon`,
    noIcon: `${$2d8620dcf810155b$var$prefix}__no-icon`
};
const $2d8620dcf810155b$export$b0ee08fae091706a = {
    infoPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).INFO}]`,
    notePanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).NOTE}]`,
    warningPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).WARNING}]`,
    errorPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).ERROR}]`,
    successPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $dGKc1.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $2d8620dcf810155b$export$8099afddf1b1be78 = (panelType)=>$2d8620dcf810155b$var$lightPanelColors[panelType] || 'none';
const $2d8620dcf810155b$export$dd3f0fd482ae7ccc = (panelType)=>(0, $6icEc.hexToEditorBackgroundPaletteColor)($2d8620dcf810155b$var$lightPanelColors[panelType]) || 'none';
module.exports["PanelSharedCssClassName"] = $2d8620dcf810155b$export$6dd740b6c888e050;
module.exports["getPanelTypeBackgroundNoTokens"] = $2d8620dcf810155b$export$8099afddf1b1be78;

});

parcelRegister("iMS6j", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $76cf05f628aba256$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $76cf05f628aba256$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $76cf05f628aba256$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $76cf05f628aba256$var$prefix = 'ak-editor-expand';
const $76cf05f628aba256$export$6ba39aa0ead007b7 = {
    prefix: $76cf05f628aba256$var$prefix,
    expanded: `${$76cf05f628aba256$var$prefix}__expanded`,
    titleContainer: `${$76cf05f628aba256$var$prefix}__title-container`,
    inputContainer: `${$76cf05f628aba256$var$prefix}__input-container`,
    iconContainer: `${$76cf05f628aba256$var$prefix}__icon-container`,
    icon: `${$76cf05f628aba256$var$prefix}__icon`,
    iconButton: `${$76cf05f628aba256$var$prefix}__icon-button`,
    iconSvg: `${$76cf05f628aba256$var$prefix}__icon-svg`,
    titleInput: `${$76cf05f628aba256$var$prefix}__title-input`,
    content: `${$76cf05f628aba256$var$prefix}__content`,
    contentCollapsed: `${$76cf05f628aba256$var$prefix}__content--collapsed`,
    type: (type)=>`${$76cf05f628aba256$var$prefix}__type-${type}`
};
module.exports["expandIconContainerStyle"] = $76cf05f628aba256$export$2e9dabdcf16aeb54;
module.exports["expandClassNames"] = $76cf05f628aba256$export$6ba39aa0ead007b7;

});

parcelRegister("ieXGd", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $b38UX = parcelRequire("b38UX");

const $097d317d23b8bcc9$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$097d317d23b8bcc9$var$getSelectionStyle(selectionStyle)).concat($097d317d23b8bcc9$export$a716852a0c5e54d5).join('\n');
const $097d317d23b8bcc9$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $097d317d23b8bcc9$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $b38UX.SelectionStyle).Border:
            return `
        border: ${0, $aFUXX.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $aFUXX.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $b38UX.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $aFUXX.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $b38UX.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FE)"};`;
        case (0, $b38UX.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $aFUXX.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};
module.exports["getSelectionStyles"] = $097d317d23b8bcc9$export$fb186b651805ffe4;
module.exports["hideNativeBrowserTextSelectionStyles"] = $097d317d23b8bcc9$export$a716852a0c5e54d5;

});

parcelRegister("b38UX", function(module, exports) {
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $5e118ec333d708f7$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});
module.exports["SelectionStyle"] = $5e118ec333d708f7$export$80010201b36a8290;

});

parcelRegister("3ae8F", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $d925B = parcelRequire("d925B");








var $hWRJP = parcelRequire("hWRJP");

class $ea497c7b8855fd08$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}





function $e83111829c538b72$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $e83111829c538b72$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    // Key each fiber by the plugin name carried on the hook function (set by
    // `processPluginsList`). This keeps fibers stable across `reconfigureState`
    // calls that change the plugin set — keying by array index would let React
    // reuse the same fiber for a different `usePluginHook`, which calls a
    // different sequence of hooks (Rules of Hooks violation).
    // Falls back to the array index for any hook that wasn't annotated.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pluginHooks?.map((usePluginHook, index)=>{
        const pluginName = usePluginHook.pluginName;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e83111829c538b72$var$MountPluginHook, {
            // eslint-disable-next-line react/no-array-index-key
            key: pluginName ?? index,
            usePluginHook: usePluginHook,
            editorView: editorView,
            containerElement: containerElement
        });
    }));
}


function $4a2d94567ed6726c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a2d94567ed6726c$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $4a2d94567ed6726c$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ea497c7b8855fd08$export$e926676385687eaf), {
        component: (0, $d925B.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e83111829c538b72$export$a9224552b63e3fe8), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $4a2d94567ed6726c$var$pluginsComponentsWrapper,
        "data-testid": "plugins-components-wrapper"
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, props);
    })));
};
const $4a2d94567ed6726c$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($4a2d94567ed6726c$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
$4a2d94567ed6726c$var$PluginSlotComponent.displayName = 'PluginSlot';
var $4a2d94567ed6726c$export$2e2bcd8739ae039 = $4a2d94567ed6726c$var$PluginSlotComponent;
module.exports["default"] = $4a2d94567ed6726c$export$2e2bcd8739ae039;

});

parcelRegister("4cy2V", function(module, exports) {
const $6c9f12e5c59418a8$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    return {
        components: components ?? editorAPI?.primaryToolbar?.sharedState.currentState()?.components
    };
};
module.exports["getPrimaryToolbarComponents"] = $6c9f12e5c59418a8$export$f454e86f6cef71f4;

});

parcelRegister("1xxAs", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eTj7Y = parcelRequire("eTj7Y");


var $zMjD6 = parcelRequire("zMjD6");


var $iu6m9 = parcelRequire("iu6m9");


var $4JDbp = parcelRequire("4JDbp");


var $geLSP = parcelRequire("geLSP");





var $dh538 = parcelRequire("dh538");

const $3aec2ffe9f521610$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!skip && ref.current && !(0, $dh538.fg)('platform_editor_prevent_toolbar_width_reflow')) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};



var $eUp7e = parcelRequire("eUp7e");










// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $bd42a2364528a44b$var$toolbarSizesFullPageNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizesFullPage = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizes = [
    {
        width: (0, $zMjD6.ToolbarWidths).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidths).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidths).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesForAppearance = (appearance)=>(0, $geLSP.isFullPage)(appearance) ? (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesFullPageNext : $bd42a2364528a44b$var$toolbarSizesFullPage : (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesNext : $bd42a2364528a44b$var$toolbarSizes;
const $bd42a2364528a44b$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $zMjD6.ToolbarWidths).S
    }).width;
};
const $bd42a2364528a44b$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $zMjD6.ToolbarSize).XXXS
    }).size;
};


function $4b0c8fc583dabeb9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b0c8fc583dabeb9$var$toolbar = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $4b0c8fc583dabeb9$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const elementWidth = (0, $3aec2ffe9f521610$export$1217913212f99c7)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $eTj7Y.isSSR)() && (0, $geLSP.isFullPage)(props.appearance) ? (0, $zMjD6.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $bd42a2364528a44b$export$886398ab6922a80f)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $42omo.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $geLSP.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $zMjD6.ToolbarSize).S : (0, $zMjD6.ToolbarSize).M;
            return `${(0, $bd42a2364528a44b$export$df8e48f984163082)(toolbarWidth, props.appearance)}px`;
        } else {
            const isPreviewPanelResponsivenessEnabled = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            });
            return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
        }
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $4b0c8fc583dabeb9$var$toolbar,
        style: {
            minWidth: minWidthValue
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4JDbp.default), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eUp7e.Toolbar), {
        toolbarSize: toolbarSize,
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: props.twoLineEditorToolbar
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref
    }));
};
module.exports["ToolbarWithSizeDetector"] = $4b0c8fc583dabeb9$export$6bb21858343ac39d;

});

parcelRegister("eUp7e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $gzUv9 = parcelRequire("gzUv9");

var $biAkr = parcelRequire("biAkr");


var $zMjD6 = parcelRequire("zMjD6");


var $91bcx = parcelRequire("91bcx");


var $kDB94 = parcelRequire("kDB94");

var $6UWPx = parcelRequire("6UWPx");

var $48SU7 = parcelRequire("48SU7");


var $cf8NL = parcelRequire("cf8NL");


var $1oCLl = parcelRequire("1oCLl");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $a4TK8 = parcelRequire("a4TK8");


var $eTj7Y = parcelRequire("eTj7Y");


var $aFUXX = parcelRequire("aFUXX");

const $85ca23d15eecf4ef$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $85ca23d15eecf4ef$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $eTj7Y.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $85ca23d15eecf4ef$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, {
                key: key
            });
        }));
    }
}


const $ba8f28fe8c9d2747$var$TOOLBAR_FALLBACKS = {
    group: (0, $kDB94.ToolbarButtonGroup),
    section: (0, $48SU7.ToolbarSection),
    menuSection: (0, $6UWPx.ToolbarDropdownItemSection)
};
const $ba8f28fe8c9d2747$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85ca23d15eecf4ef$export$7c77e89663c6a665), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $zMjD6.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};
const $ba8f28fe8c9d2747$var$usePluginState = (api)=>{
    return (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'editorViewMode',
        'userPreferences'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorViewMode: state.editorViewModeState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition
        };
    });
};
const $ba8f28fe8c9d2747$export$1606f8c5fd0ac145 = ({ toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled })=>{
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $ba8f28fe8c9d2747$var$usePluginState(editorAPI);
    // remove offline check when patch6Enabled is cleaned up
    const isOffline = (0, $91bcx.isOfflineMode)(connectivityStateMode);
    const memoizedFireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        editorAPI?.analytics?.actions.fireAnalyticsEvent(payload);
    }, [
        editorAPI
    ]);
    const fireAnalyticsEvent = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedFireAnalyticsEvent : (payload)=>memoizedFireAnalyticsEvent(payload);
    const fallbacks = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $ba8f28fe8c9d2747$var$TOOLBAR_FALLBACKS : {
        group: (0, $kDB94.ToolbarButtonGroup),
        section: (0, $48SU7.ToolbarSection),
        menuSection: (0, $6UWPx.ToolbarDropdownItemSection)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gzUv9.EditorToolbarProvider), {
        editorView: editorView ?? null,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode ?? 'edit',
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biAkr.EditorToolbarUIProvider), {
        api: editorAPI,
        isDisabled: isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf8NL.ToolbarModelRenderer), {
        toolbar: toolbar,
        components: components,
        fallbacks: fallbacks
    })));
};
module.exports["Toolbar"] = $ba8f28fe8c9d2747$export$4c260019440d418f;
module.exports["ToolbarNext"] = $ba8f28fe8c9d2747$export$1606f8c5fd0ac145;

});

parcelRegister("gzUv9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");

const $0cf4befb56ebc307$var$EditorToolbarContext = /*#__PURE__*/ (0, $42omo.createContext)({
    editorView: null,
    editorAppearance: undefined,
    editorViewMode: undefined,
    editorToolbarDockingPreference: undefined
});
const $0cf4befb56ebc307$export$d463571cb9040a24 = ()=>{
    const context = (0, $42omo.useContext)($0cf4befb56ebc307$var$EditorToolbarContext);
    if (!context) throw new Error('useEditorToolbar must be used within EditorToolbarContext');
    return context;
};
const $0cf4befb56ebc307$export$847624ff5ecdfe6d = ({ children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        }), [
        editorView,
        editorAppearance,
        editorViewMode,
        editorToolbarDockingPreference,
        isOffline
    ]);
    const contextValue = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedValue : {
        editorView: editorView,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0cf4befb56ebc307$var$EditorToolbarContext.Provider, {
        value: contextValue
    }, children);
};
module.exports["useEditorToolbar"] = $0cf4befb56ebc307$export$d463571cb9040a24;
module.exports["EditorToolbarProvider"] = $0cf4befb56ebc307$export$847624ff5ecdfe6d;

});

parcelRegister("biAkr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $f5cc64b6f3991f95$export$54b6b74e939729c = ({ children: children, api: api, isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    const onDropdownOpenChanged = (0, $42omo.useCallback)(({ isOpen: isOpen, event: event })=>{
        if (!isOpen) {
            // Only refocus the editor when the dropdown closes via mouse or programmatic close.
            // When closed via keyboard Escape, keep focus on the trigger for better keyboard UX.
            const isKeyboardEscape = event instanceof KeyboardEvent && event.key === 'Escape';
            const shouldFocusEditor = !isKeyboardEscape;
            if (shouldFocusEditor) // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
            // Hence, `.focus()` should also be called in requestAnimationFrame
            setTimeout(()=>requestAnimationFrame(()=>{
                    api?.core.actions.focus({
                        scrollIntoView: false
                    });
                }), 1);
        }
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hoW2.ToolbarUIProvider), {
        onDropdownOpenChanged: onDropdownOpenChanged,
        preventDefaultOnMouseDown: true,
        isDisabled: isDisabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent,
        keyboardNavigation: keyboardNavigation
    }, children);
};
module.exports["EditorToolbarUIProvider"] = $f5cc64b6f3991f95$export$54b6b74e939729c;

});

parcelRegister("91bcx", function(module, exports) {
const $c002f590834c9ab4$export$a73e10b357da8876 = (mode)=>{
    return mode === 'offline' || mode === 'collab-offline' || mode === 'internet-offline';
};
module.exports["isOfflineMode"] = $c002f590834c9ab4$export$a73e10b357da8876;

});

parcelRegister("cf8NL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");

const $8c4aad5c55711194$export$671f8dfe06a9af10 = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $8c4aad5c55711194$export$7fc4381d95dc76c8 = (props)=>null;
const $8c4aad5c55711194$export$fc1acc9190910d14 = (component)=>{
    return component.type === 'section';
};


const $0f156ffd6dbbb817$var$hasParents = (component)=>{
    return component.type !== 'toolbar';
};
const $0f156ffd6dbbb817$var$getChildTypesForParent = (parentType)=>{
    switch(parentType){
        case 'toolbar':
            return [
                'section'
            ];
        case 'section':
            return [
                'group'
            ];
        case 'group':
            return [
                'button',
                'menu'
            ];
        case 'menu':
        case 'nested-menu':
            return [
                'menu-section'
            ];
        case 'menu-section':
            return [
                'menu-item',
                'nested-menu'
            ];
        default:
            return [];
    }
};
const $0f156ffd6dbbb817$var$getFallbackComponent = (type, fallbacks)=>{
    switch(type){
        case 'group':
            return fallbacks.group;
        case 'menu-section':
            return fallbacks.menuSection;
        case 'section':
            return fallbacks.section;
        default:
            return 0, $8c4aad5c55711194$export$7fc4381d95dc76c8;
    }
};
const $0f156ffd6dbbb817$var$hasMenuItems = (menuSections, allComponents)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>{
            return component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key) && (!('isHidden' in component) || !component.isHidden?.());
        });
    });
    return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key));
    });
};
const $0f156ffd6dbbb817$var$shouldHideEmptyComponent = (component, children, allComponents)=>{
    if (component.type === 'menu') {
        const menuSections = children.filter((child)=>child.type === 'menu-section');
        return menuSections.length === 0 || !$0f156ffd6dbbb817$var$hasMenuItems(menuSections, allComponents);
    }
    if (component.type === 'group' || component.type === 'nested-menu' || component.type === 'menu-section') return children.length === 0;
    return false;
};
const $0f156ffd6dbbb817$var$ComponentRenderer = ({ component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks })=>{
    const childTypes = $0f156ffd6dbbb817$var$getChildTypesForParent(component.type);
    const children = (0, $8c4aad5c55711194$export$671f8dfe06a9af10)(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
    if ($0f156ffd6dbbb817$var$shouldHideEmptyComponent(component, children, allComponents)) return null;
    const Component = component.component || $0f156ffd6dbbb817$var$getFallbackComponent(component.type, fallbacks);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (children.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        parents: parents
    }, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        parents: parents
    }, children.map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0f156ffd6dbbb817$var$ComponentRenderer, {
            key: child.key,
            component: child,
            parents: newParents,
            allComponents: allComponents,
            fallbacks: fallbacks
        })));
};
const $0f156ffd6dbbb817$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const ToolbarComponent = toolbar.component || (0, $8c4aad5c55711194$export$7fc4381d95dc76c8);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const sections = (0, $8c4aad5c55711194$export$671f8dfe06a9af10)(components.filter((0, $8c4aad5c55711194$export$fc1acc9190910d14)), toolbar.key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToolbarComponent, null, sections.map((section)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0f156ffd6dbbb817$var$ComponentRenderer, {
            key: section.key,
            component: section,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            parents: [
                {
                    key: toolbar.key,
                    type: toolbar.type
                }
            ],
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            allComponents: components.filter($0f156ffd6dbbb817$var$hasParents),
            fallbacks: fallbacks
        })));
};
module.exports["ToolbarModelRenderer"] = $0f156ffd6dbbb817$export$9ceb2742df82af54;

});

parcelRegister("cPCP8", function(module, exports) {
const $a7f594e2fbd530f1$export$cc1c18c6e6b6ecaf = {
    INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
    PRIMARY_TOOLBAR: 'primary-toolbar'
};
const $a7f594e2fbd530f1$export$78ec0124ca63fa02 = {
    key: 'ai-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$124d2ee606ccdfdc = {
    key: 'ai-view-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$6d5407fbb0bc912e = {
    key: 'ai-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$ea53d97c37cdede3 = {
    key: 'ai-section-full-page-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dcbeb7730f347566 = {
    key: 'ai-section-comment-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$ab61657fb37116be = {
    key: 'rovo-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b0e50b17917e2523 = {
    key: 'rovo-group-view',
    type: 'group'
};
const $a7f594e2fbd530f1$export$67ae7e5d398cd98 = {
    key: 'rovo-group-primary-toolbar',
    type: 'group'
};
const $a7f594e2fbd530f1$export$393a27a1587c4748 = {
    key: 'rovo-group-display-small',
    type: 'group'
};
const $a7f594e2fbd530f1$export$164a0130b2b649c6 = {
    key: 'improve-writing-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e7c291289ee98d9 = {
    key: 'improve-writing-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$50fb6fd780a8da5a = {
    key: 'hero-prompt-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6ea8ae73b826b63e = {
    key: 'hero-prompt-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$3d823cd1493e8383 = {
    key: 'rovo-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$bc3c6b8bbdf543d6 = {
    key: 'rovo-write-button-primary-toolbar',
    type: 'button'
};
const $a7f594e2fbd530f1$export$4532eefb6fdb660c = {
    key: 'rovo-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$245b51779748026d = {
    key: 'rovo-menu-display-small',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$f157764a2d8d74e6 = {
    key: 'rovo-prompt-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$8be015e65f184637 = {
    key: 'rovo-prompt-menu-section-display-small',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$c9c5b3ece9aa9724 = {
    key: 'improve-writing-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1ede5932cecaa59 = {
    key: 'hero-prompt-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4799f439258ea378 = {
    key: 'make-shorter-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$b82c17edba0c6a9e = {
    key: 'make-longer-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1356bd5d76f7fc4 = {
    key: 'change-tone-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$ba297ac76e077190 = {
    key: 'spelling-and-grammar-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$86a7882cf39bf1df = {
    key: 'change-tone-default-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$d868febccc6870c7 = {
    key: 'more-professional-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4a7c57dd33fc4a14 = {
    key: 'more-casual-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$3758b89123aa4456 = {
    key: 'more-empathetic-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$76118e0d25ac1fef = {
    key: 'translate-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$a526b8293dafd11c = {
    key: 'translate-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$5836877aa3028c9d = {
    key: 'define-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$92f779590a87713f = {
    key: 'define-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$8bfe594eeaed8635 = {
    key: 'define-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8d0a77a358b8b557 = {
    key: 'add-polish-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$b60b22005cb1946b = {
    key: 'ai-suggestions-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3c6ba64af5b24c36 = {
    key: 'ai-suggestions-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$46f6ca06869869c = {
    key: 'text-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$9821adc8accbec40 = {
    key: 'text-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$65db33ca2d38a784 = {
    key: 'text-section-collapsed',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dbb8e55d66b9ce7c = {
    key: 'text-collapsed-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$50e256f5fa0723b1 = {
    key: 'text-collapsed-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$17de14a70389be62 = {
    key: 'text-styles-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e3c7868e9e7f30f = {
    key: 'text-styles-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$61c471f0e406c6cd = {
    key: 'text-styles-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$a0d395bab4f77bed = {
    key: 'normal-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$e01e7ae5367e3f41 = {
    key: 'small-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$2469e8506da598d3 = {
    key: 'heading-1-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$a065aede28a4fa60 = {
    key: 'heading-2-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$85070b7c6d42e3bb = {
    key: 'heading-3-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$e78c2531f67b545f = {
    key: 'heading-4-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$a92294de346392be = {
    key: 'heading-5-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9c3cdc8e6d51ce82 = {
    key: 'heading-6-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$f4b89f87980eb537 = {
    key: 'block-quote-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$acdcd8bfebadff8e = {
    key: 'text-formatting-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3efe78988280adb3 = {
    key: 'text-formatting-group-collapsed',
    type: 'group'
};
const $a7f594e2fbd530f1$export$d709b777a6a93241 = {
    key: 'text-formatting-group-inline',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e54b89ebe974229a = {
    key: 'bold-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$eb8680bccd13ec29 = {
    key: 'underline-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b1308631b6ed4b3 = {
    key: 'text-formatting-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$1f2df85e05c78a28 = {
    key: 'text-formatting-hero-button-collapsed',
    type: 'button'
};
const $a7f594e2fbd530f1$export$512cce888b603a21 = {
    key: 'bold-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8ba429f81350a9a5 = {
    key: 'underline-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6ed8e5719ec9c8ca = {
    key: 'text-formatting-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$8bc14fdbfc88e3d = {
    key: 'bold-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$55cababf49d70434 = {
    key: 'italic-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$74aa4c917d0fb179 = {
    key: 'underline-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9caef6162846aa5f = {
    key: 'strike-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$33821ea6eceb9d13 = {
    key: 'code-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$ee8cb7d7ef764bfe = {
    key: 'subscript-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$85ead1ec02f87839 = {
    key: 'superscript-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$6f16936b77c05f44 = {
    key: 'text-formatting-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$2d7a9246359565f = {
    key: 'clear-formatting-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$2577e452f5468087 = {
    key: 'clear-formatting-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$eb99509879c4d1a6 = {
    key: 'text-color-highlight-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$126ef012ef4d8c5f = {
    key: 'text-color-highlight-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$70638f1e77085913 = {
    key: 'text-color-highlight-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$ebd1271b08f151b0 = {
    key: 'text-color-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$bae2fe42c2b86102 = {
    key: 'highlight-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$267f9526bd36c2c = {
    key: 'clear-color-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$36cf1d476157a47d = {
    key: 'alignment-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b9d75d8ec913c411 = {
    key: 'alignment-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$a7d30f7c1c00dd6e = {
    key: 'alignment-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$fb5e83c02abc1116 = {
    key: 'align-left-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$920b9c1f02074883 = {
    key: 'align-center-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$77c582b2c8fa437c = {
    key: 'align-right-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$cfa2bcff371b7719 = {
    key: 'lists-indentation-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$e24e846ad969dbb4 = {
    key: 'lists-indentation-group-collapsed',
    type: 'group'
};
const $a7f594e2fbd530f1$export$18e3c58ea662f7ad = {
    key: 'lists-indentation-group-inline',
    type: 'group'
};
const $a7f594e2fbd530f1$export$93963c53c29fc835 = {
    key: 'bullet-list-button-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6c8387a14e0128fe = {
    key: 'bullet-list-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f625e29dbd38e447 = {
    key: 'lists-indentation-hero-button-collapsed',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8709d937e93456c5 = {
    key: 'lists-indentation-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$77b7fc28d250a53f = {
    key: 'lists-indentation-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$21a99ac537934e71 = {
    key: 'lists-indendation-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$fc39a5dc74747fed = {
    key: 'bullet-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$9d64032e4ea1097c = {
    key: 'numbered-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$d6bac99c24b8cdfd = {
    key: 'task-list-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$87678574248a0249 = {
    key: 'indent-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$8fc4080aa2f8adc2 = {
    key: 'outdent-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$8be58f85d6f2b208 = {
    key: 'insert-block-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$a55d93db15cde50c = {
    key: 'code-block-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$22d0f50f2ec2f1a8 = {
    key: 'code-block-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6265c903e79c43eb = {
    key: 'task-list-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$9634f504f88ede38 = {
    key: 'task-list-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$ce4671f9066f5c48 = {
    key: 'media-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$37025ad4bfe1d2aa = {
    key: 'media-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f4c921ea7ce3d48a = {
    key: 'mention-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$450b9a588cdf3949 = {
    key: 'mention-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$6ca7976638436c6 = {
    key: 'emoji-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$a4310034b096a4ad = {
    key: 'emoji-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$f746b10bd135ebe5 = {
    key: 'layout-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$bc099bce567fd020 = {
    key: 'layout-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$19b0175d8da45496 = {
    key: 'table-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$c37ae5d099679682 = {
    key: 'table-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$c796ec87818935d5 = {
    key: 'table-size-picker',
    type: 'button'
};
const $a7f594e2fbd530f1$export$2db6abe323bf312e = {
    key: 'insert-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$2b79c1387bf4ea1b = {
    key: 'insert-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$1fc1401e9e5d8a = {
    key: 'linking-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$87f2f2ff3eb62f79 = {
    key: 'linking-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$3d214445dcf942f2 = {
    key: 'linking-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8d13eb2ec1e19466 = {
    key: 'synced-block-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f7a124e17ae9698f = {
    key: 'synced-block-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$796e931612f154e7 = {
    key: 'synced-block-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$457818231baddd40 = {
    key: 'collab-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$8978fe8e689744cc = {
    key: 'comment-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f97beb46382b3388 = {
    key: 'comment-hero-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$d757fc54a1831d82 = {
    key: 'apps-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$c3f44bc1025dceb2 = {
    key: 'track-changes-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$b3d4f2cdc057cba1 = {
    key: 'undo-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$f13c32a4c68c0806 = {
    key: 'undo-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$e149a5154bb9b44 = {
    key: 'redo-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$1fb249ec6ca34dd0 = {
    key: 'redo-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$8e3cd3ec14c6efc = {
    key: 'track-changes-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$9cfd2622f07061e0 = {
    key: 'track-changes-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$cb18e5ae740a3f22 = {
    key: 'overflow-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$932f82408ad2af53 = {
    key: 'overflow-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$6583eb3a2765795b = {
    key: 'overflow-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$cefae60670d357d0 = {
    key: 'pin-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$76d22fa71bc28346 = {
    key: 'pin-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$1b5ea0d5074f7d18 = {
    key: 'overflow-section-primary-toolbar',
    type: 'section'
};
const $a7f594e2fbd530f1$export$a481b12c04259be8 = {
    key: 'overflow-group-primary-toolbar',
    type: 'group'
};
const $a7f594e2fbd530f1$export$b0bb124d5687709e = {
    key: 'overflow-menu-primary-toolbar',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$6d497f3df1049a22 = {
    key: 'pin-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$762436e7516a2365 = {
    key: 'pin-group',
    type: 'group'
};
const $a7f594e2fbd530f1$export$cfefbb6355b14379 = {
    key: 'pin-button',
    type: 'button'
};
const $a7f594e2fbd530f1$export$68f7a2de17e9e39d = {
    key: 'view-mode-toggle-section',
    type: 'section'
};
const $a7f594e2fbd530f1$export$dd76f40d6548a654 = {
    key: 'loom-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$4ac3fd1884a40118 = {
    key: 'loom-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$debff7788300c3ff = {
    key: 'selection-extension-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$3752412f1cf2bc0e = {
    key: 'overflow-extensions-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$41bea16b66da911 = {
    key: 'first-party-extensions-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4b664282d7b95d2c = {
    key: 'external-extensions-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$b4e8aaf730259f83 = {
    key: 'paste-menu',
    type: 'menu'
};
const $a7f594e2fbd530f1$export$76da35b5d1c35bbe = {
    key: 'paste-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$5646e8ff118a2c3f = {
    key: 'paste-nested-menu',
    type: 'nested-menu'
};
const $a7f594e2fbd530f1$export$4a6eb83eeeb712a = {
    key: 'paste-menu-nested-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$7528e3cffa17b456 = {
    key: 'rich-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$d10c0f4ac46a1253 = {
    key: 'markdown-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$ef2727de8c063819 = {
    key: 'plain-text-menu-item',
    type: 'menu-item'
};
const $a7f594e2fbd530f1$export$4d6ba29b72804f46 = {
    key: 'ai-paste-menu-section',
    type: 'menu-section'
};
const $a7f594e2fbd530f1$export$7897566b2299aaf5 = {
    INSERT: 'editor-toolbar-insert-button',
    EMOJI: 'editor-toolbar-emoji-button',
    IMAGE: 'editor-toolbar-image-button',
    MEDIA: 'editor-toolbar-media-button',
    TABLE: 'Table',
    TABLE_SELECTOR: 'editor-toolbar-table-selector-button',
    MENTION: 'editor-toolbar-mention-button',
    LAYOUT: 'editor-toolbar-layout-button',
    TASK_LIST: 'editor-toolbar-task-list-button'
};
module.exports["TOOLBARS"] = $a7f594e2fbd530f1$export$cc1c18c6e6b6ecaf;
module.exports["AI_SECTION"] = $a7f594e2fbd530f1$export$78ec0124ca63fa02;
module.exports["AI_VIEW_SECTION"] = $a7f594e2fbd530f1$export$124d2ee606ccdfdc;
module.exports["AI_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$6d5407fbb0bc912e;
module.exports["AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$ea53d97c37cdede3;
module.exports["AI_SECTION_COMMENT_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$dcbeb7730f347566;
module.exports["ROVO_GROUP"] = $a7f594e2fbd530f1$export$ab61657fb37116be;
module.exports["ROVO_GROUP_VIEW"] = $a7f594e2fbd530f1$export$b0e50b17917e2523;
module.exports["ROVO_GROUP_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$67ae7e5d398cd98;
module.exports["ROVO_GROUP_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$393a27a1587c4748;
module.exports["IMPROVE_WRITING_GROUP"] = $a7f594e2fbd530f1$export$164a0130b2b649c6;
module.exports["IMPROVE_WRITING_BUTTON"] = $a7f594e2fbd530f1$export$e7c291289ee98d9;
module.exports["HERO_PROMPT_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$50fb6fd780a8da5a;
module.exports["HERO_PROMPT_BUTTON"] = $a7f594e2fbd530f1$export$6ea8ae73b826b63e;
module.exports["ROVO_HERO_BUTTON"] = $a7f594e2fbd530f1$export$3d823cd1493e8383;
module.exports["ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$bc3c6b8bbdf543d6;
module.exports["ROVO_MENU"] = $a7f594e2fbd530f1$export$4532eefb6fdb660c;
module.exports["ROVO_MENU_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$245b51779748026d;
module.exports["ROVO_PROMPT_MENU_SECTION"] = $a7f594e2fbd530f1$export$f157764a2d8d74e6;
module.exports["ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL"] = $a7f594e2fbd530f1$export$8be015e65f184637;
module.exports["IMPROVE_WRITING_MENU_ITEM"] = $a7f594e2fbd530f1$export$c9c5b3ece9aa9724;
module.exports["HERO_PROMPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$1ede5932cecaa59;
module.exports["MAKE_SHORTER_MENU_ITEM"] = $a7f594e2fbd530f1$export$4799f439258ea378;
module.exports["MAKE_LONGER_MENU_ITEM"] = $a7f594e2fbd530f1$export$b82c17edba0c6a9e;
module.exports["CHANGE_TONE_NESTED_MENU"] = $a7f594e2fbd530f1$export$1356bd5d76f7fc4;
module.exports["SPELLING_AND_GRAMMAR_MENU_ITEM"] = $a7f594e2fbd530f1$export$ba297ac76e077190;
module.exports["CHANGE_TONE_MENU_SECTION"] = $a7f594e2fbd530f1$export$86a7882cf39bf1df;
module.exports["MORE_PROFESSIONAL_MENU_ITEM"] = $a7f594e2fbd530f1$export$d868febccc6870c7;
module.exports["MORE_CASUAL_MENU_ITEM"] = $a7f594e2fbd530f1$export$4a7c57dd33fc4a14;
module.exports["MORE_EMPATHETIC_MENU_ITEM"] = $a7f594e2fbd530f1$export$3758b89123aa4456;
module.exports["TRANSLATE_NESTED_MENU"] = $a7f594e2fbd530f1$export$76118e0d25ac1fef;
module.exports["TRANSLATE_MENU_SECTION"] = $a7f594e2fbd530f1$export$a526b8293dafd11c;
module.exports["DEFINE_MENU_ITEM"] = $a7f594e2fbd530f1$export$5836877aa3028c9d;
module.exports["DEFINE_GROUP"] = $a7f594e2fbd530f1$export$92f779590a87713f;
module.exports["DEFINE_BUTTON"] = $a7f594e2fbd530f1$export$8bfe594eeaed8635;
module.exports["ADD_POLISH_MENU_ITEM"] = $a7f594e2fbd530f1$export$8d0a77a358b8b557;
module.exports["AI_SUGGESTIONS_GROUP"] = $a7f594e2fbd530f1$export$b60b22005cb1946b;
module.exports["AI_SUGGESTIONS_BUTTON"] = $a7f594e2fbd530f1$export$3c6ba64af5b24c36;
module.exports["TEXT_SECTION"] = $a7f594e2fbd530f1$export$46f6ca06869869c;
module.exports["TEXT_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$9821adc8accbec40;
module.exports["TEXT_SECTION_COLLAPSED"] = $a7f594e2fbd530f1$export$65db33ca2d38a784;
module.exports["TEXT_COLLAPSED_GROUP"] = $a7f594e2fbd530f1$export$dbb8e55d66b9ce7c;
module.exports["TEXT_COLLAPSED_MENU"] = $a7f594e2fbd530f1$export$50e256f5fa0723b1;
module.exports["TEXT_STYLES_GROUP"] = $a7f594e2fbd530f1$export$17de14a70389be62;
module.exports["TEXT_STYLES_MENU"] = $a7f594e2fbd530f1$export$e3c7868e9e7f30f;
module.exports["TEXT_STYLES_MENU_SECTION"] = $a7f594e2fbd530f1$export$61c471f0e406c6cd;
module.exports["NORMAL_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$a0d395bab4f77bed;
module.exports["SMALL_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$e01e7ae5367e3f41;
module.exports["HEADING_1_MENU_ITEM"] = $a7f594e2fbd530f1$export$2469e8506da598d3;
module.exports["HEADING_2_MENU_ITEM"] = $a7f594e2fbd530f1$export$a065aede28a4fa60;
module.exports["HEADING_3_MENU_ITEM"] = $a7f594e2fbd530f1$export$85070b7c6d42e3bb;
module.exports["HEADING_4_MENU_ITEM"] = $a7f594e2fbd530f1$export$e78c2531f67b545f;
module.exports["HEADING_5_MENU_ITEM"] = $a7f594e2fbd530f1$export$a92294de346392be;
module.exports["HEADING_6_MENU_ITEM"] = $a7f594e2fbd530f1$export$9c3cdc8e6d51ce82;
module.exports["BLOCK_QUOTE_MENU_ITEM"] = $a7f594e2fbd530f1$export$f4b89f87980eb537;
module.exports["TEXT_FORMATTING_GROUP"] = $a7f594e2fbd530f1$export$acdcd8bfebadff8e;
module.exports["TEXT_FORMATTING_GROUP_COLLAPSED"] = $a7f594e2fbd530f1$export$3efe78988280adb3;
module.exports["TEXT_FORMATTING_GROUP_INLINE"] = $a7f594e2fbd530f1$export$d709b777a6a93241;
module.exports["BOLD_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$e54b89ebe974229a;
module.exports["UNDERLINE_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$eb8680bccd13ec29;
module.exports["TEXT_FORMATTING_HERO_BUTTON"] = $a7f594e2fbd530f1$export$b1308631b6ed4b3;
module.exports["TEXT_FORMATTING_HERO_BUTTON_COLLAPSED"] = $a7f594e2fbd530f1$export$1f2df85e05c78a28;
module.exports["BOLD_BUTTON"] = $a7f594e2fbd530f1$export$512cce888b603a21;
module.exports["UNDERLINE_BUTTON"] = $a7f594e2fbd530f1$export$8ba429f81350a9a5;
module.exports["TEXT_FORMATTING_MENU"] = $a7f594e2fbd530f1$export$6ed8e5719ec9c8ca;
module.exports["BOLD_MENU_ITEM"] = $a7f594e2fbd530f1$export$8bc14fdbfc88e3d;
module.exports["ITALIC_MENU_ITEM"] = $a7f594e2fbd530f1$export$55cababf49d70434;
module.exports["UNDERLINE_MENU_ITEM"] = $a7f594e2fbd530f1$export$74aa4c917d0fb179;
module.exports["STRIKE_MENU_ITEM"] = $a7f594e2fbd530f1$export$9caef6162846aa5f;
module.exports["CODE_MENU_ITEM"] = $a7f594e2fbd530f1$export$33821ea6eceb9d13;
module.exports["SUBSCRIPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$ee8cb7d7ef764bfe;
module.exports["SUPERSCRIPT_MENU_ITEM"] = $a7f594e2fbd530f1$export$85ead1ec02f87839;
module.exports["TEXT_FORMATTING_MENU_SECTION"] = $a7f594e2fbd530f1$export$6f16936b77c05f44;
module.exports["CLEAR_FORMARTTING_MENU_SECTION"] = $a7f594e2fbd530f1$export$2d7a9246359565f;
module.exports["CLEAR_FORMATTING_MENU_ITEM"] = $a7f594e2fbd530f1$export$2577e452f5468087;
module.exports["TEXT_COLOR_HIGHLIGHT_GROUP"] = $a7f594e2fbd530f1$export$eb99509879c4d1a6;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU"] = $a7f594e2fbd530f1$export$126ef012ef4d8c5f;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_SECTION"] = $a7f594e2fbd530f1$export$70638f1e77085913;
module.exports["TEXT_COLOR_MENU_ITEM"] = $a7f594e2fbd530f1$export$ebd1271b08f151b0;
module.exports["HIGHLIGHT_MENU_ITEM"] = $a7f594e2fbd530f1$export$bae2fe42c2b86102;
module.exports["CLEAR_COLOR_MENU_ITEM"] = $a7f594e2fbd530f1$export$267f9526bd36c2c;
module.exports["ALIGNMENT_GROUP"] = $a7f594e2fbd530f1$export$36cf1d476157a47d;
module.exports["ALIGNMENT_MENU"] = $a7f594e2fbd530f1$export$b9d75d8ec913c411;
module.exports["ALIGNMENT_MENU_SECTION"] = $a7f594e2fbd530f1$export$a7d30f7c1c00dd6e;
module.exports["ALIGN_LEFT_MENU_ITEM"] = $a7f594e2fbd530f1$export$fb5e83c02abc1116;
module.exports["ALIGN_CENTER_MENU_ITEM"] = $a7f594e2fbd530f1$export$920b9c1f02074883;
module.exports["ALIGN_RIGHT_MENU_ITEM"] = $a7f594e2fbd530f1$export$77c582b2c8fa437c;
module.exports["LISTS_INDENTATION_GROUP"] = $a7f594e2fbd530f1$export$cfa2bcff371b7719;
module.exports["LISTS_INDENTATION_GROUP_COLLAPSED"] = $a7f594e2fbd530f1$export$e24e846ad969dbb4;
module.exports["LISTS_INDENTATION_GROUP_INLINE"] = $a7f594e2fbd530f1$export$18e3c58ea662f7ad;
module.exports["BULLETED_LIST_BUTTON_GROUP"] = $a7f594e2fbd530f1$export$93963c53c29fc835;
module.exports["BULLETED_LIST_BUTTON"] = $a7f594e2fbd530f1$export$6c8387a14e0128fe;
module.exports["LISTS_INDENTATION_HERO_BUTTON_COLLAPSED"] = $a7f594e2fbd530f1$export$f625e29dbd38e447;
module.exports["LISTS_INDENTATION_HERO_BUTTON"] = $a7f594e2fbd530f1$export$8709d937e93456c5;
module.exports["LISTS_INDENTATION_MENU"] = $a7f594e2fbd530f1$export$77b7fc28d250a53f;
module.exports["LISTS_INDENTATION_MENU_SECTION"] = $a7f594e2fbd530f1$export$21a99ac537934e71;
module.exports["BULLETED_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$fc39a5dc74747fed;
module.exports["NUMBERED_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$9d64032e4ea1097c;
module.exports["TASK_LIST_MENU_ITEM"] = $a7f594e2fbd530f1$export$d6bac99c24b8cdfd;
module.exports["INDENT_MENU_ITEM"] = $a7f594e2fbd530f1$export$87678574248a0249;
module.exports["OUTDENT_MENU_ITEM"] = $a7f594e2fbd530f1$export$8fc4080aa2f8adc2;
module.exports["INSERT_BLOCK_SECTION"] = $a7f594e2fbd530f1$export$8be58f85d6f2b208;
module.exports["CODE_BLOCK_GROUP"] = $a7f594e2fbd530f1$export$a55d93db15cde50c;
module.exports["CODE_BLOCK_BUTTON"] = $a7f594e2fbd530f1$export$22d0f50f2ec2f1a8;
module.exports["TASK_LIST_GROUP"] = $a7f594e2fbd530f1$export$6265c903e79c43eb;
module.exports["TASK_LIST_BUTTON"] = $a7f594e2fbd530f1$export$9634f504f88ede38;
module.exports["MEDIA_GROUP"] = $a7f594e2fbd530f1$export$ce4671f9066f5c48;
module.exports["MEDIA_BUTTON"] = $a7f594e2fbd530f1$export$37025ad4bfe1d2aa;
module.exports["MENTION_GROUP"] = $a7f594e2fbd530f1$export$f4c921ea7ce3d48a;
module.exports["MENTION_BUTTON"] = $a7f594e2fbd530f1$export$450b9a588cdf3949;
module.exports["EMOJI_GROUP"] = $a7f594e2fbd530f1$export$6ca7976638436c6;
module.exports["EMOJI_BUTTON"] = $a7f594e2fbd530f1$export$a4310034b096a4ad;
module.exports["LAYOUT_GROUP"] = $a7f594e2fbd530f1$export$f746b10bd135ebe5;
module.exports["LAYOUT_BUTTON"] = $a7f594e2fbd530f1$export$bc099bce567fd020;
module.exports["TABLE_GROUP"] = $a7f594e2fbd530f1$export$19b0175d8da45496;
module.exports["TABLE_BUTTON"] = $a7f594e2fbd530f1$export$c37ae5d099679682;
module.exports["TABLE_SIZE_PICKER"] = $a7f594e2fbd530f1$export$c796ec87818935d5;
module.exports["INSERT_GROUP"] = $a7f594e2fbd530f1$export$2db6abe323bf312e;
module.exports["INSERT_BUTTON"] = $a7f594e2fbd530f1$export$2b79c1387bf4ea1b;
module.exports["LINKING_SECTION"] = $a7f594e2fbd530f1$export$1fc1401e9e5d8a;
module.exports["LINKING_GROUP"] = $a7f594e2fbd530f1$export$87f2f2ff3eb62f79;
module.exports["LINKING_BUTTON"] = $a7f594e2fbd530f1$export$3d214445dcf942f2;
module.exports["SYNCED_BLOCK_GROUP"] = $a7f594e2fbd530f1$export$8d13eb2ec1e19466;
module.exports["SYNCED_BLOCK_BUTTON"] = $a7f594e2fbd530f1$export$f7a124e17ae9698f;
module.exports["SYNCED_BLOCK_SECTION"] = $a7f594e2fbd530f1$export$796e931612f154e7;
module.exports["COLLAB_SECTION"] = $a7f594e2fbd530f1$export$457818231baddd40;
module.exports["COMMENT_GROUP"] = $a7f594e2fbd530f1$export$8978fe8e689744cc;
module.exports["COMMENT_HERO_BUTTON"] = $a7f594e2fbd530f1$export$f97beb46382b3388;
module.exports["APPS_SECTION"] = $a7f594e2fbd530f1$export$d757fc54a1831d82;
module.exports["TRACK_CHANGES_SECTION"] = $a7f594e2fbd530f1$export$c3f44bc1025dceb2;
module.exports["UNDO_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$b3d4f2cdc057cba1;
module.exports["UNDO_BUTTON"] = $a7f594e2fbd530f1$export$f13c32a4c68c0806;
module.exports["REDO_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$e149a5154bb9b44;
module.exports["REDO_BUTTON"] = $a7f594e2fbd530f1$export$1fb249ec6ca34dd0;
module.exports["TRACK_CHANGES_GROUP"] = $a7f594e2fbd530f1$export$8e3cd3ec14c6efc;
module.exports["TRACK_CHANGES_BUTTON"] = $a7f594e2fbd530f1$export$9cfd2622f07061e0;
module.exports["OVERFLOW_SECTION"] = $a7f594e2fbd530f1$export$cb18e5ae740a3f22;
module.exports["OVERFLOW_GROUP"] = $a7f594e2fbd530f1$export$932f82408ad2af53;
module.exports["OVERFLOW_MENU"] = $a7f594e2fbd530f1$export$6583eb3a2765795b;
module.exports["PIN_MENU_SECTION"] = $a7f594e2fbd530f1$export$cefae60670d357d0;
module.exports["PIN_MENU_ITEM"] = $a7f594e2fbd530f1$export$76d22fa71bc28346;
module.exports["OVERFLOW_SECTION_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$1b5ea0d5074f7d18;
module.exports["OVERFLOW_GROUP_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$a481b12c04259be8;
module.exports["OVERFLOW_MENU_PRIMARY_TOOLBAR"] = $a7f594e2fbd530f1$export$b0bb124d5687709e;
module.exports["PIN_SECTION"] = $a7f594e2fbd530f1$export$6d497f3df1049a22;
module.exports["PIN_GROUP"] = $a7f594e2fbd530f1$export$762436e7516a2365;
module.exports["PIN_BUTTON"] = $a7f594e2fbd530f1$export$cfefbb6355b14379;
module.exports["VIEW_MODE_TOGGLE_SECTION"] = $a7f594e2fbd530f1$export$68f7a2de17e9e39d;
module.exports["LOOM_MENU_SECTION"] = $a7f594e2fbd530f1$export$dd76f40d6548a654;
module.exports["LOOM_MENU_ITEM"] = $a7f594e2fbd530f1$export$4ac3fd1884a40118;
module.exports["SELECTION_EXTENSION_MENU_SECTION"] = $a7f594e2fbd530f1$export$debff7788300c3ff;
module.exports["OVERFLOW_EXTENSIONS_MENU_SECTION"] = $a7f594e2fbd530f1$export$3752412f1cf2bc0e;
module.exports["FIRST_PARTY_EXTENSIONS_MENU_ITEM"] = $a7f594e2fbd530f1$export$41bea16b66da911;
module.exports["EXTERNAL_EXTENSIONS_MENU_ITEM"] = $a7f594e2fbd530f1$export$4b664282d7b95d2c;
module.exports["PASTE_MENU"] = $a7f594e2fbd530f1$export$b4e8aaf730259f83;
module.exports["PASTE_MENU_SECTION"] = $a7f594e2fbd530f1$export$76da35b5d1c35bbe;
module.exports["PASTE_NESTED_MENU"] = $a7f594e2fbd530f1$export$5646e8ff118a2c3f;
module.exports["PASTE_MENU_NESTED_SECTION"] = $a7f594e2fbd530f1$export$4a6eb83eeeb712a;
module.exports["PASTE_RICH_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$7528e3cffa17b456;
module.exports["PASTE_MARKDOWN_MENU_ITEM"] = $a7f594e2fbd530f1$export$d10c0f4ac46a1253;
module.exports["PASTE_PLAIN_TEXT_MENU_ITEM"] = $a7f594e2fbd530f1$export$ef2727de8c063819;
module.exports["AI_PASTE_MENU_SECTION"] = $a7f594e2fbd530f1$export$4d6ba29b72804f46;
module.exports["TOOLBAR_BUTTON_TEST_ID"] = $a7f594e2fbd530f1$export$7897566b2299aaf5;

});

parcelRegister("5ZzFz", function(module, exports) {
const $bc040982397de978$export$75279ffd74fef67b = (component)=>{
    return component?.type === 'toolbar';
};
module.exports["isToolbar"] = $bc040982397de978$export$75279ffd74fef67b;

});

parcelRegister("1PKpt", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");


var $uq7dM = parcelRequire("uq7dM");

function $949a60155d5990f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $949a60155d5990f5$var$scrollbarStylesNew = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};
const $949a60155d5990f5$var$chromelessEditorStylesNew = {
    name: "zwat44",
    styles: "line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 8px);}}.ProseMirror{& > p:last-of-type{margin-bottom:var(--ds-space-0, 0px);}}"
};
class $949a60155d5990f5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)($949a60155d5990f5$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args);
        this.appearance = 'chromeless';
        this.containerElement = null;
        this.setContainerElement = (ref)=>{
            this.containerElement = ref;
        };
        this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(this.props.editorAPI, [
                'editorViewMode'
            ], (states)=>states?.editorViewModeState?.mode);
            const containerRef = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? this.setContainerElement : (ref)=>this.containerElement = ref;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $uq7dM.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($949a60155d5990f5$export$5ffd32ebea3773c5, {
                maxHeight: maxHeight,
                minHeight: minHeight,
                containerRef: containerRef
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
$949a60155d5990f5$export$2e2bcd8739ae039.displayName = 'ChromelessEditorAppearance';
function $949a60155d5990f5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    'use no memo';
    // renderChrome should be changed to called as a component not a function
    const maxContentSizeReached = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize'
    ], (states)=>states?.maxContentSizeState?.maxContentSizeReached);
    const maxContentSize = maxContentSizeReached === undefined ? undefined : {
        maxContentSizeReached: maxContentSizeReached
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, renderChrome({
        maxContentSize: maxContentSize
    }));
}
function $949a60155d5990f5$export$5ffd32ebea3773c5({ maxHeight: maxHeight, minHeight: minHeight, children: children, containerRef: containerRef }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $949a60155d5990f5$var$chromelessEditorStylesNew,
            $949a60155d5990f5$var$scrollbarStylesNew
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dh538.fg)('platform_editor_chromeless_akeditor_class') || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true) ? 'akEditor' : undefined,
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        ref: containerRef
    }, children);
}
module.exports["default"] = $949a60155d5990f5$export$2e2bcd8739ae039;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $6mYMS = parcelRequire("6mYMS");

/**
 * @generated SignedSource<<24ebe00000492c7932f135d73afc4d2b>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;



var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $2c3903aefb77a74c$export$2e2bcd8739ae039);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
        variables: {
            ids: ids
        }
    });
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await $ed0e2cb9f5186ade$var$getUserData(ids);
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};


class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $ed0e2cb9f5186ade$export$3adfff745266e959)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}



var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $71c2faaa98a432d0$export$82da878d725997a7)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents ?? false);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("6qdjm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $3597304f6bb24fd4$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $3597304f6bb24fd4$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>plugins, []);
}
function $3597304f6bb24fd4$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $3597304f6bb24fd4$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $42omo.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $3597304f6bb24fd4$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $3597304f6bb24fd4$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $42omo.useRef)();
    const cleanup = (0, $42omo.useRef)();
    const latestEffect = (0, $42omo.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $42omo.useLayoutEffect)(()=>{
        if (options.disabled) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $3597304f6bb24fd4$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}
module.exports["usePluginStateEffect"] = $3597304f6bb24fd4$export$85f3fdc261c569b3;

});

parcelRegister("cQMhV", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => (parcelRequire("9h6tL")).PanelInfoIcon);
$parcel$export(module.exports, "PanelWarningIcon", () => (parcelRequire("7aW37")).PanelWarningIcon);
$parcel$export(module.exports, "PanelErrorIcon", () => (parcelRequire("9f7tI")).PanelErrorIcon);
$parcel$export(module.exports, "PanelSuccessIcon", () => (parcelRequire("5Eiz2")).PanelSuccessIcon);
$parcel$export(module.exports, "PanelNoteIcon", () => (parcelRequire("9jJiA")).PanelNoteIcon);
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => (parcelRequire("c0czl")).DynamicStrokeIconDecoration);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4wH3g = parcelRequire("4wH3g");


var $9h6tL = parcelRequire("9h6tL");


var $7aW37 = parcelRequire("7aW37");


var $9f7tI = parcelRequire("9f7tI");


var $5Eiz2 = parcelRequire("5Eiz2");


var $9jJiA = parcelRequire("9jJiA");




var $c0czl = parcelRequire("c0czl");


const $37f04d4596614e71$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7Wa7q",
    name: "IconTable",
    loader: ()=>(parcelRequire("6KJ6r")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconTable"] = $37f04d4596614e71$export$84f497075f5b07be;

});

parcelRegister("6KJ6r", function(module, exports) {

let $4eaa066d01ba8f30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4eaa066d01ba8f30$var$load("k07ie"),
    $4eaa066d01ba8f30$var$load("cPsVW"),
    $4eaa066d01ba8f30$var$load("7Vmxp")
]).then(()=>parcelRequire('aJWwp'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("iGbqR", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $2e985ae6445cc58f$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? (0, $d925B.ACTION_SUBJECT).HYPERLINK : (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $2e985ae6445cc58f$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $d925B.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $d925B.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $d925B.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $2e985ae6445cc58f$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? $2e985ae6445cc58f$var$buildVisitedHyperLinkPayload() : $2e985ae6445cc58f$export$4c5e2a0406e7eae8(type, (0, $d925B.INPUT_METHOD).TOOLBAR);
};
const $2e985ae6445cc58f$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $d925B.ACTION).VISITED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $2e985ae6445cc58f$export$4c5e2a0406e7eae8 = (type, inputMethod, resolvedAttributes)=>{
    return {
        action: (0, $d925B.ACTION).VISITED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod,
            ...resolvedAttributes && {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            }
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $2e985ae6445cc58f$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
            display: $2e985ae6445cc58f$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $2e985ae6445cc58f$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $d925B.ACTION).UNLINK,
        actionSubject: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? (0, $d925B.ACTION_SUBJECT).HYPERLINK : (0, $d925B.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $d925B.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
module.exports["buildEditLinkPayload"] = $2e985ae6445cc58f$export$7f3c24765adf61f0;
module.exports["buildVisitedLinkPayload"] = $2e985ae6445cc58f$export$e81ec2390acfc152;
module.exports["buildVisitedNonHyperLinkPayload"] = $2e985ae6445cc58f$export$4c5e2a0406e7eae8;
module.exports["buildOpenedSettingsPayload"] = $2e985ae6445cc58f$export$96aa8ae974c8591a;
module.exports["unlinkPayload"] = $2e985ae6445cc58f$export$aab75a08bdd88be4;

});

parcelRegister("bEi27", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $259677dc07a6f27a$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $259677dc07a6f27a$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6xNQX")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $259677dc07a6f27a$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($259677dc07a6f27a$var$LazyAssetsConfigModal, {
            ...props
        })
    });
};
var $259677dc07a6f27a$export$2e2bcd8739ae039 = $259677dc07a6f27a$var$AssetsConfigModalWithWrappers;
module.exports["ASSETS_LIST_OF_LINKS_DATASOURCE_ID"] = $259677dc07a6f27a$export$34a6fbdd67f09ff6;
module.exports["default"] = $259677dc07a6f27a$export$2e2bcd8739ae039;

});

parcelRegister("6xNQX", function(module, exports) {

let $4c3c7ef6fa1bfeb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c3c7ef6fa1bfeb9$var$load("lTK3c"),
    $4c3c7ef6fa1bfeb9$var$load("1WXdc"),
    $4c3c7ef6fa1bfeb9$var$load("k07ie"),
    $4c3c7ef6fa1bfeb9$var$load("cPsVW"),
    $4c3c7ef6fa1bfeb9$var$load("1SgRc"),
    $4c3c7ef6fa1bfeb9$var$load("iivLa"),
    $4c3c7ef6fa1bfeb9$var$load("5pvpJ"),
    $4c3c7ef6fa1bfeb9$var$load("XNe8U"),
    $4c3c7ef6fa1bfeb9$var$load("iNa18"),
    $4c3c7ef6fa1bfeb9$var$load("8makw"),
    $4c3c7ef6fa1bfeb9$var$load("lbhYb"),
    $4c3c7ef6fa1bfeb9$var$load("emINS"),
    $4c3c7ef6fa1bfeb9$var$load("3BYXV"),
    $4c3c7ef6fa1bfeb9$var$load("c251E"),
    $4c3c7ef6fa1bfeb9$var$load("fZvb9"),
    $4c3c7ef6fa1bfeb9$var$load("1w4HF"),
    $4c3c7ef6fa1bfeb9$var$load("gFEtJ"),
    $4c3c7ef6fa1bfeb9$var$load("gT8XU"),
    $4c3c7ef6fa1bfeb9$var$load("3GuOt"),
    $4c3c7ef6fa1bfeb9$var$load("8l20h"),
    $4c3c7ef6fa1bfeb9$var$load("6wr18"),
    $4c3c7ef6fa1bfeb9$var$load("dek7I"),
    $4c3c7ef6fa1bfeb9$var$load("kHOMt"),
    $4c3c7ef6fa1bfeb9$var$load("hhss7"),
    $4c3c7ef6fa1bfeb9$var$load("ffEVr"),
    $4c3c7ef6fa1bfeb9$var$load("eTYdV"),
    $4c3c7ef6fa1bfeb9$var$load("7EorR"),
    $4c3c7ef6fa1bfeb9$var$load("Wowvf"),
    $4c3c7ef6fa1bfeb9$var$load("etEYy"),
    $4c3c7ef6fa1bfeb9$var$load("eSDS8")
]).then(()=>parcelRequire('75SNN'));

});

parcelRegister("16GCc", function(module, exports) {

var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");

var $iB8ko = parcelRequire("iB8ko");


var $dh538 = parcelRequire("dh538");

const $4d17943085b99665$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $4d17943085b99665$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $4d17943085b99665$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $dh538.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};
module.exports["getDatasourceType"] = $4d17943085b99665$export$19af9860957ca153;
module.exports["canRenderDatasource"] = $4d17943085b99665$export$1974047c293dd52e;

});

parcelRegister("jPEjP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $eb530dc3f36406bb$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $eb530dc3f36406bb$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ffUdl")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $eb530dc3f36406bb$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($eb530dc3f36406bb$var$LazyConfluenceSearchConfigModal, {
            ...props
        })
    });
};
var $eb530dc3f36406bb$export$2e2bcd8739ae039 = $eb530dc3f36406bb$var$ConfluenceSearchConfigModalWithWrappers;
module.exports["CONFLUENCE_SEARCH_DATASOURCE_ID"] = $eb530dc3f36406bb$export$d9788d6cf1867282;
module.exports["default"] = $eb530dc3f36406bb$export$2e2bcd8739ae039;

});

parcelRegister("ffUdl", function(module, exports) {

let $b1b3dcaf0f1e4261$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1b3dcaf0f1e4261$var$load("lTK3c"),
    $b1b3dcaf0f1e4261$var$load("1WXdc"),
    $b1b3dcaf0f1e4261$var$load("k07ie"),
    $b1b3dcaf0f1e4261$var$load("cPsVW"),
    $b1b3dcaf0f1e4261$var$load("1SgRc"),
    $b1b3dcaf0f1e4261$var$load("iivLa"),
    $b1b3dcaf0f1e4261$var$load("5YOHm"),
    $b1b3dcaf0f1e4261$var$load("5pvpJ"),
    $b1b3dcaf0f1e4261$var$load("XNe8U"),
    $b1b3dcaf0f1e4261$var$load("cM6bW"),
    $b1b3dcaf0f1e4261$var$load("iNa18"),
    $b1b3dcaf0f1e4261$var$load("8makw"),
    $b1b3dcaf0f1e4261$var$load("lbhYb"),
    $b1b3dcaf0f1e4261$var$load("emINS"),
    $b1b3dcaf0f1e4261$var$load("3BYXV"),
    $b1b3dcaf0f1e4261$var$load("c251E"),
    $b1b3dcaf0f1e4261$var$load("fZvb9"),
    $b1b3dcaf0f1e4261$var$load("1w4HF"),
    $b1b3dcaf0f1e4261$var$load("gFEtJ"),
    $b1b3dcaf0f1e4261$var$load("gT8XU"),
    $b1b3dcaf0f1e4261$var$load("3GuOt"),
    $b1b3dcaf0f1e4261$var$load("8l20h"),
    $b1b3dcaf0f1e4261$var$load("6wr18"),
    $b1b3dcaf0f1e4261$var$load("dek7I"),
    $b1b3dcaf0f1e4261$var$load("kHOMt"),
    $b1b3dcaf0f1e4261$var$load("hhss7"),
    $b1b3dcaf0f1e4261$var$load("ffEVr"),
    $b1b3dcaf0f1e4261$var$load("eTYdV"),
    $b1b3dcaf0f1e4261$var$load("7EorR"),
    $b1b3dcaf0f1e4261$var$load("Wowvf"),
    $b1b3dcaf0f1e4261$var$load("etEYy"),
    $b1b3dcaf0f1e4261$var$load("40QiO")
]).then(()=>parcelRequire('4dMJk'));

});

parcelRegister("iB8ko", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $0a545d08f6a56386$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $0a545d08f6a56386$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("21pjX")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $0a545d08f6a56386$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": 'jira-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($0a545d08f6a56386$var$LazyJiraIssuesConfigModal, {
            ...props
        })
    });
};
var $0a545d08f6a56386$export$2e2bcd8739ae039 = $0a545d08f6a56386$var$JiraIssuesConfigModalWithWrappers;
module.exports["JIRA_LIST_OF_LINKS_DATASOURCE_ID"] = $0a545d08f6a56386$export$8ce19958117ece5c;
module.exports["default"] = $0a545d08f6a56386$export$2e2bcd8739ae039;

});

parcelRegister("21pjX", function(module, exports) {

let $178f50f7de95c185$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $178f50f7de95c185$var$load("lTK3c"),
    $178f50f7de95c185$var$load("1WXdc"),
    $178f50f7de95c185$var$load("fJ9wN"),
    $178f50f7de95c185$var$load("k07ie"),
    $178f50f7de95c185$var$load("cPsVW"),
    $178f50f7de95c185$var$load("elrCw"),
    $178f50f7de95c185$var$load("1SgRc"),
    $178f50f7de95c185$var$load("iivLa"),
    $178f50f7de95c185$var$load("9ijrN"),
    $178f50f7de95c185$var$load("iFEfD"),
    $178f50f7de95c185$var$load("4xzkC"),
    $178f50f7de95c185$var$load("1oAGT"),
    $178f50f7de95c185$var$load("b0mVb"),
    $178f50f7de95c185$var$load("1Qgo1"),
    $178f50f7de95c185$var$load("e4wOQ"),
    $178f50f7de95c185$var$load("gINGQ"),
    $178f50f7de95c185$var$load("5YOHm"),
    $178f50f7de95c185$var$load("5pvpJ"),
    $178f50f7de95c185$var$load("XNe8U"),
    $178f50f7de95c185$var$load("jtcRz"),
    $178f50f7de95c185$var$load("l8LQp"),
    $178f50f7de95c185$var$load("iNa18"),
    $178f50f7de95c185$var$load("8makw"),
    $178f50f7de95c185$var$load("lbhYb"),
    $178f50f7de95c185$var$load("emINS"),
    $178f50f7de95c185$var$load("3BYXV"),
    $178f50f7de95c185$var$load("c251E"),
    $178f50f7de95c185$var$load("fZvb9"),
    $178f50f7de95c185$var$load("1w4HF"),
    $178f50f7de95c185$var$load("1Pok1"),
    $178f50f7de95c185$var$load("gFEtJ"),
    $178f50f7de95c185$var$load("gT8XU"),
    $178f50f7de95c185$var$load("3GuOt"),
    $178f50f7de95c185$var$load("8l20h"),
    $178f50f7de95c185$var$load("6wr18"),
    $178f50f7de95c185$var$load("dek7I"),
    $178f50f7de95c185$var$load("kHOMt"),
    $178f50f7de95c185$var$load("hhss7"),
    $178f50f7de95c185$var$load("ffEVr"),
    $178f50f7de95c185$var$load("eTYdV"),
    $178f50f7de95c185$var$load("7EorR"),
    $178f50f7de95c185$var$load("Wowvf"),
    $178f50f7de95c185$var$load("etEYy"),
    $178f50f7de95c185$var$load("2Aekd")
]).then(()=>parcelRequire('ksmD9'));

});

parcelRegister("astHL", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

/**
Delete the selection, if there is one.
*/ const $79d38fafc7d67c3d$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $79d38fafc7d67c3d$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $aXG5V.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($79d38fafc7d67c3d$var$textblockAt(before, "end") || (0, $ks2lK.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $aXG5V.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $5SAOw.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($79d38fafc7d67c3d$var$textblockAt(before, "end") ? (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $ks2lK.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $79d38fafc7d67c3d$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutBefore($cursor);
    return $cut ? $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $79d38fafc7d67c3d$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutAfter($cursor);
    return $cut ? $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $79d38fafc7d67c3d$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $aXG5V.replaceStep)(state.doc, beforePos, afterPos, (0, $5SAOw.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $aXG5V.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $79d38fafc7d67c3d$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $79d38fafc7d67c3d$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $79d38fafc7d67c3d$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $ks2lK.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $79d38fafc7d67c3d$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $79d38fafc7d67c3d$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $79d38fafc7d67c3d$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $79d38fafc7d67c3d$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($79d38fafc7d67c3d$var$textblockAt(after, "start") || (0, $ks2lK.NodeSelection).isSelectable(after))) {
        let delStep = (0, $aXG5V.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $5SAOw.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($79d38fafc7d67c3d$var$textblockAt(after, "start") ? (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $79d38fafc7d67c3d$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $79d38fafc7d67c3d$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $ks2lK.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $79d38fafc7d67c3d$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $ks2lK.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $aXG5V.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $aXG5V.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $79d38fafc7d67c3d$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $ks2lK.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $aXG5V.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $aXG5V.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $79d38fafc7d67c3d$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $aXG5V.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $79d38fafc7d67c3d$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $79d38fafc7d67c3d$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $79d38fafc7d67c3d$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $79d38fafc7d67c3d$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $79d38fafc7d67c3d$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $ks2lK.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $79d38fafc7d67c3d$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $79d38fafc7d67c3d$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $aXG5V.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $aXG5V.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $79d38fafc7d67c3d$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $aXG5V.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $79d38fafc7d67c3d$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $ks2lK.TextSelection) || state.selection instanceof (0, $ks2lK.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $aXG5V.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $aXG5V.canSplit)(tr.doc, splitPos, types.length, types);
        }
        if (!can) return false;
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $79d38fafc7d67c3d$export$e99155638ff4dff0 = $79d38fafc7d67c3d$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $79d38fafc7d67c3d$export$eeb429476568b72b = (state, dispatch)=>{
    return $79d38fafc7d67c3d$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $79d38fafc7d67c3d$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $79d38fafc7d67c3d$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $ks2lK.AllSelection)(state.doc)));
    return true;
};
function $79d38fafc7d67c3d$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $aXG5V.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $79d38fafc7d67c3d$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $79d38fafc7d67c3d$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $5SAOw.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $5SAOw.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $5SAOw.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $5SAOw.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $aXG5V.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $ks2lK.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $aXG5V.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $79d38fafc7d67c3d$var$textblockAt(after, "start", true) && $79d38fafc7d67c3d$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $5SAOw.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $5SAOw.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $aXG5V.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $5SAOw.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $79d38fafc7d67c3d$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $79d38fafc7d67c3d$export$c3a64f3c9604a1b1 = $79d38fafc7d67c3d$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $79d38fafc7d67c3d$export$a66c1876556415e5 = $79d38fafc7d67c3d$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $79d38fafc7d67c3d$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $aXG5V.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $79d38fafc7d67c3d$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $79d38fafc7d67c3d$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $79d38fafc7d67c3d$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $ks2lK.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $ks2lK.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $79d38fafc7d67c3d$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    let dropSpace = !(options && options.includeWhitespace);
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$79d38fafc7d67c3d$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $79d38fafc7d67c3d$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $79d38fafc7d67c3d$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $aXG5V.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $79d38fafc7d67c3d$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $79d38fafc7d67c3d$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $79d38fafc7d67c3d$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $79d38fafc7d67c3d$var$backspace = $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$e9a518a637d1e641, $79d38fafc7d67c3d$export$979097b097459299, $79d38fafc7d67c3d$export$52b8a4af68d19794);
let $79d38fafc7d67c3d$var$del = $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$e9a518a637d1e641, $79d38fafc7d67c3d$export$bf432e340007f9ef, $79d38fafc7d67c3d$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $79d38fafc7d67c3d$export$eb36e8971b04df36 = {
    "Enter": $79d38fafc7d67c3d$export$146a774cdef7663a($79d38fafc7d67c3d$export$a5d02b4b65e94f91, $79d38fafc7d67c3d$export$d0f80ac1b4510888, $79d38fafc7d67c3d$export$a3574cc681852c08, $79d38fafc7d67c3d$export$e99155638ff4dff0),
    "Mod-Enter": $79d38fafc7d67c3d$export$634b78845598ff5b,
    "Backspace": $79d38fafc7d67c3d$var$backspace,
    "Mod-Backspace": $79d38fafc7d67c3d$var$backspace,
    "Shift-Backspace": $79d38fafc7d67c3d$var$backspace,
    "Delete": $79d38fafc7d67c3d$var$del,
    "Mod-Delete": $79d38fafc7d67c3d$var$del,
    "Mod-a": $79d38fafc7d67c3d$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $79d38fafc7d67c3d$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $79d38fafc7d67c3d$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $79d38fafc7d67c3d$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $79d38fafc7d67c3d$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $79d38fafc7d67c3d$export$c3a64f3c9604a1b1,
    "Ctrl-e": $79d38fafc7d67c3d$export$a66c1876556415e5
};
for(let key in $79d38fafc7d67c3d$export$eb36e8971b04df36)$79d38fafc7d67c3d$export$f292ad8dbd5063c8[key] = $79d38fafc7d67c3d$export$eb36e8971b04df36[key];
const $79d38fafc7d67c3d$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $79d38fafc7d67c3d$export$4a0c2b85b1f0a889 = $79d38fafc7d67c3d$var$mac ? $79d38fafc7d67c3d$export$f292ad8dbd5063c8 : $79d38fafc7d67c3d$export$eb36e8971b04df36;
module.exports["deleteSelection"] = $79d38fafc7d67c3d$export$e9a518a637d1e641;
module.exports["selectNodeBackward"] = $79d38fafc7d67c3d$export$52b8a4af68d19794;
module.exports["exitCode"] = $79d38fafc7d67c3d$export$634b78845598ff5b;
module.exports["createParagraphNear"] = $79d38fafc7d67c3d$export$d0f80ac1b4510888;
module.exports["splitBlock"] = $79d38fafc7d67c3d$export$e99155638ff4dff0;
module.exports["selectAll"] = $79d38fafc7d67c3d$export$90aca4adda6ff0f5;
module.exports["toggleMark"] = $79d38fafc7d67c3d$export$797ad2667b8015a8;
module.exports["autoJoin"] = $79d38fafc7d67c3d$export$29903073afddcd8b;
module.exports["chainCommands"] = $79d38fafc7d67c3d$export$146a774cdef7663a;
module.exports["baseKeymap"] = $79d38fafc7d67c3d$export$4a0c2b85b1f0a889;

});

parcelRegister("dus6D", function(module, exports) {

var $kbdB6 = parcelRequire("kbdB6");


var $ks2lK = parcelRequire("ks2lK");

const $9d23e0fec4dbb6f3$var$mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
const $9d23e0fec4dbb6f3$var$windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function $9d23e0fec4dbb6f3$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($9d23e0fec4dbb6f3$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $9d23e0fec4dbb6f3$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$9d23e0fec4dbb6f3$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $9d23e0fec4dbb6f3$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $9d23e0fec4dbb6f3$export$5043418e2ef368d5(bindings) {
    return new (0, $ks2lK.Plugin)({
        props: {
            handleKeyDown: $9d23e0fec4dbb6f3$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $9d23e0fec4dbb6f3$export$53f558754f8b9fd1(bindings) {
    let map = $9d23e0fec4dbb6f3$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $kbdB6.keyName)(event), baseName, direct = map[$9d23e0fec4dbb6f3$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$9d23e0fec4dbb6f3$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
            !($9d23e0fec4dbb6f3$var$windows && event.ctrlKey && event.altKey) && (baseName = (0, $kbdB6.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060, #1529.
                let fromCode = map[$9d23e0fec4dbb6f3$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}
module.exports["keymap"] = $9d23e0fec4dbb6f3$export$5043418e2ef368d5;
module.exports["keydownHandler"] = $9d23e0fec4dbb6f3$export$53f558754f8b9fd1;

});

parcelRegister("ke2AI", function(module, exports) {
var $b7997750bf90f21f$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $b7997750bf90f21f$var$RopeSequence = function RopeSequence() {};
$b7997750bf90f21f$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $b7997750bf90f21f$var$RopeSequence.from(other);
    return !this.length && other || other.length < $b7997750bf90f21f$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $b7997750bf90f21f$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$b7997750bf90f21f$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $b7997750bf90f21f$var$RopeSequence.from(other).append(this);
};
$b7997750bf90f21f$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $b7997750bf90f21f$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$b7997750bf90f21f$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $b7997750bf90f21f$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$b7997750bf90f21f$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$b7997750bf90f21f$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$b7997750bf90f21f$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$b7997750bf90f21f$var$RopeSequence.from = function from(values) {
    if (values instanceof $b7997750bf90f21f$var$RopeSequence) return values;
    return values && values.length ? new $b7997750bf90f21f$var$Leaf(values) : $b7997750bf90f21f$var$RopeSequence.empty;
};
var $b7997750bf90f21f$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $b7997750bf90f21f$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $b7997750bf90f21f$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($b7997750bf90f21f$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$b7997750bf90f21f$var$RopeSequence.empty = new $b7997750bf90f21f$var$Leaf([]);
var $b7997750bf90f21f$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($b7997750bf90f21f$var$RopeSequence);
var $b7997750bf90f21f$export$2e2bcd8739ae039 = $b7997750bf90f21f$var$RopeSequence;



var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");




class $59f7b5b301f829df$export$ebdc1f934f4dd665 {
    constructor(step, inverted){
        this.step = step;
        this.inverted = inverted;
    }
}
function $59f7b5b301f829df$export$6137dcc98f08e76(steps, finalDoc) {
    for (const step of steps.slice().reverse())try {
        const result = step.inverted.apply(finalDoc);
        if (result.failed === null && result.doc) finalDoc = result.doc;
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    let tr = new (0, $aXG5V.Transform)(finalDoc);
    for (const step of steps)try {
        tr = tr.step(step.step);
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    return tr;
}
function $59f7b5b301f829df$export$3cddda3829daa1af(steps, tr) {
    if (steps === undefined) return undefined;
    return steps.map((step)=>{
        const newStep = step.step.map(tr.mapping);
        const newInvertedStep = step.inverted.map(tr.mapping);
        if (newStep && newInvertedStep) return new $59f7b5b301f829df$export$ebdc1f934f4dd665(newStep, newInvertedStep);
        return undefined;
    }).filter((s)=>!!s);
}


var $763dcf87625ae905$var$_Branch;
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $763dcf87625ae905$var$max_empty_items = 500;
class $763dcf87625ae905$var$Branch {
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            const next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        const transform = state.tr;
        let selection, remaining;
        const addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $763dcf87625ae905$var$Item(item.map));
                const step = item.step.map(remap.slice(mapFrom));
                let map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $763dcf87625ae905$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $763dcf87625ae905$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        const newItems = [];
        let eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            const step = transform.steps[i].invert(transform.docs[i]);
            let item = new $763dcf87625ae905$var$Item(transform.mapping.maps[i], step, selection), merged;
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line no-cond-assign
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        const overflow = eventCount - histOptions.depth;
        if (overflow > $763dcf87625ae905$var$DEPTH_OVERFLOW) {
            oldItems = $763dcf87625ae905$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $763dcf87625ae905$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        const maps = new (0, $aXG5V.Mapping)();
        this.items.forEach((item, i)=>{
            const mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return this;
        return new $763dcf87625ae905$var$Branch(this.items.append(array.map((map)=>new $763dcf87625ae905$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        const rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        const mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            const pos = mapping.getMirror(--iRebased);
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line eqeqeq
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            const map = mapping.maps[pos];
            if (item.step) {
                const step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                const selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $763dcf87625ae905$var$Item(map, step, selection));
            } else rebasedItems.push(new $763dcf87625ae905$var$Item(map));
        }, start);
        const newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $763dcf87625ae905$var$Item(mapping.maps[i]));
        const items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $763dcf87625ae905$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $763dcf87625ae905$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        const remap = this.remapping(0, upto);
        let mapFrom = remap.maps.length;
        const items = [];
        let events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                const step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    const selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const newItem = new $763dcf87625ae905$var$Item(map.invert(), step, selection);
                    let merged;
                    const last = items.length - 1;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line no-cond-assign
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $763dcf87625ae905$var$Branch((0, $b7997750bf90f21f$export$2e2bcd8739ae039).from(items.reverse()), events);
    }
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
}
$763dcf87625ae905$var$_Branch = $763dcf87625ae905$var$Branch;
$763dcf87625ae905$var$Branch.empty = new $763dcf87625ae905$var$_Branch((0, $b7997750bf90f21f$export$2e2bcd8739ae039).empty, 0);
function $763dcf87625ae905$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return items.slice(cutPoint);
}
class $763dcf87625ae905$var$Item {
    merge(other) {
        if (this.step && other.step && !other.selection) {
            const step = other.step.merge(this.step);
            if (step) return new $763dcf87625ae905$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $763dcf87625ae905$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition, /**
   * ===
   * FORK ADDITION START
   * Allow for "history slicing" which groups together changes regardless of time / position adjacency
   */ historySliceActive, trackedSteps, selectionBookmark){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
        this.historySliceActive = historySliceActive;
        this.trackedSteps = trackedSteps;
        this.selectionBookmark = selectionBookmark;
    }
}
const $763dcf87625ae905$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $763dcf87625ae905$var$applyTransaction(history, state, tr, options) {
    const historyTr = tr.getMeta($763dcf87625ae905$var$historyKey);
    let rebased;
    if (historyTr) return historyTr.historyState;
    /**
   * ===
   * FORK ADDITION START
   * If history slicing is active, we want to continue the current slice
   */ if ((tr.getMeta('startHistorySlice') === true || history?.historySliceActive) && tr.getMeta('endHistorySlice') !== true) {
        const shouldIgnoreChange = tr.getMeta('isRemote');
        if (shouldIgnoreChange) {
            // For addToHistory=false transactions during a slice, we need to:
            // 1. Update the mapping for done/undone branches
            // 2. Map the existing steps
            // 3. Update the document to rebaseline
            const mappedRanges = history.prevRanges ? $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new $763dcf87625ae905$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition, true, (0, $59f7b5b301f829df$export$3cddda3829daa1af)(history.trackedSteps, tr), history.selectionBookmark);
        }
        const startHistorySlice = tr.getMeta('startHistorySlice') === true;
        const newTrackedSteps = [
            ...history.trackedSteps || [],
            ...tr.steps.map((s, idx)=>new (0, $59f7b5b301f829df$export$ebdc1f934f4dd665)(s, s.invert(tr.docs[idx])))
        ];
        const mappedRanges = history.prevRanges ? $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new $763dcf87625ae905$var$HistoryState(history.done, startHistorySlice ? $763dcf87625ae905$var$Branch.empty : history.undone, mappedRanges, history.prevTime, history.prevComposition, true, newTrackedSteps, startHistorySlice ? state.selection.getBookmark() : history.selectionBookmark);
    } else if (tr.getMeta('endHistorySlice') === true && history.historySliceActive) {
        const trackedSteps = history.historySliceActive ? history.trackedSteps || [] : [];
        // Create transform that represents the changes made during the slice
        // Use the original slice document as the base
        const transform = (0, $59f7b5b301f829df$export$6137dcc98f08e76)(trackedSteps, tr.doc);
        const mappedRanges = history.prevRanges ? $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new $763dcf87625ae905$var$HistoryState(history.done.addMaps(tr.mapping.maps).addTransform(transform, history.selectionBookmark, options, $763dcf87625ae905$var$mustPreserveItems(state)), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition);
    }
    /**
   * FORK ADDITION END
   * ===
   */ if (tr.getMeta($763dcf87625ae905$var$closeHistoryKey)) history = new $763dcf87625ae905$var$HistoryState(history.done, history.undone, null, 0, -1);
    const appended = tr.getMeta('appendedTransaction');
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($763dcf87625ae905$var$historyKey)) {
        if (appended.getMeta($763dcf87625ae905$var$historyKey).redo) return new $763dcf87625ae905$var$HistoryState(history.done.addTransform(tr, undefined, options, $763dcf87625ae905$var$mustPreserveItems(state)), history.undone, $763dcf87625ae905$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $763dcf87625ae905$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $763dcf87625ae905$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta('addToHistory') !== false && !(appended && appended.getMeta('addToHistory') === false)) {
        // Group transforms that occur in quick succession into one event.
        const composition = tr.getMeta('composition');
        const newGroup = // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevTime == 0 || !appended && // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !$763dcf87625ae905$var$isAdjacentTo(tr, history.prevRanges));
        const prevRanges = appended ? // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping) : $763dcf87625ae905$var$rangesFor(tr.mapping.maps);
        return new $763dcf87625ae905$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $763dcf87625ae905$var$mustPreserveItems(state)), $763dcf87625ae905$var$Branch.empty, prevRanges, tr.time, // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        composition == null ? history.prevComposition : composition);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line no-cond-assign
    } else if (rebased = tr.getMeta('rebased')) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $763dcf87625ae905$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $763dcf87625ae905$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $763dcf87625ae905$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $763dcf87625ae905$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $763dcf87625ae905$var$rangesFor(maps) {
    const result = [];
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $763dcf87625ae905$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    const result = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $763dcf87625ae905$var$histTransaction(history, state, redo) {
    const preserveItems = $763dcf87625ae905$var$mustPreserveItems(state);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    const histOptions = $763dcf87625ae905$var$historyKey.get(state).spec.config;
    const pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const selection = pop.selection.resolve(pop.transform.doc);
    const added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    /**
   * ===
   * FORK ADDITION START
   * If history slicing is active when we undo/redo, when we perform an undo/redo we want to
   * map and keep the relevant steps in the new history state
   */ const newHist = history.historySliceActive ? new $763dcf87625ae905$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1, history.historySliceActive, (0, $59f7b5b301f829df$export$3cddda3829daa1af)(history.trackedSteps, pop.transform), history.selectionBookmark?.map(pop.transform.mapping)) : new $763dcf87625ae905$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    /**
   * FORK ADDITION END
   * ===
   */ return pop.transform.setSelection(selection).setMeta($763dcf87625ae905$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $763dcf87625ae905$var$cachedPreserveItems = false, $763dcf87625ae905$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $763dcf87625ae905$var$mustPreserveItems(state) {
    const plugins = state.plugins;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if ($763dcf87625ae905$var$cachedPreserveItemsPlugins != plugins) {
        $763dcf87625ae905$var$cachedPreserveItems = false;
        $763dcf87625ae905$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)// To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (plugins[i].spec.historyPreserveItems) {
            $763dcf87625ae905$var$cachedPreserveItems = true;
            break;
        }
    }
    return $763dcf87625ae905$var$cachedPreserveItems;
}
function $763dcf87625ae905$export$181a649d919c589e(tr) {
    return tr.setMeta($763dcf87625ae905$var$closeHistoryKey, true);
}
const $763dcf87625ae905$var$historyKey = new (0, $ks2lK.PluginKey)('history');
const $763dcf87625ae905$var$closeHistoryKey = new (0, $ks2lK.PluginKey)('closeHistory');
function $763dcf87625ae905$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $ks2lK.Plugin)({
        key: $763dcf87625ae905$var$historyKey,
        state: {
            init () {
                return new $763dcf87625ae905$var$HistoryState($763dcf87625ae905$var$Branch.empty, $763dcf87625ae905$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $763dcf87625ae905$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    const inputType = e.inputType;
                    const command = // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line eqeqeq
                    inputType == 'historyUndo' ? $763dcf87625ae905$export$21f930c44940fd98 : inputType == 'historyRedo' ? $763dcf87625ae905$export$1688e416fee0a49e : null;
                    if (!command || !view.editable) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $763dcf87625ae905$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        const hist = $763dcf87625ae905$var$historyKey.getState(state);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            const tr = $763dcf87625ae905$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
const $763dcf87625ae905$export$21f930c44940fd98 = $763dcf87625ae905$var$buildCommand(false, true);
const $763dcf87625ae905$export$1688e416fee0a49e = $763dcf87625ae905$var$buildCommand(true, true);
const $763dcf87625ae905$export$24b5d280435f3a3f = $763dcf87625ae905$var$buildCommand(false, false);
const $763dcf87625ae905$export$3774e54bae7be19b = $763dcf87625ae905$var$buildCommand(true, false);
function $763dcf87625ae905$export$f8a176c2b9a10bdb(state) {
    const hist = $763dcf87625ae905$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
function $763dcf87625ae905$export$3ffe6b288e7d941b(state) {
    const hist = $763dcf87625ae905$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}
module.exports["closeHistory"] = $763dcf87625ae905$export$181a649d919c589e;
module.exports["history"] = $763dcf87625ae905$export$55abd4691b317664;
module.exports["undo"] = $763dcf87625ae905$export$21f930c44940fd98;
module.exports["redo"] = $763dcf87625ae905$export$1688e416fee0a49e;

});

parcelRegister("8Doca", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f6eec6bbba6041ad$export$9b0f795b2e33f057 = (Wrapped)=>{
    class WithImageLoader extends (0, $42omo.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                imageStatus: 'loading'
            };
            this.img = void 0;
            this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            };
            this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    }
    return WithImageLoader;
};
module.exports["withImageLoader"] = $f6eec6bbba6041ad$export$9b0f795b2e33f057;

});

parcelRegister("21PP6", function(module, exports) {
const $322f4dab81de9e93$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};
module.exports["getExtensionLozengeData"] = $322f4dab81de9e93$export$4fd8ecadd193bea0;

});

parcelRegister("7iE7T", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");


var $8m4tT = parcelRequire("8m4tT");

const $3b2d37886a4003ec$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $3b2d37886a4003ec$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $3b2d37886a4003ec$export$996213f7c272fc6f = (nodes)=>nodes.every($3b2d37886a4003ec$export$4c39e41e39b3c449);
const $3b2d37886a4003ec$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $3b2d37886a4003ec$export$d7ae8c533ae18832 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $3b2d37886a4003ec$export$1879817ac5c922b7 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.nodes.text);
const $3b2d37886a4003ec$export$5dfeda3a9e6fe056 = (node, schema)=>$3b2d37886a4003ec$export$26b9f946b448f23e(node, schema.marks.link);
var $3b2d37886a4003ec$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $3b2d37886a4003ec$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $3b2d37886a4003ec$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $3b2d37886a4003ec$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $3b2d37886a4003ec$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $8m4tT.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $3b2d37886a4003ec$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $3b2d37886a4003ec$export$54fd2c36b5cc6731(node) {
    return $3b2d37886a4003ec$var$transformer.encode(node);
}
function $3b2d37886a4003ec$export$3a858d3babd60825(node) {
    return $3b2d37886a4003ec$var$transformer.encodeNode(node);
}
module.exports["isParagraph"] = $3b2d37886a4003ec$export$d7ae8c533ae18832;
module.exports["isText"] = $3b2d37886a4003ec$export$1879817ac5c922b7;
module.exports["isLinkMark"] = $3b2d37886a4003ec$export$5dfeda3a9e6fe056;
module.exports["SelectedState"] = $3b2d37886a4003ec$export$a6212ae0c82963af;
module.exports["isNodeSelectedOrInRange"] = $3b2d37886a4003ec$export$5125f50e751e84db;
module.exports["isSupportedInParent"] = $3b2d37886a4003ec$export$b6e38334b1fb4d1b;
module.exports["isMediaNode"] = $3b2d37886a4003ec$export$d6ca4605aefeca32;
module.exports["isNodeBeforeMediaNode"] = $3b2d37886a4003ec$export$cfaa7840b0c93780;
module.exports["toJSON"] = $3b2d37886a4003ec$export$54fd2c36b5cc6731;
module.exports["nodeToJSON"] = $3b2d37886a4003ec$export$3a858d3babd60825;

});

parcelRegister("TfRUG", function(module, exports) {
const $789182d0618bed14$export$15a09f5ef055bcfa = '\u200b';
const $789182d0618bed14$export$2b4d00c13dcd3c1f = '\u200d';
module.exports["ZERO_WIDTH_SPACE"] = $789182d0618bed14$export$15a09f5ef055bcfa;
module.exports["ZERO_WIDTH_JOINER"] = $789182d0618bed14$export$2b4d00c13dcd3c1f;

});

parcelRegister("led7c", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $2T4ch = parcelRequire("2T4ch");

// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $26c28de5be6088e2$var$nodeViewRenderedEventsCounter = 0;
const $26c28de5be6088e2$var$DEFAULT_SAMPLING_RATE = 100;
const $26c28de5be6088e2$var$DEFAULT_SLOW_THRESHOLD = 7;
function $26c28de5be6088e2$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $26c28de5be6088e2$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $26c28de5be6088e2$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $26c28de5be6088e2$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $2T4ch.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $26c28de5be6088e2$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $2T4ch.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$26c28de5be6088e2$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}
module.exports["getPerformanceOptions"] = $26c28de5be6088e2$export$9838b97af1c61be;
module.exports["startMeasureReactNodeViewRendered"] = $26c28de5be6088e2$export$2630f5971dfad231;
module.exports["stopMeasureReactNodeViewRendered"] = $26c28de5be6088e2$export$dc5a82f0bfc526c3;

});

parcelRegister("grmt9", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $8kPu1 = parcelRequire("8kPu1");

const $cc23084c386c6715$export$180fe852598a23ab = {
    pending: [
        'started'
    ],
    started: [
        'aborted',
        'failed',
        'succeeded'
    ],
    aborted: [
        'started'
    ],
    failed: [
        'started'
    ],
    succeeded: [
        'started'
    ]
};
const $cc23084c386c6715$export$178881f329fdb81f = (fromState, toState)=>{
    return $cc23084c386c6715$export$180fe852598a23ab[fromState]?.includes(toState) ?? false;
};


class $677a536053deeb18$export$fa331fd384051f6a {
    start(callback) {
        this.checks.forEach((check)=>check.start(callback));
    }
    stop() {
        this.checks.forEach((check)=>check.stop());
    }
    constructor(checks){
        this.checks = void 0;
        this.checks = checks;
    }
}


class $fd9e9a5afa72d596$export$c90b54e658fc4d7c {
    startCheck() {
        this.stopCheck();
        this.check.start(({ status: status, reason: reason, metadata: metadata })=>{
            if (status === 'success') this.success({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'abort') this.abort({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'failure') this.failure({
                reason: reason,
                metadata: metadata
            });
        });
    }
    stopCheck() {
        this.check.stop();
    }
    getEndStateMetadata(options = {}) {
        const metadata = {
            ...options.metadata
        };
        if (options.reason) metadata.experienceEndReason = options.reason;
        return metadata;
    }
    /**
   * Transitions to a new experience state and tracks analytics events.
   *
   * Upon transition to each state, two events are tracked:
   * - experienceMeasured: tracked on every successful transition, used for data analysis
   * - experienceSampled: tracked only on 1 out of every N transitions based on sample rate
   *
   * @param toState - The target state to transition to
   * @param metadata - Optional metadata to attach to the analytics events
   * @returns true if transition was successful, false if invalid transition
   */ transitionTo(toState, metadata) {
        if (!(0, $cc23084c386c6715$export$178881f329fdb81f)(this.currentState, toState)) return false;
        this.currentState = toState;
        if (toState === 'started') {
            this.isSampledTrackingEnabled = Math.random() < this.sampleRate;
            this.startTimeMs = Date.now();
            this.startMetadata = metadata;
        }
        this.trackTransition(toState, metadata);
        if (toState === 'started') this.startCheck();
        else {
            this.stopCheck();
            this.startMetadata = undefined;
        }
        this.statesSeen.add(toState);
        return true;
    }
    /**
   * Tracks analytics events for a state transition.
   *
   * Fires both experienceMeasured (always) and experienceSampled (sampled) events.
   *
   * @param toState - The state that was transitioned to
   * @param metadata - Metadata to include in the event, including firstInSession flag
   */ trackTransition(toState, metadata) {
        const attributes = {
            experienceKey: this.id,
            experienceStatus: toState,
            experienceStatusFirstSeen: !this.statesSeen.has(toState),
            experienceStartTime: this.startTimeMs || 0,
            experienceDuration: this.startTimeMs ? Date.now() - this.startTimeMs : 0,
            ...this.globalMetadata,
            ...this.startMetadata,
            ...metadata
        };
        const experienceMeasuredEvent = {
            action: (0, $d925B.ACTION).EXPERIENCE_MEASURED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: this.actionSubjectId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: attributes
        };
        this.dispatchAnalyticsEvent(experienceMeasuredEvent);
        if (this.isSampledTrackingEnabled) {
            const experienceSampledEvent = {
                action: (0, $d925B.ACTION).EXPERIENCE_SAMPLED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                actionSubjectId: this.actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            };
            this.dispatchAnalyticsEvent(experienceSampledEvent);
        }
    }
    /**
   * Starts tracking the experience and all checks which monitor for completion.
   *
   * Metadata from options will be merged with metadata provided in subsequent events.
   *
   * @param options - Configuration for starting the experience
   * @param options.metadata - Optional custom metadata attached to all subsequent events for this started experience
   * @param options.forceRestart - If true and experience already in progress will abort and restart
   * @param options.method - Optional method for experience start, e.g., how the experience was initiated
   */ start(options = {}) {
        if (options.forceRestart && this.currentState === 'started') this.abort({
            reason: (0, $8kPu1.EXPERIENCE_ABORT_REASON).RESTARTED
        });
        return this.transitionTo('started', {
            experienceStartMethod: options.method,
            ...options.metadata
        });
    }
    /**
   * Marks the experience as successful and stops any ongoing checks.
   *
   * @param options - Configuration for the success event
   * @param options.metadata - Optional custom metadata attached to the success event
   * @param options.reason - Optional reason for success
   * @returns false if transition to success state was not valid
   */ success(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('succeeded', metadata);
    }
    /**
   * Aborts the experience and stops any ongoing checks.
   *
   * Use this when a started experience terminates early due to user action or context change
   * (e.g., component unmount, navigation). This is neither success nor failure.
   *
   * @param options - Configuration for the abort event
   * @param options.metadata - Optional custom metadata attached to the abort event
   * @param options.reason - Optional reason for abort
   *
   * @example
   * // Abort on component unmount
   * useEffect(() => {
   *   return () => experience.abort({ reason: 'unmount', metadata: { someKey: 'someValue' } });
   * }, []);
   *
   * @returns false if transition to aborted state was not valid
   */ abort(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('aborted', metadata);
    }
    /**
   * Manually marks the experience as failed and stops any ongoing checks.
   *
   * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
   *
   * @param options - Configuration for the failure event
   * @param options.metadata - Optional custom metadata attached to the failure event
   * @param options.reason - Optional reason for failure
   * @returns false if transition to failed state was not valid
   */ failure(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('failed', metadata);
    }
    /**
   * Creates a new Experience instance for tracking user experiences.
   *
   * @param id - Unique identifier for the experience e.g. 'toolbarOpen' 'menuAction'
   * @param options - Configuration options for the experience
   * @param options.checks - Experience checks to monitor for completion
   * @param options.dispatchAnalyticsEvent - Function to dispatch analytics events
   * @param options.sampleRate - Sample rate for experienceSampled events
   * @param options.metadata - Global metadata to attach to all events
   * @param options.action - Optional sub identifier for the specific experience action e.g. 'bold' 'insertTable'
   * @param options.actionSubjectId - Optional sub identifier for the experience action subject e.g. 'selectionToolbar' 'quickInsert'
   */ constructor(id, options){
        this.id = void 0;
        this.actionSubjectId = void 0;
        this.dispatchAnalyticsEvent = void 0;
        this.sampleRate = void 0;
        this.globalMetadata = void 0;
        this.check = void 0;
        this.currentState = 'pending';
        /**
     * Set of experience states that have been seen in the current session.
     *
     * Used to determine if experienceStatusFirstSeen flag should be set in events.
     */ this.statesSeen = new Set();
        /**
     * Indicates whether sampled tracking is enabled for this current experience session.
     *
     * Set to true | false upon transitioning to 'started' state.
     * When true, on subsequent transitions we fire experienceSampled events.
     * Ensures that every tracked start has corresponding abort/fail/success tracked.
     */ this.isSampledTrackingEnabled = void 0;
        /**
     * Timestamp (in milliseconds) when the experience transitioned to 'started' state.
     *
     * Used to calculate experience duration. Set via Date.now() when experience starts.
     */ this.startTimeMs = void 0;
        /**
     * Metadata provided at experience start time to merge into subsequent events.
     *
     * Used to retain experienceStartMethod and other start-specific metadata.
     */ this.startMetadata = void 0;
        this.id = id;
        this.actionSubjectId = options.actionSubjectId;
        this.dispatchAnalyticsEvent = options.dispatchAnalyticsEvent;
        this.sampleRate = options.sampleRate ?? (0, $8kPu1.DEFAULT_EXPERIENCE_SAMPLE_RATE);
        this.globalMetadata = {
            ...options.metadata,
            experienceAction: options.action
        };
        this.check = new (0, $677a536053deeb18$export$fa331fd384051f6a)(options.checks || []);
    }
}
module.exports["Experience"] = $fd9e9a5afa72d596$export$c90b54e658fc4d7c;

});

parcelRegister("8kPu1", function(module, exports) {
/**
 * Built-in failure reasons for experience checks
 *
 * These are used by the various ExperienceCheck implementations to
 * provide consistent, well-known failure reasons for analytics and debugging.
 */ const $d05112237b8e1d04$export$21dde0ac9b2abe83 = {
    /**
	 * Experience timed out before completion
	 */ TIMEOUT: 'timeout',
    /**
	 * Target element could not be found when starting DOM mutation observation
	 */ DOM_MUTATION_TARGET_NOT_FOUND: 'domMutationTargetNotFound',
    /**
	 * Error occurred during DOM mutation check execution
	 */ DOM_MUTATION_CHECK_ERROR: 'domMutationCheckError'
};
const $d05112237b8e1d04$export$e6589edd1f8a04af = {
    /**
	 * Experience was aborted because it was restarted while already in progress
	 */ RESTARTED: 'restarted'
};
const $d05112237b8e1d04$export$8e85905c8b6efc67 = 0.001;
const $d05112237b8e1d04$export$b110169935468339 = {
    ASYNC_OPERATION: 'asyncOperation',
    MENU_ACTION: 'menuAction',
    MENU_OPEN: 'menuOpen',
    TOOLBAR_ACTION: 'toolbarAction',
    TOOLBAR_OPEN: 'toolbarOpen'
};
module.exports["EXPERIENCE_FAILURE_REASON"] = $d05112237b8e1d04$export$21dde0ac9b2abe83;
module.exports["EXPERIENCE_ABORT_REASON"] = $d05112237b8e1d04$export$e6589edd1f8a04af;
module.exports["DEFAULT_EXPERIENCE_SAMPLE_RATE"] = $d05112237b8e1d04$export$8e85905c8b6efc67;
module.exports["EXPERIENCE_ID"] = $d05112237b8e1d04$export$b110169935468339;

});

parcelRegister("fo9p3", function(module, exports) {

var $8kPu1 = parcelRequire("8kPu1");

const $5240fd93cec52085$var$DEFAULT_FAILURE_RESULT = {
    status: 'failure',
    reason: (0, $8kPu1.EXPERIENCE_FAILURE_REASON).TIMEOUT
};
class $5240fd93cec52085$export$1a6fa509d14ac50 {
    start(callback) {
        this.stop();
        this.timeoutId = setTimeout(()=>{
            const result = this.onTimeout() || $5240fd93cec52085$var$DEFAULT_FAILURE_RESULT;
            callback(result);
        }, this.durationMs);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }
    constructor({ durationMs: durationMs, onTimeout: onTimeout = ()=>$5240fd93cec52085$var$DEFAULT_FAILURE_RESULT }){
        this.timeoutId = void 0;
        this.durationMs = 0;
        this.onTimeout = void 0;
        this.durationMs = durationMs;
        this.onTimeout = onTimeout;
    }
}
module.exports["ExperienceCheckTimeout"] = $5240fd93cec52085$export$1a6fa509d14ac50;

});

parcelRegister("7fmpI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");

class $5aeffb90025ca075$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}
module.exports["ErrorBoundary"] = $5aeffb90025ca075$export$e926676385687eaf;

});

parcelRegister("c4jUA", function(module, exports) {

var $3BqCC = parcelRequire("3BqCC");


var $4U5Tv = parcelRequire("4U5Tv");


var $ehlgT = parcelRequire("ehlgT");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c954dc8baefb0c1$var$nativeCeil = Math.ceil, $8c954dc8baefb0c1$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $8c954dc8baefb0c1$var$chunk(array, size, guard) {
    if (guard ? $4U5Tv(array, size, guard) : size === undefined) size = 1;
    else size = $8c954dc8baefb0c1$var$nativeMax($ehlgT(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($8c954dc8baefb0c1$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $3BqCC(array, index, index += size);
    return result;
}
module.exports = $8c954dc8baefb0c1$var$chunk;

});

parcelRegister("9HtP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e1d16a2959b92a8$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $1e1d16a2959b92a8$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $42omo.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("2oRGU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $d925B = parcelRequire("d925B");


var $h9Yad = parcelRequire("h9Yad");

function $7292b2eba851ae1a$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $h9Yad.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}
module.exports["RenderTracking"] = $7292b2eba851ae1a$export$fe16de086fea1f5f;

});

parcelRegister("6VsTy", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");

const $33afbf7bccf03c68$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $5SAOw.Node) || Array.isArray(nodeOrMark.marks);
};
const $33afbf7bccf03c68$export$3d8be158d19aadd1 = (nodeOrMark, options)=>{
    const name = nodeOrMark.type.name;
    const isNode = $33afbf7bccf03c68$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    if (options?.anchrorId !== undefined && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) commonAttributes['data-node-anchor'] = options.anchrorId;
    return commonAttributes;
};
module.exports["createProseMirrorMetadata"] = $33afbf7bccf03c68$export$3d8be158d19aadd1;

});

parcelRegister("iScNA", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ae74dae40b2182$export$2e2bcd8739ae039);

var $80xRs = parcelRequire("80xRs");

const $72ae74dae40b2182$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $72ae74dae40b2182$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $80xRs.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $80xRs.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $80xRs.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $80xRs.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $80xRs.getOnlyFulfilled)(results);
        return $72ae74dae40b2182$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});

parcelRegister("jTtEd", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");

function $8e2fd2af7fc541b0$export$8e2864079bc476bd(appearance, contentMode) {
    if ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === 'compact') return 0, $aFUXX.akEditorFullPageDenseFontSize;
    }
    if (appearance === undefined) return 0, $aFUXX.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : undefined;
}
module.exports["getBaseFontSize"] = $8e2fd2af7fc541b0$export$8e2864079bc476bd;

});

parcelRegister("uq7dM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

const $b70de66aa381d38d$var$pulseBackground = (0, $9K4OG.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$pulseBackgroundReverse = (0, $9K4OG.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$flashWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $b70de66aa381d38d$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $b70de66aa381d38d$var$flashWrapperAnimated = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$b70de66aa381d38d$var$flashWrapper} & > div`]: {
        animationName: $b70de66aa381d38d$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $b70de66aa381d38d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: animate ? $b70de66aa381d38d$var$flashWrapperAnimated : $b70de66aa381d38d$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args);
        this.toggle = false;
    }
}
module.exports["default"] = $b70de66aa381d38d$export$2e2bcd8739ae039;

});

parcelRegister("9h6tL", function(module, exports) {
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $4e1d4745b1e8289e$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $4e1d4745b1e8289e$var$PanelInfoGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
        fill: "currentColor"
    }));
};
const $4e1d4745b1e8289e$export$2187dc2d495c3efc = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($4e1d4745b1e8289e$var$PanelInfoGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelInfoIcon"] = $4e1d4745b1e8289e$export$2187dc2d495c3efc;

});

parcelRegister("7aW37", function(module, exports) {
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c82a733b017451e7$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $c82a733b017451e7$var$PanelWarningGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
        fill: "currentColor"
    }));
};
const $c82a733b017451e7$export$246c5468186717b7 = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($c82a733b017451e7$var$PanelWarningGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelWarningIcon"] = $c82a733b017451e7$export$246c5468186717b7;

});

parcelRegister("9f7tI", function(module, exports) {
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2c603864430226d2$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $2c603864430226d2$var$PanelErrorGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
        fill: "currentColor"
    }));
};
const $2c603864430226d2$export$76fa6c311f4e2871 = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($2c603864430226d2$var$PanelErrorGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelErrorIcon"] = $2c603864430226d2$export$76fa6c311f4e2871;

});

parcelRegister("5Eiz2", function(module, exports) {
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $12304797f5f70131$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $12304797f5f70131$var$PanelSuccessGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
        fill: "currentColor"
    }));
};
const $12304797f5f70131$export$a5a5162e21242c3c = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($12304797f5f70131$var$PanelSuccessGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelSuccessIcon"] = $12304797f5f70131$export$a5a5162e21242c3c;

});

parcelRegister("9jJiA", function(module, exports) {
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0eeb07e0bc008878$var$iconStyles = null;
const $0eeb07e0bc008878$var$PanelNoteGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
        fill: "currentColor"
    }));
};
const $0eeb07e0bc008878$export$d4f894f0c3f0db6 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($0eeb07e0bc008878$var$PanelNoteGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelNoteIcon"] = $0eeb07e0bc008878$export$d4f894f0c3f0db6;

});

parcelRegister("c0czl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9K4OG = parcelRequire("9K4OG");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

function $3ae2a3e708a69581$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ae2a3e708a69581$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $3ae2a3e708a69581$var$textColorIconWrapper = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $3ae2a3e708a69581$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $3ae2a3e708a69581$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3ae2a3e708a69581$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $3ae2a3e708a69581$var$getBackground(selectedColor, disabled)
        },
        css: $3ae2a3e708a69581$var$barStyles
    }));
};
module.exports["DynamicStrokeIconDecoration"] = $3ae2a3e708a69581$export$76b0278e018f8601;

});

parcelRegister("80xRs", function(module, exports) {
var $56266f841bff4619$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $56266f841bff4619$var$isFullfilled = (result)=>result.status === "fulfilled";
const $56266f841bff4619$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $56266f841bff4619$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $56266f841bff4619$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($56266f841bff4619$var$markFullfilled).catch($56266f841bff4619$var$markRejected)));
};
const $56266f841bff4619$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $56266f841bff4619$export$b7581cbf0e22e36b = (results)=>results.filter($56266f841bff4619$var$isFullfilled).map((result)=>result.value);
module.exports["waitForAllPromises"] = $56266f841bff4619$export$b43fdcffd84b7b0f;
module.exports["waitForFirstFulfilledPromise"] = $56266f841bff4619$export$cb8861b0e3f3dd6f;
module.exports["getOnlyFulfilled"] = $56266f841bff4619$export$b7581cbf0e22e36b;

});


$parcel$global.rlb("fJ9wN")
//# sourceMappingURL=FullPageEditorComponent.4265b29a.js.map
